/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "txn/models.proto" (package "rd.txn", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { ManuallyEnteredCard } from "../payments/models_pb";
import { Product } from "../product/models_pb";
import { Contacts_Contact as Contacts_Contact$ } from "../vendors/models_pb";
import { Vendor } from "../vendors/models_pb";
import { TimestampRange } from "../proto/timestamprange/models_pb";
import { AcknowledgeCode } from "../integrations/x12/models_pb";
import { TintColor } from "../tintcolor/models_pb";
import { ReceiptPurchaseMethods } from "../ledger/models_pb";
import { Barcode } from "../pdf/barcode/models_pb";
import { CardPaymentReceiptInfo } from "../payments/models_pb";
import { TaxRate } from "../company/models_pb";
import { Location } from "../company/models_pb";
import { Company } from "../company/models_pb";
import { PurchaseOrder } from "../customer/models_pb";
import { Contacts_Contact } from "../customer/models_pb";
import { Customer } from "../customer/models_pb";
import { Kit_CustomerViewType } from "../product/models_pb";
import { Product_TallyDimension } from "../product/models_pb";
import { RuleInformation } from "../price/models_pb";
import { LedgerEntry_UomSnapshot } from "../ledger/models_pb";
import { SaleForm_CustomField } from "../company/models_pb";
import { FractionalMoney } from "../proto/money/models_pb";
import { TaxComponent } from "../company/models_pb";
import { Address } from "../proto/address/models_pb";
import { Money } from "../proto/money/models_pb";
import { Decimal } from "../proto/decimal/models_pb";
import { User } from "../user/models_pb";
import { Timestamp } from "../google/protobuf/timestamp_pb";
import { UUID } from "../proto/uuid/models_pb";
/**
 * Sale represents a transaction in which a supplier sells
 * a product or products to a customer.
 *
 * @generated from protobuf message rd.txn.Sale
 */
export interface Sale {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 5
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_purchase_order_id = 7
     */
    customerPurchaseOrderId?: UUID;
    /**
     * The location where the sale is charged from
     *
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 8
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.user.User created_by = 9
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.user.User quoted_by = 10
     */
    quotedBy?: User;
    /**
     * @generated from protobuf field: rd.user.User sold_by = 11
     */
    soldBy?: User; // returned_by for returns
    /**
     * @generated from protobuf field: rd.user.User updated_by = 12
     */
    updatedBy?: User;
    /**
     * @generated from protobuf field: rd.user.User voided_by = 13
     */
    voidedBy?: User;
    /**
     * @generated from protobuf field: rd.user.User will_called_by = 14
     */
    willCalledBy?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp quoted_at = 15
     */
    quotedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp quote_expires_at = 16
     */
    quoteExpiresAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp will_called_at = 17
     */
    willCalledAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp voided_at = 18
     */
    voidedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sold_at = 19
     */
    soldAt?: Timestamp; // returned_at for returns
    /**
     * @generated from protobuf field: string identifier = 20
     */
    identifier: string;
    /**
     * @generated from protobuf field: rd.txn.Sale.Status status = 21
     */
    status: Sale_Status;
    /**
     * @generated from protobuf field: string sale_notes = 22
     */
    saleNotes: string; // return_notes for returns
    /**
     * @generated from protobuf field: string customer_contact_id_string = 26
     */
    customerContactIdString: string;
    /**
     * @generated from protobuf field: string signature_url = 27
     */
    signatureUrl: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal tax_rate = 28
     */
    taxRate?: Decimal; // being deprecated
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID tax_rate_id = 29
     */
    taxRateId?: UUID; // being deprecated
    /**
     * @generated from protobuf field: rd.proto.money.Money subtotal = 30
     */
    subtotal?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 31
     */
    total?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money adjusted_total = 32
     */
    adjustedTotal?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal card_surcharge_rate = 33
     */
    cardSurchargeRate?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge = 34
     */
    cardSurcharge?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge_tax = 35
     */
    cardSurchargeTax?: Money; // being deprecated
    /**
     * @generated from protobuf field: rd.proto.money.Money total_early_payment_discount_adjustment = 36
     */
    totalEarlyPaymentDiscountAdjustment?: Money; // positive
    /**
     * @generated from protobuf field: string internal_notes = 37
     */
    internalNotes: string;
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 40
     */
    address?: Address;
    /**
     * @generated from protobuf field: rd.user.User special_ordered_by = 41
     */
    specialOrderedBy?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp special_ordered_at = 42
     */
    specialOrderedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.txn.Sale.SpecialOrderSale special_order_sale = 43
     */
    specialOrderSale?: Sale_SpecialOrderSale;
    /**
     * @generated from protobuf field: rd.proto.money.Money sales_tax = 45
     */
    salesTax?: Money; // returns only, being deprecated
    /**
     * @generated from protobuf field: rd.proto.money.Money rounding_adjustment = 46
     */
    roundingAdjustment?: Money; // returns only
    /**
     * @generated from protobuf field: rd.txn.Sale.Type type = 47
     */
    type: Sale_Type;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID returned_from_sale_ids = 48
     */
    returnedFromSaleIds: UUID[]; // returns only
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal restock_fee_percentage = 50
     */
    restockFeePercentage?: Decimal; // returns only, rate from 0-1
    /**
     * @generated from protobuf field: rd.proto.money.Money restock_fee_amount = 51
     */
    restockFeeAmount?: Money; // returns only
    /**
     * @generated from protobuf field: rd.proto.money.Money restock_fee_applied = 52
     */
    restockFeeApplied?: Money; // returns only
    /**
     * @generated from protobuf field: rd.txn.Sale.Totals totals = 54
     */
    totals?: Sale_Totals;
    /**
     * totals_by_returned_from_sale_id is NOT used for normal sales, only when a sale is of
     * TYPE_RETURN
     *
     * @generated from protobuf field: map<string, rd.txn.Sale.Totals> totals_by_returned_from_sale_id = 55
     */
    totalsByReturnedFromSaleId: {
        [key: string]: Sale_Totals;
    };
    /**
     * @generated from protobuf field: rd.txn.CreditAllocationStatus credit_allocation_status = 58
     */
    creditAllocationStatus: CreditAllocationStatus;
    /**
     * The location where the inventory is being fulfilled from
     *
     * @generated from protobuf field: rd.proto.uuid.UUID fulfillment_location_id = 59
     */
    fulfillmentLocationId?: UUID;
    /**
     * A simple read-only boolean. No impact on logic.
     *
     * @generated from protobuf field: bool is_delivery_fulfillment = 60
     */
    isDeliveryFulfillment: boolean;
    /**
     * @generated from protobuf field: rd.proto.money.Money initial_deposit = 61
     */
    initialDeposit?: Money;
    /**
     * negative; nil if no discount or discount is applied as a rate only
     *
     * @generated from protobuf field: rd.proto.money.Money discount_amount = 64
     */
    discountAmount?: Money;
    /**
     * rate from 0-1; nil if no discount or discount is applied as an amount only
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal discount_rate = 65
     */
    discountRate?: Decimal;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp delivery_date = 66
     */
    deliveryDate?: Timestamp;
    /**
     * @generated from protobuf field: rd.txn.Sale.CloseOutStatus close_out_status = 67
     */
    closeOutStatus: Sale_CloseOutStatus;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp closed_out_at = 68
     */
    closedOutAt?: Timestamp; // applies to sales with non-nil CloseOutStatus
    /**
     * @generated from protobuf field: rd.user.User closed_out_by = 69
     */
    closedOutBy?: User; // applies to sales with non-nil CloseOutStatus
    /**
     * @generated from protobuf field: rd.txn.Sale.Source source = 70
     */
    source: Sale_Source; // Source identifies where the sale originated (POS, e-commerce).
    /**
     * @generated from protobuf field: map<string, rd.txn.Sale.Totals.AdditionalFee> additional_fees_by_name_v2 = 71
     */
    additionalFeesByNameV2: {
        [key: string]: Sale_Totals_AdditionalFee;
    }; // returns only
    /**
     * @generated from protobuf field: map<string, rd.txn.Sale.ItemSet> item_sets_by_id = 72
     */
    itemSetsById: {
        [key: string]: Sale_ItemSet;
    };
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID designated_clerk_id = 73
     */
    designatedClerkId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tax_rate_ids = 74
     */
    taxRateIds: UUID[]; // being backfilled
    /**
     * @generated from protobuf field: map<string, rd.proto.decimal.Decimal> tax_rate_by_tax_rate_id = 75
     */
    taxRateByTaxRateId: {
        [key: string]: Decimal;
    }; // being backfilled
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> surcharge_tax_by_tax_rate_id = 76
     */
    surchargeTaxByTaxRateId: {
        [key: string]: Money;
    }; // being backfilled
    /**
     * @generated from protobuf field: bool is_staged_for_delivery = 77
     */
    isStagedForDelivery: boolean; // True when the sale has a stop waiting to be routed.
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal initial_deposit_rate = 79
     */
    initialDepositRate?: Decimal; // rate from 0-1; nil for a flat initial deposit
    /**
     * @generated from protobuf field: map<string, rd.txn.Sale.TaxComponents> tax_components_by_tax_rate_id = 80
     */
    taxComponentsByTaxRateId: {
        [key: string]: Sale_TaxComponents;
    };
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_type_id = 81
     */
    saleTypeId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tag_ids = 82
     */
    tagIds: UUID[];
}
/**
 * SpecialOrderSale is populated on sales with non-stock products. Since each
 * non-stock product will be included in its own sale, the link_id will be
 * used to track all sales associated with the same transaction - the
 * transaction being the original sale of the non-stock products. This will
 * be useful for printing a condensed receipt with all products from all
 * linked sales.
 *
 * @generated from protobuf message rd.txn.Sale.SpecialOrderSale
 */
export interface Sale_SpecialOrderSale {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID link_id = 1
     */
    linkId?: UUID;
}
/**
 * @generated from protobuf message rd.txn.Sale.Totals
 */
export interface Sale_Totals {
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal tax_rate = 1
     */
    taxRate?: Decimal; // being deprecated
    /**
     * @generated from protobuf field: rd.proto.money.Money subtotal = 2
     */
    subtotal?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money base_sales_tax = 4
     */
    baseSalesTax?: Money; // being deprecated
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge = 5
     */
    cardSurcharge?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge_tax = 6
     */
    cardSurchargeTax?: Money; // being deprecated
    /**
     * @generated from protobuf field: rd.proto.money.Money rounding_adjustment = 7
     */
    roundingAdjustment?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money restock_fee = 8
     */
    restockFee?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 9
     */
    total?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money early_payment_discount_adjustment = 10
     */
    earlyPaymentDiscountAdjustment?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money discount_applied = 11
     */
    discountApplied?: Money; // negative
    /**
     * rate from 0-1; can be nil if discount is applied as an amount only
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal discount_rate = 12
     */
    discountRate?: Decimal;
    /**
     * @generated from protobuf field: map<string, rd.txn.Sale.Totals.Tax> taxes_by_tax_rate_id = 13
     */
    taxesByTaxRateId: {
        [key: string]: Sale_Totals_Tax;
    };
    /**
     * @generated from protobuf field: map<string, rd.txn.Sale.Totals.AdditionalFee> additional_fees_by_name_v2 = 14
     */
    additionalFeesByNameV2: {
        [key: string]: Sale_Totals_AdditionalFee;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money cash_rounding_delta = 15
     */
    cashRoundingDelta?: Money;
}
/**
 * @generated from protobuf message rd.txn.Sale.Totals.Tax
 */
export interface Sale_Totals_Tax {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal rate = 2
     */
    rate?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.Money base_tax = 3
     */
    baseTax?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money surcharge_tax = 4
     */
    surchargeTax?: Money;
    /**
     * @generated from protobuf field: repeated rd.company.TaxComponent tax_components = 5
     */
    taxComponents: TaxComponent[];
}
/**
 * @generated from protobuf message rd.txn.Sale.Totals.AdditionalFee
 */
export interface Sale_Totals_AdditionalFee {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money amount = 2
     */
    amount?: Money;
    /**
     * @generated from protobuf field: string fee_id = 3
     */
    feeId: string;
}
/**
 * ItemSet is a named grouping of line items within this sale
 *
 * @generated from protobuf message rd.txn.Sale.ItemSet
 */
export interface Sale_ItemSet {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: int32 position = 3
     */
    position: number; // 1-indexed
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID sale_product_ids = 4
     */
    saleProductIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID sale_kit_ids = 5
     */
    saleKitIds: UUID[];
}
/**
 * @generated from protobuf message rd.txn.Sale.TaxComponents
 */
export interface Sale_TaxComponents {
    /**
     * @generated from protobuf field: repeated rd.company.TaxComponent components = 1
     */
    components: TaxComponent[];
}
/**
 * @generated from protobuf enum rd.txn.Sale.Status
 */
export enum Sale_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATUS_CREATED = 1;
     */
    CREATED = 1,
    /**
     * @generated from protobuf enum value: STATUS_QUOTED = 2;
     */
    QUOTED = 2,
    /**
     * @generated from protobuf enum value: STATUS_WILL_CALLED = 3;
     */
    WILL_CALLED = 3,
    /**
     * @generated from protobuf enum value: STATUS_VOIDED = 4;
     */
    VOIDED = 4,
    /**
     * RETURNED for returns
     *
     * @generated from protobuf enum value: STATUS_SOLD = 5;
     */
    SOLD = 5,
    /**
     * @generated from protobuf enum value: STATUS_PAID = 6;
     */
    PAID = 6,
    /**
     * used for tracking non-stock product sales and linked orders
     *
     * @generated from protobuf enum value: STATUS_SPECIAL_ORDER = 7;
     */
    SPECIAL_ORDER = 7
}
/**
 * @generated from protobuf enum rd.txn.Sale.Type
 */
export enum Sale_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_SALE = 1;
     */
    SALE = 1,
    /**
     * @generated from protobuf enum value: TYPE_RETURN = 2;
     */
    RETURN = 2
}
/**
 * represents whether a special order sale is fully closed out from or not in the partial closeout
 * world
 *
 * @generated from protobuf enum rd.txn.Sale.CloseOutStatus
 */
export enum Sale_CloseOutStatus {
    /**
     * @generated from protobuf enum value: CLOSE_OUT_STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: CLOSE_OUT_STATUS_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: CLOSE_OUT_STATUS_FULL = 2;
     */
    FULL = 2
}
/**
 * @generated from protobuf enum rd.txn.Sale.Source
 */
export enum Sale_Source {
    /**
     * @generated from protobuf enum value: SOURCE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: SOURCE_POS = 1;
     */
    POS = 1,
    /**
     * @generated from protobuf enum value: SOURCE_ECOMM = 2;
     */
    ECOMM = 2
}
/**
 * SaleLog represents a change of a Sale.
 *
 * @generated from protobuf message rd.txn.SaleLog
 */
export interface SaleLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 3
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.txn.Sale sale = 4
     */
    sale?: Sale;
}
/**
 * DepositConfig is the user's deposit intent, which the backend resolves into
 * an initial deposit against the deposit basis
 * Behind generalized deposits close outs flag, this simply describes a percentage or flat initial
 * deposit amount.
 *
 * @generated from protobuf message rd.txn.DepositConfig
 */
export interface DepositConfig {
    /**
     * @generated from protobuf oneof: value
     */
    value: {
        oneofKind: "percentage";
        /**
         * @generated from protobuf field: rd.proto.decimal.Decimal percentage = 1
         */
        percentage: Decimal; // fraction between 0-1
    } | {
        oneofKind: "flatAmount";
        /**
         * @generated from protobuf field: rd.proto.money.Money flat_amount = 2
         */
        flatAmount: Money;
    } | {
        oneofKind: undefined;
    };
}
/**
 * InitialDepositIntent represents the user's explicit selections used to resolve the
 * initial deposit.
 *
 * @generated from protobuf message rd.txn.InitialDepositIntent
 */
export interface InitialDepositIntent {
    /**
     * @generated from protobuf field: rd.txn.InitialDepositIntent.Mode mode = 1
     */
    mode: InitialDepositIntent_Mode;
    /**
     * set only when the user entered an explicit value for deposit
     *
     * @generated from protobuf field: rd.txn.DepositConfig deposit_config = 2
     */
    depositConfig?: DepositConfig;
}
/**
 * @generated from protobuf enum rd.txn.InitialDepositIntent.Mode
 */
export enum InitialDepositIntent_Mode {
    /**
     * @generated from protobuf enum value: MODE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: MODE_NO_DEPOSIT = 1;
     */
    NO_DEPOSIT = 1,
    /**
     * @generated from protobuf enum value: MODE_INITIAL_DEPOSIT = 2;
     */
    INITIAL_DEPOSIT = 2
}
/**
 * SaleProduct represents a product that has been sold as part of a sale
 * from a company to a customer. The is_active field being false indicates the
 * the product was removed from a non-terminal sale. The created_at, sold_at,
 * and location_id are particularly useful for simplifying the product sales
 * analytics query.
 *
 * @generated from protobuf message rd.txn.SaleProduct
 */
export interface SaleProduct {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 2
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 3
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 5
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID tint_color_id = 6
     */
    tintColorId?: UUID;
    /**
     * Deprecated: use SaleProduct.GetEffectivePriceFractional().
     *
     * @deprecated
     * @generated from protobuf field: rd.proto.money.Money price = 9 [deprecated = true]
     */
    price?: Money; // per item
    /**
     * @generated from protobuf field: string notes = 12
     */
    notes: string;
    /**
     * @generated from protobuf field: string custom_tint_color = 13
     */
    customTintColor: string;
    /**
     * @generated from protobuf field: int32 position = 14
     */
    position: number; // 1-indexed
    /**
     * @generated from protobuf field: bool is_price_edited = 15
     */
    isPriceEdited: boolean;
    /**
     * @generated from protobuf field: rd.proto.money.Money tier_1_price = 16
     */
    tier1Price?: Money; // per item
    /**
     * @generated from protobuf field: bool is_taxed = 17
     */
    isTaxed: boolean;
    /**
     * additional_fees[].is_taxed
     *
     * @generated from protobuf field: rd.proto.uuid.UUID colorx_tinted_product_id = 19
     */
    colorxTintedProductId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost_v2 = 20
     */
    costV2?: FractionalMoney; // per item
    /**
     * @generated from protobuf field: bool is_active = 21
     */
    isActive: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 22
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 23
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sold_at = 24
     */
    soldAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 25
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: bool is_cost_edited = 26
     */
    isCostEdited: boolean;
    /**
     * @generated from protobuf field: bool is_non_stock = 28
     */
    isNonStock: boolean;
    /**
     * Deprecated: use SaleProduct.GetEffectiveExpectedPriceFractional().
     *
     * @deprecated
     * @generated from protobuf field: rd.proto.money.Money expected_price = 29 [deprecated = true]
     */
    expectedPrice?: Money; // price had it not been edited for price edits report
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney standard_cost = 30
     */
    standardCost?: FractionalMoney; // per item
    /**
     * @generated from protobuf field: rd.txn.SaleProduct.Type type = 32
     */
    type: SaleProduct_Type;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID returned_from_sale_id = 33
     */
    returnedFromSaleId?: UUID; // returns only
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID returned_from_sale_product_id = 34
     */
    returnedFromSaleProductId?: UUID; // returns only
    /**
     * @generated from protobuf field: repeated rd.company.SaleForm.CustomField custom_fields = 35
     */
    customFields: SaleForm_CustomField[];
    /**
     * @generated from protobuf field: bool is_special_orderable_v2 = 36
     */
    isSpecialOrderableV2: boolean;
    /**
     * @generated from protobuf field: string internal_notes = 38
     */
    internalNotes: string;
    /**
     * QuantityV2 is the sold quantity for sale products of type sale and unused for sale products of
     * type return
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_v2 = 39
     */
    quantityV2?: Decimal;
    /**
     * QuantityReturnedV2 is the total number of items returned for a sale product of type sale and
     * the number of products returned for a particular return for a sale product of type return
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_returned_v2 = 40
     */
    quantityReturnedV2?: Decimal;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp voided_at = 41
     */
    voidedAt?: Timestamp;
    /**
     * @generated from protobuf field: bool is_taxed_edited = 51
     */
    isTaxedEdited: boolean;
    /**
     * Quantity with Unit of Measure information
     *
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 42
     */
    uomId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_uom = 43
     */
    quantityUom?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id_returned = 44
     */
    uomIdReturned?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_returned_uom = 45
     */
    quantityReturnedUom?: Decimal;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 46
     */
    uomSnapshot?: LedgerEntry_UomSnapshot;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.UomSnapshot uom_snapshot_returned = 47
     */
    uomSnapshotReturned?: LedgerEntry_UomSnapshot;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID spiff_ids = 48
     */
    spiffIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID gift_card_id = 49
     */
    giftCardId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.Money gift_card_initial_balance = 50
     */
    giftCardInitialBalance?: Money;
    /**
     * @generated from protobuf field: repeated rd.txn.SaleProduct.CCPRebate ccp_rebates = 52
     */
    ccpRebates: SaleProduct_CCPRebate[];
    /**
     * All orders and shipments that have a product associated with this sale product
     *
     * @generated from protobuf field: repeated rd.proto.uuid.UUID order_ids = 53
     */
    orderIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID shipment_ids = 54
     */
    shipmentIds: UUID[];
    /**
     * @generated from protobuf field: bool is_active_in_buyers_list = 55
     */
    isActiveInBuyersList: boolean;
    /**
     * Backlink to parent sale product for special order closeouts
     *
     * @generated from protobuf field: rd.proto.uuid.UUID closed_out_from_sale_product_id = 56
     */
    closedOutFromSaleProductId?: UUID;
    /**
     * additional_fees supersedes the singular additional_fee_name (10) and
     * additional_fee_v2 (27). During the rollout window both are populated.
     *
     * @generated from protobuf field: repeated rd.txn.SaleProduct.AdditionalFee additional_fees = 57
     */
    additionalFees: SaleProduct_AdditionalFee[];
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney price_fractional = 59
     */
    priceFractional?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney expected_price_fractional = 60
     */
    expectedPriceFractional?: FractionalMoney;
    /**
     * Snapshot of price rule candidates when priced; absent for old or edited-price sales.
     *
     * @generated from protobuf field: rd.price.RuleInformation rule_information = 61
     */
    ruleInformation?: RuleInformation;
    /**
     * @generated from protobuf field: repeated rd.txn.SaleProduct.TallyRow tally_rows = 62
     */
    tallyRows: SaleProduct_TallyRow[];
    /**
     * Snapshot of the product's tally dimension when tally_rows were entered
     *
     * @generated from protobuf field: rd.product.Product.TallyDimension tally_dimension = 63
     */
    tallyDimension: Product_TallyDimension;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_kit_id = 64
     */
    saleKitId?: UUID; // set when this line is part of a kit
    /**
     * @generated from protobuf field: int32 tally_entry_denominator = 65
     */
    tallyEntryDenominator: number;
}
/**
 * @generated from protobuf message rd.txn.SaleProduct.CCPRebate
 */
export interface SaleProduct_CCPRebate {
    /**
     * @generated from protobuf field: string credit_issue_date = 1
     */
    creditIssueDate: string;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney total_rebate = 2
     */
    totalRebate?: FractionalMoney;
    /**
     * @generated from protobuf field: string credit_number = 3
     */
    creditNumber: string;
}
/**
 * AdditionalFee is a per-line snapshot of an additional fee applied to
 * this sale product. unit_fee is at full FractionalMoney precision so
 * rollups can accumulate (unit_fee × quantity) across all lines for a
 * given fee name and round each name's total to Money once at the
 * transaction level. Each fee name rounds independently because each
 * represents its own line item; rounding any earlier compounds error.
 *
 * @generated from protobuf message rd.txn.SaleProduct.AdditionalFee
 */
export interface SaleProduct_AdditionalFee {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney unit_fee = 2
     */
    unitFee?: FractionalMoney;
    /**
     * @generated from protobuf field: bool is_taxed = 3
     */
    isTaxed: boolean;
    /**
     * @generated from protobuf field: string fee_id = 4
     */
    feeId: string;
    /**
     * if true, the additional fee is not applied to this sale product and thus the sale total
     *
     * @generated from protobuf field: bool is_disabled = 5
     */
    isDisabled: boolean;
    /**
     * if true, unit_fee came from the pricing engine and is kept as-is on
     * reprice instead of being recomputed from the company fee config
     *
     * @generated from protobuf field: bool is_fee_overriden = 6
     */
    isFeeOverriden: boolean;
}
/**
 * TallyRow is one row of the tally calculator in the line's selling unit of measure.
 *
 * @generated from protobuf message rd.txn.SaleProduct.TallyRow
 */
export interface SaleProduct_TallyRow {
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity = 1
     */
    quantity?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal length = 2
     */
    length?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal width = 3
     */
    width?: Decimal;
}
/**
 * @generated from protobuf enum rd.txn.SaleProduct.Type
 */
export enum SaleProduct_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_SALE = 1;
     */
    SALE = 1,
    /**
     * @generated from protobuf enum value: TYPE_RETURN = 2;
     */
    RETURN = 2,
    /**
     * @generated from protobuf enum value: TYPE_UNLINKED_RETURN = 3;
     */
    UNLINKED_RETURN = 3
}
/**
 * SaleProductLog represents a change to a SaleProduct.
 *
 * @generated from protobuf message rd.txn.SaleProductLog
 */
export interface SaleProductLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 3
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.txn.SaleProduct sale_product = 4
     */
    saleProduct?: SaleProduct;
}
/**
 * SaleKit is a sale time instance of a Kit.
 * The recipe is derived from the component SaleProducts and the kit quantity.
 *
 * @generated from protobuf message rd.txn.SaleKit
 */
export interface SaleKit {
    /**
     * Generic Fields
     *
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID kit_product_id = 2
     */
    kitProductId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 3
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: int32 position = 5
     */
    position: number; // 1-indexed, shared space with SaleProduct.position
    /**
     * @generated from protobuf field: bool is_active = 6
     */
    isActive: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 7
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 8
     */
    updatedAt?: Timestamp;
    /**
     * Fields for Sales
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity = 9
     */
    quantity?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney price = 10
     */
    price?: FractionalMoney; // per kit
    /**
     * @generated from protobuf field: bool is_price_edited = 11
     */
    isPriceEdited: boolean;
    /**
     * @generated from protobuf field: string notes = 12
     */
    notes: string;
    /**
     * @generated from protobuf field: string internal_notes = 13
     */
    internalNotes: string;
    /**
     * @generated from protobuf field: repeated rd.company.SaleForm.CustomField custom_fields = 14
     */
    customFields: SaleForm_CustomField[];
    /**
     * Fields for Reporting
     *
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 15
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sold_at = 16
     */
    soldAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp voided_at = 17
     */
    voidedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost = 18
     */
    cost?: FractionalMoney; // per kit
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney standard_cost = 19
     */
    standardCost?: FractionalMoney; // per kit
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney expected_price = 20
     */
    expectedPrice?: FractionalMoney; // per kit
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 21
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.Money tier_1_price = 22
     */
    tier1Price?: Money; // per kit
    /**
     * @generated from protobuf field: rd.product.Kit.CustomerViewType customer_view_type = 23
     */
    customerViewType: Kit_CustomerViewType; // the kit's setting when sold
}
/**
 * SalePDFData represents the data required to fill the html
 * template for a sale
 *
 * @generated from protobuf message rd.txn.SalePDFData
 */
export interface SalePDFData {
    /**
     * @generated from protobuf field: string identifier = 1
     */
    identifier: string;
    /**
     * @generated from protobuf field: rd.txn.Sale sale = 2
     */
    sale?: Sale;
    /**
     * @generated from protobuf field: string title = 3
     */
    title: string;
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 4
     */
    customer?: Customer;
    /**
     * @generated from protobuf field: rd.customer.Contacts.Contact primary_contact = 5
     */
    primaryContact?: Contacts_Contact;
    /**
     * @generated from protobuf field: rd.user.User last_action_staff = 6
     */
    lastActionStaff?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_action_time = 7
     */
    lastActionTime?: Timestamp;
    /**
     * @generated from protobuf field: rd.customer.PurchaseOrder purchase_order = 8
     */
    purchaseOrder?: PurchaseOrder;
    /**
     * @generated from protobuf field: rd.company.Company company = 10
     */
    company?: Company;
    /**
     * @generated from protobuf field: rd.company.Location location = 11
     */
    location?: Location;
    /**
     * @generated from protobuf field: repeated rd.txn.SalePDFData.Product products = 12
     */
    products: SalePDFData_Product[];
    /**
     * @generated from protobuf field: rd.proto.money.Money sub_total = 14
     */
    subTotal?: Money;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> fee_totals_by_name = 15
     */
    feeTotalsByName: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money sales_tax_total = 16
     */
    salesTaxTotal?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 17
     */
    total?: Money;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp due_at = 18
     */
    dueAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money remaining_balance = 19
     */
    remainingBalance?: Money;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 20
     */
    expiresAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.customer.Contacts.Contact customer_contact = 21
     */
    customerContact?: Contacts_Contact;
    /**
     * @generated from protobuf field: bool show_signature_line = 27
     */
    showSignatureLine: boolean;
    /**
     * @generated from protobuf field: rd.proto.money.Money bill_payments_total = 30
     */
    billPaymentsTotal?: Money;
    /**
     * @generated from protobuf field: rd.company.TaxRate tax_rate = 31
     */
    taxRate?: TaxRate;
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge = 33
     */
    cardSurcharge?: Money;
    /**
     * @generated from protobuf field: string card_surcharge_rate_string = 34
     */
    cardSurchargeRateString: string;
    /**
     * @generated from protobuf field: repeated rd.payments.CardPaymentReceiptInfo receipt_info = 35
     */
    receiptInfo: CardPaymentReceiptInfo[];
    /**
     * @generated from protobuf field: rd.pdf.Barcode barcode = 36
     */
    barcode?: Barcode;
    /**
     * @generated from protobuf field: bool show_prices = 37
     */
    showPrices: boolean;
    /**
     * @generated from protobuf field: rd.customer.Customer job = 38
     */
    job?: Customer;
    /**
     * @generated from protobuf field: rd.proto.money.Money total_discounts = 40
     */
    totalDiscounts?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money total_additional_fees = 41
     */
    totalAdditionalFees?: Money;
    /**
     * @generated from protobuf field: bool show_discounts = 43
     */
    showDiscounts: boolean;
    /**
     * @generated from protobuf field: string signature_url = 44
     */
    signatureUrl: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money restock_fee = 45
     */
    restockFee?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money subtotal_discount_applied = 46
     */
    subtotalDiscountApplied?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal subtotal_discount_rate = 47
     */
    subtotalDiscountRate?: Decimal;
    /**
     * @generated from protobuf field: rd.ledger.ReceiptPurchaseMethods purchase_methods = 56
     */
    purchaseMethods?: ReceiptPurchaseMethods;
    /**
     * @generated from protobuf field: rd.proto.money.Money cash_rounding_delta = 57
     */
    cashRoundingDelta?: Money;
    /**
     * @generated from protobuf field: repeated rd.txn.AppliedCoupon coupons = 58
     */
    coupons: AppliedCoupon[];
}
/**
 * @generated from protobuf message rd.txn.SalePDFData.Product
 */
export interface SalePDFData_Product {
    /**
     * @generated from protobuf field: string identifier = 1
     */
    identifier: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: rd.tintcolor.TintColor tint_color = 4
     */
    tintColor?: TintColor;
    /**
     * @generated from protobuf field: rd.proto.money.Money sub_total = 5
     */
    subTotal?: Money;
    /**
     * @generated from protobuf field: string custom_tint_color = 9
     */
    customTintColor: string;
    /**
     * @generated from protobuf field: string notes = 10
     */
    notes: string;
    /**
     * @generated from protobuf field: string price = 12
     */
    price: string;
    /**
     * @generated from protobuf field: bool show_discount = 13
     */
    showDiscount: boolean;
    /**
     * @generated from protobuf field: string tier_1_price = 14
     */
    tier1Price: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money discount = 18
     */
    discount?: Money;
    /**
     * @generated from protobuf field: bool override_tier_1_price = 21
     */
    overrideTier1Price: boolean;
    /**
     * @generated from protobuf field: string original_sale_identifier = 22
     */
    originalSaleIdentifier: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_v2 = 23
     */
    quantityV2?: Decimal;
    /**
     * Quantity with Unit of Measure information
     *
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 24
     */
    uomId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_uom = 25
     */
    quantityUom?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id_returned = 26
     */
    uomIdReturned?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_returned_uom = 27
     */
    quantityReturnedUom?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal discount_percentage = 28
     */
    discountPercentage?: Decimal;
    /**
     * @generated from protobuf field: bool show_discount_percentage = 29
     */
    showDiscountPercentage: boolean;
    /**
     * UOM snapshot information
     *
     * @generated from protobuf field: rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 30
     */
    uomSnapshot?: LedgerEntry_UomSnapshot;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.UomSnapshot uom_snapshot_returned = 31
     */
    uomSnapshotReturned?: LedgerEntry_UomSnapshot;
    /**
     * @generated from protobuf field: string non_taxable_display = 32
     */
    nonTaxableDisplay: string;
    /**
     * Gift card overwritten balance is only set for gift cards and is the overwritten balance of
     * the gift card
     *
     * @generated from protobuf field: string gift_card_overwritten_balance = 33
     */
    giftCardOverwrittenBalance: string;
    /**
     * ItemSetId is the id of the item set this product belongs to, or unset if ungrouped.
     *
     * @generated from protobuf field: rd.proto.uuid.UUID item_set_id = 34
     */
    itemSetId?: UUID;
    /**
     * TallyDisplay is the line's tally breakdown
     *
     * @generated from protobuf field: string tally_display = 35
     */
    tallyDisplay: string;
    /**
     * SaleId and Position order rows like the cart: by sale, then by position within the sale.
     *
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 36
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: int32 position = 37
     */
    position: number;
}
/**
 * TotalsInfo contains totals for a category of products (stock or special order)
 *
 * @generated from protobuf message rd.txn.SalePDFData.TotalsInfo
 */
export interface SalePDFData_TotalsInfo {
    /**
     * @generated from protobuf field: rd.proto.money.Money subtotal = 1
     */
    subtotal?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money sales_tax = 2
     */
    salesTax?: Money;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> fees_by_name = 3
     */
    feesByName: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 4
     */
    total?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge_total = 5
     */
    cardSurchargeTotal?: Money; // includes card surcharge tax
    /**
     * @generated from protobuf field: rd.txn.SaleTaxes sale_taxes = 7
     */
    saleTaxes?: SaleTaxes; // only used when FLAG_TXN_MULTI_TAX is enabled
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge = 8
     */
    cardSurcharge?: Money; // only used when FLAG_TXN_MULTI_TAX is enabled
    /**
     * @generated from protobuf field: rd.proto.money.Money restock_fee = 9
     */
    restockFee?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money discount_applied = 10
     */
    discountApplied?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money cash_rounding_delta = 11
     */
    cashRoundingDelta?: Money;
}
/**
 * @generated from protobuf message rd.txn.AppliedCoupon
 */
export interface AppliedCoupon {
    /**
     * @generated from protobuf field: string coupon_code = 1
     */
    couponCode: string;
    /**
     * The rule, for a coupon whose worth is not obvious from the amount alone: "15% off" for a
     * percentage coupon, empty for a fixed one.
     *
     * @generated from protobuf field: string rule = 2
     */
    rule: string;
    /**
     * What the coupon actually took off this sale, which is not its face value when the cart capped
     * it or a manual discount got there first.
     *
     * @generated from protobuf field: rd.proto.money.Money amount = 3
     */
    amount?: Money;
}
/**
 * Order represents a purchase order or "PO" placed by
 * a supplier to order more inventory from a vendor.
 *
 * @generated from protobuf message rd.txn.Order
 */
export interface Order {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 4
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.user.User ordered_by = 5
     */
    orderedBy?: User;
    /**
     * @generated from protobuf field: rd.user.User received_by = 6
     */
    receivedBy?: User;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 7
     */
    updatedBy?: User;
    /**
     * @generated from protobuf field: rd.user.User voided_by = 8
     */
    voidedBy?: User;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 9
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 10
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 11
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp requested_delivery_at = 12
     */
    requestedDeliveryAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp ordered_at = 13
     */
    orderedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp received_at = 14
     */
    receivedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp voided_at = 15
     */
    voidedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.txn.Order.Status status = 16
     */
    status: Order_Status;
    /**
     * @generated from protobuf field: string identifier = 17
     */
    identifier: string;
    /**
     * @generated from protobuf field: string order_notes = 18
     */
    orderNotes: string;
    /**
     * @generated from protobuf field: string internal_notes = 19
     */
    internalNotes: string;
    /**
     * @generated from protobuf field: rd.txn.Order.Method method = 21
     */
    method: Order_Method;
    /**
     * @generated from protobuf field: repeated rd.txn.Order.Product products = 27
     */
    products: Order_Product[];
    /**
     * @generated from protobuf field: rd.txn.InvoiceDetails invoice_details = 28
     */
    invoiceDetails?: InvoiceDetails;
    /**
     * @generated from protobuf field: rd.proto.address.Address dropship_address = 29
     */
    dropshipAddress?: Address;
    /**
     * @generated from protobuf field: string dropship_recipient = 30
     */
    dropshipRecipient: string;
    /**
     * @generated from protobuf field: rd.integrations.x12.AcknowledgeCode acknowledgment = 31
     */
    acknowledgment: AcknowledgeCode;
    /**
     * @generated from protobuf field: string promo_code = 32
     */
    promoCode: string;
    /**
     * @generated from protobuf field: repeated rd.txn.CostAdjustment cost_adjustments = 33
     */
    costAdjustments: CostAdjustment[];
}
/**
 * @generated from protobuf message rd.txn.Order.Product
 */
export interface Order_Product {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 1
     */
    productId?: UUID;
    /**
     * additional_fees_when_received[].unit_fee
     *
     * @generated from protobuf field: int32 position = 6
     */
    position: number;
    /**
     * @generated from protobuf field: string notes = 7
     */
    notes: string;
    /**
     * additional_fees_when_received[].name
     *
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost_v2 = 9
     */
    costV2?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 10
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 11
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: string sale_identifier = 12
     */
    saleIdentifier: string;
    /**
     * @generated from protobuf field: repeated rd.company.SaleForm.CustomField custom_fields = 35
     */
    customFields: SaleForm_CustomField[];
    /**
     * @generated from protobuf field: bool is_special_order = 14
     */
    isSpecialOrder: boolean; // for inventory ledger entries
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_ordered_v2 = 15
     */
    quantityOrderedV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_received_v2 = 16
     */
    quantityReceivedV2?: Decimal;
    /**
     * @generated from protobuf field: string reasoning_notes = 17
     */
    reasoningNotes: string; // for storing reasoning notes from LLMs
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_product_id = 18
     */
    saleProductId?: UUID;
    /**
     * Quantity with Unit of Measure information
     *
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 36
     */
    uomId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_ordered_uom = 37
     */
    quantityOrderedUom?: Decimal;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 39
     */
    uomSnapshot?: LedgerEntry_UomSnapshot;
    /**
     * @generated from protobuf field: bool is_cost_overridden = 40
     */
    isCostOverridden: boolean;
    /**
     * additional_fees_when_received supersedes the singular
     * additional_fee_when_received (5) and additional_fee_name_when_received
     * (8). Both are populated during the rollout window.
     *
     * @generated from protobuf field: repeated rd.txn.Order.Product.AdditionalFee additional_fees_when_received = 41
     */
    additionalFeesWhenReceived: Order_Product_AdditionalFee[];
    /**
     * quantity_staged_received is a saved draft of the quantity to receive
     * on the next shipment. It has no inventory impact and is
     * cleared when a shipment is received.
     *
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_staged_received = 42
     */
    quantityStagedReceived?: Decimal;
}
/**
 * AdditionalFee is a per-line snapshot of an additional fee applied
 * at receive time. unit_fee is at full FractionalMoney precision so
 * rollups can accumulate (unit_fee × quantity) across all lines for
 * a given fee name and round each name's total to Money once at the
 * transaction level. Each fee name rounds independently because each
 * represents its own line item; rounding any earlier compounds error.
 *
 * @generated from protobuf message rd.txn.Order.Product.AdditionalFee
 */
export interface Order_Product_AdditionalFee {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney unit_fee = 2
     */
    unitFee?: FractionalMoney;
    /**
     * @generated from protobuf field: string fee_id = 3
     */
    feeId: string;
}
/**
 * @generated from protobuf enum rd.txn.Order.Status
 */
export enum Order_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATUS_CREATED = 1;
     */
    CREATED = 1,
    /**
     * @generated from protobuf enum value: STATUS_ORDERED = 2;
     */
    ORDERED = 2,
    /**
     * @generated from protobuf enum value: STATUS_RECEIVED = 3;
     */
    RECEIVED = 3,
    /**
     * @generated from protobuf enum value: STATUS_VOIDED = 4;
     */
    VOIDED = 4
}
/**
 * @generated from protobuf enum rd.txn.Order.Method
 */
export enum Order_Method {
    /**
     * @generated from protobuf enum value: METHOD_EMAIL = 0;
     */
    EMAIL = 0,
    /**
     * @generated from protobuf enum value: METHOD_EDI = 1;
     */
    EDI = 1,
    /**
     * @generated from protobuf enum value: METHOD_NONE = 2;
     */
    NONE = 2
}
/**
 * OrderLog represents a change of an Order.
 *
 * @generated from protobuf message rd.txn.OrderLog
 */
export interface OrderLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 3
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.txn.Order order = 4
     */
    order?: Order;
}
/**
 * OrderProductFilter narrows a vendor's products before order quantities are
 * calculated by the order generation flows. An unset field does not filter.
 *
 * @generated from protobuf message rd.txn.OrderProductFilter
 */
export interface OrderProductFilter {
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID department_ids = 1
     */
    departmentIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID class_ids = 2
     */
    classIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID fineline_ids = 3
     */
    finelineIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID tag_ids = 4
     */
    tagIds: UUID[];
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange last_sale_range = 5
     */
    lastSaleRange?: TimestampRange;
}
/**
 * CostAdjustment can either be a fee or discount
 *
 * @generated from protobuf message rd.txn.CostAdjustment
 */
export interface CostAdjustment {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID chart_of_account_id = 1
     */
    chartOfAccountId?: UUID;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money amount = 3
     */
    amount?: Money; // fee always (+) and discount always (-)
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 5
     */
    id?: UUID; // revives field 4's id, as a new field
    /**
     * @generated from protobuf field: rd.txn.CostAdjustment.DistributionMethod distribution_method = 6
     */
    distributionMethod: CostAdjustment_DistributionMethod;
}
/**
 * @generated from protobuf enum rd.txn.CostAdjustment.DistributionMethod
 */
export enum CostAdjustment_DistributionMethod {
    /**
     * never explicitly set - historical records fall back on this
     *
     * @generated from protobuf enum value: DISTRIBUTION_METHOD_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * explicitly chose not to distribute (default)
     *
     * @generated from protobuf enum value: DISTRIBUTION_METHOD_NOT_DISTRIBUTED = 1;
     */
    NOT_DISTRIBUTED = 1,
    /**
     * @generated from protobuf enum value: DISTRIBUTION_METHOD_BY_QUANTITY = 2;
     */
    BY_QUANTITY = 2,
    /**
     * @generated from protobuf enum value: DISTRIBUTION_METHOD_BY_SUBTOTAL = 3;
     */
    BY_SUBTOTAL = 3
}
/**
 * OrderShipment represents a partial or
 * full shipment of a purchase order.
 *
 * @generated from protobuf message rd.txn.OrderShipment
 */
export interface OrderShipment {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_id = 2
     */
    orderId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 3
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 5
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp received_at = 8
     */
    receivedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User received_by = 9
     */
    receivedBy?: User;
    /**
     * @generated from protobuf field: string notes = 10
     */
    notes: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 11
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: string identifier = 12
     */
    identifier: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 13
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.txn.CostAdjustment cost_adjustments = 14
     */
    costAdjustments: CostAdjustment[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID financial_transaction_id = 15
     */
    financialTransactionId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID external_transaction_id = 16
     */
    externalTransactionId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp marked_paid_at = 17
     */
    markedPaidAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User marked_paid_by = 18
     */
    markedPaidBy?: User;
    /**
     * @generated from protobuf field: rd.txn.OrderShipment.Status status = 19
     */
    status: OrderShipment_Status;
    /**
     * @generated from protobuf field: string pay_to = 20
     */
    payTo: string;
    /**
     * @generated from protobuf field: rd.txn.InvoiceDetails invoice_details = 21
     */
    invoiceDetails?: InvoiceDetails;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp vouchered_at = 22
     */
    voucheredAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User vouchered_by = 23
     */
    voucheredBy?: User;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 24
     */
    updatedBy?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 25
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: repeated rd.txn.OrderShipment.Product products = 26
     */
    products: OrderShipment_Product[];
    /**
     * @generated from protobuf field: rd.proto.address.Address dropship_address = 27
     */
    dropshipAddress?: Address;
    /**
     * @generated from protobuf field: string dropship_recipient = 28
     */
    dropshipRecipient: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal total_received_v2 = 29
     */
    totalReceivedV2?: Decimal;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp scheduled_delivery_at = 31
     */
    scheduledDeliveryAt?: Timestamp;
}
/**
 * @generated from protobuf message rd.txn.OrderShipment.Product
 */
export interface OrderShipment_Product {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 1
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: int32 position = 6
     */
    position: number;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost_v2 = 7
     */
    costV2?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 8
     */
    id?: UUID; // this is the same ID as the corresponding Order_Product ID
    /**
     * @generated from protobuf field: repeated rd.company.SaleForm.CustomField custom_fields = 35
     */
    customFields: SaleForm_CustomField[];
    /**
     * @generated from protobuf field: bool is_special_order = 10
     */
    isSpecialOrder: boolean; // for inventory ledger entries
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_received_v2 = 12
     */
    quantityReceivedV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_shipped_v2 = 14
     */
    quantityShippedV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_product_id = 15
     */
    saleProductId?: UUID;
    /**
     * Quantity with Unit of Measure information
     *
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 36
     */
    uomId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_shipped_uom = 37
     */
    quantityShippedUom?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_received_uom = 38
     */
    quantityReceivedUom?: Decimal;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 39
     */
    uomSnapshot?: LedgerEntry_UomSnapshot;
    /**
     * additional_fees supersedes the singular additional_fee_name (4) and
     * additional_fee_amount (5). Both are populated during the rollout window.
     *
     * @generated from protobuf field: repeated rd.txn.OrderShipment.Product.AdditionalFee additional_fees = 40
     */
    additionalFees: OrderShipment_Product_AdditionalFee[];
    /**
     * Snapshotted from the originating Order_Product at shipment creation
     * so the historical record stays stable if the order is later edited.
     *
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 41
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: string sale_identifier = 42
     */
    saleIdentifier: string;
    /**
     * distributed_costs maps a distributed CostAdjustment.id to this line's per-unit share.
     * Names aren't snapshotted - look them up from CostAdjustments.
     *
     * @generated from protobuf field: map<string, rd.proto.money.FractionalMoney> distributed_costs = 43
     */
    distributedCosts: {
        [key: string]: FractionalMoney;
    };
}
/**
 * AdditionalFee is a per-line snapshot of an additional fee applied
 * to this shipment line. unit_fee is at full FractionalMoney
 * precision so rollups can accumulate (unit_fee × quantity) across
 * all lines for a given fee name and round each name's total to
 * Money once at the transaction level. Each fee name rounds
 * independently because each represents its own line item; rounding
 * any earlier compounds error.
 *
 * @generated from protobuf message rd.txn.OrderShipment.Product.AdditionalFee
 */
export interface OrderShipment_Product_AdditionalFee {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney unit_fee = 2
     */
    unitFee?: FractionalMoney;
    /**
     * @generated from protobuf field: string fee_id = 3
     */
    feeId: string;
}
/**
 * @generated from protobuf enum rd.txn.OrderShipment.Status
 */
export enum OrderShipment_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATUS_RECEIVED = 1;
     */
    RECEIVED = 1,
    /**
     * @generated from protobuf enum value: STATUS_PAID = 2;
     */
    PAID = 2,
    /**
     * @generated from protobuf enum value: STATUS_VOUCHERED = 3;
     */
    VOUCHERED = 3
}
/**
 * @generated from protobuf message rd.txn.InvoiceDetails
 */
export interface InvoiceDetails {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp invoice_date = 1
     */
    invoiceDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp due_date = 2
     */
    dueDate?: Timestamp;
    /**
     * @generated from protobuf field: string invoice_number = 3
     */
    invoiceNumber: string;
    /**
     * @generated from protobuf field: string reference_number = 4
     */
    referenceNumber: string;
}
/**
 * OrderShipmentLog represents a change of an OrderShipment
 *
 * @generated from protobuf message rd.txn.OrderShipmentLog
 */
export interface OrderShipmentLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 3
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.txn.OrderShipment order_shipment = 4
     */
    orderShipment?: OrderShipment;
}
/**
 * OrderPDFData represents the data required to fill the html
 * template for a purchase order
 *
 * @generated from protobuf message rd.txn.OrderPDFData
 */
export interface OrderPDFData {
    /**
     * @generated from protobuf field: string identifier = 1
     */
    identifier: string;
    /**
     * @generated from protobuf field: rd.txn.Order order = 2
     */
    order?: Order;
    /**
     * @generated from protobuf field: rd.company.Company company = 3
     */
    company?: Company;
    /**
     * @generated from protobuf field: rd.company.Location location = 4
     */
    location?: Location;
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 5
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: rd.vendors.Contacts.Contact vendor_contact = 6
     */
    vendorContact?: Contacts_Contact$;
    /**
     * @generated from protobuf field: repeated rd.txn.OrderPDFData.VendorProduct products = 7
     */
    products: OrderPDFData_VendorProduct[];
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 9
     */
    total?: Money;
    /**
     * @generated from protobuf field: string account_number = 10
     */
    accountNumber: string;
    /**
     * @generated from protobuf field: bool show_value = 11
     */
    showValue: boolean; // toggles display of total order value and product costs
    /**
     * @generated from protobuf field: string invoice_number = 12
     */
    invoiceNumber: string;
    /**
     * @generated from protobuf field: string invoice_date = 13
     */
    invoiceDate: string;
    /**
     * @generated from protobuf field: string due_date = 14
     */
    dueDate: string;
    /**
     * @generated from protobuf field: bool show_invoice_section = 15
     */
    showInvoiceSection: boolean;
    /**
     * @generated from protobuf field: string reference_number = 17
     */
    referenceNumber: string;
}
/**
 * @generated from protobuf message rd.txn.OrderPDFData.VendorProduct
 */
export interface OrderPDFData_VendorProduct {
    /**
     * @generated from protobuf field: string identifier = 1
     */
    identifier: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 4
     */
    total?: Money;
    /**
     * @generated from protobuf field: string notes = 7
     */
    notes: string;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost_v2 = 9
     */
    costV2?: FractionalMoney;
    /**
     * @generated from protobuf field: repeated rd.company.SaleForm.CustomField custom_fields = 10
     */
    customFields: SaleForm_CustomField[];
    /**
     * @generated from protobuf field: string vendor_sku = 11
     */
    vendorSku: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_ordered_v2 = 12
     */
    quantityOrderedV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_received_v2 = 13
     */
    quantityReceivedV2?: Decimal;
    /**
     * Quantity with Unit of Measure information
     *
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 14
     */
    uomId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_ordered_uom = 15
     */
    quantityOrderedUom?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_received_uom = 16
     */
    quantityReceivedUom?: Decimal;
    /**
     * total_unit_fee is the combined per-unit additional fee shown next to
     * the unit cost in the line item.
     *
     * @generated from protobuf field: rd.proto.money.FractionalMoney total_unit_fee = 17
     */
    totalUnitFee?: FractionalMoney;
    /**
     * @generated from protobuf field: string uom_code = 18
     */
    uomCode: string;
}
/**
 * UpsertOrderError stores invalid upc products for an EDI order that has invalid products
 *
 * @generated from protobuf message rd.txn.UpsertOrderError
 */
export interface UpsertOrderError {
    /**
     * @generated from protobuf field: repeated rd.product.Product invalid_upc_products = 1
     */
    invalidUpcProducts: Product[];
    /**
     * @generated from protobuf field: bool is_vendor_sku_missing = 2
     */
    isVendorSkuMissing: boolean;
}
/**
 * Transfer represents a transaction type in which inventory
 * is moved between locations.
 *
 * @generated from protobuf message rd.txn.Transfer
 */
export interface Transfer {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.user.User created_by = 5
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.user.User sent_by = 6
     */
    sentBy?: User;
    /**
     * @generated from protobuf field: rd.user.User received_by = 7
     */
    receivedBy?: User;
    /**
     * @generated from protobuf field: rd.user.User voided_by = 8
     */
    voidedBy?: User;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID from_location_id = 9
     */
    fromLocationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID to_location_id = 10
     */
    toLocationId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sent_at = 11
     */
    sentAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp received_at = 12
     */
    receivedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp voided_at = 13
     */
    voidedAt?: Timestamp;
    /**
     * @generated from protobuf field: string identifier = 14
     */
    identifier: string;
    /**
     * @generated from protobuf field: rd.txn.Transfer.Status status = 15
     */
    status: Transfer_Status;
    /**
     * @generated from protobuf field: map<string, rd.txn.Transfer.Product> products_by_id = 16
     */
    productsById: {
        [key: string]: Transfer_Product;
    };
    /**
     * @generated from protobuf field: int64 total_cost_cents = 17
     */
    totalCostCents: bigint;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp requested_at = 20
     */
    requestedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User requested_by = 21
     */
    requestedBy?: User;
    /**
     * @generated from protobuf field: string notes = 22
     */
    notes: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp request_date = 23
     */
    requestDate?: Timestamp;
}
/**
 * @generated from protobuf message rd.txn.Transfer.Product
 */
export interface Transfer_Product {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 1
     */
    productId?: UUID;
    /**
     * additional_fees_when_received[].unit_fee
     *
     * @generated from protobuf field: int32 position = 6
     */
    position: number;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost_v2 = 7
     */
    costV2?: FractionalMoney;
    /**
     * @generated from protobuf field: bool is_special_order = 9
     */
    isSpecialOrder: boolean; // for inventory ledger entries
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_sent_v2 = 10
     */
    quantitySentV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_received_v2 = 11
     */
    quantityReceivedV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_requested_v2 = 12
     */
    quantityRequestedV2?: Decimal;
    /**
     * Quantity with Unit of Measure information
     *
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 13
     */
    uomId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_sent_uom = 14
     */
    quantitySentUom?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_received_uom = 15
     */
    quantityReceivedUom?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_requested_uom = 16
     */
    quantityRequestedUom?: Decimal;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 17
     */
    uomSnapshot?: LedgerEntry_UomSnapshot;
    /**
     * additional_fees_when_received supersedes the singular
     * additional_fee_when_received (5) and additional_fee_name_when_received
     * (18). Both are populated during the rollout window.
     *
     * @generated from protobuf field: repeated rd.txn.Transfer.Product.AdditionalFee additional_fees_when_received = 19
     */
    additionalFeesWhenReceived: Transfer_Product_AdditionalFee[];
}
/**
 * additional_fees_when_received[].name
 * AdditionalFee is a per-line snapshot of an additional fee applied
 * at receive time. unit_fee is at full FractionalMoney precision so
 * rollups can accumulate (unit_fee × quantity) across all lines for
 * a given fee name and round each name's total to Money once at the
 * transaction level. Each fee name rounds independently because each
 * represents its own line item; rounding any earlier compounds error.
 *
 * @generated from protobuf message rd.txn.Transfer.Product.AdditionalFee
 */
export interface Transfer_Product_AdditionalFee {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney unit_fee = 2
     */
    unitFee?: FractionalMoney;
    /**
     * @generated from protobuf field: string fee_id = 3
     */
    feeId: string;
}
/**
 * @generated from protobuf enum rd.txn.Transfer.Status
 */
export enum Transfer_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATUS_CREATED = 1;
     */
    CREATED = 1,
    /**
     * @generated from protobuf enum value: STATUS_SENT = 2;
     */
    SENT = 2,
    /**
     * @generated from protobuf enum value: STATUS_RECEIVED = 3;
     */
    RECEIVED = 3,
    /**
     * @generated from protobuf enum value: STATUS_VOIDED = 4;
     */
    VOIDED = 4,
    /**
     * @generated from protobuf enum value: STATUS_REQUESTED = 5;
     */
    REQUESTED = 5
}
/**
 * TransferLog represents a change of a Transfer.
 *
 * @generated from protobuf message rd.txn.TransferLog
 */
export interface TransferLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 3
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.txn.Transfer transfer = 4
     */
    transfer?: Transfer;
}
/**
 * @generated from protobuf message rd.txn.ToFromTransferCounts
 */
export interface ToFromTransferCounts {
    /**
     * @generated from protobuf field: int32 from_count = 1
     */
    fromCount: number;
    /**
     * @generated from protobuf field: int32 to_count = 2
     */
    toCount: number;
}
/**
 * TransferPDFData represents the data required to fill the html
 * template for a transfer
 *
 * @generated from protobuf message rd.txn.TransferPDFData
 */
export interface TransferPDFData {
    /**
     * @generated from protobuf field: string identifier = 1
     */
    identifier: string;
    /**
     * @generated from protobuf field: rd.txn.Transfer transfer = 2
     */
    transfer?: Transfer;
    /**
     * @generated from protobuf field: rd.company.Company company = 3
     */
    company?: Company;
    /**
     * @generated from protobuf field: rd.company.Location location = 4
     */
    location?: Location;
    /**
     * @generated from protobuf field: rd.company.Location to_location = 5
     */
    toLocation?: Location;
    /**
     * @generated from protobuf field: repeated rd.txn.TransferPDFData.Product products = 6
     */
    products: TransferPDFData_Product[];
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 7
     */
    total?: Money;
    /**
     * @generated from protobuf field: bool show_value = 9
     */
    showValue: boolean; // toggles display of total transfer value and product costs
}
/**
 * @generated from protobuf message rd.txn.TransferPDFData.Product
 */
export interface TransferPDFData_Product {
    /**
     * @generated from protobuf field: string identifier = 1
     */
    identifier: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 4
     */
    total?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost_v2 = 8
     */
    costV2?: FractionalMoney;
    /**
     * @generated from protobuf field: string from_location_bin = 9
     */
    fromLocationBin: string;
    /**
     * @generated from protobuf field: string to_location_bin = 10
     */
    toLocationBin: string;
    /**
     * @generated from protobuf field: int32 position = 11
     */
    position: number;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_v2 = 12
     */
    quantityV2?: Decimal;
    /**
     * Quantity with Unit of Measure information
     *
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 13
     */
    uomId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_uom = 14
     */
    quantityUom?: Decimal;
    /**
     * total_unit_fee is the combined per-unit additional fee. Not rendered on
     * the transfer PDF (fees are factored into total) but kept for parity with
     * the order and shipment PDFs.
     *
     * @generated from protobuf field: rd.proto.money.FractionalMoney total_unit_fee = 15
     */
    totalUnitFee?: FractionalMoney;
}
/**
 * BillPayment represents a bill payment made by a customer that
 * goes toward the outstanding balance on their charge account.
 *
 * @generated from protobuf message rd.txn.BillPayment
 */
export interface BillPayment {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 4
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 5
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 6
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 7
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: string identifier = 8
     */
    identifier: string;
    /**
     * @generated from protobuf field: string notes = 9
     */
    notes: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp refunded_at = 10
     */
    refundedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User refunded_by = 11
     */
    refundedBy?: User;
    /**
     * @generated from protobuf field: string refund_notes = 12
     */
    refundNotes: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal card_surcharge_rate = 13
     */
    cardSurchargeRate?: Decimal;
    /**
     * @generated from protobuf field: string credit_notes = 16
     */
    creditNotes: string;
    /**
     * @generated from protobuf field: rd.txn.CreditAllocationStatus credit_allocation_status = 17
     */
    creditAllocationStatus: CreditAllocationStatus;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp voided_at = 18
     */
    voidedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User voided_by = 19
     */
    voidedBy?: User;
    /**
     * @generated from protobuf field: string void_notes = 20
     */
    voidNotes: string;
    /**
     * @generated from protobuf field: rd.txn.BillPayment.Source source = 21
     */
    source: BillPayment_Source;
    /**
     * @generated from protobuf field: map<string, rd.txn.BillPayment.Tax> taxes_by_tax_rate_id = 22
     */
    taxesByTaxRateId: {
        [key: string]: BillPayment_Tax;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money cash_rounding_delta = 23
     */
    cashRoundingDelta?: Money; // positive = rounded up
    /**
     * @generated from protobuf field: rd.proto.money.Money refund_cash_rounding_delta = 24
     */
    refundCashRoundingDelta?: Money; // positive = rounded up
}
/**
 * A bill payment is taxed only on its card surcharge, never on the payment
 * amount itself — the bills it pays were already taxed at sale time, so only
 * surcharge_tax is populated here.
 *
 * @generated from protobuf message rd.txn.BillPayment.Tax
 */
export interface BillPayment_Tax {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal rate = 2
     */
    rate?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.Money surcharge_tax = 4
     */
    surchargeTax?: Money;
    /**
     * @generated from protobuf field: repeated rd.company.TaxComponent tax_components = 5
     */
    taxComponents: TaxComponent[];
}
/**
 * @generated from protobuf enum rd.txn.BillPayment.Source
 */
export enum BillPayment_Source {
    /**
     * @generated from protobuf enum value: SOURCE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: SOURCE_CXA_APP = 1;
     */
    CXA_APP = 1,
    /**
     * @generated from protobuf enum value: SOURCE_AUTOPAY = 2;
     */
    AUTOPAY = 2
}
/**
 * CustomerBalance represents the amount a given customer owes
 * a company. These are stored in the database & updated every
 * time a ledger entry is inserted for the given customer.
 *
 * @generated from protobuf message rd.txn.CustomerBalance
 */
export interface CustomerBalance {
    /**
     * @generated from protobuf field: rd.proto.money.Money credits = 1
     */
    credits?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money current = 2
     */
    current?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money late_1_to_30 = 3
     */
    late1To30?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money late_31_to_60 = 4
     */
    late31To60?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money late_61_plus = 5
     */
    late61Plus?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money financing_charges = 6
     */
    financingCharges?: Money;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> outstanding_purchases = 7
     */
    outstandingPurchases: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 8
     */
    id?: UUID; // customer id
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 9
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 10
     */
    companyId?: UUID;
    /**
     * aging_ledger stores the per-transaction aging data that was used to
     * compute the CustomerBalance; primarily useful for the customer aging
     * report
     *
     * @generated from protobuf field: rd.txn.CustomerAgingLedger aging_ledger = 11
     */
    agingLedger?: CustomerAgingLedger;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> outstanding_finance_charges = 12
     */
    outstandingFinanceCharges: {
        [key: string]: Money;
    }; // used to store unpaid finance charges
}
/**
 * CustomerAgingLedger represents the amount a given customer owes
 * a company, broken down by purchase ID maps and net financing
 * charges owed
 *
 * @generated from protobuf message rd.txn.CustomerAgingLedger
 */
export interface CustomerAgingLedger {
    /**
     * @generated from protobuf field: rd.proto.money.Money credits = 1
     */
    credits?: Money;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> current = 2
     */
    current: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> late_1_to_30 = 3
     */
    late1To30: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> late_31_to_60 = 4
     */
    late31To60: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> late_61_plus = 5
     */
    late61Plus: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money financing_charges = 6
     */
    financingCharges?: Money;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> outstanding_purchases = 7
     */
    outstandingPurchases: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 8
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 9
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 10
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> outstanding_finance_charges = 11
     */
    outstandingFinanceCharges: {
        [key: string]: Money;
    }; // used to store unpaid finance charges
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> credits_by_id = 12
     */
    creditsById: {
        [key: string]: Money;
    }; // used to store credits
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> missing_balances_by_id = 13
     */
    missingBalancesById: {
        [key: string]: Money;
    }; // used to store missing balances
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> late_61_to_90 = 14
     */
    late61To90: {
        [key: string]: Money;
    }; // used when split_61_plus is requested
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> late_91_plus = 15
     */
    late91Plus: {
        [key: string]: Money;
    }; // used when split_61_plus is requested
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal average_days_to_pay = 16
     */
    averageDaysToPay?: Decimal; // excludes days to use a credit
}
/**
 * @generated from protobuf message rd.txn.CustomerSaleHistoryPDFData
 */
export interface CustomerSaleHistoryPDFData {
    /**
     * @generated from protobuf field: rd.company.Company company = 1
     */
    company?: Company;
    /**
     * @generated from protobuf field: rd.company.Location location = 2
     */
    location?: Location;
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 3
     */
    customer?: Customer;
    /**
     * @generated from protobuf field: rd.customer.Contacts.Contact primary_contact = 4
     */
    primaryContact?: Contacts_Contact;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange timestamp_range = 5
     */
    timestampRange?: TimestampRange;
    /**
     * @generated from protobuf field: repeated rd.txn.CustomerSaleHistoryPDFData.Sale sales = 6
     */
    sales: CustomerSaleHistoryPDFData_Sale[];
    /**
     * @generated from protobuf field: rd.proto.money.Money sales_total = 7
     */
    salesTotal?: Money;
    /**
     * @generated from protobuf field: repeated rd.customer.PurchaseOrder purchase_orders = 8
     */
    purchaseOrders: PurchaseOrder[];
    /**
     * @generated from protobuf field: rd.proto.money.Money remaining_balance_total = 9
     */
    remainingBalanceTotal?: Money;
    /**
     * @generated from protobuf field: string formatted_timestamp_range = 10
     */
    formattedTimestampRange: string;
}
/**
 * @generated from protobuf message rd.txn.CustomerSaleHistoryPDFData.Sale
 */
export interface CustomerSaleHistoryPDFData_Sale {
    /**
     * @generated from protobuf field: string identifier = 1
     */
    identifier: string;
    /**
     * @generated from protobuf field: string location_name = 2
     */
    locationName: string;
    /**
     * @generated from protobuf field: string purchase_order = 3
     */
    purchaseOrder: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sold_at = 4
     */
    soldAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp due_at = 5
     */
    dueAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 6
     */
    total?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money remaining_balance = 7
     */
    remainingBalance?: Money;
}
/**
 * PettyCash represents a transaction type in which cash is withdrawn or deposited
 * to the register for company use.
 *
 * @generated from protobuf message rd.txn.PettyCash
 */
export interface PettyCash {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 3
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: string identifier = 4
     */
    identifier: string;
    /**
     * @generated from protobuf field: string notes = 5
     */
    notes: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 6
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 7
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID cash_register_id = 8
     */
    cashRegisterId?: UUID;
}
/**
 * CloseOut represents a transaction in which a register is closed
 * out by counting and submitting the total cash collected.
 *
 * @generated from protobuf message rd.txn.CloseOut
 */
export interface CloseOut {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 3
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 5
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: string identifier = 6
     */
    identifier: string;
    /**
     * @generated from protobuf field: string notes = 7
     */
    notes: string;
    /**
     * @generated from protobuf field: int32 counted_100_dollar_bills = 8
     */
    counted100DollarBills: number;
    /**
     * @generated from protobuf field: int32 counted_50_dollar_bills = 9
     */
    counted50DollarBills: number;
    /**
     * @generated from protobuf field: int32 counted_20_dollar_bills = 10
     */
    counted20DollarBills: number;
    /**
     * @generated from protobuf field: int32 counted_10_dollar_bills = 11
     */
    counted10DollarBills: number;
    /**
     * @generated from protobuf field: int32 counted_5_dollar_bills = 12
     */
    counted5DollarBills: number;
    /**
     * @generated from protobuf field: int32 counted_1_dollar_bills = 13
     */
    counted1DollarBills: number;
    /**
     * @generated from protobuf field: int32 counted_25_cent_coins = 14
     */
    counted25CentCoins: number;
    /**
     * @generated from protobuf field: int32 counted_10_cent_coins = 15
     */
    counted10CentCoins: number;
    /**
     * @generated from protobuf field: int32 counted_5_cent_coins = 16
     */
    counted5CentCoins: number;
    /**
     * @generated from protobuf field: int32 counted_1_cent_coins = 17
     */
    counted1CentCoins: number;
    /**
     * float is the base cash amount that stays in the register for making change the next day.
     * Set in register settings, not deposited during close-out. Total counted must be >= float.
     *
     * @generated from protobuf field: rd.proto.money.Money float = 18
     */
    float?: Money;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID cash_register_id = 19
     */
    cashRegisterId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 20
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 21
     */
    updatedBy?: User;
    /**
     * @generated from protobuf field: int32 counted_2_dollar_bills = 22
     */
    counted2DollarBills: number;
}
/**
 * CloseOutLog represents a change of a CloseOut.
 *
 * @generated from protobuf message rd.txn.CloseOutLog
 */
export interface CloseOutLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 3
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.txn.CloseOut close_out = 4
     */
    closeOut?: CloseOut;
}
/**
 * CustomerSalesAnalytics represents sales analytics data for a customer.
 *
 * @generated from protobuf message rd.txn.CustomerSalesAnalytics
 */
export interface CustomerSalesAnalytics {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // customer id
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.Money sales_ytd = 3
     */
    salesYtd?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money sales_last_ytd = 4
     */
    salesLastYtd?: Money;
    /**
     * @generated from protobuf field: float yoy_growth = 5
     */
    yoyGrowth: number;
    /**
     * @generated from protobuf field: float margin_ytd = 6
     */
    marginYtd: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_sale = 7
     */
    lastSale?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money sales_last_12mo = 8
     */
    salesLast12Mo?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money sales_last_3mo = 9
     */
    salesLast3Mo?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money sales_last_1mo = 10
     */
    salesLast1Mo?: Money;
    /**
     * @generated from protobuf field: float standard_margin_ytd = 11
     */
    standardMarginYtd: number;
}
/**
 * CustomerSalesRollup is a summary of a customer's sales data over a period
 * of time.
 *
 * @generated from protobuf message rd.txn.CustomerSalesRollup
 */
export interface CustomerSalesRollup {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp series_start = 4
     */
    seriesStart?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp series_end = 5
     */
    seriesEnd?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 6
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 7
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: string ledger_entries_hash = 8
     */
    ledgerEntriesHash: string;
    /**
     * @generated from protobuf field: rd.txn.CustomerSalesRollup.SalesData sales_data = 9
     */
    salesData?: CustomerSalesRollup_SalesData;
}
/**
 * @generated from protobuf message rd.txn.CustomerSalesRollup.SalesData
 */
export interface CustomerSalesRollup_SalesData {
    /**
     * @generated from protobuf field: rd.proto.money.Money price_of_goods_sold = 1
     */
    priceOfGoodsSold?: Money;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_sale = 3
     */
    lastSale?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost_of_goods_sold_v2 = 4
     */
    costOfGoodsSoldV2?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney standard_cost_of_goods_sold = 5
     */
    standardCostOfGoodsSold?: FractionalMoney;
}
/**
 * ProductSalesAnalytics represents sales analytics data for a product at a
 * location.
 *
 * @generated from protobuf message rd.txn.ProductSalesAnalytics
 */
export interface ProductSalesAnalytics {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // xor product id and location id
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 2
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 3
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: float yoy_growth = 7
     */
    yoyGrowth: number;
    /**
     * @generated from protobuf field: float margin_ytd = 8
     */
    marginYtd: number; // using average cost
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_sale = 9
     */
    lastSale?: Timestamp;
    /**
     * units_last_1mo
     *
     * @generated from protobuf field: float inventory_turns = 13
     */
    inventoryTurns: number;
    /**
     * @generated from protobuf field: float standard_margin_ytd = 14
     */
    standardMarginYtd: number;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal units_ytd_v2 = 15
     */
    unitsYtdV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal units_last_ytd_v2 = 16
     */
    unitsLastYtdV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal units_last_12mo_v2 = 17
     */
    unitsLast12MoV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal units_last_3mo_v2 = 18
     */
    unitsLast3MoV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal units_last_1mo_v2 = 19
     */
    unitsLast1MoV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.Money revenue_ytd = 20
     */
    revenueYtd?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney average_cost_ytd = 21
     */
    averageCostYtd?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney standard_cost_ytd = 22
     */
    standardCostYtd?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal stock = 23
     */
    stock?: Decimal;
}
/**
 * ProductSalesRollup is a summary of a product's sales data over a period
 * of time at each of its company's locations.
 *
 * @generated from protobuf message rd.txn.ProductSalesRollup
 */
export interface ProductSalesRollup {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp series_start = 4
     */
    seriesStart?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp series_end = 5
     */
    seriesEnd?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 6
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 7
     */
    productId?: UUID;
    /**
     * @generated from protobuf field: string sales_hash = 8
     */
    salesHash: string;
    /**
     * @generated from protobuf field: map<string, rd.txn.ProductSalesRollup.SalesData> sales_data_by_location_id = 9
     */
    salesDataByLocationId: {
        [key: string]: ProductSalesRollup_SalesData;
    };
}
/**
 * @generated from protobuf message rd.txn.ProductSalesRollup.SalesData
 */
export interface ProductSalesRollup_SalesData {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 1
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: int32 units_sold = 2
     */
    unitsSold: number;
    /**
     * @generated from protobuf field: rd.proto.money.Money price_of_goods_sold = 3
     */
    priceOfGoodsSold?: Money;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_sale = 5
     */
    lastSale?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost_of_goods_sold_v2 = 6
     */
    costOfGoodsSoldV2?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney standard_cost_of_goods_sold = 7
     */
    standardCostOfGoodsSold?: FractionalMoney;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal units_sold_v2 = 8
     */
    unitsSoldV2?: Decimal;
}
/**
 * CondensedSalesPDFData represents the data required to fill the html template for condensed
 * sales
 *
 * @generated from protobuf message rd.txn.CondensedSalePDFData
 */
export interface CondensedSalePDFData {
    /**
     * @generated from protobuf field: repeated rd.txn.CondensedSalePDFData.Sale condensed_sales = 1
     */
    condensedSales: CondensedSalePDFData_Sale[];
}
/**
 * @generated from protobuf message rd.txn.CondensedSalePDFData.Sale
 */
export interface CondensedSalePDFData_Sale {
    /**
     * @generated from protobuf field: string identifier = 1
     */
    identifier: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sold_at = 2
     */
    soldAt?: Timestamp;
    /**
     * @generated from protobuf field: string purchase_order_name = 3
     */
    purchaseOrderName: string;
    /**
     * @generated from protobuf field: string sale_notes = 4
     */
    saleNotes: string;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> additional_fee_totals_by_name = 6
     */
    additionalFeeTotalsByName: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money sales_tax = 7
     */
    salesTax?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 9
     */
    total?: Money;
    /**
     * @generated from protobuf field: string signature_url = 10
     */
    signatureUrl: string;
    /**
     * @generated from protobuf field: string customer_name = 11
     */
    customerName: string;
    /**
     * @generated from protobuf field: rd.company.TaxRate tax_rate = 12
     */
    taxRate?: TaxRate;
    /**
     * @generated from protobuf field: repeated rd.txn.CondensedSalePDFData.Sale.Product products = 13
     */
    products: CondensedSalePDFData_Sale_Product[];
    /**
     * @generated from protobuf field: bool show_discount = 14
     */
    showDiscount: boolean;
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge = 16
     */
    cardSurcharge?: Money;
    /**
     * @generated from protobuf field: string card_surcharge_rate_string = 17
     */
    cardSurchargeRateString: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money early_payment_discount = 18
     */
    earlyPaymentDiscount?: Money;
    /**
     * @generated from protobuf field: bool show_early_payment_discount = 19
     */
    showEarlyPaymentDiscount: boolean;
    /**
     * @generated from protobuf field: string job_name = 20
     */
    jobName: string;
    /**
     * @generated from protobuf field: string sale_type = 21
     */
    saleType: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money restocking_fee = 22
     */
    restockingFee?: Money;
    /**
     * @generated from protobuf field: bool show_discount_percentage = 23
     */
    showDiscountPercentage: boolean;
    /**
     * @generated from protobuf field: rd.proto.money.Money subtotal_discount_applied = 24
     */
    subtotalDiscountApplied?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal subtotal_discount_rate = 25
     */
    subtotalDiscountRate?: Decimal;
    /**
     * @generated from protobuf field: rd.txn.SaleTaxes sale_taxes = 26
     */
    saleTaxes?: SaleTaxes; // only used if show_multiple_sale_taxes is true
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge_without_tax = 27
     */
    cardSurchargeWithoutTax?: Money; // only used if show_multiple_sale_taxes is true
    /**
     * @generated from protobuf field: bool show_multiple_sale_taxes = 28
     */
    showMultipleSaleTaxes: boolean;
    /**
     * @generated from protobuf field: rd.proto.money.Money cash_rounding_delta = 29
     */
    cashRoundingDelta?: Money;
}
/**
 * @generated from protobuf message rd.txn.CondensedSalePDFData.Sale.Product
 */
export interface CondensedSalePDFData_Sale_Product {
    /**
     * @generated from protobuf field: string identifier = 1
     */
    identifier: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: rd.tintcolor.TintColor tint_color = 3
     */
    tintColor?: TintColor;
    /**
     * @generated from protobuf field: rd.proto.money.Money sub_total = 4
     */
    subTotal?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money returned_sub_total = 5
     */
    returnedSubTotal?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money price = 8
     */
    price?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money tier_1_price = 9
     */
    tier1Price?: Money;
    /**
     * @generated from protobuf field: string notes = 10
     */
    notes: string;
    /**
     * @generated from protobuf field: string custom_tint_color = 11
     */
    customTintColor: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_v2 = 12
     */
    quantityV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_returned_v2 = 13
     */
    quantityReturnedV2?: Decimal;
    /**
     * Quantity with Unit of Measure information
     *
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 14
     */
    uomId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_uom = 15
     */
    quantityUom?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id_returned = 16
     */
    uomIdReturned?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_returned_uom = 17
     */
    quantityReturnedUom?: Decimal;
    /**
     * UOM snapshot information for receipt display.
     *
     * @generated from protobuf field: rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 18
     */
    uomSnapshot?: LedgerEntry_UomSnapshot;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry.UomSnapshot uom_snapshot_returned = 19
     */
    uomSnapshotReturned?: LedgerEntry_UomSnapshot;
    /**
     * @generated from protobuf field: string non_taxable_display = 20
     */
    nonTaxableDisplay: string;
    /**
     * Gift card overwritten balance is only set for gift cards and is the overwritten balance of
     * the gift card
     *
     * @generated from protobuf field: string gift_card_overwritten_balance = 21
     */
    giftCardOverwrittenBalance: string;
}
/**
 * OrderShipmentPDFData represents the data required to fill the html
 * template for an order shipment pdf
 *
 * @generated from protobuf message rd.txn.OrderShipmentPDFData
 */
export interface OrderShipmentPDFData {
    /**
     * @generated from protobuf field: rd.txn.OrderShipment order_shipment = 1
     */
    orderShipment?: OrderShipment;
    /**
     * @generated from protobuf field: rd.txn.Order order = 2
     */
    order?: Order;
    /**
     * @generated from protobuf field: rd.company.Company company = 3
     */
    company?: Company;
    /**
     * @generated from protobuf field: rd.company.Location location = 4
     */
    location?: Location;
    /**
     * @generated from protobuf field: rd.vendors.Vendor vendor = 5
     */
    vendor?: Vendor;
    /**
     * @generated from protobuf field: rd.vendors.Contacts.Contact vendor_contact = 6
     */
    vendorContact?: Contacts_Contact$;
    /**
     * @generated from protobuf field: repeated rd.txn.OrderShipmentPDFData.Product products = 7
     */
    products: OrderShipmentPDFData_Product[];
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 8
     */
    total?: Money;
    /**
     * @generated from protobuf field: string account_number = 9
     */
    accountNumber: string;
    /**
     * @generated from protobuf field: string status_tag = 10
     */
    statusTag: string;
    /**
     * @generated from protobuf field: string invoice_date = 11
     */
    invoiceDate: string;
    /**
     * @generated from protobuf field: string due_date = 12
     */
    dueDate: string;
    /**
     * @generated from protobuf field: string invoice_number = 13
     */
    invoiceNumber: string;
    /**
     * @generated from protobuf field: bool show_invoice_section = 14
     */
    showInvoiceSection: boolean;
    /**
     * @generated from protobuf field: bool show_value = 15
     */
    showValue: boolean; // toggles display of total order shipment value and product costs
    /**
     * @generated from protobuf field: string identifier = 16
     */
    identifier: string;
    /**
     * order shipment PDF
     *
     * @generated from protobuf field: string reference_number = 18
     */
    referenceNumber: string;
}
/**
 * @generated from protobuf message rd.txn.OrderShipmentPDFData.Product
 */
export interface OrderShipmentPDFData_Product {
    /**
     * @generated from protobuf field: string identifier = 1
     */
    identifier: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 3
     */
    total?: Money;
    /**
     * @generated from protobuf field: int32 quantity_ordered = 4
     */
    quantityOrdered: number;
    /**
     * @generated from protobuf field: string notes = 7
     */
    notes: string;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney cost_v2 = 8
     */
    costV2?: FractionalMoney;
    /**
     * @generated from protobuf field: repeated rd.company.SaleForm.CustomField custom_fields = 9
     */
    customFields: SaleForm_CustomField[];
    /**
     * @generated from protobuf field: string vendor_sku = 10
     */
    vendorSku: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_ordered_v2 = 11
     */
    quantityOrderedV2?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_received_v2 = 12
     */
    quantityReceivedV2?: Decimal;
    /**
     * Quantity with Unit of Measure information
     *
     * @generated from protobuf field: rd.proto.uuid.UUID uom_id = 13
     */
    uomId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_ordered_uom = 14
     */
    quantityOrderedUom?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal quantity_received_uom = 15
     */
    quantityReceivedUom?: Decimal;
    /**
     * total_unit_fee is the combined per-unit additional fee shown next to
     * the unit cost in the line item.
     *
     * @generated from protobuf field: rd.proto.money.FractionalMoney total_unit_fee = 16
     */
    totalUnitFee?: FractionalMoney;
}
/**
 * PaymentIdempotentKeyPair are used to ensure payment idempotency.
 *
 * @generated from protobuf message rd.txn.PaymentIdempotentKeyPair
 */
export interface PaymentIdempotentKeyPair {
    /**
     * @generated from protobuf field: string authorize_key = 1
     */
    authorizeKey: string;
    /**
     * @generated from protobuf field: string capture_key = 2
     */
    captureKey: string;
}
/**
 * PotentialDiscountMetadata contains metadata for a potential discount
 *
 * @generated from protobuf message rd.txn.PotentialDiscountMetadata
 */
export interface PotentialDiscountMetadata {
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal rate = 1
     */
    rate?: Decimal;
    /**
     * @generated from protobuf field: string term_name = 2
     */
    termName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 3
     */
    expiresAt?: Timestamp;
}
/**
 * UpsertSaleV3Metadata contains parameters necessary for various payment types
 * such as credit card information, sale total amounts, and whether to save
 * a card to a customer.
 *
 * @generated from protobuf message rd.txn.UpsertSaleV3Metadata
 */
export interface UpsertSaleV3Metadata {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp payment_due_at = 1
     */
    paymentDueAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 2
     */
    total?: Money;
    /**
     * @generated from protobuf field: string stripe_reader_id = 4
     */
    stripeReaderId: string;
    /**
     * @generated from protobuf field: string idempotency_key = 5
     */
    idempotencyKey: string;
    /**
     * @generated from protobuf field: rd.txn.PotentialDiscountMetadata potential_discount_metadata = 6
     */
    potentialDiscountMetadata?: PotentialDiscountMetadata;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> adjusted_totals_by_returned_from_sale_id = 9
     */
    adjustedTotalsByReturnedFromSaleId: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money additional_deposit = 10
     */
    additionalDeposit?: Money;
    /**
     * @generated from protobuf field: repeated rd.txn.TenderSubmissionMetadata tender_submissions = 14
     */
    tenderSubmissions: TenderSubmissionMetadata[];
    /**
     * @generated from protobuf field: rd.proto.money.Money additional_deposit_surcharge_total = 15
     */
    additionalDepositSurchargeTotal?: Money;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata deposit_refund_tender_submission_metadata = 16
     */
    depositRefundTenderSubmissionMetadata?: TenderSubmissionMetadata;
    /**
     * @generated from protobuf field: rd.proto.money.Money principal_to_refund = 17
     */
    principalToRefund?: Money;
}
/**
 * TotalsLineItem is a line item in the totals breakdown of a sale.
 *
 * @generated from protobuf message rd.txn.TotalsLineItem
 */
export interface TotalsLineItem {
    /**
     * @generated from protobuf field: rd.txn.TotalsLineItem.Type type = 1
     */
    type: TotalsLineItem_Type;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * @generated from protobuf field: string rate = 4
     */
    rate: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money amount = 5
     */
    amount?: Money;
    /**
     * @generated from protobuf field: rd.txn.TotalsLineItem.ProductType product_type = 7
     */
    productType: TotalsLineItem_ProductType;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID from_sale_id = 8
     */
    fromSaleId?: UUID;
    /**
     * @generated from protobuf field: string from_sale_identifier = 9
     */
    fromSaleIdentifier: string;
}
/**
 * @generated from protobuf enum rd.txn.TotalsLineItem.Type
 */
export enum TotalsLineItem_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_SUBTOTAL = 1;
     */
    SUBTOTAL = 1,
    /**
     * @generated from protobuf enum value: TYPE_TAX = 2;
     */
    TAX = 2,
    /**
     * @generated from protobuf enum value: TYPE_CARD_SURCHARGE = 3;
     */
    CARD_SURCHARGE = 3,
    /**
     * @generated from protobuf enum value: TYPE_ADDITIONAL_FEE = 4;
     */
    ADDITIONAL_FEE = 4,
    /**
     * @generated from protobuf enum value: TYPE_RESTOCK_FEE = 5;
     */
    RESTOCK_FEE = 5,
    /**
     * @generated from protobuf enum value: TYPE_EARLY_PAYMENT_DISCOUNT_ADJUSTMENT = 6;
     */
    EARLY_PAYMENT_DISCOUNT_ADJUSTMENT = 6,
    /**
     * @generated from protobuf enum value: TYPE_ROUNDING_ADJUSTMENT = 7;
     */
    ROUNDING_ADJUSTMENT = 7,
    /**
     * @generated from protobuf enum value: TYPE_DEPOSIT = 8;
     */
    DEPOSIT = 8,
    /**
     * @generated from protobuf enum value: TYPE_DISCOUNT = 9;
     */
    DISCOUNT = 9,
    /**
     * @generated from protobuf enum value: TYPE_SURCHARGE_TAX = 10;
     */
    SURCHARGE_TAX = 10,
    /**
     * @generated from protobuf enum value: TYPE_CASH_ROUNDING = 11;
     */
    CASH_ROUNDING = 11
}
/**
 * @generated from protobuf enum rd.txn.TotalsLineItem.ProductType
 */
export enum TotalsLineItem_ProductType {
    /**
     * @generated from protobuf enum value: PRODUCT_TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: PRODUCT_TYPE_STOCK = 1;
     */
    STOCK = 1,
    /**
     * @generated from protobuf enum value: PRODUCT_TYPE_SPECIAL_ORDER = 2;
     */
    SPECIAL_ORDER = 2
}
/**
 * TaxLine is one tax rate applied to a transaction, carrying the rate name and
 * a backend-built display label ("Name (X%)"). It is read-only display data
 * shared by sales (SaleTaxes) and bill-payment card-fee tax responses.
 *
 * @generated from protobuf message rd.txn.TaxLine
 */
export interface TaxLine {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID tax_rate_id = 1
     */
    taxRateId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal rate = 2
     */
    rate?: Decimal;
    /**
     * @generated from protobuf field: string tax_rate_name = 3
     */
    taxRateName: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money tax = 4
     */
    tax?: Money;
    /**
     * @generated from protobuf field: string label = 5
     */
    label: string;
    /**
     * @generated from protobuf field: repeated rd.company.TaxComponent tax_components = 6
     */
    taxComponents: TaxComponent[];
}
/**
 * @generated from protobuf message rd.txn.SaleTaxes
 */
export interface SaleTaxes {
    /**
     * @generated from protobuf field: repeated rd.txn.TaxLine base_taxes = 1
     */
    baseTaxes: TaxLine[];
    /**
     * @generated from protobuf field: repeated rd.txn.TaxLine surcharge_taxes = 2
     */
    surchargeTaxes: TaxLine[];
}
/**
 * CreditHistoryLink represents a link between a transaction and a credit history.
 * It contains the data necessary to display a credit history link in the UI.
 * It can either be a link to an origin transaction or an allocation transaction.
 *
 * @generated from protobuf message rd.txn.CreditHistoryLink
 */
export interface CreditHistoryLink {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money amount = 3
     */
    amount?: Money;
    /**
     * @generated from protobuf field: rd.txn.CreditHistoryLink.Type type = 4
     */
    type: CreditHistoryLink_Type;
    /**
     * @generated from protobuf field: rd.txn.CreditHistoryLink.TransactionType transaction_type = 5
     */
    transactionType: CreditHistoryLink_TransactionType;
}
/**
 * @generated from protobuf enum rd.txn.CreditHistoryLink.Type
 */
export enum CreditHistoryLink_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_ORIGIN = 1;
     */
    ORIGIN = 1,
    /**
     * @generated from protobuf enum value: TYPE_ALLOCATION = 2;
     */
    ALLOCATION = 2
}
/**
 * @generated from protobuf enum rd.txn.CreditHistoryLink.TransactionType
 */
export enum CreditHistoryLink_TransactionType {
    /**
     * @generated from protobuf enum value: TRANSACTION_TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TRANSACTION_TYPE_BILL_PAYMENT = 1;
     */
    BILL_PAYMENT = 1,
    /**
     * @generated from protobuf enum value: TRANSACTION_TYPE_RETURN = 2;
     */
    RETURN = 2
}
/**
 * Receivable is a frontend-facing abstraction around receivable ledger entries
 *
 * @generated from protobuf message rd.txn.Receivable
 */
export interface Receivable {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp date = 2
     */
    date?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money original = 3
     */
    original?: Money; // positive for charges, negative for credits
    /**
     * @generated from protobuf field: rd.proto.money.Money balance = 4
     */
    balance?: Money; // positive for charges, negative for credits
    /**
     * @generated from protobuf field: rd.proto.money.Money running_balance = 5
     */
    runningBalance?: Money;
    /**
     * @generated from protobuf field: rd.txn.Receivable.Type type = 6
     */
    type: Receivable_Type;
    /**
     * @generated from protobuf field: rd.txn.Receivable.Invoice invoice = 7
     */
    invoice?: Receivable_Invoice;
    /**
     * @generated from protobuf field: rd.txn.Receivable.Transaction transaction = 8
     */
    transaction?: Receivable_Transaction;
    /**
     * @generated from protobuf field: rd.txn.Receivable.Customer customer = 9
     */
    customer?: Receivable_Customer;
    /**
     * @generated from protobuf field: rd.txn.Receivable.Job job = 10
     */
    job?: Receivable_Job;
    /**
     * @generated from protobuf field: rd.txn.Receivable.PurchaseOrder purchase_order = 11
     */
    purchaseOrder?: Receivable_PurchaseOrder;
    /**
     * @generated from protobuf field: rd.txn.Receivable.Location location = 12
     */
    location?: Receivable_Location;
    /**
     * @generated from protobuf field: rd.user.User user = 13
     */
    user?: User;
    /**
     * @generated from protobuf field: rd.txn.Receivable.Contact contact = 14
     */
    contact?: Receivable_Contact;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal days_to_pay = 15
     */
    daysToPay?: Decimal;
}
/**
 * @generated from protobuf message rd.txn.Receivable.Invoice
 */
export interface Receivable_Invoice {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp due_date = 1
     */
    dueDate?: Timestamp;
    /**
     * @generated from protobuf field: int32 days_overdue = 2
     */
    daysOverdue: number;
    /**
     * @generated from protobuf field: rd.proto.money.Money potential_discount = 3
     */
    potentialDiscount?: Money; // negative
    /**
     * @generated from protobuf field: google.protobuf.Timestamp potential_discount_expires_at = 4
     */
    potentialDiscountExpiresAt?: Timestamp;
}
/**
 * @generated from protobuf message rd.txn.Receivable.Transaction
 */
export interface Receivable_Transaction {
    /**
     * @generated from protobuf field: rd.txn.Receivable.Transaction.Type type = 1
     */
    type: Receivable_Transaction_Type;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 2
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string identifier = 3
     */
    identifier: string;
}
/**
 * @generated from protobuf enum rd.txn.Receivable.Transaction.Type
 */
export enum Receivable_Transaction_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_INVOICE = 1;
     */
    INVOICE = 1,
    /**
     * @generated from protobuf enum value: TYPE_BILL_PAYMENT = 2;
     */
    BILL_PAYMENT = 2,
    /**
     * @generated from protobuf enum value: TYPE_RETURN = 4;
     */
    RETURN = 4,
    /**
     * @generated from protobuf enum value: TYPE_BILL_REFUND = 5;
     */
    BILL_REFUND = 5,
    /**
     * @generated from protobuf enum value: TYPE_FINANCE_CHARGE = 6;
     */
    FINANCE_CHARGE = 6,
    /**
     * @generated from protobuf enum value: TYPE_DISCOUNT = 7;
     */
    DISCOUNT = 7,
    /**
     * @generated from protobuf enum value: TYPE_DISCOUNT_REVERSAL = 8;
     */
    DISCOUNT_REVERSAL = 8,
    /**
     * @generated from protobuf enum value: TYPE_DEPOSIT_REDEMPTION = 9;
     */
    DEPOSIT_REDEMPTION = 9
}
/**
 * @generated from protobuf message rd.txn.Receivable.Customer
 */
export interface Receivable_Customer {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
}
/**
 * @generated from protobuf message rd.txn.Receivable.Job
 */
export interface Receivable_Job {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
}
/**
 * @generated from protobuf message rd.txn.Receivable.PurchaseOrder
 */
export interface Receivable_PurchaseOrder {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
}
/**
 * @generated from protobuf message rd.txn.Receivable.Location
 */
export interface Receivable_Location {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string prefix = 3
     */
    prefix: string;
}
/**
 * @generated from protobuf message rd.txn.Receivable.Contact
 */
export interface Receivable_Contact {
    /**
     * @generated from protobuf field: string id_string = 1
     */
    idString: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
}
/**
 * @generated from protobuf enum rd.txn.Receivable.Type
 */
export enum Receivable_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_INVOICE = 1;
     */
    INVOICE = 1,
    /**
     * @generated from protobuf enum value: TYPE_FINANCE_CHARGE = 2;
     */
    FINANCE_CHARGE = 2,
    /**
     * @generated from protobuf enum value: TYPE_CREDIT = 3;
     */
    CREDIT = 3
}
/**
 * @generated from protobuf message rd.txn.AllocatedReceivable
 */
export interface AllocatedReceivable {
    /**
     * @generated from protobuf field: rd.txn.Receivable receivable = 1
     */
    receivable?: Receivable;
    /**
     * @generated from protobuf field: rd.proto.money.Money allocation = 2
     */
    allocation?: Money; // positive for charges, negative for credits
    /**
     * @generated from protobuf field: rd.proto.money.Money discount = 3
     */
    discount?: Money; // positive
    /**
     * @generated from protobuf field: rd.proto.money.Money reversed_discount = 4
     */
    reversedDiscount?: Money; // negative
}
/**
 * @generated from protobuf message rd.txn.TenderSubmissionMetadata
 */
export interface TenderSubmissionMetadata {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID tender_method_id = 1
     */
    tenderMethodId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.Money amount = 2
     */
    amount?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money surcharge = 3
     */
    surcharge?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money surcharge_tax = 4
     */
    surchargeTax?: Money; // being deprecated
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata.SubmissionType submission_type = 5
     */
    submissionType: TenderSubmissionMetadata_SubmissionType;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata.ChargeAccount charge_account = 6
     */
    chargeAccount?: TenderSubmissionMetadata_ChargeAccount;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata.PreviousCard previous_card = 7
     */
    previousCard?: TenderSubmissionMetadata_PreviousCard;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata.PresentCard present_card = 8
     */
    presentCard?: TenderSubmissionMetadata_PresentCard;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata.SavedCard saved_card = 9
     */
    savedCard?: TenderSubmissionMetadata_SavedCard;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata.ManuallyEnteredCard manually_entered_card = 10
     */
    manuallyEnteredCard?: TenderSubmissionMetadata_ManuallyEnteredCard;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata.Cash cash = 11
     */
    cash?: TenderSubmissionMetadata_Cash;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata.Check check = 12
     */
    check?: TenderSubmissionMetadata_Check;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata.WriteOff write_off = 13
     */
    writeOff?: TenderSubmissionMetadata_WriteOff;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata.Custom custom = 14
     */
    custom?: TenderSubmissionMetadata_Custom;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata.PreviousACH previous_ach = 15
     */
    previousAch?: TenderSubmissionMetadata_PreviousACH;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata.SavedACH saved_ach = 16
     */
    savedAch?: TenderSubmissionMetadata_SavedACH;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata.GiftCard gift_card = 17
     */
    giftCard?: TenderSubmissionMetadata_GiftCard;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata.PreviousInteracCard previous_interac_card = 18
     */
    previousInteracCard?: TenderSubmissionMetadata_PreviousInteracCard;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> surcharge_tax_by_tax_rate_id = 19
     */
    surchargeTaxByTaxRateId: {
        [key: string]: Money;
    }; // only used if flag is on
}
/**
 * @generated from protobuf message rd.txn.TenderSubmissionMetadata.ChargeAccount
 */
export interface TenderSubmissionMetadata_ChargeAccount {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID cash_register_id = 2
     */
    cashRegisterId?: UUID;
}
/**
 * No additional fields needed
 *
 * @generated from protobuf message rd.txn.TenderSubmissionMetadata.PreviousCard
 */
export interface TenderSubmissionMetadata_PreviousCard {
}
/**
 * @generated from protobuf message rd.txn.TenderSubmissionMetadata.PresentCard
 */
export interface TenderSubmissionMetadata_PresentCard {
    /**
     * @generated from protobuf field: string stripe_reader_id = 1
     */
    stripeReaderId: string;
    /**
     * @generated from protobuf field: bool should_save_card = 3
     */
    shouldSaveCard: boolean;
    /**
     * @generated from protobuf field: string nickname = 4
     */
    nickname: string;
    /**
     * @generated from protobuf field: string stripe_payment_intent_id = 5
     */
    stripePaymentIntentId: string;
    /**
     * @generated from protobuf field: bool set_is_primary = 6
     */
    setIsPrimary: boolean;
    /**
     * @generated from protobuf field: bool is_interac = 7
     */
    isInterac: boolean;
    /**
     * @generated from protobuf field: string postal_code = 8
     */
    postalCode: string;
}
/**
 * @generated from protobuf message rd.txn.TenderSubmissionMetadata.SavedCard
 */
export interface TenderSubmissionMetadata_SavedCard {
    /**
     * @generated from protobuf field: string stripe_payment_method_id = 1
     */
    stripePaymentMethodId: string;
    /**
     * @generated from protobuf field: string stripe_payment_intent_id = 2
     */
    stripePaymentIntentId: string;
    /**
     * @generated from protobuf field: bool set_is_primary = 3
     */
    setIsPrimary: boolean;
    /**
     * @generated from protobuf field: bool should_save_card = 4
     */
    shouldSaveCard: boolean;
    /**
     * @generated from protobuf field: string nickname = 5
     */
    nickname: string;
}
/**
 * @generated from protobuf message rd.txn.TenderSubmissionMetadata.ManuallyEnteredCard
 */
export interface TenderSubmissionMetadata_ManuallyEnteredCard {
    /**
     * @generated from protobuf field: rd.payments.ManuallyEnteredCard card = 1
     */
    card?: ManuallyEnteredCard;
    /**
     * @generated from protobuf field: bool should_save_card = 2
     */
    shouldSaveCard: boolean;
    /**
     * @generated from protobuf field: string nickname = 3
     */
    nickname: string;
    /**
     * @generated from protobuf field: string stripe_payment_intent_id = 4
     */
    stripePaymentIntentId: string;
    /**
     * @generated from protobuf field: bool set_is_primary = 5
     */
    setIsPrimary: boolean;
}
/**
 * @generated from protobuf message rd.txn.TenderSubmissionMetadata.Cash
 */
export interface TenderSubmissionMetadata_Cash {
    /**
     * @generated from protobuf field: rd.proto.money.Money cash_received = 1
     */
    cashReceived?: Money;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID cash_register_id = 2
     */
    cashRegisterId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.Money cash_rounding_delta = 3
     */
    cashRoundingDelta?: Money;
}
/**
 * @generated from protobuf message rd.txn.TenderSubmissionMetadata.Check
 */
export interface TenderSubmissionMetadata_Check {
    /**
     * @generated from protobuf field: string check_number = 1
     */
    checkNumber: string;
}
/**
 * @generated from protobuf message rd.txn.TenderSubmissionMetadata.WriteOff
 */
export interface TenderSubmissionMetadata_WriteOff {
}
/**
 * @generated from protobuf message rd.txn.TenderSubmissionMetadata.Custom
 */
export interface TenderSubmissionMetadata_Custom {
    /**
     * @generated from protobuf field: string note = 1
     */
    note: string;
}
/**
 * No additional fields needed
 *
 * @generated from protobuf message rd.txn.TenderSubmissionMetadata.PreviousACH
 */
export interface TenderSubmissionMetadata_PreviousACH {
}
/**
 * @generated from protobuf message rd.txn.TenderSubmissionMetadata.SavedACH
 */
export interface TenderSubmissionMetadata_SavedACH {
    /**
     * @generated from protobuf field: string stripe_payment_method_id = 1
     */
    stripePaymentMethodId: string;
    /**
     * @generated from protobuf field: string nickname = 2
     */
    nickname: string;
    /**
     * @generated from protobuf field: bool set_is_primary = 3
     */
    setIsPrimary: boolean;
    /**
     * @generated from protobuf field: string stripe_payment_intent_id = 4
     */
    stripePaymentIntentId: string;
}
/**
 * @generated from protobuf message rd.txn.TenderSubmissionMetadata.GiftCard
 */
export interface TenderSubmissionMetadata_GiftCard {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID gift_card_id = 1
     */
    giftCardId?: UUID;
}
/**
 * @generated from protobuf message rd.txn.TenderSubmissionMetadata.PreviousInteracCard
 */
export interface TenderSubmissionMetadata_PreviousInteracCard {
    /**
     * @generated from protobuf field: string stripe_reader_id = 1
     */
    stripeReaderId: string;
}
/**
 * @generated from protobuf enum rd.txn.TenderSubmissionMetadata.SubmissionType
 */
export enum TenderSubmissionMetadata_SubmissionType {
    /**
     * @generated from protobuf enum value: SUBMISSION_TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * Charge account submission type
     *
     * @generated from protobuf enum value: SUBMISSION_TYPE_CHARGE_ACCOUNT = 1;
     */
    CHARGE_ACCOUNT = 1,
    /**
     * Card submission types
     *
     * @generated from protobuf enum value: SUBMISSION_TYPE_PREVIOUS_CARD = 2;
     */
    PREVIOUS_CARD = 2,
    /**
     * @generated from protobuf enum value: SUBMISSION_TYPE_PRESENT_CARD = 3;
     */
    PRESENT_CARD = 3,
    /**
     * @generated from protobuf enum value: SUBMISSION_TYPE_SAVED_CARD = 4;
     */
    SAVED_CARD = 4,
    /**
     * @generated from protobuf enum value: SUBMISSION_TYPE_MANUALLY_ENTERED_CARD = 5;
     */
    MANUALLY_ENTERED_CARD = 5,
    /**
     * Cash submission types
     *
     * @generated from protobuf enum value: SUBMISSION_TYPE_CASH = 6;
     */
    CASH = 6,
    /**
     * Check submission types
     *
     * @generated from protobuf enum value: SUBMISSION_TYPE_CHECK = 7;
     */
    CHECK = 7,
    /**
     * Write off submission types
     *
     * @generated from protobuf enum value: SUBMISSION_TYPE_WRITE_OFF = 8;
     */
    WRITE_OFF = 8,
    /**
     * Custom submission types
     *
     * @generated from protobuf enum value: SUBMISSION_TYPE_CUSTOM = 9;
     */
    CUSTOM = 9,
    /**
     * ACH submission types
     *
     * @generated from protobuf enum value: SUBMISSION_TYPE_PREVIOUS_ACH = 10;
     */
    PREVIOUS_ACH = 10,
    /**
     * @generated from protobuf enum value: SUBMISSION_TYPE_SAVED_ACH = 11;
     */
    SAVED_ACH = 11,
    /**
     * Gift card submission types
     *
     * @generated from protobuf enum value: SUBMISSION_TYPE_GIFT_CARD = 12;
     */
    GIFT_CARD = 12,
    /**
     * Interac card-present refund submission type
     *
     * @generated from protobuf enum value: SUBMISSION_TYPE_PREVIOUS_INTERAC_CARD = 13;
     */
    PREVIOUS_INTERAC_CARD = 13
}
/**
 * @generated from protobuf message rd.txn.CCPRebateReportUpload
 */
export interface CCPRebateReportUpload {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID uploaded_by_user_id = 5
     */
    uploadedByUserId?: UUID;
    /**
     * @generated from protobuf field: rd.txn.CCPRebateReportUpload.Status status = 6
     */
    status: CCPRebateReportUpload_Status;
    /**
     * @generated from protobuf field: string file_url = 7
     */
    fileUrl: string;
    /**
     * @generated from protobuf field: int32 total_rows = 9
     */
    totalRows: number;
    /**
     * @generated from protobuf field: int32 rows_matched = 10
     */
    rowsMatched: number;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney total_rebate_amount = 12
     */
    totalRebateAmount?: FractionalMoney;
    /**
     * @generated from protobuf field: string error_message = 13
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: string error_file_url = 14
     */
    errorFileUrl: string;
}
/**
 * @generated from protobuf enum rd.txn.CCPRebateReportUpload.Status
 */
export enum CCPRebateReportUpload_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATUS_PROCESSING = 1;
     */
    PROCESSING = 1,
    /**
     * @generated from protobuf enum value: STATUS_COMPLETED = 2;
     */
    COMPLETED = 2,
    /**
     * @generated from protobuf enum value: STATUS_FAILED = 3;
     */
    FAILED = 3
}
/**
 * @generated from protobuf message rd.txn.SaleCountBySource
 */
export interface SaleCountBySource {
    /**
     * @generated from protobuf field: int32 pos = 1
     */
    pos: number;
    /**
     * @generated from protobuf field: int32 ecomm = 2
     */
    ecomm: number;
}
/**
 * Delivery represents a delivery of transactions to a customer.
 *
 * @generated from protobuf message rd.txn.Delivery
 */
export interface Delivery {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 3
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 4
     */
    locationId?: UUID; // location delivery is dispatched from
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp; // internal timestamp
    /**
     * @generated from protobuf field: rd.user.User created_by = 6
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7
     */
    updatedAt?: Timestamp; // internal timestamp
    /**
     * @generated from protobuf field: rd.user.User updated_by = 8
     */
    updatedBy?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp departure_time = 9
     */
    departureTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp return_time = 10
     */
    returnTime?: Timestamp;
    /**
     * @generated from protobuf field: string carrier = 11
     */
    carrier: string; // e.g. truck number, UPS tracking number, FedEx tracking number, etc.
    /**
     * @generated from protobuf field: rd.user.User assigned_to = 12
     */
    assignedTo?: User; // e.g. delivery driver
    /**
     * @generated from protobuf field: string notes = 15
     */
    notes: string;
    /**
     * @generated from protobuf field: string internal_notes = 16
     */
    internalNotes: string;
}
/**
 * used for stop status metadata
 *
 * @generated from protobuf message rd.txn.Delivery.StatusMetadata
 */
export interface Delivery_StatusMetadata {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp at = 1
     */
    at?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User by = 2
     */
    by?: User;
}
/**
 * Derived from the stops on read; never stored.
 *
 * @generated from protobuf enum rd.txn.Delivery.Status
 */
export enum Delivery_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATUS_SCHEDULED = 1;
     */
    SCHEDULED = 1,
    /**
     * @generated from protobuf enum value: STATUS_IN_PROGRESS = 2;
     */
    IN_PROGRESS = 2,
    /**
     * @generated from protobuf enum value: STATUS_COMPLETED = 3;
     */
    COMPLETED = 3,
    /**
     * @generated from protobuf enum value: STATUS_VOIDED = 4;
     */
    VOIDED = 4
}
/**
 * DeliveryStop is a delivery drop.
 *
 * @generated from protobuf message rd.txn.DeliveryStop
 */
export interface DeliveryStop {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID delivery_id = 3
     */
    deliveryId?: UUID; // empty while staged
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID dispatch_location_id = 4
     */
    dispatchLocationId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 6
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 8
     */
    updatedBy?: User;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID sale_ids = 9
     */
    saleIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID customer_ids = 10
     */
    customerIds: UUID[];
    /**
     * @generated from protobuf field: string internal_notes = 14
     */
    internalNotes: string;
    /**
     * @generated from protobuf field: rd.txn.DeliveryStop.Status status = 15
     */
    status: DeliveryStop_Status;
    /**
     * @generated from protobuf field: map<int32, rd.txn.Delivery.StatusMetadata> metadata_by_status = 16
     */
    metadataByStatus: {
        [key: number]: Delivery_StatusMetadata;
    };
    /**
     * @generated from protobuf field: int32 position = 17
     */
    position: number; // 0 while staged
    /**
     * @generated from protobuf field: rd.txn.DeliveryDetails details = 18
     */
    details?: DeliveryDetails; // customer request details
    /**
     * @generated from protobuf field: map<string, rd.txn.DeliveryStop.DeliveryAttempt> delivery_attempts_by_id = 19
     */
    deliveryAttemptsById: {
        [key: string]: DeliveryStop_DeliveryAttempt;
    }; // keyed by id
}
/**
 * @generated from protobuf message rd.txn.DeliveryStop.DeliveryAttempt
 */
export interface DeliveryStop_DeliveryAttempt {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // set by the client so a retried request appends once
    /**
     * @generated from protobuf field: rd.txn.DeliveryStop.DeliveryAttempt.Status status = 2
     */
    status: DeliveryStop_DeliveryAttempt_Status;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp at = 3
     */
    at?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User by = 4
     */
    by?: User;
    /**
     * Both ids are set by the backend from the rd.attachment.Attachments with parent_id == id.
     *
     * @generated from protobuf field: rd.proto.uuid.UUID signature_attachment_id = 5
     */
    signatureAttachmentId?: UUID; // the attachment named signature_*
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID photo_attachment_ids = 6
     */
    photoAttachmentIds: UUID[]; // every other attachment, oldest first
    /**
     * @generated from protobuf field: string notes = 7
     */
    notes: string;
}
/**
 * @generated from protobuf enum rd.txn.DeliveryStop.DeliveryAttempt.Status
 */
export enum DeliveryStop_DeliveryAttempt_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATUS_FAIL = 1;
     */
    FAIL = 1,
    /**
     * @generated from protobuf enum value: STATUS_SUCCESS = 2;
     */
    SUCCESS = 2
}
/**
 * @generated from protobuf enum rd.txn.DeliveryStop.Status
 */
export enum DeliveryStop_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATUS_ATTACHED = 1;
     */
    ATTACHED = 1,
    /**
     * @generated from protobuf enum value: STATUS_LOADED = 2;
     */
    LOADED = 2,
    /**
     * @generated from protobuf enum value: STATUS_IN_PROGRESS = 3;
     */
    IN_PROGRESS = 3,
    /**
     * @generated from protobuf enum value: STATUS_DELIVERED = 4;
     */
    DELIVERED = 4,
    /**
     * @generated from protobuf enum value: STATUS_CANCELLED = 5;
     */
    CANCELLED = 5,
    /**
     * waiting to be routed
     *
     * @generated from protobuf enum value: STATUS_STAGED = 6;
     */
    STAGED = 6
}
/**
 * DeliveryDetails holds the details collected when staging a stop or
 * attaching one to a delivery.
 *
 * @generated from protobuf message rd.txn.DeliveryDetails
 */
export interface DeliveryDetails {
    /**
     * @generated from protobuf field: rd.proto.address.Address address = 1
     */
    address?: Address;
    /**
     * @generated from protobuf field: rd.txn.DeliveryDetails.Contact contact = 2
     */
    contact?: DeliveryDetails_Contact;
    /**
     * @generated from protobuf field: string notes = 3
     */
    notes: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp requested_date = 4
     */
    requestedDate?: Timestamp;
    /**
     * @generated from protobuf field: repeated string customer_contact_id_strings = 5
     */
    customerContactIdStrings: string[];
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange requested_date_range = 6
     */
    requestedDateRange?: TimestampRange;
}
/**
 * @generated from protobuf message rd.txn.DeliveryDetails.Contact
 */
export interface DeliveryDetails_Contact {
    /**
     * @generated from protobuf field: string phone = 1
     */
    phone: string;
    /**
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * @generated from protobuf field: string email = 3
     */
    email: string;
}
/**
 * CreditAllocationStatus represents the current status of the credit
 * created from a bill payment or return. This should only be used on
 * the bill payment and return models right now.
 *
 * @generated from protobuf enum rd.txn.CreditAllocationStatus
 */
export enum CreditAllocationStatus {
    /**
     * @generated from protobuf enum value: CREDIT_ALLOCATION_STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: CREDIT_ALLOCATION_STATUS_UNALLOCATED = 1;
     */
    UNALLOCATED = 1,
    /**
     * @generated from protobuf enum value: CREDIT_ALLOCATION_STATUS_PARTIALLY_ALLOCATED = 2;
     */
    PARTIALLY_ALLOCATED = 2,
    /**
     * @generated from protobuf enum value: CREDIT_ALLOCATION_STATUS_FULLY_ALLOCATED = 3;
     */
    FULLY_ALLOCATED = 3,
    /**
     * @generated from protobuf enum value: CREDIT_ALLOCATION_STATUS_REFUNDED = 4;
     */
    REFUNDED = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class Sale$Type extends MessageType<Sale> {
    constructor() {
        super("rd.txn.Sale", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "customer_id", kind: "message", T: () => UUID },
            { no: 7, name: "customer_purchase_order_id", kind: "message", T: () => UUID },
            { no: 8, name: "location_id", kind: "message", T: () => UUID },
            { no: 9, name: "created_by", kind: "message", T: () => User },
            { no: 10, name: "quoted_by", kind: "message", T: () => User },
            { no: 11, name: "sold_by", kind: "message", T: () => User },
            { no: 12, name: "updated_by", kind: "message", T: () => User },
            { no: 13, name: "voided_by", kind: "message", T: () => User },
            { no: 14, name: "will_called_by", kind: "message", T: () => User },
            { no: 15, name: "quoted_at", kind: "message", T: () => Timestamp },
            { no: 16, name: "quote_expires_at", kind: "message", T: () => Timestamp },
            { no: 17, name: "will_called_at", kind: "message", T: () => Timestamp },
            { no: 18, name: "voided_at", kind: "message", T: () => Timestamp },
            { no: 19, name: "sold_at", kind: "message", T: () => Timestamp },
            { no: 20, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "status", kind: "enum", T: () => ["rd.txn.Sale.Status", Sale_Status, "STATUS_"] },
            { no: 22, name: "sale_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 26, name: "customer_contact_id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "signature_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "tax_rate", kind: "message", T: () => Decimal },
            { no: 29, name: "tax_rate_id", kind: "message", T: () => UUID },
            { no: 30, name: "subtotal", kind: "message", T: () => Money },
            { no: 31, name: "total", kind: "message", T: () => Money },
            { no: 32, name: "adjusted_total", kind: "message", T: () => Money },
            { no: 33, name: "card_surcharge_rate", kind: "message", T: () => Decimal },
            { no: 34, name: "card_surcharge", kind: "message", T: () => Money },
            { no: 35, name: "card_surcharge_tax", kind: "message", T: () => Money },
            { no: 36, name: "total_early_payment_discount_adjustment", kind: "message", T: () => Money },
            { no: 37, name: "internal_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.cxa": true } },
            { no: 40, name: "address", kind: "message", T: () => Address },
            { no: 41, name: "special_ordered_by", kind: "message", T: () => User },
            { no: 42, name: "special_ordered_at", kind: "message", T: () => Timestamp },
            { no: 43, name: "special_order_sale", kind: "message", T: () => Sale_SpecialOrderSale },
            { no: 45, name: "sales_tax", kind: "message", T: () => Money },
            { no: 46, name: "rounding_adjustment", kind: "message", T: () => Money },
            { no: 47, name: "type", kind: "enum", T: () => ["rd.txn.Sale.Type", Sale_Type, "TYPE_"] },
            { no: 48, name: "returned_from_sale_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 50, name: "restock_fee_percentage", kind: "message", T: () => Decimal },
            { no: 51, name: "restock_fee_amount", kind: "message", T: () => Money },
            { no: 52, name: "restock_fee_applied", kind: "message", T: () => Money },
            { no: 54, name: "totals", kind: "message", T: () => Sale_Totals },
            { no: 55, name: "totals_by_returned_from_sale_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Sale_Totals } },
            { no: 58, name: "credit_allocation_status", kind: "enum", T: () => ["rd.txn.CreditAllocationStatus", CreditAllocationStatus, "CREDIT_ALLOCATION_STATUS_"] },
            { no: 59, name: "fulfillment_location_id", kind: "message", T: () => UUID },
            { no: 60, name: "is_delivery_fulfillment", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 61, name: "initial_deposit", kind: "message", T: () => Money },
            { no: 64, name: "discount_amount", kind: "message", T: () => Money },
            { no: 65, name: "discount_rate", kind: "message", T: () => Decimal },
            { no: 66, name: "delivery_date", kind: "message", T: () => Timestamp },
            { no: 67, name: "close_out_status", kind: "enum", T: () => ["rd.txn.Sale.CloseOutStatus", Sale_CloseOutStatus, "CLOSE_OUT_STATUS_"] },
            { no: 68, name: "closed_out_at", kind: "message", T: () => Timestamp },
            { no: 69, name: "closed_out_by", kind: "message", T: () => User },
            { no: 70, name: "source", kind: "enum", T: () => ["rd.txn.Sale.Source", Sale_Source, "SOURCE_"] },
            { no: 71, name: "additional_fees_by_name_v2", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Sale_Totals_AdditionalFee } },
            { no: 72, name: "item_sets_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Sale_ItemSet } },
            { no: 73, name: "designated_clerk_id", kind: "message", T: () => UUID },
            { no: 74, name: "tax_rate_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 75, name: "tax_rate_by_tax_rate_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Decimal } },
            { no: 76, name: "surcharge_tax_by_tax_rate_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 77, name: "is_staged_for_delivery", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 79, name: "initial_deposit_rate", kind: "message", T: () => Decimal },
            { no: 80, name: "tax_components_by_tax_rate_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Sale_TaxComponents } },
            { no: 81, name: "sale_type_id", kind: "message", T: () => UUID },
            { no: 82, name: "tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<Sale>): Sale {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.status = 0;
        message.saleNotes = "";
        message.customerContactIdString = "";
        message.signatureUrl = "";
        message.internalNotes = "";
        message.type = 0;
        message.returnedFromSaleIds = [];
        message.totalsByReturnedFromSaleId = {};
        message.creditAllocationStatus = 0;
        message.isDeliveryFulfillment = false;
        message.closeOutStatus = 0;
        message.source = 0;
        message.additionalFeesByNameV2 = {};
        message.itemSetsById = {};
        message.taxRateIds = [];
        message.taxRateByTaxRateId = {};
        message.surchargeTaxByTaxRateId = {};
        message.isStagedForDelivery = false;
        message.taxComponentsByTaxRateId = {};
        message.tagIds = [];
        if (value !== undefined)
            reflectionMergePartial<Sale>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Sale): Sale {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 5:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.uuid.UUID customer_purchase_order_id */ 7:
                    message.customerPurchaseOrderId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerPurchaseOrderId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 8:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.user.User created_by */ 9:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.user.User quoted_by */ 10:
                    message.quotedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.quotedBy);
                    break;
                case /* rd.user.User sold_by */ 11:
                    message.soldBy = User.internalBinaryRead(reader, reader.uint32(), options, message.soldBy);
                    break;
                case /* rd.user.User updated_by */ 12:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* rd.user.User voided_by */ 13:
                    message.voidedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.voidedBy);
                    break;
                case /* rd.user.User will_called_by */ 14:
                    message.willCalledBy = User.internalBinaryRead(reader, reader.uint32(), options, message.willCalledBy);
                    break;
                case /* google.protobuf.Timestamp quoted_at */ 15:
                    message.quotedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.quotedAt);
                    break;
                case /* google.protobuf.Timestamp quote_expires_at */ 16:
                    message.quoteExpiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.quoteExpiresAt);
                    break;
                case /* google.protobuf.Timestamp will_called_at */ 17:
                    message.willCalledAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.willCalledAt);
                    break;
                case /* google.protobuf.Timestamp voided_at */ 18:
                    message.voidedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.voidedAt);
                    break;
                case /* google.protobuf.Timestamp sold_at */ 19:
                    message.soldAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.soldAt);
                    break;
                case /* string identifier */ 20:
                    message.identifier = reader.string();
                    break;
                case /* rd.txn.Sale.Status status */ 21:
                    message.status = reader.int32();
                    break;
                case /* string sale_notes */ 22:
                    message.saleNotes = reader.string();
                    break;
                case /* string customer_contact_id_string */ 26:
                    message.customerContactIdString = reader.string();
                    break;
                case /* string signature_url */ 27:
                    message.signatureUrl = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal tax_rate */ 28:
                    message.taxRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.taxRate);
                    break;
                case /* rd.proto.uuid.UUID tax_rate_id */ 29:
                    message.taxRateId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.taxRateId);
                    break;
                case /* rd.proto.money.Money subtotal */ 30:
                    message.subtotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.subtotal);
                    break;
                case /* rd.proto.money.Money total */ 31:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* rd.proto.money.Money adjusted_total */ 32:
                    message.adjustedTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.adjustedTotal);
                    break;
                case /* rd.proto.decimal.Decimal card_surcharge_rate */ 33:
                    message.cardSurchargeRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.cardSurchargeRate);
                    break;
                case /* rd.proto.money.Money card_surcharge */ 34:
                    message.cardSurcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurcharge);
                    break;
                case /* rd.proto.money.Money card_surcharge_tax */ 35:
                    message.cardSurchargeTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurchargeTax);
                    break;
                case /* rd.proto.money.Money total_early_payment_discount_adjustment */ 36:
                    message.totalEarlyPaymentDiscountAdjustment = Money.internalBinaryRead(reader, reader.uint32(), options, message.totalEarlyPaymentDiscountAdjustment);
                    break;
                case /* string internal_notes */ 37:
                    message.internalNotes = reader.string();
                    break;
                case /* rd.proto.address.Address address */ 40:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                case /* rd.user.User special_ordered_by */ 41:
                    message.specialOrderedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.specialOrderedBy);
                    break;
                case /* google.protobuf.Timestamp special_ordered_at */ 42:
                    message.specialOrderedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.specialOrderedAt);
                    break;
                case /* rd.txn.Sale.SpecialOrderSale special_order_sale */ 43:
                    message.specialOrderSale = Sale_SpecialOrderSale.internalBinaryRead(reader, reader.uint32(), options, message.specialOrderSale);
                    break;
                case /* rd.proto.money.Money sales_tax */ 45:
                    message.salesTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.salesTax);
                    break;
                case /* rd.proto.money.Money rounding_adjustment */ 46:
                    message.roundingAdjustment = Money.internalBinaryRead(reader, reader.uint32(), options, message.roundingAdjustment);
                    break;
                case /* rd.txn.Sale.Type type */ 47:
                    message.type = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID returned_from_sale_ids */ 48:
                    message.returnedFromSaleIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.decimal.Decimal restock_fee_percentage */ 50:
                    message.restockFeePercentage = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.restockFeePercentage);
                    break;
                case /* rd.proto.money.Money restock_fee_amount */ 51:
                    message.restockFeeAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.restockFeeAmount);
                    break;
                case /* rd.proto.money.Money restock_fee_applied */ 52:
                    message.restockFeeApplied = Money.internalBinaryRead(reader, reader.uint32(), options, message.restockFeeApplied);
                    break;
                case /* rd.txn.Sale.Totals totals */ 54:
                    message.totals = Sale_Totals.internalBinaryRead(reader, reader.uint32(), options, message.totals);
                    break;
                case /* map<string, rd.txn.Sale.Totals> totals_by_returned_from_sale_id */ 55:
                    this.binaryReadMap55(message.totalsByReturnedFromSaleId, reader, options);
                    break;
                case /* rd.txn.CreditAllocationStatus credit_allocation_status */ 58:
                    message.creditAllocationStatus = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID fulfillment_location_id */ 59:
                    message.fulfillmentLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.fulfillmentLocationId);
                    break;
                case /* bool is_delivery_fulfillment */ 60:
                    message.isDeliveryFulfillment = reader.bool();
                    break;
                case /* rd.proto.money.Money initial_deposit */ 61:
                    message.initialDeposit = Money.internalBinaryRead(reader, reader.uint32(), options, message.initialDeposit);
                    break;
                case /* rd.proto.money.Money discount_amount */ 64:
                    message.discountAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.discountAmount);
                    break;
                case /* rd.proto.decimal.Decimal discount_rate */ 65:
                    message.discountRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.discountRate);
                    break;
                case /* google.protobuf.Timestamp delivery_date */ 66:
                    message.deliveryDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deliveryDate);
                    break;
                case /* rd.txn.Sale.CloseOutStatus close_out_status */ 67:
                    message.closeOutStatus = reader.int32();
                    break;
                case /* google.protobuf.Timestamp closed_out_at */ 68:
                    message.closedOutAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.closedOutAt);
                    break;
                case /* rd.user.User closed_out_by */ 69:
                    message.closedOutBy = User.internalBinaryRead(reader, reader.uint32(), options, message.closedOutBy);
                    break;
                case /* rd.txn.Sale.Source source */ 70:
                    message.source = reader.int32();
                    break;
                case /* map<string, rd.txn.Sale.Totals.AdditionalFee> additional_fees_by_name_v2 */ 71:
                    this.binaryReadMap71(message.additionalFeesByNameV2, reader, options);
                    break;
                case /* map<string, rd.txn.Sale.ItemSet> item_sets_by_id */ 72:
                    this.binaryReadMap72(message.itemSetsById, reader, options);
                    break;
                case /* rd.proto.uuid.UUID designated_clerk_id */ 73:
                    message.designatedClerkId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.designatedClerkId);
                    break;
                case /* repeated rd.proto.uuid.UUID tax_rate_ids */ 74:
                    message.taxRateIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<string, rd.proto.decimal.Decimal> tax_rate_by_tax_rate_id */ 75:
                    this.binaryReadMap75(message.taxRateByTaxRateId, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> surcharge_tax_by_tax_rate_id */ 76:
                    this.binaryReadMap76(message.surchargeTaxByTaxRateId, reader, options);
                    break;
                case /* bool is_staged_for_delivery */ 77:
                    message.isStagedForDelivery = reader.bool();
                    break;
                case /* rd.proto.decimal.Decimal initial_deposit_rate */ 79:
                    message.initialDepositRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.initialDepositRate);
                    break;
                case /* map<string, rd.txn.Sale.TaxComponents> tax_components_by_tax_rate_id */ 80:
                    this.binaryReadMap80(message.taxComponentsByTaxRateId, reader, options);
                    break;
                case /* rd.proto.uuid.UUID sale_type_id */ 81:
                    message.saleTypeId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleTypeId);
                    break;
                case /* repeated rd.proto.uuid.UUID tag_ids */ 82:
                    message.tagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap55(map: Sale["totalsByReturnedFromSaleId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Sale["totalsByReturnedFromSaleId"] | undefined, val: Sale["totalsByReturnedFromSaleId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Sale_Totals.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.Sale.totals_by_returned_from_sale_id");
            }
        }
        map[key ?? ""] = val ?? Sale_Totals.create();
    }
    private binaryReadMap71(map: Sale["additionalFeesByNameV2"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Sale["additionalFeesByNameV2"] | undefined, val: Sale["additionalFeesByNameV2"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Sale_Totals_AdditionalFee.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.Sale.additional_fees_by_name_v2");
            }
        }
        map[key ?? ""] = val ?? Sale_Totals_AdditionalFee.create();
    }
    private binaryReadMap72(map: Sale["itemSetsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Sale["itemSetsById"] | undefined, val: Sale["itemSetsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Sale_ItemSet.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.Sale.item_sets_by_id");
            }
        }
        map[key ?? ""] = val ?? Sale_ItemSet.create();
    }
    private binaryReadMap75(map: Sale["taxRateByTaxRateId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Sale["taxRateByTaxRateId"] | undefined, val: Sale["taxRateByTaxRateId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Decimal.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.Sale.tax_rate_by_tax_rate_id");
            }
        }
        map[key ?? ""] = val ?? Decimal.create();
    }
    private binaryReadMap76(map: Sale["surchargeTaxByTaxRateId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Sale["surchargeTaxByTaxRateId"] | undefined, val: Sale["surchargeTaxByTaxRateId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.Sale.surcharge_tax_by_tax_rate_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap80(map: Sale["taxComponentsByTaxRateId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Sale["taxComponentsByTaxRateId"] | undefined, val: Sale["taxComponentsByTaxRateId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Sale_TaxComponents.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.Sale.tax_components_by_tax_rate_id");
            }
        }
        map[key ?? ""] = val ?? Sale_TaxComponents.create();
    }
    internalBinaryWrite(message: Sale, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 5; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_purchase_order_id = 7; */
        if (message.customerPurchaseOrderId)
            UUID.internalBinaryWrite(message.customerPurchaseOrderId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 8; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 9; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User quoted_by = 10; */
        if (message.quotedBy)
            User.internalBinaryWrite(message.quotedBy, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User sold_by = 11; */
        if (message.soldBy)
            User.internalBinaryWrite(message.soldBy, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 12; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User voided_by = 13; */
        if (message.voidedBy)
            User.internalBinaryWrite(message.voidedBy, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User will_called_by = 14; */
        if (message.willCalledBy)
            User.internalBinaryWrite(message.willCalledBy, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp quoted_at = 15; */
        if (message.quotedAt)
            Timestamp.internalBinaryWrite(message.quotedAt, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp quote_expires_at = 16; */
        if (message.quoteExpiresAt)
            Timestamp.internalBinaryWrite(message.quoteExpiresAt, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp will_called_at = 17; */
        if (message.willCalledAt)
            Timestamp.internalBinaryWrite(message.willCalledAt, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp voided_at = 18; */
        if (message.voidedAt)
            Timestamp.internalBinaryWrite(message.voidedAt, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp sold_at = 19; */
        if (message.soldAt)
            Timestamp.internalBinaryWrite(message.soldAt, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 20; */
        if (message.identifier !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.identifier);
        /* rd.txn.Sale.Status status = 21; */
        if (message.status !== 0)
            writer.tag(21, WireType.Varint).int32(message.status);
        /* string sale_notes = 22; */
        if (message.saleNotes !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.saleNotes);
        /* string customer_contact_id_string = 26; */
        if (message.customerContactIdString !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.customerContactIdString);
        /* string signature_url = 27; */
        if (message.signatureUrl !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.signatureUrl);
        /* rd.proto.decimal.Decimal tax_rate = 28; */
        if (message.taxRate)
            Decimal.internalBinaryWrite(message.taxRate, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID tax_rate_id = 29; */
        if (message.taxRateId)
            UUID.internalBinaryWrite(message.taxRateId, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money subtotal = 30; */
        if (message.subtotal)
            Money.internalBinaryWrite(message.subtotal, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total = 31; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money adjusted_total = 32; */
        if (message.adjustedTotal)
            Money.internalBinaryWrite(message.adjustedTotal, writer.tag(32, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal card_surcharge_rate = 33; */
        if (message.cardSurchargeRate)
            Decimal.internalBinaryWrite(message.cardSurchargeRate, writer.tag(33, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money card_surcharge = 34; */
        if (message.cardSurcharge)
            Money.internalBinaryWrite(message.cardSurcharge, writer.tag(34, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money card_surcharge_tax = 35; */
        if (message.cardSurchargeTax)
            Money.internalBinaryWrite(message.cardSurchargeTax, writer.tag(35, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total_early_payment_discount_adjustment = 36; */
        if (message.totalEarlyPaymentDiscountAdjustment)
            Money.internalBinaryWrite(message.totalEarlyPaymentDiscountAdjustment, writer.tag(36, WireType.LengthDelimited).fork(), options).join();
        /* string internal_notes = 37; */
        if (message.internalNotes !== "")
            writer.tag(37, WireType.LengthDelimited).string(message.internalNotes);
        /* rd.proto.address.Address address = 40; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(40, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User special_ordered_by = 41; */
        if (message.specialOrderedBy)
            User.internalBinaryWrite(message.specialOrderedBy, writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp special_ordered_at = 42; */
        if (message.specialOrderedAt)
            Timestamp.internalBinaryWrite(message.specialOrderedAt, writer.tag(42, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Sale.SpecialOrderSale special_order_sale = 43; */
        if (message.specialOrderSale)
            Sale_SpecialOrderSale.internalBinaryWrite(message.specialOrderSale, writer.tag(43, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money sales_tax = 45; */
        if (message.salesTax)
            Money.internalBinaryWrite(message.salesTax, writer.tag(45, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money rounding_adjustment = 46; */
        if (message.roundingAdjustment)
            Money.internalBinaryWrite(message.roundingAdjustment, writer.tag(46, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Sale.Type type = 47; */
        if (message.type !== 0)
            writer.tag(47, WireType.Varint).int32(message.type);
        /* repeated rd.proto.uuid.UUID returned_from_sale_ids = 48; */
        for (let i = 0; i < message.returnedFromSaleIds.length; i++)
            UUID.internalBinaryWrite(message.returnedFromSaleIds[i], writer.tag(48, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal restock_fee_percentage = 50; */
        if (message.restockFeePercentage)
            Decimal.internalBinaryWrite(message.restockFeePercentage, writer.tag(50, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money restock_fee_amount = 51; */
        if (message.restockFeeAmount)
            Money.internalBinaryWrite(message.restockFeeAmount, writer.tag(51, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money restock_fee_applied = 52; */
        if (message.restockFeeApplied)
            Money.internalBinaryWrite(message.restockFeeApplied, writer.tag(52, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Sale.Totals totals = 54; */
        if (message.totals)
            Sale_Totals.internalBinaryWrite(message.totals, writer.tag(54, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.txn.Sale.Totals> totals_by_returned_from_sale_id = 55; */
        for (let k of globalThis.Object.keys(message.totalsByReturnedFromSaleId)) {
            writer.tag(55, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Sale_Totals.internalBinaryWrite(message.totalsByReturnedFromSaleId[k], writer, options);
            writer.join().join();
        }
        /* rd.txn.CreditAllocationStatus credit_allocation_status = 58; */
        if (message.creditAllocationStatus !== 0)
            writer.tag(58, WireType.Varint).int32(message.creditAllocationStatus);
        /* rd.proto.uuid.UUID fulfillment_location_id = 59; */
        if (message.fulfillmentLocationId)
            UUID.internalBinaryWrite(message.fulfillmentLocationId, writer.tag(59, WireType.LengthDelimited).fork(), options).join();
        /* bool is_delivery_fulfillment = 60; */
        if (message.isDeliveryFulfillment !== false)
            writer.tag(60, WireType.Varint).bool(message.isDeliveryFulfillment);
        /* rd.proto.money.Money initial_deposit = 61; */
        if (message.initialDeposit)
            Money.internalBinaryWrite(message.initialDeposit, writer.tag(61, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money discount_amount = 64; */
        if (message.discountAmount)
            Money.internalBinaryWrite(message.discountAmount, writer.tag(64, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal discount_rate = 65; */
        if (message.discountRate)
            Decimal.internalBinaryWrite(message.discountRate, writer.tag(65, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp delivery_date = 66; */
        if (message.deliveryDate)
            Timestamp.internalBinaryWrite(message.deliveryDate, writer.tag(66, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Sale.CloseOutStatus close_out_status = 67; */
        if (message.closeOutStatus !== 0)
            writer.tag(67, WireType.Varint).int32(message.closeOutStatus);
        /* google.protobuf.Timestamp closed_out_at = 68; */
        if (message.closedOutAt)
            Timestamp.internalBinaryWrite(message.closedOutAt, writer.tag(68, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User closed_out_by = 69; */
        if (message.closedOutBy)
            User.internalBinaryWrite(message.closedOutBy, writer.tag(69, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Sale.Source source = 70; */
        if (message.source !== 0)
            writer.tag(70, WireType.Varint).int32(message.source);
        /* map<string, rd.txn.Sale.Totals.AdditionalFee> additional_fees_by_name_v2 = 71; */
        for (let k of globalThis.Object.keys(message.additionalFeesByNameV2)) {
            writer.tag(71, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Sale_Totals_AdditionalFee.internalBinaryWrite(message.additionalFeesByNameV2[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.txn.Sale.ItemSet> item_sets_by_id = 72; */
        for (let k of globalThis.Object.keys(message.itemSetsById)) {
            writer.tag(72, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Sale_ItemSet.internalBinaryWrite(message.itemSetsById[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.uuid.UUID designated_clerk_id = 73; */
        if (message.designatedClerkId)
            UUID.internalBinaryWrite(message.designatedClerkId, writer.tag(73, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tax_rate_ids = 74; */
        for (let i = 0; i < message.taxRateIds.length; i++)
            UUID.internalBinaryWrite(message.taxRateIds[i], writer.tag(74, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.decimal.Decimal> tax_rate_by_tax_rate_id = 75; */
        for (let k of globalThis.Object.keys(message.taxRateByTaxRateId)) {
            writer.tag(75, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Decimal.internalBinaryWrite(message.taxRateByTaxRateId[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> surcharge_tax_by_tax_rate_id = 76; */
        for (let k of globalThis.Object.keys(message.surchargeTaxByTaxRateId)) {
            writer.tag(76, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.surchargeTaxByTaxRateId[k], writer, options);
            writer.join().join();
        }
        /* bool is_staged_for_delivery = 77; */
        if (message.isStagedForDelivery !== false)
            writer.tag(77, WireType.Varint).bool(message.isStagedForDelivery);
        /* rd.proto.decimal.Decimal initial_deposit_rate = 79; */
        if (message.initialDepositRate)
            Decimal.internalBinaryWrite(message.initialDepositRate, writer.tag(79, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.txn.Sale.TaxComponents> tax_components_by_tax_rate_id = 80; */
        for (let k of globalThis.Object.keys(message.taxComponentsByTaxRateId)) {
            writer.tag(80, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Sale_TaxComponents.internalBinaryWrite(message.taxComponentsByTaxRateId[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.uuid.UUID sale_type_id = 81; */
        if (message.saleTypeId)
            UUID.internalBinaryWrite(message.saleTypeId, writer.tag(81, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tag_ids = 82; */
        for (let i = 0; i < message.tagIds.length; i++)
            UUID.internalBinaryWrite(message.tagIds[i], writer.tag(82, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Sale
 */
export const Sale = new Sale$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Sale_SpecialOrderSale$Type extends MessageType<Sale_SpecialOrderSale> {
    constructor() {
        super("rd.txn.Sale.SpecialOrderSale", [
            { no: 1, name: "link_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<Sale_SpecialOrderSale>): Sale_SpecialOrderSale {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Sale_SpecialOrderSale>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Sale_SpecialOrderSale): Sale_SpecialOrderSale {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID link_id */ 1:
                    message.linkId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.linkId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Sale_SpecialOrderSale, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID link_id = 1; */
        if (message.linkId)
            UUID.internalBinaryWrite(message.linkId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Sale.SpecialOrderSale
 */
export const Sale_SpecialOrderSale = new Sale_SpecialOrderSale$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Sale_Totals$Type extends MessageType<Sale_Totals> {
    constructor() {
        super("rd.txn.Sale.Totals", [
            { no: 1, name: "tax_rate", kind: "message", T: () => Decimal },
            { no: 2, name: "subtotal", kind: "message", T: () => Money },
            { no: 4, name: "base_sales_tax", kind: "message", T: () => Money },
            { no: 5, name: "card_surcharge", kind: "message", T: () => Money },
            { no: 6, name: "card_surcharge_tax", kind: "message", T: () => Money },
            { no: 7, name: "rounding_adjustment", kind: "message", T: () => Money },
            { no: 8, name: "restock_fee", kind: "message", T: () => Money },
            { no: 9, name: "total", kind: "message", T: () => Money },
            { no: 10, name: "early_payment_discount_adjustment", kind: "message", T: () => Money },
            { no: 11, name: "discount_applied", kind: "message", T: () => Money },
            { no: 12, name: "discount_rate", kind: "message", T: () => Decimal },
            { no: 13, name: "taxes_by_tax_rate_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Sale_Totals_Tax } },
            { no: 14, name: "additional_fees_by_name_v2", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Sale_Totals_AdditionalFee } },
            { no: 15, name: "cash_rounding_delta", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<Sale_Totals>): Sale_Totals {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taxesByTaxRateId = {};
        message.additionalFeesByNameV2 = {};
        if (value !== undefined)
            reflectionMergePartial<Sale_Totals>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Sale_Totals): Sale_Totals {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.decimal.Decimal tax_rate */ 1:
                    message.taxRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.taxRate);
                    break;
                case /* rd.proto.money.Money subtotal */ 2:
                    message.subtotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.subtotal);
                    break;
                case /* rd.proto.money.Money base_sales_tax */ 4:
                    message.baseSalesTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.baseSalesTax);
                    break;
                case /* rd.proto.money.Money card_surcharge */ 5:
                    message.cardSurcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurcharge);
                    break;
                case /* rd.proto.money.Money card_surcharge_tax */ 6:
                    message.cardSurchargeTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurchargeTax);
                    break;
                case /* rd.proto.money.Money rounding_adjustment */ 7:
                    message.roundingAdjustment = Money.internalBinaryRead(reader, reader.uint32(), options, message.roundingAdjustment);
                    break;
                case /* rd.proto.money.Money restock_fee */ 8:
                    message.restockFee = Money.internalBinaryRead(reader, reader.uint32(), options, message.restockFee);
                    break;
                case /* rd.proto.money.Money total */ 9:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* rd.proto.money.Money early_payment_discount_adjustment */ 10:
                    message.earlyPaymentDiscountAdjustment = Money.internalBinaryRead(reader, reader.uint32(), options, message.earlyPaymentDiscountAdjustment);
                    break;
                case /* rd.proto.money.Money discount_applied */ 11:
                    message.discountApplied = Money.internalBinaryRead(reader, reader.uint32(), options, message.discountApplied);
                    break;
                case /* rd.proto.decimal.Decimal discount_rate */ 12:
                    message.discountRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.discountRate);
                    break;
                case /* map<string, rd.txn.Sale.Totals.Tax> taxes_by_tax_rate_id */ 13:
                    this.binaryReadMap13(message.taxesByTaxRateId, reader, options);
                    break;
                case /* map<string, rd.txn.Sale.Totals.AdditionalFee> additional_fees_by_name_v2 */ 14:
                    this.binaryReadMap14(message.additionalFeesByNameV2, reader, options);
                    break;
                case /* rd.proto.money.Money cash_rounding_delta */ 15:
                    message.cashRoundingDelta = Money.internalBinaryRead(reader, reader.uint32(), options, message.cashRoundingDelta);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap13(map: Sale_Totals["taxesByTaxRateId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Sale_Totals["taxesByTaxRateId"] | undefined, val: Sale_Totals["taxesByTaxRateId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Sale_Totals_Tax.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.Sale.Totals.taxes_by_tax_rate_id");
            }
        }
        map[key ?? ""] = val ?? Sale_Totals_Tax.create();
    }
    private binaryReadMap14(map: Sale_Totals["additionalFeesByNameV2"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Sale_Totals["additionalFeesByNameV2"] | undefined, val: Sale_Totals["additionalFeesByNameV2"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Sale_Totals_AdditionalFee.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.Sale.Totals.additional_fees_by_name_v2");
            }
        }
        map[key ?? ""] = val ?? Sale_Totals_AdditionalFee.create();
    }
    internalBinaryWrite(message: Sale_Totals, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.decimal.Decimal tax_rate = 1; */
        if (message.taxRate)
            Decimal.internalBinaryWrite(message.taxRate, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money subtotal = 2; */
        if (message.subtotal)
            Money.internalBinaryWrite(message.subtotal, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money base_sales_tax = 4; */
        if (message.baseSalesTax)
            Money.internalBinaryWrite(message.baseSalesTax, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money card_surcharge = 5; */
        if (message.cardSurcharge)
            Money.internalBinaryWrite(message.cardSurcharge, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money card_surcharge_tax = 6; */
        if (message.cardSurchargeTax)
            Money.internalBinaryWrite(message.cardSurchargeTax, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money rounding_adjustment = 7; */
        if (message.roundingAdjustment)
            Money.internalBinaryWrite(message.roundingAdjustment, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money restock_fee = 8; */
        if (message.restockFee)
            Money.internalBinaryWrite(message.restockFee, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total = 9; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money early_payment_discount_adjustment = 10; */
        if (message.earlyPaymentDiscountAdjustment)
            Money.internalBinaryWrite(message.earlyPaymentDiscountAdjustment, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money discount_applied = 11; */
        if (message.discountApplied)
            Money.internalBinaryWrite(message.discountApplied, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal discount_rate = 12; */
        if (message.discountRate)
            Decimal.internalBinaryWrite(message.discountRate, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.txn.Sale.Totals.Tax> taxes_by_tax_rate_id = 13; */
        for (let k of globalThis.Object.keys(message.taxesByTaxRateId)) {
            writer.tag(13, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Sale_Totals_Tax.internalBinaryWrite(message.taxesByTaxRateId[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.txn.Sale.Totals.AdditionalFee> additional_fees_by_name_v2 = 14; */
        for (let k of globalThis.Object.keys(message.additionalFeesByNameV2)) {
            writer.tag(14, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Sale_Totals_AdditionalFee.internalBinaryWrite(message.additionalFeesByNameV2[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money cash_rounding_delta = 15; */
        if (message.cashRoundingDelta)
            Money.internalBinaryWrite(message.cashRoundingDelta, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Sale.Totals
 */
export const Sale_Totals = new Sale_Totals$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Sale_Totals_Tax$Type extends MessageType<Sale_Totals_Tax> {
    constructor() {
        super("rd.txn.Sale.Totals.Tax", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "rate", kind: "message", T: () => Decimal },
            { no: 3, name: "base_tax", kind: "message", T: () => Money },
            { no: 4, name: "surcharge_tax", kind: "message", T: () => Money },
            { no: 5, name: "tax_components", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaxComponent }
        ]);
    }
    create(value?: PartialMessage<Sale_Totals_Tax>): Sale_Totals_Tax {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taxComponents = [];
        if (value !== undefined)
            reflectionMergePartial<Sale_Totals_Tax>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Sale_Totals_Tax): Sale_Totals_Tax {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.decimal.Decimal rate */ 2:
                    message.rate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.rate);
                    break;
                case /* rd.proto.money.Money base_tax */ 3:
                    message.baseTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.baseTax);
                    break;
                case /* rd.proto.money.Money surcharge_tax */ 4:
                    message.surchargeTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.surchargeTax);
                    break;
                case /* repeated rd.company.TaxComponent tax_components */ 5:
                    message.taxComponents.push(TaxComponent.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Sale_Totals_Tax, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal rate = 2; */
        if (message.rate)
            Decimal.internalBinaryWrite(message.rate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money base_tax = 3; */
        if (message.baseTax)
            Money.internalBinaryWrite(message.baseTax, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money surcharge_tax = 4; */
        if (message.surchargeTax)
            Money.internalBinaryWrite(message.surchargeTax, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.company.TaxComponent tax_components = 5; */
        for (let i = 0; i < message.taxComponents.length; i++)
            TaxComponent.internalBinaryWrite(message.taxComponents[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Sale.Totals.Tax
 */
export const Sale_Totals_Tax = new Sale_Totals_Tax$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Sale_Totals_AdditionalFee$Type extends MessageType<Sale_Totals_AdditionalFee> {
    constructor() {
        super("rd.txn.Sale.Totals.AdditionalFee", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "amount", kind: "message", T: () => Money },
            { no: 3, name: "fee_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Sale_Totals_AdditionalFee>): Sale_Totals_AdditionalFee {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.feeId = "";
        if (value !== undefined)
            reflectionMergePartial<Sale_Totals_AdditionalFee>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Sale_Totals_AdditionalFee): Sale_Totals_AdditionalFee {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* rd.proto.money.Money amount */ 2:
                    message.amount = Money.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                case /* string fee_id */ 3:
                    message.feeId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Sale_Totals_AdditionalFee, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* rd.proto.money.Money amount = 2; */
        if (message.amount)
            Money.internalBinaryWrite(message.amount, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string fee_id = 3; */
        if (message.feeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.feeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Sale.Totals.AdditionalFee
 */
export const Sale_Totals_AdditionalFee = new Sale_Totals_AdditionalFee$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Sale_ItemSet$Type extends MessageType<Sale_ItemSet> {
    constructor() {
        super("rd.txn.Sale.ItemSet", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "sale_product_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 5, name: "sale_kit_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<Sale_ItemSet>): Sale_ItemSet {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.position = 0;
        message.saleProductIds = [];
        message.saleKitIds = [];
        if (value !== undefined)
            reflectionMergePartial<Sale_ItemSet>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Sale_ItemSet): Sale_ItemSet {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* int32 position */ 3:
                    message.position = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID sale_product_ids */ 4:
                    message.saleProductIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID sale_kit_ids */ 5:
                    message.saleKitIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Sale_ItemSet, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* int32 position = 3; */
        if (message.position !== 0)
            writer.tag(3, WireType.Varint).int32(message.position);
        /* repeated rd.proto.uuid.UUID sale_product_ids = 4; */
        for (let i = 0; i < message.saleProductIds.length; i++)
            UUID.internalBinaryWrite(message.saleProductIds[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID sale_kit_ids = 5; */
        for (let i = 0; i < message.saleKitIds.length; i++)
            UUID.internalBinaryWrite(message.saleKitIds[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Sale.ItemSet
 */
export const Sale_ItemSet = new Sale_ItemSet$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Sale_TaxComponents$Type extends MessageType<Sale_TaxComponents> {
    constructor() {
        super("rd.txn.Sale.TaxComponents", [
            { no: 1, name: "components", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaxComponent }
        ]);
    }
    create(value?: PartialMessage<Sale_TaxComponents>): Sale_TaxComponents {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.components = [];
        if (value !== undefined)
            reflectionMergePartial<Sale_TaxComponents>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Sale_TaxComponents): Sale_TaxComponents {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.company.TaxComponent components */ 1:
                    message.components.push(TaxComponent.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Sale_TaxComponents, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.company.TaxComponent components = 1; */
        for (let i = 0; i < message.components.length; i++)
            TaxComponent.internalBinaryWrite(message.components[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Sale.TaxComponents
 */
export const Sale_TaxComponents = new Sale_TaxComponents$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaleLog$Type extends MessageType<SaleLog> {
    constructor() {
        super("rd.txn.SaleLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "created_by", kind: "message", T: () => User },
            { no: 4, name: "sale", kind: "message", T: () => Sale }
        ]);
    }
    create(value?: PartialMessage<SaleLog>): SaleLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SaleLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SaleLog): SaleLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 3:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.txn.Sale sale */ 4:
                    message.sale = Sale.internalBinaryRead(reader, reader.uint32(), options, message.sale);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SaleLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 3; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Sale sale = 4; */
        if (message.sale)
            Sale.internalBinaryWrite(message.sale, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.SaleLog
 */
export const SaleLog = new SaleLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DepositConfig$Type extends MessageType<DepositConfig> {
    constructor() {
        super("rd.txn.DepositConfig", [
            { no: 1, name: "percentage", kind: "message", oneof: "value", T: () => Decimal },
            { no: 2, name: "flat_amount", kind: "message", oneof: "value", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<DepositConfig>): DepositConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.value = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<DepositConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DepositConfig): DepositConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.decimal.Decimal percentage */ 1:
                    message.value = {
                        oneofKind: "percentage",
                        percentage: Decimal.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).percentage)
                    };
                    break;
                case /* rd.proto.money.Money flat_amount */ 2:
                    message.value = {
                        oneofKind: "flatAmount",
                        flatAmount: Money.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).flatAmount)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DepositConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.decimal.Decimal percentage = 1; */
        if (message.value.oneofKind === "percentage")
            Decimal.internalBinaryWrite(message.value.percentage, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money flat_amount = 2; */
        if (message.value.oneofKind === "flatAmount")
            Money.internalBinaryWrite(message.value.flatAmount, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.DepositConfig
 */
export const DepositConfig = new DepositConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InitialDepositIntent$Type extends MessageType<InitialDepositIntent> {
    constructor() {
        super("rd.txn.InitialDepositIntent", [
            { no: 1, name: "mode", kind: "enum", T: () => ["rd.txn.InitialDepositIntent.Mode", InitialDepositIntent_Mode, "MODE_"] },
            { no: 2, name: "deposit_config", kind: "message", T: () => DepositConfig }
        ]);
    }
    create(value?: PartialMessage<InitialDepositIntent>): InitialDepositIntent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.mode = 0;
        if (value !== undefined)
            reflectionMergePartial<InitialDepositIntent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InitialDepositIntent): InitialDepositIntent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.InitialDepositIntent.Mode mode */ 1:
                    message.mode = reader.int32();
                    break;
                case /* rd.txn.DepositConfig deposit_config */ 2:
                    message.depositConfig = DepositConfig.internalBinaryRead(reader, reader.uint32(), options, message.depositConfig);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InitialDepositIntent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.InitialDepositIntent.Mode mode = 1; */
        if (message.mode !== 0)
            writer.tag(1, WireType.Varint).int32(message.mode);
        /* rd.txn.DepositConfig deposit_config = 2; */
        if (message.depositConfig)
            DepositConfig.internalBinaryWrite(message.depositConfig, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.InitialDepositIntent
 */
export const InitialDepositIntent = new InitialDepositIntent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaleProduct$Type extends MessageType<SaleProduct> {
    constructor() {
        super("rd.txn.SaleProduct", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "product_id", kind: "message", T: () => UUID },
            { no: 3, name: "sale_id", kind: "message", T: () => UUID },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "customer_id", kind: "message", T: () => UUID },
            { no: 6, name: "tint_color_id", kind: "message", T: () => UUID },
            { no: 9, name: "price", kind: "message", T: () => Money },
            { no: 12, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "custom_tint_color", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "is_price_edited", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "tier_1_price", kind: "message", T: () => Money },
            { no: 17, name: "is_taxed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "colorx_tinted_product_id", kind: "message", T: () => UUID },
            { no: 20, name: "cost_v2", kind: "message", T: () => FractionalMoney },
            { no: 21, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 23, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 24, name: "sold_at", kind: "message", T: () => Timestamp },
            { no: 25, name: "location_id", kind: "message", T: () => UUID },
            { no: 26, name: "is_cost_edited", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 28, name: "is_non_stock", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 29, name: "expected_price", kind: "message", T: () => Money },
            { no: 30, name: "standard_cost", kind: "message", T: () => FractionalMoney },
            { no: 32, name: "type", kind: "enum", T: () => ["rd.txn.SaleProduct.Type", SaleProduct_Type, "TYPE_"] },
            { no: 33, name: "returned_from_sale_id", kind: "message", T: () => UUID },
            { no: 34, name: "returned_from_sale_product_id", kind: "message", T: () => UUID },
            { no: 35, name: "custom_fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleForm_CustomField },
            { no: 36, name: "is_special_orderable_v2", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 38, name: "internal_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.cxa": true } },
            { no: 39, name: "quantity_v2", kind: "message", T: () => Decimal },
            { no: 40, name: "quantity_returned_v2", kind: "message", T: () => Decimal },
            { no: 41, name: "voided_at", kind: "message", T: () => Timestamp },
            { no: 51, name: "is_taxed_edited", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 42, name: "uom_id", kind: "message", T: () => UUID },
            { no: 43, name: "quantity_uom", kind: "message", T: () => Decimal },
            { no: 44, name: "uom_id_returned", kind: "message", T: () => UUID },
            { no: 45, name: "quantity_returned_uom", kind: "message", T: () => Decimal },
            { no: 46, name: "uom_snapshot", kind: "message", T: () => LedgerEntry_UomSnapshot },
            { no: 47, name: "uom_snapshot_returned", kind: "message", T: () => LedgerEntry_UomSnapshot },
            { no: 48, name: "spiff_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 49, name: "gift_card_id", kind: "message", T: () => UUID },
            { no: 50, name: "gift_card_initial_balance", kind: "message", T: () => Money },
            { no: 52, name: "ccp_rebates", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleProduct_CCPRebate },
            { no: 53, name: "order_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 54, name: "shipment_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 55, name: "is_active_in_buyers_list", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 56, name: "closed_out_from_sale_product_id", kind: "message", T: () => UUID },
            { no: 57, name: "additional_fees", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleProduct_AdditionalFee },
            { no: 59, name: "price_fractional", kind: "message", T: () => FractionalMoney },
            { no: 60, name: "expected_price_fractional", kind: "message", T: () => FractionalMoney },
            { no: 61, name: "rule_information", kind: "message", T: () => RuleInformation },
            { no: 62, name: "tally_rows", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleProduct_TallyRow },
            { no: 63, name: "tally_dimension", kind: "enum", T: () => ["rd.product.Product.TallyDimension", Product_TallyDimension, "TALLY_DIMENSION_"] },
            { no: 64, name: "sale_kit_id", kind: "message", T: () => UUID },
            { no: 65, name: "tally_entry_denominator", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SaleProduct>): SaleProduct {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notes = "";
        message.customTintColor = "";
        message.position = 0;
        message.isPriceEdited = false;
        message.isTaxed = false;
        message.isActive = false;
        message.isCostEdited = false;
        message.isNonStock = false;
        message.type = 0;
        message.customFields = [];
        message.isSpecialOrderableV2 = false;
        message.internalNotes = "";
        message.isTaxedEdited = false;
        message.spiffIds = [];
        message.ccpRebates = [];
        message.orderIds = [];
        message.shipmentIds = [];
        message.isActiveInBuyersList = false;
        message.additionalFees = [];
        message.tallyRows = [];
        message.tallyDimension = 0;
        message.tallyEntryDenominator = 0;
        if (value !== undefined)
            reflectionMergePartial<SaleProduct>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SaleProduct): SaleProduct {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID product_id */ 2:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 3:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 5:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.uuid.UUID tint_color_id */ 6:
                    message.tintColorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.tintColorId);
                    break;
                case /* rd.proto.money.Money price = 9 [deprecated = true] */ 9:
                    message.price = Money.internalBinaryRead(reader, reader.uint32(), options, message.price);
                    break;
                case /* string notes */ 12:
                    message.notes = reader.string();
                    break;
                case /* string custom_tint_color */ 13:
                    message.customTintColor = reader.string();
                    break;
                case /* int32 position */ 14:
                    message.position = reader.int32();
                    break;
                case /* bool is_price_edited */ 15:
                    message.isPriceEdited = reader.bool();
                    break;
                case /* rd.proto.money.Money tier_1_price */ 16:
                    message.tier1Price = Money.internalBinaryRead(reader, reader.uint32(), options, message.tier1Price);
                    break;
                case /* bool is_taxed */ 17:
                    message.isTaxed = reader.bool();
                    break;
                case /* rd.proto.uuid.UUID colorx_tinted_product_id */ 19:
                    message.colorxTintedProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.colorxTintedProductId);
                    break;
                case /* rd.proto.money.FractionalMoney cost_v2 */ 20:
                    message.costV2 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.costV2);
                    break;
                case /* bool is_active */ 21:
                    message.isActive = reader.bool();
                    break;
                case /* google.protobuf.Timestamp created_at */ 22:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 23:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp sold_at */ 24:
                    message.soldAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.soldAt);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 25:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* bool is_cost_edited */ 26:
                    message.isCostEdited = reader.bool();
                    break;
                case /* bool is_non_stock */ 28:
                    message.isNonStock = reader.bool();
                    break;
                case /* rd.proto.money.Money expected_price = 29 [deprecated = true] */ 29:
                    message.expectedPrice = Money.internalBinaryRead(reader, reader.uint32(), options, message.expectedPrice);
                    break;
                case /* rd.proto.money.FractionalMoney standard_cost */ 30:
                    message.standardCost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.standardCost);
                    break;
                case /* rd.txn.SaleProduct.Type type */ 32:
                    message.type = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID returned_from_sale_id */ 33:
                    message.returnedFromSaleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.returnedFromSaleId);
                    break;
                case /* rd.proto.uuid.UUID returned_from_sale_product_id */ 34:
                    message.returnedFromSaleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.returnedFromSaleProductId);
                    break;
                case /* repeated rd.company.SaleForm.CustomField custom_fields */ 35:
                    message.customFields.push(SaleForm_CustomField.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_special_orderable_v2 */ 36:
                    message.isSpecialOrderableV2 = reader.bool();
                    break;
                case /* string internal_notes */ 38:
                    message.internalNotes = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal quantity_v2 */ 39:
                    message.quantityV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityV2);
                    break;
                case /* rd.proto.decimal.Decimal quantity_returned_v2 */ 40:
                    message.quantityReturnedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReturnedV2);
                    break;
                case /* google.protobuf.Timestamp voided_at */ 41:
                    message.voidedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.voidedAt);
                    break;
                case /* bool is_taxed_edited */ 51:
                    message.isTaxedEdited = reader.bool();
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 42:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_uom */ 43:
                    message.quantityUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityUom);
                    break;
                case /* rd.proto.uuid.UUID uom_id_returned */ 44:
                    message.uomIdReturned = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomIdReturned);
                    break;
                case /* rd.proto.decimal.Decimal quantity_returned_uom */ 45:
                    message.quantityReturnedUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReturnedUom);
                    break;
                case /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot */ 46:
                    message.uomSnapshot = LedgerEntry_UomSnapshot.internalBinaryRead(reader, reader.uint32(), options, message.uomSnapshot);
                    break;
                case /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot_returned */ 47:
                    message.uomSnapshotReturned = LedgerEntry_UomSnapshot.internalBinaryRead(reader, reader.uint32(), options, message.uomSnapshotReturned);
                    break;
                case /* repeated rd.proto.uuid.UUID spiff_ids */ 48:
                    message.spiffIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID gift_card_id */ 49:
                    message.giftCardId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.giftCardId);
                    break;
                case /* rd.proto.money.Money gift_card_initial_balance */ 50:
                    message.giftCardInitialBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.giftCardInitialBalance);
                    break;
                case /* repeated rd.txn.SaleProduct.CCPRebate ccp_rebates */ 52:
                    message.ccpRebates.push(SaleProduct_CCPRebate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID order_ids */ 53:
                    message.orderIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID shipment_ids */ 54:
                    message.shipmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_active_in_buyers_list */ 55:
                    message.isActiveInBuyersList = reader.bool();
                    break;
                case /* rd.proto.uuid.UUID closed_out_from_sale_product_id */ 56:
                    message.closedOutFromSaleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.closedOutFromSaleProductId);
                    break;
                case /* repeated rd.txn.SaleProduct.AdditionalFee additional_fees */ 57:
                    message.additionalFees.push(SaleProduct_AdditionalFee.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.FractionalMoney price_fractional */ 59:
                    message.priceFractional = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.priceFractional);
                    break;
                case /* rd.proto.money.FractionalMoney expected_price_fractional */ 60:
                    message.expectedPriceFractional = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.expectedPriceFractional);
                    break;
                case /* rd.price.RuleInformation rule_information */ 61:
                    message.ruleInformation = RuleInformation.internalBinaryRead(reader, reader.uint32(), options, message.ruleInformation);
                    break;
                case /* repeated rd.txn.SaleProduct.TallyRow tally_rows */ 62:
                    message.tallyRows.push(SaleProduct_TallyRow.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.product.Product.TallyDimension tally_dimension */ 63:
                    message.tallyDimension = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID sale_kit_id */ 64:
                    message.saleKitId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleKitId);
                    break;
                case /* int32 tally_entry_denominator */ 65:
                    message.tallyEntryDenominator = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SaleProduct, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID product_id = 2; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 3; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 5; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID tint_color_id = 6; */
        if (message.tintColorId)
            UUID.internalBinaryWrite(message.tintColorId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money price = 9 [deprecated = true]; */
        if (message.price)
            Money.internalBinaryWrite(message.price, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 12; */
        if (message.notes !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.notes);
        /* string custom_tint_color = 13; */
        if (message.customTintColor !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.customTintColor);
        /* int32 position = 14; */
        if (message.position !== 0)
            writer.tag(14, WireType.Varint).int32(message.position);
        /* bool is_price_edited = 15; */
        if (message.isPriceEdited !== false)
            writer.tag(15, WireType.Varint).bool(message.isPriceEdited);
        /* rd.proto.money.Money tier_1_price = 16; */
        if (message.tier1Price)
            Money.internalBinaryWrite(message.tier1Price, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* bool is_taxed = 17; */
        if (message.isTaxed !== false)
            writer.tag(17, WireType.Varint).bool(message.isTaxed);
        /* rd.proto.uuid.UUID colorx_tinted_product_id = 19; */
        if (message.colorxTintedProductId)
            UUID.internalBinaryWrite(message.colorxTintedProductId, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney cost_v2 = 20; */
        if (message.costV2)
            FractionalMoney.internalBinaryWrite(message.costV2, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* bool is_active = 21; */
        if (message.isActive !== false)
            writer.tag(21, WireType.Varint).bool(message.isActive);
        /* google.protobuf.Timestamp created_at = 22; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 23; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp sold_at = 24; */
        if (message.soldAt)
            Timestamp.internalBinaryWrite(message.soldAt, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 25; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* bool is_cost_edited = 26; */
        if (message.isCostEdited !== false)
            writer.tag(26, WireType.Varint).bool(message.isCostEdited);
        /* bool is_non_stock = 28; */
        if (message.isNonStock !== false)
            writer.tag(28, WireType.Varint).bool(message.isNonStock);
        /* rd.proto.money.Money expected_price = 29 [deprecated = true]; */
        if (message.expectedPrice)
            Money.internalBinaryWrite(message.expectedPrice, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney standard_cost = 30; */
        if (message.standardCost)
            FractionalMoney.internalBinaryWrite(message.standardCost, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.SaleProduct.Type type = 32; */
        if (message.type !== 0)
            writer.tag(32, WireType.Varint).int32(message.type);
        /* rd.proto.uuid.UUID returned_from_sale_id = 33; */
        if (message.returnedFromSaleId)
            UUID.internalBinaryWrite(message.returnedFromSaleId, writer.tag(33, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID returned_from_sale_product_id = 34; */
        if (message.returnedFromSaleProductId)
            UUID.internalBinaryWrite(message.returnedFromSaleProductId, writer.tag(34, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.company.SaleForm.CustomField custom_fields = 35; */
        for (let i = 0; i < message.customFields.length; i++)
            SaleForm_CustomField.internalBinaryWrite(message.customFields[i], writer.tag(35, WireType.LengthDelimited).fork(), options).join();
        /* bool is_special_orderable_v2 = 36; */
        if (message.isSpecialOrderableV2 !== false)
            writer.tag(36, WireType.Varint).bool(message.isSpecialOrderableV2);
        /* string internal_notes = 38; */
        if (message.internalNotes !== "")
            writer.tag(38, WireType.LengthDelimited).string(message.internalNotes);
        /* rd.proto.decimal.Decimal quantity_v2 = 39; */
        if (message.quantityV2)
            Decimal.internalBinaryWrite(message.quantityV2, writer.tag(39, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_returned_v2 = 40; */
        if (message.quantityReturnedV2)
            Decimal.internalBinaryWrite(message.quantityReturnedV2, writer.tag(40, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp voided_at = 41; */
        if (message.voidedAt)
            Timestamp.internalBinaryWrite(message.voidedAt, writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 42; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(42, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_uom = 43; */
        if (message.quantityUom)
            Decimal.internalBinaryWrite(message.quantityUom, writer.tag(43, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id_returned = 44; */
        if (message.uomIdReturned)
            UUID.internalBinaryWrite(message.uomIdReturned, writer.tag(44, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_returned_uom = 45; */
        if (message.quantityReturnedUom)
            Decimal.internalBinaryWrite(message.quantityReturnedUom, writer.tag(45, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 46; */
        if (message.uomSnapshot)
            LedgerEntry_UomSnapshot.internalBinaryWrite(message.uomSnapshot, writer.tag(46, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot_returned = 47; */
        if (message.uomSnapshotReturned)
            LedgerEntry_UomSnapshot.internalBinaryWrite(message.uomSnapshotReturned, writer.tag(47, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID spiff_ids = 48; */
        for (let i = 0; i < message.spiffIds.length; i++)
            UUID.internalBinaryWrite(message.spiffIds[i], writer.tag(48, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID gift_card_id = 49; */
        if (message.giftCardId)
            UUID.internalBinaryWrite(message.giftCardId, writer.tag(49, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money gift_card_initial_balance = 50; */
        if (message.giftCardInitialBalance)
            Money.internalBinaryWrite(message.giftCardInitialBalance, writer.tag(50, WireType.LengthDelimited).fork(), options).join();
        /* bool is_taxed_edited = 51; */
        if (message.isTaxedEdited !== false)
            writer.tag(51, WireType.Varint).bool(message.isTaxedEdited);
        /* repeated rd.txn.SaleProduct.CCPRebate ccp_rebates = 52; */
        for (let i = 0; i < message.ccpRebates.length; i++)
            SaleProduct_CCPRebate.internalBinaryWrite(message.ccpRebates[i], writer.tag(52, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID order_ids = 53; */
        for (let i = 0; i < message.orderIds.length; i++)
            UUID.internalBinaryWrite(message.orderIds[i], writer.tag(53, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID shipment_ids = 54; */
        for (let i = 0; i < message.shipmentIds.length; i++)
            UUID.internalBinaryWrite(message.shipmentIds[i], writer.tag(54, WireType.LengthDelimited).fork(), options).join();
        /* bool is_active_in_buyers_list = 55; */
        if (message.isActiveInBuyersList !== false)
            writer.tag(55, WireType.Varint).bool(message.isActiveInBuyersList);
        /* rd.proto.uuid.UUID closed_out_from_sale_product_id = 56; */
        if (message.closedOutFromSaleProductId)
            UUID.internalBinaryWrite(message.closedOutFromSaleProductId, writer.tag(56, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.SaleProduct.AdditionalFee additional_fees = 57; */
        for (let i = 0; i < message.additionalFees.length; i++)
            SaleProduct_AdditionalFee.internalBinaryWrite(message.additionalFees[i], writer.tag(57, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney price_fractional = 59; */
        if (message.priceFractional)
            FractionalMoney.internalBinaryWrite(message.priceFractional, writer.tag(59, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney expected_price_fractional = 60; */
        if (message.expectedPriceFractional)
            FractionalMoney.internalBinaryWrite(message.expectedPriceFractional, writer.tag(60, WireType.LengthDelimited).fork(), options).join();
        /* rd.price.RuleInformation rule_information = 61; */
        if (message.ruleInformation)
            RuleInformation.internalBinaryWrite(message.ruleInformation, writer.tag(61, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.SaleProduct.TallyRow tally_rows = 62; */
        for (let i = 0; i < message.tallyRows.length; i++)
            SaleProduct_TallyRow.internalBinaryWrite(message.tallyRows[i], writer.tag(62, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product.TallyDimension tally_dimension = 63; */
        if (message.tallyDimension !== 0)
            writer.tag(63, WireType.Varint).int32(message.tallyDimension);
        /* rd.proto.uuid.UUID sale_kit_id = 64; */
        if (message.saleKitId)
            UUID.internalBinaryWrite(message.saleKitId, writer.tag(64, WireType.LengthDelimited).fork(), options).join();
        /* int32 tally_entry_denominator = 65; */
        if (message.tallyEntryDenominator !== 0)
            writer.tag(65, WireType.Varint).int32(message.tallyEntryDenominator);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.SaleProduct
 */
export const SaleProduct = new SaleProduct$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaleProduct_CCPRebate$Type extends MessageType<SaleProduct_CCPRebate> {
    constructor() {
        super("rd.txn.SaleProduct.CCPRebate", [
            { no: 1, name: "credit_issue_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "total_rebate", kind: "message", T: () => FractionalMoney },
            { no: 3, name: "credit_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SaleProduct_CCPRebate>): SaleProduct_CCPRebate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.creditIssueDate = "";
        message.creditNumber = "";
        if (value !== undefined)
            reflectionMergePartial<SaleProduct_CCPRebate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SaleProduct_CCPRebate): SaleProduct_CCPRebate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string credit_issue_date */ 1:
                    message.creditIssueDate = reader.string();
                    break;
                case /* rd.proto.money.FractionalMoney total_rebate */ 2:
                    message.totalRebate = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.totalRebate);
                    break;
                case /* string credit_number */ 3:
                    message.creditNumber = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SaleProduct_CCPRebate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string credit_issue_date = 1; */
        if (message.creditIssueDate !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.creditIssueDate);
        /* rd.proto.money.FractionalMoney total_rebate = 2; */
        if (message.totalRebate)
            FractionalMoney.internalBinaryWrite(message.totalRebate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string credit_number = 3; */
        if (message.creditNumber !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.creditNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.SaleProduct.CCPRebate
 */
export const SaleProduct_CCPRebate = new SaleProduct_CCPRebate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaleProduct_AdditionalFee$Type extends MessageType<SaleProduct_AdditionalFee> {
    constructor() {
        super("rd.txn.SaleProduct.AdditionalFee", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "unit_fee", kind: "message", T: () => FractionalMoney },
            { no: 3, name: "is_taxed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "fee_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "is_disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "is_fee_overriden", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SaleProduct_AdditionalFee>): SaleProduct_AdditionalFee {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.isTaxed = false;
        message.feeId = "";
        message.isDisabled = false;
        message.isFeeOverriden = false;
        if (value !== undefined)
            reflectionMergePartial<SaleProduct_AdditionalFee>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SaleProduct_AdditionalFee): SaleProduct_AdditionalFee {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* rd.proto.money.FractionalMoney unit_fee */ 2:
                    message.unitFee = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.unitFee);
                    break;
                case /* bool is_taxed */ 3:
                    message.isTaxed = reader.bool();
                    break;
                case /* string fee_id */ 4:
                    message.feeId = reader.string();
                    break;
                case /* bool is_disabled */ 5:
                    message.isDisabled = reader.bool();
                    break;
                case /* bool is_fee_overriden */ 6:
                    message.isFeeOverriden = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SaleProduct_AdditionalFee, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* rd.proto.money.FractionalMoney unit_fee = 2; */
        if (message.unitFee)
            FractionalMoney.internalBinaryWrite(message.unitFee, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool is_taxed = 3; */
        if (message.isTaxed !== false)
            writer.tag(3, WireType.Varint).bool(message.isTaxed);
        /* string fee_id = 4; */
        if (message.feeId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.feeId);
        /* bool is_disabled = 5; */
        if (message.isDisabled !== false)
            writer.tag(5, WireType.Varint).bool(message.isDisabled);
        /* bool is_fee_overriden = 6; */
        if (message.isFeeOverriden !== false)
            writer.tag(6, WireType.Varint).bool(message.isFeeOverriden);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.SaleProduct.AdditionalFee
 */
export const SaleProduct_AdditionalFee = new SaleProduct_AdditionalFee$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaleProduct_TallyRow$Type extends MessageType<SaleProduct_TallyRow> {
    constructor() {
        super("rd.txn.SaleProduct.TallyRow", [
            { no: 1, name: "quantity", kind: "message", T: () => Decimal },
            { no: 2, name: "length", kind: "message", T: () => Decimal },
            { no: 3, name: "width", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<SaleProduct_TallyRow>): SaleProduct_TallyRow {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SaleProduct_TallyRow>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SaleProduct_TallyRow): SaleProduct_TallyRow {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.decimal.Decimal quantity */ 1:
                    message.quantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantity);
                    break;
                case /* rd.proto.decimal.Decimal length */ 2:
                    message.length = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.length);
                    break;
                case /* rd.proto.decimal.Decimal width */ 3:
                    message.width = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.width);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SaleProduct_TallyRow, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.decimal.Decimal quantity = 1; */
        if (message.quantity)
            Decimal.internalBinaryWrite(message.quantity, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal length = 2; */
        if (message.length)
            Decimal.internalBinaryWrite(message.length, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal width = 3; */
        if (message.width)
            Decimal.internalBinaryWrite(message.width, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.SaleProduct.TallyRow
 */
export const SaleProduct_TallyRow = new SaleProduct_TallyRow$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaleProductLog$Type extends MessageType<SaleProductLog> {
    constructor() {
        super("rd.txn.SaleProductLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "created_by", kind: "message", T: () => User },
            { no: 4, name: "sale_product", kind: "message", T: () => SaleProduct }
        ]);
    }
    create(value?: PartialMessage<SaleProductLog>): SaleProductLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SaleProductLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SaleProductLog): SaleProductLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 3:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.txn.SaleProduct sale_product */ 4:
                    message.saleProduct = SaleProduct.internalBinaryRead(reader, reader.uint32(), options, message.saleProduct);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SaleProductLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 3; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.SaleProduct sale_product = 4; */
        if (message.saleProduct)
            SaleProduct.internalBinaryWrite(message.saleProduct, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.SaleProductLog
 */
export const SaleProductLog = new SaleProductLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaleKit$Type extends MessageType<SaleKit> {
    constructor() {
        super("rd.txn.SaleKit", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "kit_product_id", kind: "message", T: () => UUID },
            { no: 3, name: "sale_id", kind: "message", T: () => UUID },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "quantity", kind: "message", T: () => Decimal },
            { no: 10, name: "price", kind: "message", T: () => FractionalMoney },
            { no: 11, name: "is_price_edited", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "internal_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.cxa": true } },
            { no: 14, name: "custom_fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleForm_CustomField },
            { no: 15, name: "location_id", kind: "message", T: () => UUID },
            { no: 16, name: "sold_at", kind: "message", T: () => Timestamp },
            { no: 17, name: "voided_at", kind: "message", T: () => Timestamp },
            { no: 18, name: "cost", kind: "message", T: () => FractionalMoney },
            { no: 19, name: "standard_cost", kind: "message", T: () => FractionalMoney },
            { no: 20, name: "expected_price", kind: "message", T: () => FractionalMoney },
            { no: 21, name: "customer_id", kind: "message", T: () => UUID },
            { no: 22, name: "tier_1_price", kind: "message", T: () => Money },
            { no: 23, name: "customer_view_type", kind: "enum", T: () => ["rd.product.Kit.CustomerViewType", Kit_CustomerViewType, "CUSTOMER_VIEW_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<SaleKit>): SaleKit {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.position = 0;
        message.isActive = false;
        message.isPriceEdited = false;
        message.notes = "";
        message.internalNotes = "";
        message.customFields = [];
        message.customerViewType = 0;
        if (value !== undefined)
            reflectionMergePartial<SaleKit>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SaleKit): SaleKit {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID kit_product_id */ 2:
                    message.kitProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.kitProductId);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 3:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* int32 position */ 5:
                    message.position = reader.int32();
                    break;
                case /* bool is_active */ 6:
                    message.isActive = reader.bool();
                    break;
                case /* google.protobuf.Timestamp created_at */ 7:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 8:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.decimal.Decimal quantity */ 9:
                    message.quantity = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantity);
                    break;
                case /* rd.proto.money.FractionalMoney price */ 10:
                    message.price = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.price);
                    break;
                case /* bool is_price_edited */ 11:
                    message.isPriceEdited = reader.bool();
                    break;
                case /* string notes */ 12:
                    message.notes = reader.string();
                    break;
                case /* string internal_notes */ 13:
                    message.internalNotes = reader.string();
                    break;
                case /* repeated rd.company.SaleForm.CustomField custom_fields */ 14:
                    message.customFields.push(SaleForm_CustomField.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID location_id */ 15:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* google.protobuf.Timestamp sold_at */ 16:
                    message.soldAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.soldAt);
                    break;
                case /* google.protobuf.Timestamp voided_at */ 17:
                    message.voidedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.voidedAt);
                    break;
                case /* rd.proto.money.FractionalMoney cost */ 18:
                    message.cost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.cost);
                    break;
                case /* rd.proto.money.FractionalMoney standard_cost */ 19:
                    message.standardCost = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.standardCost);
                    break;
                case /* rd.proto.money.FractionalMoney expected_price */ 20:
                    message.expectedPrice = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.expectedPrice);
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 21:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.money.Money tier_1_price */ 22:
                    message.tier1Price = Money.internalBinaryRead(reader, reader.uint32(), options, message.tier1Price);
                    break;
                case /* rd.product.Kit.CustomerViewType customer_view_type */ 23:
                    message.customerViewType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SaleKit, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID kit_product_id = 2; */
        if (message.kitProductId)
            UUID.internalBinaryWrite(message.kitProductId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 3; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 position = 5; */
        if (message.position !== 0)
            writer.tag(5, WireType.Varint).int32(message.position);
        /* bool is_active = 6; */
        if (message.isActive !== false)
            writer.tag(6, WireType.Varint).bool(message.isActive);
        /* google.protobuf.Timestamp created_at = 7; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 8; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity = 9; */
        if (message.quantity)
            Decimal.internalBinaryWrite(message.quantity, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney price = 10; */
        if (message.price)
            FractionalMoney.internalBinaryWrite(message.price, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* bool is_price_edited = 11; */
        if (message.isPriceEdited !== false)
            writer.tag(11, WireType.Varint).bool(message.isPriceEdited);
        /* string notes = 12; */
        if (message.notes !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.notes);
        /* string internal_notes = 13; */
        if (message.internalNotes !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.internalNotes);
        /* repeated rd.company.SaleForm.CustomField custom_fields = 14; */
        for (let i = 0; i < message.customFields.length; i++)
            SaleForm_CustomField.internalBinaryWrite(message.customFields[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 15; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp sold_at = 16; */
        if (message.soldAt)
            Timestamp.internalBinaryWrite(message.soldAt, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp voided_at = 17; */
        if (message.voidedAt)
            Timestamp.internalBinaryWrite(message.voidedAt, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney cost = 18; */
        if (message.cost)
            FractionalMoney.internalBinaryWrite(message.cost, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney standard_cost = 19; */
        if (message.standardCost)
            FractionalMoney.internalBinaryWrite(message.standardCost, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney expected_price = 20; */
        if (message.expectedPrice)
            FractionalMoney.internalBinaryWrite(message.expectedPrice, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 21; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money tier_1_price = 22; */
        if (message.tier1Price)
            Money.internalBinaryWrite(message.tier1Price, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Kit.CustomerViewType customer_view_type = 23; */
        if (message.customerViewType !== 0)
            writer.tag(23, WireType.Varint).int32(message.customerViewType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.SaleKit
 */
export const SaleKit = new SaleKit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SalePDFData$Type extends MessageType<SalePDFData> {
    constructor() {
        super("rd.txn.SalePDFData", [
            { no: 1, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sale", kind: "message", T: () => Sale },
            { no: 3, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "customer", kind: "message", T: () => Customer },
            { no: 5, name: "primary_contact", kind: "message", T: () => Contacts_Contact },
            { no: 6, name: "last_action_staff", kind: "message", T: () => User },
            { no: 7, name: "last_action_time", kind: "message", T: () => Timestamp },
            { no: 8, name: "purchase_order", kind: "message", T: () => PurchaseOrder },
            { no: 10, name: "company", kind: "message", T: () => Company },
            { no: 11, name: "location", kind: "message", T: () => Location },
            { no: 12, name: "products", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SalePDFData_Product },
            { no: 14, name: "sub_total", kind: "message", T: () => Money },
            { no: 15, name: "fee_totals_by_name", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 16, name: "sales_tax_total", kind: "message", T: () => Money },
            { no: 17, name: "total", kind: "message", T: () => Money },
            { no: 18, name: "due_at", kind: "message", T: () => Timestamp },
            { no: 19, name: "remaining_balance", kind: "message", T: () => Money },
            { no: 20, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 21, name: "customer_contact", kind: "message", T: () => Contacts_Contact },
            { no: 27, name: "show_signature_line", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 30, name: "bill_payments_total", kind: "message", T: () => Money },
            { no: 31, name: "tax_rate", kind: "message", T: () => TaxRate },
            { no: 33, name: "card_surcharge", kind: "message", T: () => Money },
            { no: 34, name: "card_surcharge_rate_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 35, name: "receipt_info", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CardPaymentReceiptInfo },
            { no: 36, name: "barcode", kind: "message", T: () => Barcode },
            { no: 37, name: "show_prices", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 38, name: "job", kind: "message", T: () => Customer },
            { no: 40, name: "total_discounts", kind: "message", T: () => Money },
            { no: 41, name: "total_additional_fees", kind: "message", T: () => Money },
            { no: 43, name: "show_discounts", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 44, name: "signature_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 45, name: "restock_fee", kind: "message", T: () => Money },
            { no: 46, name: "subtotal_discount_applied", kind: "message", T: () => Money },
            { no: 47, name: "subtotal_discount_rate", kind: "message", T: () => Decimal },
            { no: 56, name: "purchase_methods", kind: "message", T: () => ReceiptPurchaseMethods },
            { no: 57, name: "cash_rounding_delta", kind: "message", T: () => Money },
            { no: 58, name: "coupons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppliedCoupon }
        ]);
    }
    create(value?: PartialMessage<SalePDFData>): SalePDFData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.title = "";
        message.products = [];
        message.feeTotalsByName = {};
        message.showSignatureLine = false;
        message.cardSurchargeRateString = "";
        message.receiptInfo = [];
        message.showPrices = false;
        message.showDiscounts = false;
        message.signatureUrl = "";
        message.coupons = [];
        if (value !== undefined)
            reflectionMergePartial<SalePDFData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SalePDFData): SalePDFData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identifier */ 1:
                    message.identifier = reader.string();
                    break;
                case /* rd.txn.Sale sale */ 2:
                    message.sale = Sale.internalBinaryRead(reader, reader.uint32(), options, message.sale);
                    break;
                case /* string title */ 3:
                    message.title = reader.string();
                    break;
                case /* rd.customer.Customer customer */ 4:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* rd.customer.Contacts.Contact primary_contact */ 5:
                    message.primaryContact = Contacts_Contact.internalBinaryRead(reader, reader.uint32(), options, message.primaryContact);
                    break;
                case /* rd.user.User last_action_staff */ 6:
                    message.lastActionStaff = User.internalBinaryRead(reader, reader.uint32(), options, message.lastActionStaff);
                    break;
                case /* google.protobuf.Timestamp last_action_time */ 7:
                    message.lastActionTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastActionTime);
                    break;
                case /* rd.customer.PurchaseOrder purchase_order */ 8:
                    message.purchaseOrder = PurchaseOrder.internalBinaryRead(reader, reader.uint32(), options, message.purchaseOrder);
                    break;
                case /* rd.company.Company company */ 10:
                    message.company = Company.internalBinaryRead(reader, reader.uint32(), options, message.company);
                    break;
                case /* rd.company.Location location */ 11:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* repeated rd.txn.SalePDFData.Product products */ 12:
                    message.products.push(SalePDFData_Product.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.Money sub_total */ 14:
                    message.subTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.subTotal);
                    break;
                case /* map<string, rd.proto.money.Money> fee_totals_by_name */ 15:
                    this.binaryReadMap15(message.feeTotalsByName, reader, options);
                    break;
                case /* rd.proto.money.Money sales_tax_total */ 16:
                    message.salesTaxTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.salesTaxTotal);
                    break;
                case /* rd.proto.money.Money total */ 17:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* google.protobuf.Timestamp due_at */ 18:
                    message.dueAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.dueAt);
                    break;
                case /* rd.proto.money.Money remaining_balance */ 19:
                    message.remainingBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.remainingBalance);
                    break;
                case /* google.protobuf.Timestamp expires_at */ 20:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                case /* rd.customer.Contacts.Contact customer_contact */ 21:
                    message.customerContact = Contacts_Contact.internalBinaryRead(reader, reader.uint32(), options, message.customerContact);
                    break;
                case /* bool show_signature_line */ 27:
                    message.showSignatureLine = reader.bool();
                    break;
                case /* rd.proto.money.Money bill_payments_total */ 30:
                    message.billPaymentsTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.billPaymentsTotal);
                    break;
                case /* rd.company.TaxRate tax_rate */ 31:
                    message.taxRate = TaxRate.internalBinaryRead(reader, reader.uint32(), options, message.taxRate);
                    break;
                case /* rd.proto.money.Money card_surcharge */ 33:
                    message.cardSurcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurcharge);
                    break;
                case /* string card_surcharge_rate_string */ 34:
                    message.cardSurchargeRateString = reader.string();
                    break;
                case /* repeated rd.payments.CardPaymentReceiptInfo receipt_info */ 35:
                    message.receiptInfo.push(CardPaymentReceiptInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.pdf.Barcode barcode */ 36:
                    message.barcode = Barcode.internalBinaryRead(reader, reader.uint32(), options, message.barcode);
                    break;
                case /* bool show_prices */ 37:
                    message.showPrices = reader.bool();
                    break;
                case /* rd.customer.Customer job */ 38:
                    message.job = Customer.internalBinaryRead(reader, reader.uint32(), options, message.job);
                    break;
                case /* rd.proto.money.Money total_discounts */ 40:
                    message.totalDiscounts = Money.internalBinaryRead(reader, reader.uint32(), options, message.totalDiscounts);
                    break;
                case /* rd.proto.money.Money total_additional_fees */ 41:
                    message.totalAdditionalFees = Money.internalBinaryRead(reader, reader.uint32(), options, message.totalAdditionalFees);
                    break;
                case /* bool show_discounts */ 43:
                    message.showDiscounts = reader.bool();
                    break;
                case /* string signature_url */ 44:
                    message.signatureUrl = reader.string();
                    break;
                case /* rd.proto.money.Money restock_fee */ 45:
                    message.restockFee = Money.internalBinaryRead(reader, reader.uint32(), options, message.restockFee);
                    break;
                case /* rd.proto.money.Money subtotal_discount_applied */ 46:
                    message.subtotalDiscountApplied = Money.internalBinaryRead(reader, reader.uint32(), options, message.subtotalDiscountApplied);
                    break;
                case /* rd.proto.decimal.Decimal subtotal_discount_rate */ 47:
                    message.subtotalDiscountRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.subtotalDiscountRate);
                    break;
                case /* rd.ledger.ReceiptPurchaseMethods purchase_methods */ 56:
                    message.purchaseMethods = ReceiptPurchaseMethods.internalBinaryRead(reader, reader.uint32(), options, message.purchaseMethods);
                    break;
                case /* rd.proto.money.Money cash_rounding_delta */ 57:
                    message.cashRoundingDelta = Money.internalBinaryRead(reader, reader.uint32(), options, message.cashRoundingDelta);
                    break;
                case /* repeated rd.txn.AppliedCoupon coupons */ 58:
                    message.coupons.push(AppliedCoupon.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap15(map: SalePDFData["feeTotalsByName"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SalePDFData["feeTotalsByName"] | undefined, val: SalePDFData["feeTotalsByName"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.SalePDFData.fee_totals_by_name");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: SalePDFData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identifier = 1; */
        if (message.identifier !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier);
        /* rd.txn.Sale sale = 2; */
        if (message.sale)
            Sale.internalBinaryWrite(message.sale, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string title = 3; */
        if (message.title !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.title);
        /* rd.customer.Customer customer = 4; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Contacts.Contact primary_contact = 5; */
        if (message.primaryContact)
            Contacts_Contact.internalBinaryWrite(message.primaryContact, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User last_action_staff = 6; */
        if (message.lastActionStaff)
            User.internalBinaryWrite(message.lastActionStaff, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp last_action_time = 7; */
        if (message.lastActionTime)
            Timestamp.internalBinaryWrite(message.lastActionTime, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.PurchaseOrder purchase_order = 8; */
        if (message.purchaseOrder)
            PurchaseOrder.internalBinaryWrite(message.purchaseOrder, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Company company = 10; */
        if (message.company)
            Company.internalBinaryWrite(message.company, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 11; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.SalePDFData.Product products = 12; */
        for (let i = 0; i < message.products.length; i++)
            SalePDFData_Product.internalBinaryWrite(message.products[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money sub_total = 14; */
        if (message.subTotal)
            Money.internalBinaryWrite(message.subTotal, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> fee_totals_by_name = 15; */
        for (let k of globalThis.Object.keys(message.feeTotalsByName)) {
            writer.tag(15, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.feeTotalsByName[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money sales_tax_total = 16; */
        if (message.salesTaxTotal)
            Money.internalBinaryWrite(message.salesTaxTotal, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total = 17; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp due_at = 18; */
        if (message.dueAt)
            Timestamp.internalBinaryWrite(message.dueAt, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money remaining_balance = 19; */
        if (message.remainingBalance)
            Money.internalBinaryWrite(message.remainingBalance, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expires_at = 20; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Contacts.Contact customer_contact = 21; */
        if (message.customerContact)
            Contacts_Contact.internalBinaryWrite(message.customerContact, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* bool show_signature_line = 27; */
        if (message.showSignatureLine !== false)
            writer.tag(27, WireType.Varint).bool(message.showSignatureLine);
        /* rd.proto.money.Money bill_payments_total = 30; */
        if (message.billPaymentsTotal)
            Money.internalBinaryWrite(message.billPaymentsTotal, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.TaxRate tax_rate = 31; */
        if (message.taxRate)
            TaxRate.internalBinaryWrite(message.taxRate, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money card_surcharge = 33; */
        if (message.cardSurcharge)
            Money.internalBinaryWrite(message.cardSurcharge, writer.tag(33, WireType.LengthDelimited).fork(), options).join();
        /* string card_surcharge_rate_string = 34; */
        if (message.cardSurchargeRateString !== "")
            writer.tag(34, WireType.LengthDelimited).string(message.cardSurchargeRateString);
        /* repeated rd.payments.CardPaymentReceiptInfo receipt_info = 35; */
        for (let i = 0; i < message.receiptInfo.length; i++)
            CardPaymentReceiptInfo.internalBinaryWrite(message.receiptInfo[i], writer.tag(35, WireType.LengthDelimited).fork(), options).join();
        /* rd.pdf.Barcode barcode = 36; */
        if (message.barcode)
            Barcode.internalBinaryWrite(message.barcode, writer.tag(36, WireType.LengthDelimited).fork(), options).join();
        /* bool show_prices = 37; */
        if (message.showPrices !== false)
            writer.tag(37, WireType.Varint).bool(message.showPrices);
        /* rd.customer.Customer job = 38; */
        if (message.job)
            Customer.internalBinaryWrite(message.job, writer.tag(38, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total_discounts = 40; */
        if (message.totalDiscounts)
            Money.internalBinaryWrite(message.totalDiscounts, writer.tag(40, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total_additional_fees = 41; */
        if (message.totalAdditionalFees)
            Money.internalBinaryWrite(message.totalAdditionalFees, writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* bool show_discounts = 43; */
        if (message.showDiscounts !== false)
            writer.tag(43, WireType.Varint).bool(message.showDiscounts);
        /* string signature_url = 44; */
        if (message.signatureUrl !== "")
            writer.tag(44, WireType.LengthDelimited).string(message.signatureUrl);
        /* rd.proto.money.Money restock_fee = 45; */
        if (message.restockFee)
            Money.internalBinaryWrite(message.restockFee, writer.tag(45, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money subtotal_discount_applied = 46; */
        if (message.subtotalDiscountApplied)
            Money.internalBinaryWrite(message.subtotalDiscountApplied, writer.tag(46, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal subtotal_discount_rate = 47; */
        if (message.subtotalDiscountRate)
            Decimal.internalBinaryWrite(message.subtotalDiscountRate, writer.tag(47, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.ReceiptPurchaseMethods purchase_methods = 56; */
        if (message.purchaseMethods)
            ReceiptPurchaseMethods.internalBinaryWrite(message.purchaseMethods, writer.tag(56, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money cash_rounding_delta = 57; */
        if (message.cashRoundingDelta)
            Money.internalBinaryWrite(message.cashRoundingDelta, writer.tag(57, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.AppliedCoupon coupons = 58; */
        for (let i = 0; i < message.coupons.length; i++)
            AppliedCoupon.internalBinaryWrite(message.coupons[i], writer.tag(58, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.SalePDFData
 */
export const SalePDFData = new SalePDFData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SalePDFData_Product$Type extends MessageType<SalePDFData_Product> {
    constructor() {
        super("rd.txn.SalePDFData.Product", [
            { no: 1, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "tint_color", kind: "message", T: () => TintColor },
            { no: 5, name: "sub_total", kind: "message", T: () => Money },
            { no: 9, name: "custom_tint_color", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "price", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "show_discount", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "tier_1_price", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "discount", kind: "message", T: () => Money },
            { no: 21, name: "override_tier_1_price", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "original_sale_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "quantity_v2", kind: "message", T: () => Decimal },
            { no: 24, name: "uom_id", kind: "message", T: () => UUID },
            { no: 25, name: "quantity_uom", kind: "message", T: () => Decimal },
            { no: 26, name: "uom_id_returned", kind: "message", T: () => UUID },
            { no: 27, name: "quantity_returned_uom", kind: "message", T: () => Decimal },
            { no: 28, name: "discount_percentage", kind: "message", T: () => Decimal },
            { no: 29, name: "show_discount_percentage", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 30, name: "uom_snapshot", kind: "message", T: () => LedgerEntry_UomSnapshot },
            { no: 31, name: "uom_snapshot_returned", kind: "message", T: () => LedgerEntry_UomSnapshot },
            { no: 32, name: "non_taxable_display", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 33, name: "gift_card_overwritten_balance", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 34, name: "item_set_id", kind: "message", T: () => UUID },
            { no: 35, name: "tally_display", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 36, name: "sale_id", kind: "message", T: () => UUID },
            { no: 37, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SalePDFData_Product>): SalePDFData_Product {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.name = "";
        message.customTintColor = "";
        message.notes = "";
        message.price = "";
        message.showDiscount = false;
        message.tier1Price = "";
        message.overrideTier1Price = false;
        message.originalSaleIdentifier = "";
        message.showDiscountPercentage = false;
        message.nonTaxableDisplay = "";
        message.giftCardOverwrittenBalance = "";
        message.tallyDisplay = "";
        message.position = 0;
        if (value !== undefined)
            reflectionMergePartial<SalePDFData_Product>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SalePDFData_Product): SalePDFData_Product {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identifier */ 1:
                    message.identifier = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* rd.tintcolor.TintColor tint_color */ 4:
                    message.tintColor = TintColor.internalBinaryRead(reader, reader.uint32(), options, message.tintColor);
                    break;
                case /* rd.proto.money.Money sub_total */ 5:
                    message.subTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.subTotal);
                    break;
                case /* string custom_tint_color */ 9:
                    message.customTintColor = reader.string();
                    break;
                case /* string notes */ 10:
                    message.notes = reader.string();
                    break;
                case /* string price */ 12:
                    message.price = reader.string();
                    break;
                case /* bool show_discount */ 13:
                    message.showDiscount = reader.bool();
                    break;
                case /* string tier_1_price */ 14:
                    message.tier1Price = reader.string();
                    break;
                case /* rd.proto.money.Money discount */ 18:
                    message.discount = Money.internalBinaryRead(reader, reader.uint32(), options, message.discount);
                    break;
                case /* bool override_tier_1_price */ 21:
                    message.overrideTier1Price = reader.bool();
                    break;
                case /* string original_sale_identifier */ 22:
                    message.originalSaleIdentifier = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal quantity_v2 */ 23:
                    message.quantityV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityV2);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 24:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_uom */ 25:
                    message.quantityUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityUom);
                    break;
                case /* rd.proto.uuid.UUID uom_id_returned */ 26:
                    message.uomIdReturned = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomIdReturned);
                    break;
                case /* rd.proto.decimal.Decimal quantity_returned_uom */ 27:
                    message.quantityReturnedUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReturnedUom);
                    break;
                case /* rd.proto.decimal.Decimal discount_percentage */ 28:
                    message.discountPercentage = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.discountPercentage);
                    break;
                case /* bool show_discount_percentage */ 29:
                    message.showDiscountPercentage = reader.bool();
                    break;
                case /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot */ 30:
                    message.uomSnapshot = LedgerEntry_UomSnapshot.internalBinaryRead(reader, reader.uint32(), options, message.uomSnapshot);
                    break;
                case /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot_returned */ 31:
                    message.uomSnapshotReturned = LedgerEntry_UomSnapshot.internalBinaryRead(reader, reader.uint32(), options, message.uomSnapshotReturned);
                    break;
                case /* string non_taxable_display */ 32:
                    message.nonTaxableDisplay = reader.string();
                    break;
                case /* string gift_card_overwritten_balance */ 33:
                    message.giftCardOverwrittenBalance = reader.string();
                    break;
                case /* rd.proto.uuid.UUID item_set_id */ 34:
                    message.itemSetId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.itemSetId);
                    break;
                case /* string tally_display */ 35:
                    message.tallyDisplay = reader.string();
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 36:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* int32 position */ 37:
                    message.position = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SalePDFData_Product, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identifier = 1; */
        if (message.identifier !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* rd.tintcolor.TintColor tint_color = 4; */
        if (message.tintColor)
            TintColor.internalBinaryWrite(message.tintColor, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money sub_total = 5; */
        if (message.subTotal)
            Money.internalBinaryWrite(message.subTotal, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string custom_tint_color = 9; */
        if (message.customTintColor !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.customTintColor);
        /* string notes = 10; */
        if (message.notes !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.notes);
        /* string price = 12; */
        if (message.price !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.price);
        /* bool show_discount = 13; */
        if (message.showDiscount !== false)
            writer.tag(13, WireType.Varint).bool(message.showDiscount);
        /* string tier_1_price = 14; */
        if (message.tier1Price !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.tier1Price);
        /* rd.proto.money.Money discount = 18; */
        if (message.discount)
            Money.internalBinaryWrite(message.discount, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* bool override_tier_1_price = 21; */
        if (message.overrideTier1Price !== false)
            writer.tag(21, WireType.Varint).bool(message.overrideTier1Price);
        /* string original_sale_identifier = 22; */
        if (message.originalSaleIdentifier !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.originalSaleIdentifier);
        /* rd.proto.decimal.Decimal quantity_v2 = 23; */
        if (message.quantityV2)
            Decimal.internalBinaryWrite(message.quantityV2, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 24; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_uom = 25; */
        if (message.quantityUom)
            Decimal.internalBinaryWrite(message.quantityUom, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id_returned = 26; */
        if (message.uomIdReturned)
            UUID.internalBinaryWrite(message.uomIdReturned, writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_returned_uom = 27; */
        if (message.quantityReturnedUom)
            Decimal.internalBinaryWrite(message.quantityReturnedUom, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal discount_percentage = 28; */
        if (message.discountPercentage)
            Decimal.internalBinaryWrite(message.discountPercentage, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* bool show_discount_percentage = 29; */
        if (message.showDiscountPercentage !== false)
            writer.tag(29, WireType.Varint).bool(message.showDiscountPercentage);
        /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 30; */
        if (message.uomSnapshot)
            LedgerEntry_UomSnapshot.internalBinaryWrite(message.uomSnapshot, writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot_returned = 31; */
        if (message.uomSnapshotReturned)
            LedgerEntry_UomSnapshot.internalBinaryWrite(message.uomSnapshotReturned, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        /* string non_taxable_display = 32; */
        if (message.nonTaxableDisplay !== "")
            writer.tag(32, WireType.LengthDelimited).string(message.nonTaxableDisplay);
        /* string gift_card_overwritten_balance = 33; */
        if (message.giftCardOverwrittenBalance !== "")
            writer.tag(33, WireType.LengthDelimited).string(message.giftCardOverwrittenBalance);
        /* rd.proto.uuid.UUID item_set_id = 34; */
        if (message.itemSetId)
            UUID.internalBinaryWrite(message.itemSetId, writer.tag(34, WireType.LengthDelimited).fork(), options).join();
        /* string tally_display = 35; */
        if (message.tallyDisplay !== "")
            writer.tag(35, WireType.LengthDelimited).string(message.tallyDisplay);
        /* rd.proto.uuid.UUID sale_id = 36; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(36, WireType.LengthDelimited).fork(), options).join();
        /* int32 position = 37; */
        if (message.position !== 0)
            writer.tag(37, WireType.Varint).int32(message.position);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.SalePDFData.Product
 */
export const SalePDFData_Product = new SalePDFData_Product$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SalePDFData_TotalsInfo$Type extends MessageType<SalePDFData_TotalsInfo> {
    constructor() {
        super("rd.txn.SalePDFData.TotalsInfo", [
            { no: 1, name: "subtotal", kind: "message", T: () => Money },
            { no: 2, name: "sales_tax", kind: "message", T: () => Money },
            { no: 3, name: "fees_by_name", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 4, name: "total", kind: "message", T: () => Money },
            { no: 5, name: "card_surcharge_total", kind: "message", T: () => Money },
            { no: 7, name: "sale_taxes", kind: "message", T: () => SaleTaxes },
            { no: 8, name: "card_surcharge", kind: "message", T: () => Money },
            { no: 9, name: "restock_fee", kind: "message", T: () => Money },
            { no: 10, name: "discount_applied", kind: "message", T: () => Money },
            { no: 11, name: "cash_rounding_delta", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<SalePDFData_TotalsInfo>): SalePDFData_TotalsInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.feesByName = {};
        if (value !== undefined)
            reflectionMergePartial<SalePDFData_TotalsInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SalePDFData_TotalsInfo): SalePDFData_TotalsInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money subtotal */ 1:
                    message.subtotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.subtotal);
                    break;
                case /* rd.proto.money.Money sales_tax */ 2:
                    message.salesTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.salesTax);
                    break;
                case /* map<string, rd.proto.money.Money> fees_by_name */ 3:
                    this.binaryReadMap3(message.feesByName, reader, options);
                    break;
                case /* rd.proto.money.Money total */ 4:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* rd.proto.money.Money card_surcharge_total */ 5:
                    message.cardSurchargeTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurchargeTotal);
                    break;
                case /* rd.txn.SaleTaxes sale_taxes */ 7:
                    message.saleTaxes = SaleTaxes.internalBinaryRead(reader, reader.uint32(), options, message.saleTaxes);
                    break;
                case /* rd.proto.money.Money card_surcharge */ 8:
                    message.cardSurcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurcharge);
                    break;
                case /* rd.proto.money.Money restock_fee */ 9:
                    message.restockFee = Money.internalBinaryRead(reader, reader.uint32(), options, message.restockFee);
                    break;
                case /* rd.proto.money.Money discount_applied */ 10:
                    message.discountApplied = Money.internalBinaryRead(reader, reader.uint32(), options, message.discountApplied);
                    break;
                case /* rd.proto.money.Money cash_rounding_delta */ 11:
                    message.cashRoundingDelta = Money.internalBinaryRead(reader, reader.uint32(), options, message.cashRoundingDelta);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: SalePDFData_TotalsInfo["feesByName"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SalePDFData_TotalsInfo["feesByName"] | undefined, val: SalePDFData_TotalsInfo["feesByName"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.SalePDFData.TotalsInfo.fees_by_name");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: SalePDFData_TotalsInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money subtotal = 1; */
        if (message.subtotal)
            Money.internalBinaryWrite(message.subtotal, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money sales_tax = 2; */
        if (message.salesTax)
            Money.internalBinaryWrite(message.salesTax, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> fees_by_name = 3; */
        for (let k of globalThis.Object.keys(message.feesByName)) {
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.feesByName[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money total = 4; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money card_surcharge_total = 5; */
        if (message.cardSurchargeTotal)
            Money.internalBinaryWrite(message.cardSurchargeTotal, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.SaleTaxes sale_taxes = 7; */
        if (message.saleTaxes)
            SaleTaxes.internalBinaryWrite(message.saleTaxes, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money card_surcharge = 8; */
        if (message.cardSurcharge)
            Money.internalBinaryWrite(message.cardSurcharge, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money restock_fee = 9; */
        if (message.restockFee)
            Money.internalBinaryWrite(message.restockFee, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money discount_applied = 10; */
        if (message.discountApplied)
            Money.internalBinaryWrite(message.discountApplied, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money cash_rounding_delta = 11; */
        if (message.cashRoundingDelta)
            Money.internalBinaryWrite(message.cashRoundingDelta, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.SalePDFData.TotalsInfo
 */
export const SalePDFData_TotalsInfo = new SalePDFData_TotalsInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppliedCoupon$Type extends MessageType<AppliedCoupon> {
    constructor() {
        super("rd.txn.AppliedCoupon", [
            { no: 1, name: "coupon_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "rule", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "amount", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<AppliedCoupon>): AppliedCoupon {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.couponCode = "";
        message.rule = "";
        if (value !== undefined)
            reflectionMergePartial<AppliedCoupon>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppliedCoupon): AppliedCoupon {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string coupon_code */ 1:
                    message.couponCode = reader.string();
                    break;
                case /* string rule */ 2:
                    message.rule = reader.string();
                    break;
                case /* rd.proto.money.Money amount */ 3:
                    message.amount = Money.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppliedCoupon, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string coupon_code = 1; */
        if (message.couponCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.couponCode);
        /* string rule = 2; */
        if (message.rule !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.rule);
        /* rd.proto.money.Money amount = 3; */
        if (message.amount)
            Money.internalBinaryWrite(message.amount, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.AppliedCoupon
 */
export const AppliedCoupon = new AppliedCoupon$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Order$Type extends MessageType<Order> {
    constructor() {
        super("rd.txn.Order", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "created_by", kind: "message", T: () => User },
            { no: 5, name: "ordered_by", kind: "message", T: () => User },
            { no: 6, name: "received_by", kind: "message", T: () => User },
            { no: 7, name: "updated_by", kind: "message", T: () => User },
            { no: 8, name: "voided_by", kind: "message", T: () => User },
            { no: 9, name: "company_id", kind: "message", T: () => UUID },
            { no: 10, name: "location_id", kind: "message", T: () => UUID },
            { no: 11, name: "vendor_id", kind: "message", T: () => UUID },
            { no: 12, name: "requested_delivery_at", kind: "message", T: () => Timestamp },
            { no: 13, name: "ordered_at", kind: "message", T: () => Timestamp },
            { no: 14, name: "received_at", kind: "message", T: () => Timestamp },
            { no: 15, name: "voided_at", kind: "message", T: () => Timestamp },
            { no: 16, name: "status", kind: "enum", T: () => ["rd.txn.Order.Status", Order_Status, "STATUS_"] },
            { no: 17, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "order_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "internal_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "method", kind: "enum", T: () => ["rd.txn.Order.Method", Order_Method, "METHOD_"] },
            { no: 27, name: "products", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Order_Product },
            { no: 28, name: "invoice_details", kind: "message", T: () => InvoiceDetails },
            { no: 29, name: "dropship_address", kind: "message", T: () => Address },
            { no: 30, name: "dropship_recipient", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 31, name: "acknowledgment", kind: "enum", T: () => ["rd.integrations.x12.AcknowledgeCode", AcknowledgeCode, "ACKNOWLEDGE_CODE_"] },
            { no: 32, name: "promo_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 33, name: "cost_adjustments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CostAdjustment }
        ]);
    }
    create(value?: PartialMessage<Order>): Order {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        message.identifier = "";
        message.orderNotes = "";
        message.internalNotes = "";
        message.method = 0;
        message.products = [];
        message.dropshipRecipient = "";
        message.acknowledgment = 0;
        message.promoCode = "";
        message.costAdjustments = [];
        if (value !== undefined)
            reflectionMergePartial<Order>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Order): Order {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User created_by */ 4:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.user.User ordered_by */ 5:
                    message.orderedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.orderedBy);
                    break;
                case /* rd.user.User received_by */ 6:
                    message.receivedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.receivedBy);
                    break;
                case /* rd.user.User updated_by */ 7:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* rd.user.User voided_by */ 8:
                    message.voidedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.voidedBy);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 9:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 10:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.proto.uuid.UUID vendor_id */ 11:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* google.protobuf.Timestamp requested_delivery_at */ 12:
                    message.requestedDeliveryAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.requestedDeliveryAt);
                    break;
                case /* google.protobuf.Timestamp ordered_at */ 13:
                    message.orderedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.orderedAt);
                    break;
                case /* google.protobuf.Timestamp received_at */ 14:
                    message.receivedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.receivedAt);
                    break;
                case /* google.protobuf.Timestamp voided_at */ 15:
                    message.voidedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.voidedAt);
                    break;
                case /* rd.txn.Order.Status status */ 16:
                    message.status = reader.int32();
                    break;
                case /* string identifier */ 17:
                    message.identifier = reader.string();
                    break;
                case /* string order_notes */ 18:
                    message.orderNotes = reader.string();
                    break;
                case /* string internal_notes */ 19:
                    message.internalNotes = reader.string();
                    break;
                case /* rd.txn.Order.Method method */ 21:
                    message.method = reader.int32();
                    break;
                case /* repeated rd.txn.Order.Product products */ 27:
                    message.products.push(Order_Product.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.txn.InvoiceDetails invoice_details */ 28:
                    message.invoiceDetails = InvoiceDetails.internalBinaryRead(reader, reader.uint32(), options, message.invoiceDetails);
                    break;
                case /* rd.proto.address.Address dropship_address */ 29:
                    message.dropshipAddress = Address.internalBinaryRead(reader, reader.uint32(), options, message.dropshipAddress);
                    break;
                case /* string dropship_recipient */ 30:
                    message.dropshipRecipient = reader.string();
                    break;
                case /* rd.integrations.x12.AcknowledgeCode acknowledgment */ 31:
                    message.acknowledgment = reader.int32();
                    break;
                case /* string promo_code */ 32:
                    message.promoCode = reader.string();
                    break;
                case /* repeated rd.txn.CostAdjustment cost_adjustments */ 33:
                    message.costAdjustments.push(CostAdjustment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Order, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 4; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User ordered_by = 5; */
        if (message.orderedBy)
            User.internalBinaryWrite(message.orderedBy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User received_by = 6; */
        if (message.receivedBy)
            User.internalBinaryWrite(message.receivedBy, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 7; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User voided_by = 8; */
        if (message.voidedBy)
            User.internalBinaryWrite(message.voidedBy, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 9; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 10; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID vendor_id = 11; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp requested_delivery_at = 12; */
        if (message.requestedDeliveryAt)
            Timestamp.internalBinaryWrite(message.requestedDeliveryAt, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp ordered_at = 13; */
        if (message.orderedAt)
            Timestamp.internalBinaryWrite(message.orderedAt, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp received_at = 14; */
        if (message.receivedAt)
            Timestamp.internalBinaryWrite(message.receivedAt, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp voided_at = 15; */
        if (message.voidedAt)
            Timestamp.internalBinaryWrite(message.voidedAt, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Order.Status status = 16; */
        if (message.status !== 0)
            writer.tag(16, WireType.Varint).int32(message.status);
        /* string identifier = 17; */
        if (message.identifier !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.identifier);
        /* string order_notes = 18; */
        if (message.orderNotes !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.orderNotes);
        /* string internal_notes = 19; */
        if (message.internalNotes !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.internalNotes);
        /* rd.txn.Order.Method method = 21; */
        if (message.method !== 0)
            writer.tag(21, WireType.Varint).int32(message.method);
        /* repeated rd.txn.Order.Product products = 27; */
        for (let i = 0; i < message.products.length; i++)
            Order_Product.internalBinaryWrite(message.products[i], writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.InvoiceDetails invoice_details = 28; */
        if (message.invoiceDetails)
            InvoiceDetails.internalBinaryWrite(message.invoiceDetails, writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.address.Address dropship_address = 29; */
        if (message.dropshipAddress)
            Address.internalBinaryWrite(message.dropshipAddress, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* string dropship_recipient = 30; */
        if (message.dropshipRecipient !== "")
            writer.tag(30, WireType.LengthDelimited).string(message.dropshipRecipient);
        /* rd.integrations.x12.AcknowledgeCode acknowledgment = 31; */
        if (message.acknowledgment !== 0)
            writer.tag(31, WireType.Varint).int32(message.acknowledgment);
        /* string promo_code = 32; */
        if (message.promoCode !== "")
            writer.tag(32, WireType.LengthDelimited).string(message.promoCode);
        /* repeated rd.txn.CostAdjustment cost_adjustments = 33; */
        for (let i = 0; i < message.costAdjustments.length; i++)
            CostAdjustment.internalBinaryWrite(message.costAdjustments[i], writer.tag(33, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Order
 */
export const Order = new Order$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Order_Product$Type extends MessageType<Order_Product> {
    constructor() {
        super("rd.txn.Order.Product", [
            { no: 1, name: "product_id", kind: "message", T: () => UUID },
            { no: 6, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "cost_v2", kind: "message", T: () => FractionalMoney },
            { no: 10, name: "id", kind: "message", T: () => UUID },
            { no: 11, name: "sale_id", kind: "message", T: () => UUID },
            { no: 12, name: "sale_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 35, name: "custom_fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleForm_CustomField },
            { no: 14, name: "is_special_order", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "quantity_ordered_v2", kind: "message", T: () => Decimal },
            { no: 16, name: "quantity_received_v2", kind: "message", T: () => Decimal },
            { no: 17, name: "reasoning_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "sale_product_id", kind: "message", T: () => UUID },
            { no: 36, name: "uom_id", kind: "message", T: () => UUID },
            { no: 37, name: "quantity_ordered_uom", kind: "message", T: () => Decimal },
            { no: 39, name: "uom_snapshot", kind: "message", T: () => LedgerEntry_UomSnapshot },
            { no: 40, name: "is_cost_overridden", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 41, name: "additional_fees_when_received", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Order_Product_AdditionalFee },
            { no: 42, name: "quantity_staged_received", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<Order_Product>): Order_Product {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.position = 0;
        message.notes = "";
        message.saleIdentifier = "";
        message.customFields = [];
        message.isSpecialOrder = false;
        message.reasoningNotes = "";
        message.isCostOverridden = false;
        message.additionalFeesWhenReceived = [];
        if (value !== undefined)
            reflectionMergePartial<Order_Product>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Order_Product): Order_Product {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID product_id */ 1:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* int32 position */ 6:
                    message.position = reader.int32();
                    break;
                case /* string notes */ 7:
                    message.notes = reader.string();
                    break;
                case /* rd.proto.money.FractionalMoney cost_v2 */ 9:
                    message.costV2 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.costV2);
                    break;
                case /* rd.proto.uuid.UUID id */ 10:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 11:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* string sale_identifier */ 12:
                    message.saleIdentifier = reader.string();
                    break;
                case /* repeated rd.company.SaleForm.CustomField custom_fields */ 35:
                    message.customFields.push(SaleForm_CustomField.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_special_order */ 14:
                    message.isSpecialOrder = reader.bool();
                    break;
                case /* rd.proto.decimal.Decimal quantity_ordered_v2 */ 15:
                    message.quantityOrderedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityOrderedV2);
                    break;
                case /* rd.proto.decimal.Decimal quantity_received_v2 */ 16:
                    message.quantityReceivedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReceivedV2);
                    break;
                case /* string reasoning_notes */ 17:
                    message.reasoningNotes = reader.string();
                    break;
                case /* rd.proto.uuid.UUID sale_product_id */ 18:
                    message.saleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleProductId);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 36:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_ordered_uom */ 37:
                    message.quantityOrderedUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityOrderedUom);
                    break;
                case /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot */ 39:
                    message.uomSnapshot = LedgerEntry_UomSnapshot.internalBinaryRead(reader, reader.uint32(), options, message.uomSnapshot);
                    break;
                case /* bool is_cost_overridden */ 40:
                    message.isCostOverridden = reader.bool();
                    break;
                case /* repeated rd.txn.Order.Product.AdditionalFee additional_fees_when_received */ 41:
                    message.additionalFeesWhenReceived.push(Order_Product_AdditionalFee.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.decimal.Decimal quantity_staged_received */ 42:
                    message.quantityStagedReceived = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityStagedReceived);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Order_Product, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID product_id = 1; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 position = 6; */
        if (message.position !== 0)
            writer.tag(6, WireType.Varint).int32(message.position);
        /* string notes = 7; */
        if (message.notes !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.notes);
        /* rd.proto.money.FractionalMoney cost_v2 = 9; */
        if (message.costV2)
            FractionalMoney.internalBinaryWrite(message.costV2, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID id = 10; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 11; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string sale_identifier = 12; */
        if (message.saleIdentifier !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.saleIdentifier);
        /* bool is_special_order = 14; */
        if (message.isSpecialOrder !== false)
            writer.tag(14, WireType.Varint).bool(message.isSpecialOrder);
        /* rd.proto.decimal.Decimal quantity_ordered_v2 = 15; */
        if (message.quantityOrderedV2)
            Decimal.internalBinaryWrite(message.quantityOrderedV2, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_received_v2 = 16; */
        if (message.quantityReceivedV2)
            Decimal.internalBinaryWrite(message.quantityReceivedV2, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* string reasoning_notes = 17; */
        if (message.reasoningNotes !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.reasoningNotes);
        /* rd.proto.uuid.UUID sale_product_id = 18; */
        if (message.saleProductId)
            UUID.internalBinaryWrite(message.saleProductId, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.company.SaleForm.CustomField custom_fields = 35; */
        for (let i = 0; i < message.customFields.length; i++)
            SaleForm_CustomField.internalBinaryWrite(message.customFields[i], writer.tag(35, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 36; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(36, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_ordered_uom = 37; */
        if (message.quantityOrderedUom)
            Decimal.internalBinaryWrite(message.quantityOrderedUom, writer.tag(37, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 39; */
        if (message.uomSnapshot)
            LedgerEntry_UomSnapshot.internalBinaryWrite(message.uomSnapshot, writer.tag(39, WireType.LengthDelimited).fork(), options).join();
        /* bool is_cost_overridden = 40; */
        if (message.isCostOverridden !== false)
            writer.tag(40, WireType.Varint).bool(message.isCostOverridden);
        /* repeated rd.txn.Order.Product.AdditionalFee additional_fees_when_received = 41; */
        for (let i = 0; i < message.additionalFeesWhenReceived.length; i++)
            Order_Product_AdditionalFee.internalBinaryWrite(message.additionalFeesWhenReceived[i], writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_staged_received = 42; */
        if (message.quantityStagedReceived)
            Decimal.internalBinaryWrite(message.quantityStagedReceived, writer.tag(42, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Order.Product
 */
export const Order_Product = new Order_Product$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Order_Product_AdditionalFee$Type extends MessageType<Order_Product_AdditionalFee> {
    constructor() {
        super("rd.txn.Order.Product.AdditionalFee", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "unit_fee", kind: "message", T: () => FractionalMoney },
            { no: 3, name: "fee_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Order_Product_AdditionalFee>): Order_Product_AdditionalFee {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.feeId = "";
        if (value !== undefined)
            reflectionMergePartial<Order_Product_AdditionalFee>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Order_Product_AdditionalFee): Order_Product_AdditionalFee {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* rd.proto.money.FractionalMoney unit_fee */ 2:
                    message.unitFee = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.unitFee);
                    break;
                case /* string fee_id */ 3:
                    message.feeId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Order_Product_AdditionalFee, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* rd.proto.money.FractionalMoney unit_fee = 2; */
        if (message.unitFee)
            FractionalMoney.internalBinaryWrite(message.unitFee, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string fee_id = 3; */
        if (message.feeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.feeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Order.Product.AdditionalFee
 */
export const Order_Product_AdditionalFee = new Order_Product_AdditionalFee$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderLog$Type extends MessageType<OrderLog> {
    constructor() {
        super("rd.txn.OrderLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "created_by", kind: "message", T: () => User },
            { no: 4, name: "order", kind: "message", T: () => Order }
        ]);
    }
    create(value?: PartialMessage<OrderLog>): OrderLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<OrderLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderLog): OrderLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 3:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.txn.Order order */ 4:
                    message.order = Order.internalBinaryRead(reader, reader.uint32(), options, message.order);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 3; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Order order = 4; */
        if (message.order)
            Order.internalBinaryWrite(message.order, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.OrderLog
 */
export const OrderLog = new OrderLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderProductFilter$Type extends MessageType<OrderProductFilter> {
    constructor() {
        super("rd.txn.OrderProductFilter", [
            { no: 1, name: "department_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 2, name: "class_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 3, name: "fineline_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 4, name: "tag_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 5, name: "last_sale_range", kind: "message", T: () => TimestampRange }
        ]);
    }
    create(value?: PartialMessage<OrderProductFilter>): OrderProductFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.departmentIds = [];
        message.classIds = [];
        message.finelineIds = [];
        message.tagIds = [];
        if (value !== undefined)
            reflectionMergePartial<OrderProductFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderProductFilter): OrderProductFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.proto.uuid.UUID department_ids */ 1:
                    message.departmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID class_ids */ 2:
                    message.classIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID fineline_ids */ 3:
                    message.finelineIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID tag_ids */ 4:
                    message.tagIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.timestamprange.TimestampRange last_sale_range */ 5:
                    message.lastSaleRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.lastSaleRange);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderProductFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.proto.uuid.UUID department_ids = 1; */
        for (let i = 0; i < message.departmentIds.length; i++)
            UUID.internalBinaryWrite(message.departmentIds[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID class_ids = 2; */
        for (let i = 0; i < message.classIds.length; i++)
            UUID.internalBinaryWrite(message.classIds[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID fineline_ids = 3; */
        for (let i = 0; i < message.finelineIds.length; i++)
            UUID.internalBinaryWrite(message.finelineIds[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID tag_ids = 4; */
        for (let i = 0; i < message.tagIds.length; i++)
            UUID.internalBinaryWrite(message.tagIds[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange last_sale_range = 5; */
        if (message.lastSaleRange)
            TimestampRange.internalBinaryWrite(message.lastSaleRange, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.OrderProductFilter
 */
export const OrderProductFilter = new OrderProductFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CostAdjustment$Type extends MessageType<CostAdjustment> {
    constructor() {
        super("rd.txn.CostAdjustment", [
            { no: 1, name: "chart_of_account_id", kind: "message", T: () => UUID },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "amount", kind: "message", T: () => Money },
            { no: 5, name: "id", kind: "message", T: () => UUID },
            { no: 6, name: "distribution_method", kind: "enum", T: () => ["rd.txn.CostAdjustment.DistributionMethod", CostAdjustment_DistributionMethod, "DISTRIBUTION_METHOD_"] }
        ]);
    }
    create(value?: PartialMessage<CostAdjustment>): CostAdjustment {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.distributionMethod = 0;
        if (value !== undefined)
            reflectionMergePartial<CostAdjustment>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CostAdjustment): CostAdjustment {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID chart_of_account_id */ 1:
                    message.chartOfAccountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.chartOfAccountId);
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* rd.proto.money.Money amount */ 3:
                    message.amount = Money.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                case /* rd.proto.uuid.UUID id */ 5:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.txn.CostAdjustment.DistributionMethod distribution_method */ 6:
                    message.distributionMethod = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CostAdjustment, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID chart_of_account_id = 1; */
        if (message.chartOfAccountId)
            UUID.internalBinaryWrite(message.chartOfAccountId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* rd.proto.money.Money amount = 3; */
        if (message.amount)
            Money.internalBinaryWrite(message.amount, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID id = 5; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.CostAdjustment.DistributionMethod distribution_method = 6; */
        if (message.distributionMethod !== 0)
            writer.tag(6, WireType.Varint).int32(message.distributionMethod);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.CostAdjustment
 */
export const CostAdjustment = new CostAdjustment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderShipment$Type extends MessageType<OrderShipment> {
    constructor() {
        super("rd.txn.OrderShipment", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "order_id", kind: "message", T: () => UUID },
            { no: 3, name: "company_id", kind: "message", T: () => UUID },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "created_by", kind: "message", T: () => User },
            { no: 8, name: "received_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "received_by", kind: "message", T: () => User },
            { no: 10, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "location_id", kind: "message", T: () => UUID },
            { no: 12, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "vendor_id", kind: "message", T: () => UUID },
            { no: 14, name: "cost_adjustments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CostAdjustment },
            { no: 15, name: "financial_transaction_id", kind: "message", T: () => UUID },
            { no: 16, name: "external_transaction_id", kind: "message", T: () => UUID },
            { no: 17, name: "marked_paid_at", kind: "message", T: () => Timestamp },
            { no: 18, name: "marked_paid_by", kind: "message", T: () => User },
            { no: 19, name: "status", kind: "enum", T: () => ["rd.txn.OrderShipment.Status", OrderShipment_Status, "STATUS_"] },
            { no: 20, name: "pay_to", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "invoice_details", kind: "message", T: () => InvoiceDetails },
            { no: 22, name: "vouchered_at", kind: "message", T: () => Timestamp },
            { no: 23, name: "vouchered_by", kind: "message", T: () => User },
            { no: 24, name: "updated_by", kind: "message", T: () => User },
            { no: 25, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 26, name: "products", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrderShipment_Product },
            { no: 27, name: "dropship_address", kind: "message", T: () => Address },
            { no: 28, name: "dropship_recipient", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "total_received_v2", kind: "message", T: () => Decimal },
            { no: 31, name: "scheduled_delivery_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<OrderShipment>): OrderShipment {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notes = "";
        message.identifier = "";
        message.costAdjustments = [];
        message.status = 0;
        message.payTo = "";
        message.products = [];
        message.dropshipRecipient = "";
        if (value !== undefined)
            reflectionMergePartial<OrderShipment>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderShipment): OrderShipment {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID order_id */ 2:
                    message.orderId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderId);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 3:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 5:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* google.protobuf.Timestamp received_at */ 8:
                    message.receivedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.receivedAt);
                    break;
                case /* rd.user.User received_by */ 9:
                    message.receivedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.receivedBy);
                    break;
                case /* string notes */ 10:
                    message.notes = reader.string();
                    break;
                case /* rd.proto.uuid.UUID location_id */ 11:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* string identifier */ 12:
                    message.identifier = reader.string();
                    break;
                case /* rd.proto.uuid.UUID vendor_id */ 13:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* repeated rd.txn.CostAdjustment cost_adjustments */ 14:
                    message.costAdjustments.push(CostAdjustment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID financial_transaction_id */ 15:
                    message.financialTransactionId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.financialTransactionId);
                    break;
                case /* rd.proto.uuid.UUID external_transaction_id */ 16:
                    message.externalTransactionId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.externalTransactionId);
                    break;
                case /* google.protobuf.Timestamp marked_paid_at */ 17:
                    message.markedPaidAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.markedPaidAt);
                    break;
                case /* rd.user.User marked_paid_by */ 18:
                    message.markedPaidBy = User.internalBinaryRead(reader, reader.uint32(), options, message.markedPaidBy);
                    break;
                case /* rd.txn.OrderShipment.Status status */ 19:
                    message.status = reader.int32();
                    break;
                case /* string pay_to */ 20:
                    message.payTo = reader.string();
                    break;
                case /* rd.txn.InvoiceDetails invoice_details */ 21:
                    message.invoiceDetails = InvoiceDetails.internalBinaryRead(reader, reader.uint32(), options, message.invoiceDetails);
                    break;
                case /* google.protobuf.Timestamp vouchered_at */ 22:
                    message.voucheredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.voucheredAt);
                    break;
                case /* rd.user.User vouchered_by */ 23:
                    message.voucheredBy = User.internalBinaryRead(reader, reader.uint32(), options, message.voucheredBy);
                    break;
                case /* rd.user.User updated_by */ 24:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 25:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* repeated rd.txn.OrderShipment.Product products */ 26:
                    message.products.push(OrderShipment_Product.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.address.Address dropship_address */ 27:
                    message.dropshipAddress = Address.internalBinaryRead(reader, reader.uint32(), options, message.dropshipAddress);
                    break;
                case /* string dropship_recipient */ 28:
                    message.dropshipRecipient = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal total_received_v2 */ 29:
                    message.totalReceivedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.totalReceivedV2);
                    break;
                case /* google.protobuf.Timestamp scheduled_delivery_at */ 31:
                    message.scheduledDeliveryAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.scheduledDeliveryAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderShipment, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID order_id = 2; */
        if (message.orderId)
            UUID.internalBinaryWrite(message.orderId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 3; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 5; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp received_at = 8; */
        if (message.receivedAt)
            Timestamp.internalBinaryWrite(message.receivedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User received_by = 9; */
        if (message.receivedBy)
            User.internalBinaryWrite(message.receivedBy, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 10; */
        if (message.notes !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.notes);
        /* rd.proto.uuid.UUID location_id = 11; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 12; */
        if (message.identifier !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.identifier);
        /* rd.proto.uuid.UUID vendor_id = 13; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.CostAdjustment cost_adjustments = 14; */
        for (let i = 0; i < message.costAdjustments.length; i++)
            CostAdjustment.internalBinaryWrite(message.costAdjustments[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID financial_transaction_id = 15; */
        if (message.financialTransactionId)
            UUID.internalBinaryWrite(message.financialTransactionId, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID external_transaction_id = 16; */
        if (message.externalTransactionId)
            UUID.internalBinaryWrite(message.externalTransactionId, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp marked_paid_at = 17; */
        if (message.markedPaidAt)
            Timestamp.internalBinaryWrite(message.markedPaidAt, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User marked_paid_by = 18; */
        if (message.markedPaidBy)
            User.internalBinaryWrite(message.markedPaidBy, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.OrderShipment.Status status = 19; */
        if (message.status !== 0)
            writer.tag(19, WireType.Varint).int32(message.status);
        /* string pay_to = 20; */
        if (message.payTo !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.payTo);
        /* rd.txn.InvoiceDetails invoice_details = 21; */
        if (message.invoiceDetails)
            InvoiceDetails.internalBinaryWrite(message.invoiceDetails, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp vouchered_at = 22; */
        if (message.voucheredAt)
            Timestamp.internalBinaryWrite(message.voucheredAt, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User vouchered_by = 23; */
        if (message.voucheredBy)
            User.internalBinaryWrite(message.voucheredBy, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 24; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 25; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.OrderShipment.Product products = 26; */
        for (let i = 0; i < message.products.length; i++)
            OrderShipment_Product.internalBinaryWrite(message.products[i], writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.address.Address dropship_address = 27; */
        if (message.dropshipAddress)
            Address.internalBinaryWrite(message.dropshipAddress, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* string dropship_recipient = 28; */
        if (message.dropshipRecipient !== "")
            writer.tag(28, WireType.LengthDelimited).string(message.dropshipRecipient);
        /* rd.proto.decimal.Decimal total_received_v2 = 29; */
        if (message.totalReceivedV2)
            Decimal.internalBinaryWrite(message.totalReceivedV2, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp scheduled_delivery_at = 31; */
        if (message.scheduledDeliveryAt)
            Timestamp.internalBinaryWrite(message.scheduledDeliveryAt, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.OrderShipment
 */
export const OrderShipment = new OrderShipment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderShipment_Product$Type extends MessageType<OrderShipment_Product> {
    constructor() {
        super("rd.txn.OrderShipment.Product", [
            { no: 1, name: "product_id", kind: "message", T: () => UUID },
            { no: 6, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "cost_v2", kind: "message", T: () => FractionalMoney },
            { no: 8, name: "id", kind: "message", T: () => UUID },
            { no: 35, name: "custom_fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleForm_CustomField },
            { no: 10, name: "is_special_order", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "quantity_received_v2", kind: "message", T: () => Decimal },
            { no: 14, name: "quantity_shipped_v2", kind: "message", T: () => Decimal },
            { no: 15, name: "sale_product_id", kind: "message", T: () => UUID },
            { no: 36, name: "uom_id", kind: "message", T: () => UUID },
            { no: 37, name: "quantity_shipped_uom", kind: "message", T: () => Decimal },
            { no: 38, name: "quantity_received_uom", kind: "message", T: () => Decimal },
            { no: 39, name: "uom_snapshot", kind: "message", T: () => LedgerEntry_UomSnapshot },
            { no: 40, name: "additional_fees", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrderShipment_Product_AdditionalFee },
            { no: 41, name: "sale_id", kind: "message", T: () => UUID },
            { no: 42, name: "sale_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 43, name: "distributed_costs", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => FractionalMoney } }
        ]);
    }
    create(value?: PartialMessage<OrderShipment_Product>): OrderShipment_Product {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.position = 0;
        message.customFields = [];
        message.isSpecialOrder = false;
        message.additionalFees = [];
        message.saleIdentifier = "";
        message.distributedCosts = {};
        if (value !== undefined)
            reflectionMergePartial<OrderShipment_Product>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderShipment_Product): OrderShipment_Product {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID product_id */ 1:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* int32 position */ 6:
                    message.position = reader.int32();
                    break;
                case /* rd.proto.money.FractionalMoney cost_v2 */ 7:
                    message.costV2 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.costV2);
                    break;
                case /* rd.proto.uuid.UUID id */ 8:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* repeated rd.company.SaleForm.CustomField custom_fields */ 35:
                    message.customFields.push(SaleForm_CustomField.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_special_order */ 10:
                    message.isSpecialOrder = reader.bool();
                    break;
                case /* rd.proto.decimal.Decimal quantity_received_v2 */ 12:
                    message.quantityReceivedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReceivedV2);
                    break;
                case /* rd.proto.decimal.Decimal quantity_shipped_v2 */ 14:
                    message.quantityShippedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityShippedV2);
                    break;
                case /* rd.proto.uuid.UUID sale_product_id */ 15:
                    message.saleProductId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleProductId);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 36:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_shipped_uom */ 37:
                    message.quantityShippedUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityShippedUom);
                    break;
                case /* rd.proto.decimal.Decimal quantity_received_uom */ 38:
                    message.quantityReceivedUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReceivedUom);
                    break;
                case /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot */ 39:
                    message.uomSnapshot = LedgerEntry_UomSnapshot.internalBinaryRead(reader, reader.uint32(), options, message.uomSnapshot);
                    break;
                case /* repeated rd.txn.OrderShipment.Product.AdditionalFee additional_fees */ 40:
                    message.additionalFees.push(OrderShipment_Product_AdditionalFee.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 41:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* string sale_identifier */ 42:
                    message.saleIdentifier = reader.string();
                    break;
                case /* map<string, rd.proto.money.FractionalMoney> distributed_costs */ 43:
                    this.binaryReadMap43(message.distributedCosts, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap43(map: OrderShipment_Product["distributedCosts"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof OrderShipment_Product["distributedCosts"] | undefined, val: OrderShipment_Product["distributedCosts"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.OrderShipment.Product.distributed_costs");
            }
        }
        map[key ?? ""] = val ?? FractionalMoney.create();
    }
    internalBinaryWrite(message: OrderShipment_Product, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID product_id = 1; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 position = 6; */
        if (message.position !== 0)
            writer.tag(6, WireType.Varint).int32(message.position);
        /* rd.proto.money.FractionalMoney cost_v2 = 7; */
        if (message.costV2)
            FractionalMoney.internalBinaryWrite(message.costV2, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID id = 8; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bool is_special_order = 10; */
        if (message.isSpecialOrder !== false)
            writer.tag(10, WireType.Varint).bool(message.isSpecialOrder);
        /* rd.proto.decimal.Decimal quantity_received_v2 = 12; */
        if (message.quantityReceivedV2)
            Decimal.internalBinaryWrite(message.quantityReceivedV2, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_shipped_v2 = 14; */
        if (message.quantityShippedV2)
            Decimal.internalBinaryWrite(message.quantityShippedV2, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_product_id = 15; */
        if (message.saleProductId)
            UUID.internalBinaryWrite(message.saleProductId, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.company.SaleForm.CustomField custom_fields = 35; */
        for (let i = 0; i < message.customFields.length; i++)
            SaleForm_CustomField.internalBinaryWrite(message.customFields[i], writer.tag(35, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 36; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(36, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_shipped_uom = 37; */
        if (message.quantityShippedUom)
            Decimal.internalBinaryWrite(message.quantityShippedUom, writer.tag(37, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_received_uom = 38; */
        if (message.quantityReceivedUom)
            Decimal.internalBinaryWrite(message.quantityReceivedUom, writer.tag(38, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 39; */
        if (message.uomSnapshot)
            LedgerEntry_UomSnapshot.internalBinaryWrite(message.uomSnapshot, writer.tag(39, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.OrderShipment.Product.AdditionalFee additional_fees = 40; */
        for (let i = 0; i < message.additionalFees.length; i++)
            OrderShipment_Product_AdditionalFee.internalBinaryWrite(message.additionalFees[i], writer.tag(40, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID sale_id = 41; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* string sale_identifier = 42; */
        if (message.saleIdentifier !== "")
            writer.tag(42, WireType.LengthDelimited).string(message.saleIdentifier);
        /* map<string, rd.proto.money.FractionalMoney> distributed_costs = 43; */
        for (let k of globalThis.Object.keys(message.distributedCosts)) {
            writer.tag(43, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            FractionalMoney.internalBinaryWrite(message.distributedCosts[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.OrderShipment.Product
 */
export const OrderShipment_Product = new OrderShipment_Product$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderShipment_Product_AdditionalFee$Type extends MessageType<OrderShipment_Product_AdditionalFee> {
    constructor() {
        super("rd.txn.OrderShipment.Product.AdditionalFee", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "unit_fee", kind: "message", T: () => FractionalMoney },
            { no: 3, name: "fee_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OrderShipment_Product_AdditionalFee>): OrderShipment_Product_AdditionalFee {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.feeId = "";
        if (value !== undefined)
            reflectionMergePartial<OrderShipment_Product_AdditionalFee>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderShipment_Product_AdditionalFee): OrderShipment_Product_AdditionalFee {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* rd.proto.money.FractionalMoney unit_fee */ 2:
                    message.unitFee = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.unitFee);
                    break;
                case /* string fee_id */ 3:
                    message.feeId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderShipment_Product_AdditionalFee, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* rd.proto.money.FractionalMoney unit_fee = 2; */
        if (message.unitFee)
            FractionalMoney.internalBinaryWrite(message.unitFee, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string fee_id = 3; */
        if (message.feeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.feeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.OrderShipment.Product.AdditionalFee
 */
export const OrderShipment_Product_AdditionalFee = new OrderShipment_Product_AdditionalFee$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoiceDetails$Type extends MessageType<InvoiceDetails> {
    constructor() {
        super("rd.txn.InvoiceDetails", [
            { no: 1, name: "invoice_date", kind: "message", T: () => Timestamp },
            { no: 2, name: "due_date", kind: "message", T: () => Timestamp },
            { no: 3, name: "invoice_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "reference_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<InvoiceDetails>): InvoiceDetails {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.invoiceNumber = "";
        message.referenceNumber = "";
        if (value !== undefined)
            reflectionMergePartial<InvoiceDetails>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InvoiceDetails): InvoiceDetails {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp invoice_date */ 1:
                    message.invoiceDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.invoiceDate);
                    break;
                case /* google.protobuf.Timestamp due_date */ 2:
                    message.dueDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.dueDate);
                    break;
                case /* string invoice_number */ 3:
                    message.invoiceNumber = reader.string();
                    break;
                case /* string reference_number */ 4:
                    message.referenceNumber = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: InvoiceDetails, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp invoice_date = 1; */
        if (message.invoiceDate)
            Timestamp.internalBinaryWrite(message.invoiceDate, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp due_date = 2; */
        if (message.dueDate)
            Timestamp.internalBinaryWrite(message.dueDate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string invoice_number = 3; */
        if (message.invoiceNumber !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.invoiceNumber);
        /* string reference_number = 4; */
        if (message.referenceNumber !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.referenceNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.InvoiceDetails
 */
export const InvoiceDetails = new InvoiceDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderShipmentLog$Type extends MessageType<OrderShipmentLog> {
    constructor() {
        super("rd.txn.OrderShipmentLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "created_by", kind: "message", T: () => User },
            { no: 4, name: "order_shipment", kind: "message", T: () => OrderShipment }
        ]);
    }
    create(value?: PartialMessage<OrderShipmentLog>): OrderShipmentLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<OrderShipmentLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderShipmentLog): OrderShipmentLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 3:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.txn.OrderShipment order_shipment */ 4:
                    message.orderShipment = OrderShipment.internalBinaryRead(reader, reader.uint32(), options, message.orderShipment);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderShipmentLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 3; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.OrderShipment order_shipment = 4; */
        if (message.orderShipment)
            OrderShipment.internalBinaryWrite(message.orderShipment, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.OrderShipmentLog
 */
export const OrderShipmentLog = new OrderShipmentLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderPDFData$Type extends MessageType<OrderPDFData> {
    constructor() {
        super("rd.txn.OrderPDFData", [
            { no: 1, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "order", kind: "message", T: () => Order },
            { no: 3, name: "company", kind: "message", T: () => Company },
            { no: 4, name: "location", kind: "message", T: () => Location },
            { no: 5, name: "vendor", kind: "message", T: () => Vendor },
            { no: 6, name: "vendor_contact", kind: "message", T: () => Contacts_Contact$ },
            { no: 7, name: "products", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrderPDFData_VendorProduct },
            { no: 9, name: "total", kind: "message", T: () => Money },
            { no: 10, name: "account_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "show_value", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "invoice_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "invoice_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "due_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "show_invoice_section", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "reference_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OrderPDFData>): OrderPDFData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.products = [];
        message.accountNumber = "";
        message.showValue = false;
        message.invoiceNumber = "";
        message.invoiceDate = "";
        message.dueDate = "";
        message.showInvoiceSection = false;
        message.referenceNumber = "";
        if (value !== undefined)
            reflectionMergePartial<OrderPDFData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderPDFData): OrderPDFData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identifier */ 1:
                    message.identifier = reader.string();
                    break;
                case /* rd.txn.Order order */ 2:
                    message.order = Order.internalBinaryRead(reader, reader.uint32(), options, message.order);
                    break;
                case /* rd.company.Company company */ 3:
                    message.company = Company.internalBinaryRead(reader, reader.uint32(), options, message.company);
                    break;
                case /* rd.company.Location location */ 4:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.vendors.Vendor vendor */ 5:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* rd.vendors.Contacts.Contact vendor_contact */ 6:
                    message.vendorContact = Contacts_Contact$.internalBinaryRead(reader, reader.uint32(), options, message.vendorContact);
                    break;
                case /* repeated rd.txn.OrderPDFData.VendorProduct products */ 7:
                    message.products.push(OrderPDFData_VendorProduct.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.Money total */ 9:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* string account_number */ 10:
                    message.accountNumber = reader.string();
                    break;
                case /* bool show_value */ 11:
                    message.showValue = reader.bool();
                    break;
                case /* string invoice_number */ 12:
                    message.invoiceNumber = reader.string();
                    break;
                case /* string invoice_date */ 13:
                    message.invoiceDate = reader.string();
                    break;
                case /* string due_date */ 14:
                    message.dueDate = reader.string();
                    break;
                case /* bool show_invoice_section */ 15:
                    message.showInvoiceSection = reader.bool();
                    break;
                case /* string reference_number */ 17:
                    message.referenceNumber = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderPDFData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identifier = 1; */
        if (message.identifier !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier);
        /* rd.txn.Order order = 2; */
        if (message.order)
            Order.internalBinaryWrite(message.order, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Company company = 3; */
        if (message.company)
            Company.internalBinaryWrite(message.company, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 4; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor vendor = 5; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Contacts.Contact vendor_contact = 6; */
        if (message.vendorContact)
            Contacts_Contact$.internalBinaryWrite(message.vendorContact, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.OrderPDFData.VendorProduct products = 7; */
        for (let i = 0; i < message.products.length; i++)
            OrderPDFData_VendorProduct.internalBinaryWrite(message.products[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total = 9; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string account_number = 10; */
        if (message.accountNumber !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.accountNumber);
        /* bool show_value = 11; */
        if (message.showValue !== false)
            writer.tag(11, WireType.Varint).bool(message.showValue);
        /* string invoice_number = 12; */
        if (message.invoiceNumber !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.invoiceNumber);
        /* string invoice_date = 13; */
        if (message.invoiceDate !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.invoiceDate);
        /* string due_date = 14; */
        if (message.dueDate !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.dueDate);
        /* bool show_invoice_section = 15; */
        if (message.showInvoiceSection !== false)
            writer.tag(15, WireType.Varint).bool(message.showInvoiceSection);
        /* string reference_number = 17; */
        if (message.referenceNumber !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.referenceNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.OrderPDFData
 */
export const OrderPDFData = new OrderPDFData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderPDFData_VendorProduct$Type extends MessageType<OrderPDFData_VendorProduct> {
    constructor() {
        super("rd.txn.OrderPDFData.VendorProduct", [
            { no: 1, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "total", kind: "message", T: () => Money },
            { no: 7, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "cost_v2", kind: "message", T: () => FractionalMoney },
            { no: 10, name: "custom_fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleForm_CustomField },
            { no: 11, name: "vendor_sku", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "quantity_ordered_v2", kind: "message", T: () => Decimal },
            { no: 13, name: "quantity_received_v2", kind: "message", T: () => Decimal },
            { no: 14, name: "uom_id", kind: "message", T: () => UUID },
            { no: 15, name: "quantity_ordered_uom", kind: "message", T: () => Decimal },
            { no: 16, name: "quantity_received_uom", kind: "message", T: () => Decimal },
            { no: 17, name: "total_unit_fee", kind: "message", T: () => FractionalMoney },
            { no: 18, name: "uom_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OrderPDFData_VendorProduct>): OrderPDFData_VendorProduct {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.name = "";
        message.notes = "";
        message.customFields = [];
        message.vendorSku = "";
        message.uomCode = "";
        if (value !== undefined)
            reflectionMergePartial<OrderPDFData_VendorProduct>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderPDFData_VendorProduct): OrderPDFData_VendorProduct {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identifier */ 1:
                    message.identifier = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* rd.proto.money.Money total */ 4:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* string notes */ 7:
                    message.notes = reader.string();
                    break;
                case /* rd.proto.money.FractionalMoney cost_v2 */ 9:
                    message.costV2 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.costV2);
                    break;
                case /* repeated rd.company.SaleForm.CustomField custom_fields */ 10:
                    message.customFields.push(SaleForm_CustomField.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string vendor_sku */ 11:
                    message.vendorSku = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal quantity_ordered_v2 */ 12:
                    message.quantityOrderedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityOrderedV2);
                    break;
                case /* rd.proto.decimal.Decimal quantity_received_v2 */ 13:
                    message.quantityReceivedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReceivedV2);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 14:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_ordered_uom */ 15:
                    message.quantityOrderedUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityOrderedUom);
                    break;
                case /* rd.proto.decimal.Decimal quantity_received_uom */ 16:
                    message.quantityReceivedUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReceivedUom);
                    break;
                case /* rd.proto.money.FractionalMoney total_unit_fee */ 17:
                    message.totalUnitFee = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.totalUnitFee);
                    break;
                case /* string uom_code */ 18:
                    message.uomCode = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderPDFData_VendorProduct, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identifier = 1; */
        if (message.identifier !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* rd.proto.money.Money total = 4; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 7; */
        if (message.notes !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.notes);
        /* rd.proto.money.FractionalMoney cost_v2 = 9; */
        if (message.costV2)
            FractionalMoney.internalBinaryWrite(message.costV2, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.company.SaleForm.CustomField custom_fields = 10; */
        for (let i = 0; i < message.customFields.length; i++)
            SaleForm_CustomField.internalBinaryWrite(message.customFields[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string vendor_sku = 11; */
        if (message.vendorSku !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.vendorSku);
        /* rd.proto.decimal.Decimal quantity_ordered_v2 = 12; */
        if (message.quantityOrderedV2)
            Decimal.internalBinaryWrite(message.quantityOrderedV2, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_received_v2 = 13; */
        if (message.quantityReceivedV2)
            Decimal.internalBinaryWrite(message.quantityReceivedV2, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 14; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_ordered_uom = 15; */
        if (message.quantityOrderedUom)
            Decimal.internalBinaryWrite(message.quantityOrderedUom, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_received_uom = 16; */
        if (message.quantityReceivedUom)
            Decimal.internalBinaryWrite(message.quantityReceivedUom, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney total_unit_fee = 17; */
        if (message.totalUnitFee)
            FractionalMoney.internalBinaryWrite(message.totalUnitFee, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* string uom_code = 18; */
        if (message.uomCode !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.uomCode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.OrderPDFData.VendorProduct
 */
export const OrderPDFData_VendorProduct = new OrderPDFData_VendorProduct$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpsertOrderError$Type extends MessageType<UpsertOrderError> {
    constructor() {
        super("rd.txn.UpsertOrderError", [
            { no: 1, name: "invalid_upc_products", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Product },
            { no: 2, name: "is_vendor_sku_missing", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpsertOrderError>): UpsertOrderError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.invalidUpcProducts = [];
        message.isVendorSkuMissing = false;
        if (value !== undefined)
            reflectionMergePartial<UpsertOrderError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpsertOrderError): UpsertOrderError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.product.Product invalid_upc_products */ 1:
                    message.invalidUpcProducts.push(Product.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_vendor_sku_missing */ 2:
                    message.isVendorSkuMissing = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpsertOrderError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.product.Product invalid_upc_products = 1; */
        for (let i = 0; i < message.invalidUpcProducts.length; i++)
            Product.internalBinaryWrite(message.invalidUpcProducts[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_vendor_sku_missing = 2; */
        if (message.isVendorSkuMissing !== false)
            writer.tag(2, WireType.Varint).bool(message.isVendorSkuMissing);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.UpsertOrderError
 */
export const UpsertOrderError = new UpsertOrderError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Transfer$Type extends MessageType<Transfer> {
    constructor() {
        super("rd.txn.Transfer", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "created_by", kind: "message", T: () => User },
            { no: 6, name: "sent_by", kind: "message", T: () => User },
            { no: 7, name: "received_by", kind: "message", T: () => User },
            { no: 8, name: "voided_by", kind: "message", T: () => User },
            { no: 9, name: "from_location_id", kind: "message", T: () => UUID },
            { no: 10, name: "to_location_id", kind: "message", T: () => UUID },
            { no: 11, name: "sent_at", kind: "message", T: () => Timestamp },
            { no: 12, name: "received_at", kind: "message", T: () => Timestamp },
            { no: 13, name: "voided_at", kind: "message", T: () => Timestamp },
            { no: 14, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "status", kind: "enum", T: () => ["rd.txn.Transfer.Status", Transfer_Status, "STATUS_"] },
            { no: 16, name: "products_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Transfer_Product } },
            { no: 17, name: "total_cost_cents", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 20, name: "requested_at", kind: "message", T: () => Timestamp },
            { no: 21, name: "requested_by", kind: "message", T: () => User },
            { no: 22, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "request_date", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<Transfer>): Transfer {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.status = 0;
        message.productsById = {};
        message.totalCostCents = 0n;
        message.notes = "";
        if (value !== undefined)
            reflectionMergePartial<Transfer>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Transfer): Transfer {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.user.User created_by */ 5:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.user.User sent_by */ 6:
                    message.sentBy = User.internalBinaryRead(reader, reader.uint32(), options, message.sentBy);
                    break;
                case /* rd.user.User received_by */ 7:
                    message.receivedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.receivedBy);
                    break;
                case /* rd.user.User voided_by */ 8:
                    message.voidedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.voidedBy);
                    break;
                case /* rd.proto.uuid.UUID from_location_id */ 9:
                    message.fromLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.fromLocationId);
                    break;
                case /* rd.proto.uuid.UUID to_location_id */ 10:
                    message.toLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.toLocationId);
                    break;
                case /* google.protobuf.Timestamp sent_at */ 11:
                    message.sentAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.sentAt);
                    break;
                case /* google.protobuf.Timestamp received_at */ 12:
                    message.receivedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.receivedAt);
                    break;
                case /* google.protobuf.Timestamp voided_at */ 13:
                    message.voidedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.voidedAt);
                    break;
                case /* string identifier */ 14:
                    message.identifier = reader.string();
                    break;
                case /* rd.txn.Transfer.Status status */ 15:
                    message.status = reader.int32();
                    break;
                case /* map<string, rd.txn.Transfer.Product> products_by_id */ 16:
                    this.binaryReadMap16(message.productsById, reader, options);
                    break;
                case /* int64 total_cost_cents */ 17:
                    message.totalCostCents = reader.int64().toBigInt();
                    break;
                case /* google.protobuf.Timestamp requested_at */ 20:
                    message.requestedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.requestedAt);
                    break;
                case /* rd.user.User requested_by */ 21:
                    message.requestedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.requestedBy);
                    break;
                case /* string notes */ 22:
                    message.notes = reader.string();
                    break;
                case /* google.protobuf.Timestamp request_date */ 23:
                    message.requestDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.requestDate);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap16(map: Transfer["productsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Transfer["productsById"] | undefined, val: Transfer["productsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Transfer_Product.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.Transfer.products_by_id");
            }
        }
        map[key ?? ""] = val ?? Transfer_Product.create();
    }
    internalBinaryWrite(message: Transfer, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 5; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User sent_by = 6; */
        if (message.sentBy)
            User.internalBinaryWrite(message.sentBy, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User received_by = 7; */
        if (message.receivedBy)
            User.internalBinaryWrite(message.receivedBy, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User voided_by = 8; */
        if (message.voidedBy)
            User.internalBinaryWrite(message.voidedBy, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID from_location_id = 9; */
        if (message.fromLocationId)
            UUID.internalBinaryWrite(message.fromLocationId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID to_location_id = 10; */
        if (message.toLocationId)
            UUID.internalBinaryWrite(message.toLocationId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp sent_at = 11; */
        if (message.sentAt)
            Timestamp.internalBinaryWrite(message.sentAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp received_at = 12; */
        if (message.receivedAt)
            Timestamp.internalBinaryWrite(message.receivedAt, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp voided_at = 13; */
        if (message.voidedAt)
            Timestamp.internalBinaryWrite(message.voidedAt, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 14; */
        if (message.identifier !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.identifier);
        /* rd.txn.Transfer.Status status = 15; */
        if (message.status !== 0)
            writer.tag(15, WireType.Varint).int32(message.status);
        /* map<string, rd.txn.Transfer.Product> products_by_id = 16; */
        for (let k of globalThis.Object.keys(message.productsById)) {
            writer.tag(16, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Transfer_Product.internalBinaryWrite(message.productsById[k], writer, options);
            writer.join().join();
        }
        /* int64 total_cost_cents = 17; */
        if (message.totalCostCents !== 0n)
            writer.tag(17, WireType.Varint).int64(message.totalCostCents);
        /* google.protobuf.Timestamp requested_at = 20; */
        if (message.requestedAt)
            Timestamp.internalBinaryWrite(message.requestedAt, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User requested_by = 21; */
        if (message.requestedBy)
            User.internalBinaryWrite(message.requestedBy, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 22; */
        if (message.notes !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.notes);
        /* google.protobuf.Timestamp request_date = 23; */
        if (message.requestDate)
            Timestamp.internalBinaryWrite(message.requestDate, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Transfer
 */
export const Transfer = new Transfer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Transfer_Product$Type extends MessageType<Transfer_Product> {
    constructor() {
        super("rd.txn.Transfer.Product", [
            { no: 1, name: "product_id", kind: "message", T: () => UUID },
            { no: 6, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "cost_v2", kind: "message", T: () => FractionalMoney },
            { no: 9, name: "is_special_order", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "quantity_sent_v2", kind: "message", T: () => Decimal },
            { no: 11, name: "quantity_received_v2", kind: "message", T: () => Decimal },
            { no: 12, name: "quantity_requested_v2", kind: "message", T: () => Decimal },
            { no: 13, name: "uom_id", kind: "message", T: () => UUID },
            { no: 14, name: "quantity_sent_uom", kind: "message", T: () => Decimal },
            { no: 15, name: "quantity_received_uom", kind: "message", T: () => Decimal },
            { no: 16, name: "quantity_requested_uom", kind: "message", T: () => Decimal },
            { no: 17, name: "uom_snapshot", kind: "message", T: () => LedgerEntry_UomSnapshot },
            { no: 19, name: "additional_fees_when_received", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Transfer_Product_AdditionalFee }
        ]);
    }
    create(value?: PartialMessage<Transfer_Product>): Transfer_Product {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.position = 0;
        message.isSpecialOrder = false;
        message.additionalFeesWhenReceived = [];
        if (value !== undefined)
            reflectionMergePartial<Transfer_Product>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Transfer_Product): Transfer_Product {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID product_id */ 1:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* int32 position */ 6:
                    message.position = reader.int32();
                    break;
                case /* rd.proto.money.FractionalMoney cost_v2 */ 7:
                    message.costV2 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.costV2);
                    break;
                case /* bool is_special_order */ 9:
                    message.isSpecialOrder = reader.bool();
                    break;
                case /* rd.proto.decimal.Decimal quantity_sent_v2 */ 10:
                    message.quantitySentV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantitySentV2);
                    break;
                case /* rd.proto.decimal.Decimal quantity_received_v2 */ 11:
                    message.quantityReceivedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReceivedV2);
                    break;
                case /* rd.proto.decimal.Decimal quantity_requested_v2 */ 12:
                    message.quantityRequestedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityRequestedV2);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 13:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_sent_uom */ 14:
                    message.quantitySentUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantitySentUom);
                    break;
                case /* rd.proto.decimal.Decimal quantity_received_uom */ 15:
                    message.quantityReceivedUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReceivedUom);
                    break;
                case /* rd.proto.decimal.Decimal quantity_requested_uom */ 16:
                    message.quantityRequestedUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityRequestedUom);
                    break;
                case /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot */ 17:
                    message.uomSnapshot = LedgerEntry_UomSnapshot.internalBinaryRead(reader, reader.uint32(), options, message.uomSnapshot);
                    break;
                case /* repeated rd.txn.Transfer.Product.AdditionalFee additional_fees_when_received */ 19:
                    message.additionalFeesWhenReceived.push(Transfer_Product_AdditionalFee.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Transfer_Product, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID product_id = 1; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 position = 6; */
        if (message.position !== 0)
            writer.tag(6, WireType.Varint).int32(message.position);
        /* rd.proto.money.FractionalMoney cost_v2 = 7; */
        if (message.costV2)
            FractionalMoney.internalBinaryWrite(message.costV2, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bool is_special_order = 9; */
        if (message.isSpecialOrder !== false)
            writer.tag(9, WireType.Varint).bool(message.isSpecialOrder);
        /* rd.proto.decimal.Decimal quantity_sent_v2 = 10; */
        if (message.quantitySentV2)
            Decimal.internalBinaryWrite(message.quantitySentV2, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_received_v2 = 11; */
        if (message.quantityReceivedV2)
            Decimal.internalBinaryWrite(message.quantityReceivedV2, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_requested_v2 = 12; */
        if (message.quantityRequestedV2)
            Decimal.internalBinaryWrite(message.quantityRequestedV2, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 13; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_sent_uom = 14; */
        if (message.quantitySentUom)
            Decimal.internalBinaryWrite(message.quantitySentUom, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_received_uom = 15; */
        if (message.quantityReceivedUom)
            Decimal.internalBinaryWrite(message.quantityReceivedUom, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_requested_uom = 16; */
        if (message.quantityRequestedUom)
            Decimal.internalBinaryWrite(message.quantityRequestedUom, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 17; */
        if (message.uomSnapshot)
            LedgerEntry_UomSnapshot.internalBinaryWrite(message.uomSnapshot, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.Transfer.Product.AdditionalFee additional_fees_when_received = 19; */
        for (let i = 0; i < message.additionalFeesWhenReceived.length; i++)
            Transfer_Product_AdditionalFee.internalBinaryWrite(message.additionalFeesWhenReceived[i], writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Transfer.Product
 */
export const Transfer_Product = new Transfer_Product$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Transfer_Product_AdditionalFee$Type extends MessageType<Transfer_Product_AdditionalFee> {
    constructor() {
        super("rd.txn.Transfer.Product.AdditionalFee", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "unit_fee", kind: "message", T: () => FractionalMoney },
            { no: 3, name: "fee_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Transfer_Product_AdditionalFee>): Transfer_Product_AdditionalFee {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.feeId = "";
        if (value !== undefined)
            reflectionMergePartial<Transfer_Product_AdditionalFee>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Transfer_Product_AdditionalFee): Transfer_Product_AdditionalFee {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* rd.proto.money.FractionalMoney unit_fee */ 2:
                    message.unitFee = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.unitFee);
                    break;
                case /* string fee_id */ 3:
                    message.feeId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Transfer_Product_AdditionalFee, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* rd.proto.money.FractionalMoney unit_fee = 2; */
        if (message.unitFee)
            FractionalMoney.internalBinaryWrite(message.unitFee, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string fee_id = 3; */
        if (message.feeId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.feeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Transfer.Product.AdditionalFee
 */
export const Transfer_Product_AdditionalFee = new Transfer_Product_AdditionalFee$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransferLog$Type extends MessageType<TransferLog> {
    constructor() {
        super("rd.txn.TransferLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "created_by", kind: "message", T: () => User },
            { no: 4, name: "transfer", kind: "message", T: () => Transfer }
        ]);
    }
    create(value?: PartialMessage<TransferLog>): TransferLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TransferLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TransferLog): TransferLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 3:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.txn.Transfer transfer */ 4:
                    message.transfer = Transfer.internalBinaryRead(reader, reader.uint32(), options, message.transfer);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TransferLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 3; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Transfer transfer = 4; */
        if (message.transfer)
            Transfer.internalBinaryWrite(message.transfer, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TransferLog
 */
export const TransferLog = new TransferLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToFromTransferCounts$Type extends MessageType<ToFromTransferCounts> {
    constructor() {
        super("rd.txn.ToFromTransferCounts", [
            { no: 1, name: "from_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "to_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ToFromTransferCounts>): ToFromTransferCounts {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fromCount = 0;
        message.toCount = 0;
        if (value !== undefined)
            reflectionMergePartial<ToFromTransferCounts>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToFromTransferCounts): ToFromTransferCounts {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 from_count */ 1:
                    message.fromCount = reader.int32();
                    break;
                case /* int32 to_count */ 2:
                    message.toCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToFromTransferCounts, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 from_count = 1; */
        if (message.fromCount !== 0)
            writer.tag(1, WireType.Varint).int32(message.fromCount);
        /* int32 to_count = 2; */
        if (message.toCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.toCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.ToFromTransferCounts
 */
export const ToFromTransferCounts = new ToFromTransferCounts$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransferPDFData$Type extends MessageType<TransferPDFData> {
    constructor() {
        super("rd.txn.TransferPDFData", [
            { no: 1, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "transfer", kind: "message", T: () => Transfer },
            { no: 3, name: "company", kind: "message", T: () => Company },
            { no: 4, name: "location", kind: "message", T: () => Location },
            { no: 5, name: "to_location", kind: "message", T: () => Location },
            { no: 6, name: "products", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TransferPDFData_Product },
            { no: 7, name: "total", kind: "message", T: () => Money },
            { no: 9, name: "show_value", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TransferPDFData>): TransferPDFData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.products = [];
        message.showValue = false;
        if (value !== undefined)
            reflectionMergePartial<TransferPDFData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TransferPDFData): TransferPDFData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identifier */ 1:
                    message.identifier = reader.string();
                    break;
                case /* rd.txn.Transfer transfer */ 2:
                    message.transfer = Transfer.internalBinaryRead(reader, reader.uint32(), options, message.transfer);
                    break;
                case /* rd.company.Company company */ 3:
                    message.company = Company.internalBinaryRead(reader, reader.uint32(), options, message.company);
                    break;
                case /* rd.company.Location location */ 4:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.company.Location to_location */ 5:
                    message.toLocation = Location.internalBinaryRead(reader, reader.uint32(), options, message.toLocation);
                    break;
                case /* repeated rd.txn.TransferPDFData.Product products */ 6:
                    message.products.push(TransferPDFData_Product.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.Money total */ 7:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* bool show_value */ 9:
                    message.showValue = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TransferPDFData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identifier = 1; */
        if (message.identifier !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier);
        /* rd.txn.Transfer transfer = 2; */
        if (message.transfer)
            Transfer.internalBinaryWrite(message.transfer, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Company company = 3; */
        if (message.company)
            Company.internalBinaryWrite(message.company, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 4; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location to_location = 5; */
        if (message.toLocation)
            Location.internalBinaryWrite(message.toLocation, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.TransferPDFData.Product products = 6; */
        for (let i = 0; i < message.products.length; i++)
            TransferPDFData_Product.internalBinaryWrite(message.products[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total = 7; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bool show_value = 9; */
        if (message.showValue !== false)
            writer.tag(9, WireType.Varint).bool(message.showValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TransferPDFData
 */
export const TransferPDFData = new TransferPDFData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransferPDFData_Product$Type extends MessageType<TransferPDFData_Product> {
    constructor() {
        super("rd.txn.TransferPDFData.Product", [
            { no: 1, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "total", kind: "message", T: () => Money },
            { no: 8, name: "cost_v2", kind: "message", T: () => FractionalMoney },
            { no: 9, name: "from_location_bin", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "to_location_bin", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "quantity_v2", kind: "message", T: () => Decimal },
            { no: 13, name: "uom_id", kind: "message", T: () => UUID },
            { no: 14, name: "quantity_uom", kind: "message", T: () => Decimal },
            { no: 15, name: "total_unit_fee", kind: "message", T: () => FractionalMoney }
        ]);
    }
    create(value?: PartialMessage<TransferPDFData_Product>): TransferPDFData_Product {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.name = "";
        message.fromLocationBin = "";
        message.toLocationBin = "";
        message.position = 0;
        if (value !== undefined)
            reflectionMergePartial<TransferPDFData_Product>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TransferPDFData_Product): TransferPDFData_Product {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identifier */ 1:
                    message.identifier = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* rd.proto.money.Money total */ 4:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* rd.proto.money.FractionalMoney cost_v2 */ 8:
                    message.costV2 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.costV2);
                    break;
                case /* string from_location_bin */ 9:
                    message.fromLocationBin = reader.string();
                    break;
                case /* string to_location_bin */ 10:
                    message.toLocationBin = reader.string();
                    break;
                case /* int32 position */ 11:
                    message.position = reader.int32();
                    break;
                case /* rd.proto.decimal.Decimal quantity_v2 */ 12:
                    message.quantityV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityV2);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 13:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_uom */ 14:
                    message.quantityUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityUom);
                    break;
                case /* rd.proto.money.FractionalMoney total_unit_fee */ 15:
                    message.totalUnitFee = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.totalUnitFee);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TransferPDFData_Product, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identifier = 1; */
        if (message.identifier !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* rd.proto.money.Money total = 4; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney cost_v2 = 8; */
        if (message.costV2)
            FractionalMoney.internalBinaryWrite(message.costV2, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string from_location_bin = 9; */
        if (message.fromLocationBin !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.fromLocationBin);
        /* string to_location_bin = 10; */
        if (message.toLocationBin !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.toLocationBin);
        /* int32 position = 11; */
        if (message.position !== 0)
            writer.tag(11, WireType.Varint).int32(message.position);
        /* rd.proto.decimal.Decimal quantity_v2 = 12; */
        if (message.quantityV2)
            Decimal.internalBinaryWrite(message.quantityV2, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 13; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_uom = 14; */
        if (message.quantityUom)
            Decimal.internalBinaryWrite(message.quantityUom, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney total_unit_fee = 15; */
        if (message.totalUnitFee)
            FractionalMoney.internalBinaryWrite(message.totalUnitFee, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TransferPDFData.Product
 */
export const TransferPDFData_Product = new TransferPDFData_Product$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BillPayment$Type extends MessageType<BillPayment> {
    constructor() {
        super("rd.txn.BillPayment", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "created_by", kind: "message", T: () => User },
            { no: 5, name: "company_id", kind: "message", T: () => UUID },
            { no: 6, name: "customer_id", kind: "message", T: () => UUID },
            { no: 7, name: "location_id", kind: "message", T: () => UUID },
            { no: 8, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "refunded_at", kind: "message", T: () => Timestamp },
            { no: 11, name: "refunded_by", kind: "message", T: () => User },
            { no: 12, name: "refund_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "card_surcharge_rate", kind: "message", T: () => Decimal },
            { no: 16, name: "credit_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "credit_allocation_status", kind: "enum", T: () => ["rd.txn.CreditAllocationStatus", CreditAllocationStatus, "CREDIT_ALLOCATION_STATUS_"] },
            { no: 18, name: "voided_at", kind: "message", T: () => Timestamp },
            { no: 19, name: "voided_by", kind: "message", T: () => User },
            { no: 20, name: "void_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "source", kind: "enum", T: () => ["rd.txn.BillPayment.Source", BillPayment_Source, "SOURCE_"] },
            { no: 22, name: "taxes_by_tax_rate_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => BillPayment_Tax } },
            { no: 23, name: "cash_rounding_delta", kind: "message", T: () => Money },
            { no: 24, name: "refund_cash_rounding_delta", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<BillPayment>): BillPayment {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.notes = "";
        message.refundNotes = "";
        message.creditNotes = "";
        message.creditAllocationStatus = 0;
        message.voidNotes = "";
        message.source = 0;
        message.taxesByTaxRateId = {};
        if (value !== undefined)
            reflectionMergePartial<BillPayment>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BillPayment): BillPayment {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User created_by */ 4:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 5:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 6:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 7:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* string identifier */ 8:
                    message.identifier = reader.string();
                    break;
                case /* string notes */ 9:
                    message.notes = reader.string();
                    break;
                case /* google.protobuf.Timestamp refunded_at */ 10:
                    message.refundedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.refundedAt);
                    break;
                case /* rd.user.User refunded_by */ 11:
                    message.refundedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.refundedBy);
                    break;
                case /* string refund_notes */ 12:
                    message.refundNotes = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal card_surcharge_rate */ 13:
                    message.cardSurchargeRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.cardSurchargeRate);
                    break;
                case /* string credit_notes */ 16:
                    message.creditNotes = reader.string();
                    break;
                case /* rd.txn.CreditAllocationStatus credit_allocation_status */ 17:
                    message.creditAllocationStatus = reader.int32();
                    break;
                case /* google.protobuf.Timestamp voided_at */ 18:
                    message.voidedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.voidedAt);
                    break;
                case /* rd.user.User voided_by */ 19:
                    message.voidedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.voidedBy);
                    break;
                case /* string void_notes */ 20:
                    message.voidNotes = reader.string();
                    break;
                case /* rd.txn.BillPayment.Source source */ 21:
                    message.source = reader.int32();
                    break;
                case /* map<string, rd.txn.BillPayment.Tax> taxes_by_tax_rate_id */ 22:
                    this.binaryReadMap22(message.taxesByTaxRateId, reader, options);
                    break;
                case /* rd.proto.money.Money cash_rounding_delta */ 23:
                    message.cashRoundingDelta = Money.internalBinaryRead(reader, reader.uint32(), options, message.cashRoundingDelta);
                    break;
                case /* rd.proto.money.Money refund_cash_rounding_delta */ 24:
                    message.refundCashRoundingDelta = Money.internalBinaryRead(reader, reader.uint32(), options, message.refundCashRoundingDelta);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap22(map: BillPayment["taxesByTaxRateId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof BillPayment["taxesByTaxRateId"] | undefined, val: BillPayment["taxesByTaxRateId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = BillPayment_Tax.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.BillPayment.taxes_by_tax_rate_id");
            }
        }
        map[key ?? ""] = val ?? BillPayment_Tax.create();
    }
    internalBinaryWrite(message: BillPayment, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 4; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 5; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 6; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 7; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 8; */
        if (message.identifier !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.identifier);
        /* string notes = 9; */
        if (message.notes !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.notes);
        /* google.protobuf.Timestamp refunded_at = 10; */
        if (message.refundedAt)
            Timestamp.internalBinaryWrite(message.refundedAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User refunded_by = 11; */
        if (message.refundedBy)
            User.internalBinaryWrite(message.refundedBy, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string refund_notes = 12; */
        if (message.refundNotes !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.refundNotes);
        /* rd.proto.decimal.Decimal card_surcharge_rate = 13; */
        if (message.cardSurchargeRate)
            Decimal.internalBinaryWrite(message.cardSurchargeRate, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* string credit_notes = 16; */
        if (message.creditNotes !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.creditNotes);
        /* rd.txn.CreditAllocationStatus credit_allocation_status = 17; */
        if (message.creditAllocationStatus !== 0)
            writer.tag(17, WireType.Varint).int32(message.creditAllocationStatus);
        /* google.protobuf.Timestamp voided_at = 18; */
        if (message.voidedAt)
            Timestamp.internalBinaryWrite(message.voidedAt, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User voided_by = 19; */
        if (message.voidedBy)
            User.internalBinaryWrite(message.voidedBy, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* string void_notes = 20; */
        if (message.voidNotes !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.voidNotes);
        /* rd.txn.BillPayment.Source source = 21; */
        if (message.source !== 0)
            writer.tag(21, WireType.Varint).int32(message.source);
        /* map<string, rd.txn.BillPayment.Tax> taxes_by_tax_rate_id = 22; */
        for (let k of globalThis.Object.keys(message.taxesByTaxRateId)) {
            writer.tag(22, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            BillPayment_Tax.internalBinaryWrite(message.taxesByTaxRateId[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money cash_rounding_delta = 23; */
        if (message.cashRoundingDelta)
            Money.internalBinaryWrite(message.cashRoundingDelta, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money refund_cash_rounding_delta = 24; */
        if (message.refundCashRoundingDelta)
            Money.internalBinaryWrite(message.refundCashRoundingDelta, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.BillPayment
 */
export const BillPayment = new BillPayment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BillPayment_Tax$Type extends MessageType<BillPayment_Tax> {
    constructor() {
        super("rd.txn.BillPayment.Tax", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "rate", kind: "message", T: () => Decimal },
            { no: 4, name: "surcharge_tax", kind: "message", T: () => Money },
            { no: 5, name: "tax_components", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaxComponent }
        ]);
    }
    create(value?: PartialMessage<BillPayment_Tax>): BillPayment_Tax {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taxComponents = [];
        if (value !== undefined)
            reflectionMergePartial<BillPayment_Tax>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BillPayment_Tax): BillPayment_Tax {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.decimal.Decimal rate */ 2:
                    message.rate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.rate);
                    break;
                case /* rd.proto.money.Money surcharge_tax */ 4:
                    message.surchargeTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.surchargeTax);
                    break;
                case /* repeated rd.company.TaxComponent tax_components */ 5:
                    message.taxComponents.push(TaxComponent.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BillPayment_Tax, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal rate = 2; */
        if (message.rate)
            Decimal.internalBinaryWrite(message.rate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money surcharge_tax = 4; */
        if (message.surchargeTax)
            Money.internalBinaryWrite(message.surchargeTax, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.company.TaxComponent tax_components = 5; */
        for (let i = 0; i < message.taxComponents.length; i++)
            TaxComponent.internalBinaryWrite(message.taxComponents[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.BillPayment.Tax
 */
export const BillPayment_Tax = new BillPayment_Tax$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CustomerBalance$Type extends MessageType<CustomerBalance> {
    constructor() {
        super("rd.txn.CustomerBalance", [
            { no: 1, name: "credits", kind: "message", T: () => Money },
            { no: 2, name: "current", kind: "message", T: () => Money },
            { no: 3, name: "late_1_to_30", kind: "message", T: () => Money },
            { no: 4, name: "late_31_to_60", kind: "message", T: () => Money },
            { no: 5, name: "late_61_plus", kind: "message", T: () => Money },
            { no: 6, name: "financing_charges", kind: "message", T: () => Money },
            { no: 7, name: "outstanding_purchases", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 8, name: "id", kind: "message", T: () => UUID },
            { no: 9, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 10, name: "company_id", kind: "message", T: () => UUID },
            { no: 11, name: "aging_ledger", kind: "message", T: () => CustomerAgingLedger },
            { no: 12, name: "outstanding_finance_charges", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } }
        ]);
    }
    create(value?: PartialMessage<CustomerBalance>): CustomerBalance {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.outstandingPurchases = {};
        message.outstandingFinanceCharges = {};
        if (value !== undefined)
            reflectionMergePartial<CustomerBalance>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CustomerBalance): CustomerBalance {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money credits */ 1:
                    message.credits = Money.internalBinaryRead(reader, reader.uint32(), options, message.credits);
                    break;
                case /* rd.proto.money.Money current */ 2:
                    message.current = Money.internalBinaryRead(reader, reader.uint32(), options, message.current);
                    break;
                case /* rd.proto.money.Money late_1_to_30 */ 3:
                    message.late1To30 = Money.internalBinaryRead(reader, reader.uint32(), options, message.late1To30);
                    break;
                case /* rd.proto.money.Money late_31_to_60 */ 4:
                    message.late31To60 = Money.internalBinaryRead(reader, reader.uint32(), options, message.late31To60);
                    break;
                case /* rd.proto.money.Money late_61_plus */ 5:
                    message.late61Plus = Money.internalBinaryRead(reader, reader.uint32(), options, message.late61Plus);
                    break;
                case /* rd.proto.money.Money financing_charges */ 6:
                    message.financingCharges = Money.internalBinaryRead(reader, reader.uint32(), options, message.financingCharges);
                    break;
                case /* map<string, rd.proto.money.Money> outstanding_purchases */ 7:
                    this.binaryReadMap7(message.outstandingPurchases, reader, options);
                    break;
                case /* rd.proto.uuid.UUID id */ 8:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 9:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 10:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.txn.CustomerAgingLedger aging_ledger */ 11:
                    message.agingLedger = CustomerAgingLedger.internalBinaryRead(reader, reader.uint32(), options, message.agingLedger);
                    break;
                case /* map<string, rd.proto.money.Money> outstanding_finance_charges */ 12:
                    this.binaryReadMap12(message.outstandingFinanceCharges, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap7(map: CustomerBalance["outstandingPurchases"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CustomerBalance["outstandingPurchases"] | undefined, val: CustomerBalance["outstandingPurchases"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.CustomerBalance.outstanding_purchases");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap12(map: CustomerBalance["outstandingFinanceCharges"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CustomerBalance["outstandingFinanceCharges"] | undefined, val: CustomerBalance["outstandingFinanceCharges"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.CustomerBalance.outstanding_finance_charges");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: CustomerBalance, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money credits = 1; */
        if (message.credits)
            Money.internalBinaryWrite(message.credits, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money current = 2; */
        if (message.current)
            Money.internalBinaryWrite(message.current, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money late_1_to_30 = 3; */
        if (message.late1To30)
            Money.internalBinaryWrite(message.late1To30, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money late_31_to_60 = 4; */
        if (message.late31To60)
            Money.internalBinaryWrite(message.late31To60, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money late_61_plus = 5; */
        if (message.late61Plus)
            Money.internalBinaryWrite(message.late61Plus, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money financing_charges = 6; */
        if (message.financingCharges)
            Money.internalBinaryWrite(message.financingCharges, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> outstanding_purchases = 7; */
        for (let k of globalThis.Object.keys(message.outstandingPurchases)) {
            writer.tag(7, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.outstandingPurchases[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.uuid.UUID id = 8; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 9; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 10; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.CustomerAgingLedger aging_ledger = 11; */
        if (message.agingLedger)
            CustomerAgingLedger.internalBinaryWrite(message.agingLedger, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> outstanding_finance_charges = 12; */
        for (let k of globalThis.Object.keys(message.outstandingFinanceCharges)) {
            writer.tag(12, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.outstandingFinanceCharges[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.CustomerBalance
 */
export const CustomerBalance = new CustomerBalance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CustomerAgingLedger$Type extends MessageType<CustomerAgingLedger> {
    constructor() {
        super("rd.txn.CustomerAgingLedger", [
            { no: 1, name: "credits", kind: "message", T: () => Money },
            { no: 2, name: "current", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 3, name: "late_1_to_30", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 4, name: "late_31_to_60", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 5, name: "late_61_plus", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 6, name: "financing_charges", kind: "message", T: () => Money },
            { no: 7, name: "outstanding_purchases", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 8, name: "id", kind: "message", T: () => UUID },
            { no: 9, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 10, name: "company_id", kind: "message", T: () => UUID },
            { no: 11, name: "outstanding_finance_charges", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 12, name: "credits_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 13, name: "missing_balances_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 14, name: "late_61_to_90", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 15, name: "late_91_plus", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 16, name: "average_days_to_pay", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<CustomerAgingLedger>): CustomerAgingLedger {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.current = {};
        message.late1To30 = {};
        message.late31To60 = {};
        message.late61Plus = {};
        message.outstandingPurchases = {};
        message.outstandingFinanceCharges = {};
        message.creditsById = {};
        message.missingBalancesById = {};
        message.late61To90 = {};
        message.late91Plus = {};
        if (value !== undefined)
            reflectionMergePartial<CustomerAgingLedger>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CustomerAgingLedger): CustomerAgingLedger {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money credits */ 1:
                    message.credits = Money.internalBinaryRead(reader, reader.uint32(), options, message.credits);
                    break;
                case /* map<string, rd.proto.money.Money> current */ 2:
                    this.binaryReadMap2(message.current, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> late_1_to_30 */ 3:
                    this.binaryReadMap3(message.late1To30, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> late_31_to_60 */ 4:
                    this.binaryReadMap4(message.late31To60, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> late_61_plus */ 5:
                    this.binaryReadMap5(message.late61Plus, reader, options);
                    break;
                case /* rd.proto.money.Money financing_charges */ 6:
                    message.financingCharges = Money.internalBinaryRead(reader, reader.uint32(), options, message.financingCharges);
                    break;
                case /* map<string, rd.proto.money.Money> outstanding_purchases */ 7:
                    this.binaryReadMap7(message.outstandingPurchases, reader, options);
                    break;
                case /* rd.proto.uuid.UUID id */ 8:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 9:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 10:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* map<string, rd.proto.money.Money> outstanding_finance_charges */ 11:
                    this.binaryReadMap11(message.outstandingFinanceCharges, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> credits_by_id */ 12:
                    this.binaryReadMap12(message.creditsById, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> missing_balances_by_id */ 13:
                    this.binaryReadMap13(message.missingBalancesById, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> late_61_to_90 */ 14:
                    this.binaryReadMap14(message.late61To90, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> late_91_plus */ 15:
                    this.binaryReadMap15(message.late91Plus, reader, options);
                    break;
                case /* rd.proto.decimal.Decimal average_days_to_pay */ 16:
                    message.averageDaysToPay = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.averageDaysToPay);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: CustomerAgingLedger["current"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CustomerAgingLedger["current"] | undefined, val: CustomerAgingLedger["current"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.CustomerAgingLedger.current");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap3(map: CustomerAgingLedger["late1To30"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CustomerAgingLedger["late1To30"] | undefined, val: CustomerAgingLedger["late1To30"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.CustomerAgingLedger.late_1_to_30");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap4(map: CustomerAgingLedger["late31To60"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CustomerAgingLedger["late31To60"] | undefined, val: CustomerAgingLedger["late31To60"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.CustomerAgingLedger.late_31_to_60");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap5(map: CustomerAgingLedger["late61Plus"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CustomerAgingLedger["late61Plus"] | undefined, val: CustomerAgingLedger["late61Plus"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.CustomerAgingLedger.late_61_plus");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap7(map: CustomerAgingLedger["outstandingPurchases"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CustomerAgingLedger["outstandingPurchases"] | undefined, val: CustomerAgingLedger["outstandingPurchases"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.CustomerAgingLedger.outstanding_purchases");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap11(map: CustomerAgingLedger["outstandingFinanceCharges"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CustomerAgingLedger["outstandingFinanceCharges"] | undefined, val: CustomerAgingLedger["outstandingFinanceCharges"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.CustomerAgingLedger.outstanding_finance_charges");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap12(map: CustomerAgingLedger["creditsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CustomerAgingLedger["creditsById"] | undefined, val: CustomerAgingLedger["creditsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.CustomerAgingLedger.credits_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap13(map: CustomerAgingLedger["missingBalancesById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CustomerAgingLedger["missingBalancesById"] | undefined, val: CustomerAgingLedger["missingBalancesById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.CustomerAgingLedger.missing_balances_by_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap14(map: CustomerAgingLedger["late61To90"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CustomerAgingLedger["late61To90"] | undefined, val: CustomerAgingLedger["late61To90"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.CustomerAgingLedger.late_61_to_90");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap15(map: CustomerAgingLedger["late91Plus"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CustomerAgingLedger["late91Plus"] | undefined, val: CustomerAgingLedger["late91Plus"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.CustomerAgingLedger.late_91_plus");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: CustomerAgingLedger, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money credits = 1; */
        if (message.credits)
            Money.internalBinaryWrite(message.credits, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> current = 2; */
        for (let k of globalThis.Object.keys(message.current)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.current[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> late_1_to_30 = 3; */
        for (let k of globalThis.Object.keys(message.late1To30)) {
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.late1To30[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> late_31_to_60 = 4; */
        for (let k of globalThis.Object.keys(message.late31To60)) {
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.late31To60[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> late_61_plus = 5; */
        for (let k of globalThis.Object.keys(message.late61Plus)) {
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.late61Plus[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money financing_charges = 6; */
        if (message.financingCharges)
            Money.internalBinaryWrite(message.financingCharges, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> outstanding_purchases = 7; */
        for (let k of globalThis.Object.keys(message.outstandingPurchases)) {
            writer.tag(7, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.outstandingPurchases[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.uuid.UUID id = 8; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 9; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 10; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> outstanding_finance_charges = 11; */
        for (let k of globalThis.Object.keys(message.outstandingFinanceCharges)) {
            writer.tag(11, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.outstandingFinanceCharges[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> credits_by_id = 12; */
        for (let k of globalThis.Object.keys(message.creditsById)) {
            writer.tag(12, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.creditsById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> missing_balances_by_id = 13; */
        for (let k of globalThis.Object.keys(message.missingBalancesById)) {
            writer.tag(13, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.missingBalancesById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> late_61_to_90 = 14; */
        for (let k of globalThis.Object.keys(message.late61To90)) {
            writer.tag(14, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.late61To90[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> late_91_plus = 15; */
        for (let k of globalThis.Object.keys(message.late91Plus)) {
            writer.tag(15, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.late91Plus[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.decimal.Decimal average_days_to_pay = 16; */
        if (message.averageDaysToPay)
            Decimal.internalBinaryWrite(message.averageDaysToPay, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.CustomerAgingLedger
 */
export const CustomerAgingLedger = new CustomerAgingLedger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CustomerSaleHistoryPDFData$Type extends MessageType<CustomerSaleHistoryPDFData> {
    constructor() {
        super("rd.txn.CustomerSaleHistoryPDFData", [
            { no: 1, name: "company", kind: "message", T: () => Company },
            { no: 2, name: "location", kind: "message", T: () => Location },
            { no: 3, name: "customer", kind: "message", T: () => Customer },
            { no: 4, name: "primary_contact", kind: "message", T: () => Contacts_Contact },
            { no: 5, name: "timestamp_range", kind: "message", T: () => TimestampRange },
            { no: 6, name: "sales", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CustomerSaleHistoryPDFData_Sale },
            { no: 7, name: "sales_total", kind: "message", T: () => Money },
            { no: 8, name: "purchase_orders", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PurchaseOrder },
            { no: 9, name: "remaining_balance_total", kind: "message", T: () => Money },
            { no: 10, name: "formatted_timestamp_range", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CustomerSaleHistoryPDFData>): CustomerSaleHistoryPDFData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sales = [];
        message.purchaseOrders = [];
        message.formattedTimestampRange = "";
        if (value !== undefined)
            reflectionMergePartial<CustomerSaleHistoryPDFData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CustomerSaleHistoryPDFData): CustomerSaleHistoryPDFData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.company.Company company */ 1:
                    message.company = Company.internalBinaryRead(reader, reader.uint32(), options, message.company);
                    break;
                case /* rd.company.Location location */ 2:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.customer.Customer customer */ 3:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* rd.customer.Contacts.Contact primary_contact */ 4:
                    message.primaryContact = Contacts_Contact.internalBinaryRead(reader, reader.uint32(), options, message.primaryContact);
                    break;
                case /* rd.proto.timestamprange.TimestampRange timestamp_range */ 5:
                    message.timestampRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.timestampRange);
                    break;
                case /* repeated rd.txn.CustomerSaleHistoryPDFData.Sale sales */ 6:
                    message.sales.push(CustomerSaleHistoryPDFData_Sale.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.Money sales_total */ 7:
                    message.salesTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.salesTotal);
                    break;
                case /* repeated rd.customer.PurchaseOrder purchase_orders */ 8:
                    message.purchaseOrders.push(PurchaseOrder.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.Money remaining_balance_total */ 9:
                    message.remainingBalanceTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.remainingBalanceTotal);
                    break;
                case /* string formatted_timestamp_range */ 10:
                    message.formattedTimestampRange = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CustomerSaleHistoryPDFData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.company.Company company = 1; */
        if (message.company)
            Company.internalBinaryWrite(message.company, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 2; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer customer = 3; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Contacts.Contact primary_contact = 4; */
        if (message.primaryContact)
            Contacts_Contact.internalBinaryWrite(message.primaryContact, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange timestamp_range = 5; */
        if (message.timestampRange)
            TimestampRange.internalBinaryWrite(message.timestampRange, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.CustomerSaleHistoryPDFData.Sale sales = 6; */
        for (let i = 0; i < message.sales.length; i++)
            CustomerSaleHistoryPDFData_Sale.internalBinaryWrite(message.sales[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money sales_total = 7; */
        if (message.salesTotal)
            Money.internalBinaryWrite(message.salesTotal, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.customer.PurchaseOrder purchase_orders = 8; */
        for (let i = 0; i < message.purchaseOrders.length; i++)
            PurchaseOrder.internalBinaryWrite(message.purchaseOrders[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money remaining_balance_total = 9; */
        if (message.remainingBalanceTotal)
            Money.internalBinaryWrite(message.remainingBalanceTotal, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string formatted_timestamp_range = 10; */
        if (message.formattedTimestampRange !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.formattedTimestampRange);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.CustomerSaleHistoryPDFData
 */
export const CustomerSaleHistoryPDFData = new CustomerSaleHistoryPDFData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CustomerSaleHistoryPDFData_Sale$Type extends MessageType<CustomerSaleHistoryPDFData_Sale> {
    constructor() {
        super("rd.txn.CustomerSaleHistoryPDFData.Sale", [
            { no: 1, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "location_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "purchase_order", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sold_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "due_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "total", kind: "message", T: () => Money },
            { no: 7, name: "remaining_balance", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<CustomerSaleHistoryPDFData_Sale>): CustomerSaleHistoryPDFData_Sale {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.locationName = "";
        message.purchaseOrder = "";
        if (value !== undefined)
            reflectionMergePartial<CustomerSaleHistoryPDFData_Sale>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CustomerSaleHistoryPDFData_Sale): CustomerSaleHistoryPDFData_Sale {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identifier */ 1:
                    message.identifier = reader.string();
                    break;
                case /* string location_name */ 2:
                    message.locationName = reader.string();
                    break;
                case /* string purchase_order */ 3:
                    message.purchaseOrder = reader.string();
                    break;
                case /* google.protobuf.Timestamp sold_at */ 4:
                    message.soldAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.soldAt);
                    break;
                case /* google.protobuf.Timestamp due_at */ 5:
                    message.dueAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.dueAt);
                    break;
                case /* rd.proto.money.Money total */ 6:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* rd.proto.money.Money remaining_balance */ 7:
                    message.remainingBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.remainingBalance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CustomerSaleHistoryPDFData_Sale, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identifier = 1; */
        if (message.identifier !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier);
        /* string location_name = 2; */
        if (message.locationName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.locationName);
        /* string purchase_order = 3; */
        if (message.purchaseOrder !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.purchaseOrder);
        /* google.protobuf.Timestamp sold_at = 4; */
        if (message.soldAt)
            Timestamp.internalBinaryWrite(message.soldAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp due_at = 5; */
        if (message.dueAt)
            Timestamp.internalBinaryWrite(message.dueAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total = 6; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money remaining_balance = 7; */
        if (message.remainingBalance)
            Money.internalBinaryWrite(message.remainingBalance, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.CustomerSaleHistoryPDFData.Sale
 */
export const CustomerSaleHistoryPDFData_Sale = new CustomerSaleHistoryPDFData_Sale$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PettyCash$Type extends MessageType<PettyCash> {
    constructor() {
        super("rd.txn.PettyCash", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "created_by", kind: "message", T: () => User },
            { no: 4, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "location_id", kind: "message", T: () => UUID },
            { no: 7, name: "company_id", kind: "message", T: () => UUID },
            { no: 8, name: "cash_register_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<PettyCash>): PettyCash {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.notes = "";
        if (value !== undefined)
            reflectionMergePartial<PettyCash>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PettyCash): PettyCash {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 3:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* string identifier */ 4:
                    message.identifier = reader.string();
                    break;
                case /* string notes */ 5:
                    message.notes = reader.string();
                    break;
                case /* rd.proto.uuid.UUID location_id */ 6:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 7:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID cash_register_id */ 8:
                    message.cashRegisterId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.cashRegisterId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PettyCash, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 3; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 4; */
        if (message.identifier !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.identifier);
        /* string notes = 5; */
        if (message.notes !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.notes);
        /* rd.proto.uuid.UUID location_id = 6; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 7; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID cash_register_id = 8; */
        if (message.cashRegisterId)
            UUID.internalBinaryWrite(message.cashRegisterId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.PettyCash
 */
export const PettyCash = new PettyCash$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CloseOut$Type extends MessageType<CloseOut> {
    constructor() {
        super("rd.txn.CloseOut", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "created_by", kind: "message", T: () => User },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "location_id", kind: "message", T: () => UUID },
            { no: 6, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "counted_100_dollar_bills", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "counted_50_dollar_bills", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "counted_20_dollar_bills", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "counted_10_dollar_bills", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "counted_5_dollar_bills", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "counted_1_dollar_bills", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "counted_25_cent_coins", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "counted_10_cent_coins", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "counted_5_cent_coins", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "counted_1_cent_coins", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "float", kind: "message", T: () => Money },
            { no: 19, name: "cash_register_id", kind: "message", T: () => UUID },
            { no: 20, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 21, name: "updated_by", kind: "message", T: () => User },
            { no: 22, name: "counted_2_dollar_bills", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<CloseOut>): CloseOut {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.notes = "";
        message.counted100DollarBills = 0;
        message.counted50DollarBills = 0;
        message.counted20DollarBills = 0;
        message.counted10DollarBills = 0;
        message.counted5DollarBills = 0;
        message.counted1DollarBills = 0;
        message.counted25CentCoins = 0;
        message.counted10CentCoins = 0;
        message.counted5CentCoins = 0;
        message.counted1CentCoins = 0;
        message.counted2DollarBills = 0;
        if (value !== undefined)
            reflectionMergePartial<CloseOut>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CloseOut): CloseOut {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 3:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 5:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* string identifier */ 6:
                    message.identifier = reader.string();
                    break;
                case /* string notes */ 7:
                    message.notes = reader.string();
                    break;
                case /* int32 counted_100_dollar_bills */ 8:
                    message.counted100DollarBills = reader.int32();
                    break;
                case /* int32 counted_50_dollar_bills */ 9:
                    message.counted50DollarBills = reader.int32();
                    break;
                case /* int32 counted_20_dollar_bills */ 10:
                    message.counted20DollarBills = reader.int32();
                    break;
                case /* int32 counted_10_dollar_bills */ 11:
                    message.counted10DollarBills = reader.int32();
                    break;
                case /* int32 counted_5_dollar_bills */ 12:
                    message.counted5DollarBills = reader.int32();
                    break;
                case /* int32 counted_1_dollar_bills */ 13:
                    message.counted1DollarBills = reader.int32();
                    break;
                case /* int32 counted_25_cent_coins */ 14:
                    message.counted25CentCoins = reader.int32();
                    break;
                case /* int32 counted_10_cent_coins */ 15:
                    message.counted10CentCoins = reader.int32();
                    break;
                case /* int32 counted_5_cent_coins */ 16:
                    message.counted5CentCoins = reader.int32();
                    break;
                case /* int32 counted_1_cent_coins */ 17:
                    message.counted1CentCoins = reader.int32();
                    break;
                case /* rd.proto.money.Money float */ 18:
                    message.float = Money.internalBinaryRead(reader, reader.uint32(), options, message.float);
                    break;
                case /* rd.proto.uuid.UUID cash_register_id */ 19:
                    message.cashRegisterId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.cashRegisterId);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 20:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User updated_by */ 21:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* int32 counted_2_dollar_bills */ 22:
                    message.counted2DollarBills = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CloseOut, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 3; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 5; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 6; */
        if (message.identifier !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.identifier);
        /* string notes = 7; */
        if (message.notes !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.notes);
        /* int32 counted_100_dollar_bills = 8; */
        if (message.counted100DollarBills !== 0)
            writer.tag(8, WireType.Varint).int32(message.counted100DollarBills);
        /* int32 counted_50_dollar_bills = 9; */
        if (message.counted50DollarBills !== 0)
            writer.tag(9, WireType.Varint).int32(message.counted50DollarBills);
        /* int32 counted_20_dollar_bills = 10; */
        if (message.counted20DollarBills !== 0)
            writer.tag(10, WireType.Varint).int32(message.counted20DollarBills);
        /* int32 counted_10_dollar_bills = 11; */
        if (message.counted10DollarBills !== 0)
            writer.tag(11, WireType.Varint).int32(message.counted10DollarBills);
        /* int32 counted_5_dollar_bills = 12; */
        if (message.counted5DollarBills !== 0)
            writer.tag(12, WireType.Varint).int32(message.counted5DollarBills);
        /* int32 counted_1_dollar_bills = 13; */
        if (message.counted1DollarBills !== 0)
            writer.tag(13, WireType.Varint).int32(message.counted1DollarBills);
        /* int32 counted_25_cent_coins = 14; */
        if (message.counted25CentCoins !== 0)
            writer.tag(14, WireType.Varint).int32(message.counted25CentCoins);
        /* int32 counted_10_cent_coins = 15; */
        if (message.counted10CentCoins !== 0)
            writer.tag(15, WireType.Varint).int32(message.counted10CentCoins);
        /* int32 counted_5_cent_coins = 16; */
        if (message.counted5CentCoins !== 0)
            writer.tag(16, WireType.Varint).int32(message.counted5CentCoins);
        /* int32 counted_1_cent_coins = 17; */
        if (message.counted1CentCoins !== 0)
            writer.tag(17, WireType.Varint).int32(message.counted1CentCoins);
        /* rd.proto.money.Money float = 18; */
        if (message.float)
            Money.internalBinaryWrite(message.float, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID cash_register_id = 19; */
        if (message.cashRegisterId)
            UUID.internalBinaryWrite(message.cashRegisterId, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 20; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 21; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* int32 counted_2_dollar_bills = 22; */
        if (message.counted2DollarBills !== 0)
            writer.tag(22, WireType.Varint).int32(message.counted2DollarBills);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.CloseOut
 */
export const CloseOut = new CloseOut$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CloseOutLog$Type extends MessageType<CloseOutLog> {
    constructor() {
        super("rd.txn.CloseOutLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "created_by", kind: "message", T: () => User },
            { no: 4, name: "close_out", kind: "message", T: () => CloseOut }
        ]);
    }
    create(value?: PartialMessage<CloseOutLog>): CloseOutLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CloseOutLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CloseOutLog): CloseOutLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 3:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.txn.CloseOut close_out */ 4:
                    message.closeOut = CloseOut.internalBinaryRead(reader, reader.uint32(), options, message.closeOut);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CloseOutLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 3; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.CloseOut close_out = 4; */
        if (message.closeOut)
            CloseOut.internalBinaryWrite(message.closeOut, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.CloseOutLog
 */
export const CloseOutLog = new CloseOutLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CustomerSalesAnalytics$Type extends MessageType<CustomerSalesAnalytics> {
    constructor() {
        super("rd.txn.CustomerSalesAnalytics", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "sales_ytd", kind: "message", T: () => Money },
            { no: 4, name: "sales_last_ytd", kind: "message", T: () => Money },
            { no: 5, name: "yoy_growth", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "margin_ytd", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 7, name: "last_sale", kind: "message", T: () => Timestamp },
            { no: 8, name: "sales_last_12mo", kind: "message", jsonName: "salesLast12mo", T: () => Money },
            { no: 9, name: "sales_last_3mo", kind: "message", jsonName: "salesLast3mo", T: () => Money },
            { no: 10, name: "sales_last_1mo", kind: "message", jsonName: "salesLast1mo", T: () => Money },
            { no: 11, name: "standard_margin_ytd", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value?: PartialMessage<CustomerSalesAnalytics>): CustomerSalesAnalytics {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.yoyGrowth = 0;
        message.marginYtd = 0;
        message.standardMarginYtd = 0;
        if (value !== undefined)
            reflectionMergePartial<CustomerSalesAnalytics>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CustomerSalesAnalytics): CustomerSalesAnalytics {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.money.Money sales_ytd */ 3:
                    message.salesYtd = Money.internalBinaryRead(reader, reader.uint32(), options, message.salesYtd);
                    break;
                case /* rd.proto.money.Money sales_last_ytd */ 4:
                    message.salesLastYtd = Money.internalBinaryRead(reader, reader.uint32(), options, message.salesLastYtd);
                    break;
                case /* float yoy_growth */ 5:
                    message.yoyGrowth = reader.float();
                    break;
                case /* float margin_ytd */ 6:
                    message.marginYtd = reader.float();
                    break;
                case /* google.protobuf.Timestamp last_sale */ 7:
                    message.lastSale = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastSale);
                    break;
                case /* rd.proto.money.Money sales_last_12mo */ 8:
                    message.salesLast12Mo = Money.internalBinaryRead(reader, reader.uint32(), options, message.salesLast12Mo);
                    break;
                case /* rd.proto.money.Money sales_last_3mo */ 9:
                    message.salesLast3Mo = Money.internalBinaryRead(reader, reader.uint32(), options, message.salesLast3Mo);
                    break;
                case /* rd.proto.money.Money sales_last_1mo */ 10:
                    message.salesLast1Mo = Money.internalBinaryRead(reader, reader.uint32(), options, message.salesLast1Mo);
                    break;
                case /* float standard_margin_ytd */ 11:
                    message.standardMarginYtd = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CustomerSalesAnalytics, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money sales_ytd = 3; */
        if (message.salesYtd)
            Money.internalBinaryWrite(message.salesYtd, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money sales_last_ytd = 4; */
        if (message.salesLastYtd)
            Money.internalBinaryWrite(message.salesLastYtd, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* float yoy_growth = 5; */
        if (message.yoyGrowth !== 0)
            writer.tag(5, WireType.Bit32).float(message.yoyGrowth);
        /* float margin_ytd = 6; */
        if (message.marginYtd !== 0)
            writer.tag(6, WireType.Bit32).float(message.marginYtd);
        /* google.protobuf.Timestamp last_sale = 7; */
        if (message.lastSale)
            Timestamp.internalBinaryWrite(message.lastSale, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money sales_last_12mo = 8; */
        if (message.salesLast12Mo)
            Money.internalBinaryWrite(message.salesLast12Mo, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money sales_last_3mo = 9; */
        if (message.salesLast3Mo)
            Money.internalBinaryWrite(message.salesLast3Mo, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money sales_last_1mo = 10; */
        if (message.salesLast1Mo)
            Money.internalBinaryWrite(message.salesLast1Mo, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* float standard_margin_ytd = 11; */
        if (message.standardMarginYtd !== 0)
            writer.tag(11, WireType.Bit32).float(message.standardMarginYtd);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.CustomerSalesAnalytics
 */
export const CustomerSalesAnalytics = new CustomerSalesAnalytics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CustomerSalesRollup$Type extends MessageType<CustomerSalesRollup> {
    constructor() {
        super("rd.txn.CustomerSalesRollup", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "series_start", kind: "message", T: () => Timestamp },
            { no: 5, name: "series_end", kind: "message", T: () => Timestamp },
            { no: 6, name: "company_id", kind: "message", T: () => UUID },
            { no: 7, name: "customer_id", kind: "message", T: () => UUID },
            { no: 8, name: "ledger_entries_hash", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "sales_data", kind: "message", T: () => CustomerSalesRollup_SalesData }
        ]);
    }
    create(value?: PartialMessage<CustomerSalesRollup>): CustomerSalesRollup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ledgerEntriesHash = "";
        if (value !== undefined)
            reflectionMergePartial<CustomerSalesRollup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CustomerSalesRollup): CustomerSalesRollup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp series_start */ 4:
                    message.seriesStart = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.seriesStart);
                    break;
                case /* google.protobuf.Timestamp series_end */ 5:
                    message.seriesEnd = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.seriesEnd);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 6:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 7:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* string ledger_entries_hash */ 8:
                    message.ledgerEntriesHash = reader.string();
                    break;
                case /* rd.txn.CustomerSalesRollup.SalesData sales_data */ 9:
                    message.salesData = CustomerSalesRollup_SalesData.internalBinaryRead(reader, reader.uint32(), options, message.salesData);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CustomerSalesRollup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp series_start = 4; */
        if (message.seriesStart)
            Timestamp.internalBinaryWrite(message.seriesStart, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp series_end = 5; */
        if (message.seriesEnd)
            Timestamp.internalBinaryWrite(message.seriesEnd, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 6; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 7; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string ledger_entries_hash = 8; */
        if (message.ledgerEntriesHash !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.ledgerEntriesHash);
        /* rd.txn.CustomerSalesRollup.SalesData sales_data = 9; */
        if (message.salesData)
            CustomerSalesRollup_SalesData.internalBinaryWrite(message.salesData, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.CustomerSalesRollup
 */
export const CustomerSalesRollup = new CustomerSalesRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CustomerSalesRollup_SalesData$Type extends MessageType<CustomerSalesRollup_SalesData> {
    constructor() {
        super("rd.txn.CustomerSalesRollup.SalesData", [
            { no: 1, name: "price_of_goods_sold", kind: "message", T: () => Money },
            { no: 3, name: "last_sale", kind: "message", T: () => Timestamp },
            { no: 4, name: "cost_of_goods_sold_v2", kind: "message", T: () => FractionalMoney },
            { no: 5, name: "standard_cost_of_goods_sold", kind: "message", T: () => FractionalMoney }
        ]);
    }
    create(value?: PartialMessage<CustomerSalesRollup_SalesData>): CustomerSalesRollup_SalesData {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CustomerSalesRollup_SalesData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CustomerSalesRollup_SalesData): CustomerSalesRollup_SalesData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money price_of_goods_sold */ 1:
                    message.priceOfGoodsSold = Money.internalBinaryRead(reader, reader.uint32(), options, message.priceOfGoodsSold);
                    break;
                case /* google.protobuf.Timestamp last_sale */ 3:
                    message.lastSale = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastSale);
                    break;
                case /* rd.proto.money.FractionalMoney cost_of_goods_sold_v2 */ 4:
                    message.costOfGoodsSoldV2 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.costOfGoodsSoldV2);
                    break;
                case /* rd.proto.money.FractionalMoney standard_cost_of_goods_sold */ 5:
                    message.standardCostOfGoodsSold = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.standardCostOfGoodsSold);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CustomerSalesRollup_SalesData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money price_of_goods_sold = 1; */
        if (message.priceOfGoodsSold)
            Money.internalBinaryWrite(message.priceOfGoodsSold, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp last_sale = 3; */
        if (message.lastSale)
            Timestamp.internalBinaryWrite(message.lastSale, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney cost_of_goods_sold_v2 = 4; */
        if (message.costOfGoodsSoldV2)
            FractionalMoney.internalBinaryWrite(message.costOfGoodsSoldV2, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney standard_cost_of_goods_sold = 5; */
        if (message.standardCostOfGoodsSold)
            FractionalMoney.internalBinaryWrite(message.standardCostOfGoodsSold, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.CustomerSalesRollup.SalesData
 */
export const CustomerSalesRollup_SalesData = new CustomerSalesRollup_SalesData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductSalesAnalytics$Type extends MessageType<ProductSalesAnalytics> {
    constructor() {
        super("rd.txn.ProductSalesAnalytics", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "product_id", kind: "message", T: () => UUID },
            { no: 3, name: "location_id", kind: "message", T: () => UUID },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 7, name: "yoy_growth", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "margin_ytd", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "last_sale", kind: "message", T: () => Timestamp },
            { no: 13, name: "inventory_turns", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 14, name: "standard_margin_ytd", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 15, name: "units_ytd_v2", kind: "message", T: () => Decimal },
            { no: 16, name: "units_last_ytd_v2", kind: "message", T: () => Decimal },
            { no: 17, name: "units_last_12mo_v2", kind: "message", jsonName: "unitsLast12moV2", T: () => Decimal },
            { no: 18, name: "units_last_3mo_v2", kind: "message", jsonName: "unitsLast3moV2", T: () => Decimal },
            { no: 19, name: "units_last_1mo_v2", kind: "message", jsonName: "unitsLast1moV2", T: () => Decimal },
            { no: 20, name: "revenue_ytd", kind: "message", T: () => Money },
            { no: 21, name: "average_cost_ytd", kind: "message", T: () => FractionalMoney },
            { no: 22, name: "standard_cost_ytd", kind: "message", T: () => FractionalMoney },
            { no: 23, name: "stock", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<ProductSalesAnalytics>): ProductSalesAnalytics {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.yoyGrowth = 0;
        message.marginYtd = 0;
        message.inventoryTurns = 0;
        message.standardMarginYtd = 0;
        if (value !== undefined)
            reflectionMergePartial<ProductSalesAnalytics>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductSalesAnalytics): ProductSalesAnalytics {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID product_id */ 2:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 3:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* float yoy_growth */ 7:
                    message.yoyGrowth = reader.float();
                    break;
                case /* float margin_ytd */ 8:
                    message.marginYtd = reader.float();
                    break;
                case /* google.protobuf.Timestamp last_sale */ 9:
                    message.lastSale = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastSale);
                    break;
                case /* float inventory_turns */ 13:
                    message.inventoryTurns = reader.float();
                    break;
                case /* float standard_margin_ytd */ 14:
                    message.standardMarginYtd = reader.float();
                    break;
                case /* rd.proto.decimal.Decimal units_ytd_v2 */ 15:
                    message.unitsYtdV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.unitsYtdV2);
                    break;
                case /* rd.proto.decimal.Decimal units_last_ytd_v2 */ 16:
                    message.unitsLastYtdV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.unitsLastYtdV2);
                    break;
                case /* rd.proto.decimal.Decimal units_last_12mo_v2 */ 17:
                    message.unitsLast12MoV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.unitsLast12MoV2);
                    break;
                case /* rd.proto.decimal.Decimal units_last_3mo_v2 */ 18:
                    message.unitsLast3MoV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.unitsLast3MoV2);
                    break;
                case /* rd.proto.decimal.Decimal units_last_1mo_v2 */ 19:
                    message.unitsLast1MoV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.unitsLast1MoV2);
                    break;
                case /* rd.proto.money.Money revenue_ytd */ 20:
                    message.revenueYtd = Money.internalBinaryRead(reader, reader.uint32(), options, message.revenueYtd);
                    break;
                case /* rd.proto.money.FractionalMoney average_cost_ytd */ 21:
                    message.averageCostYtd = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.averageCostYtd);
                    break;
                case /* rd.proto.money.FractionalMoney standard_cost_ytd */ 22:
                    message.standardCostYtd = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.standardCostYtd);
                    break;
                case /* rd.proto.decimal.Decimal stock */ 23:
                    message.stock = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.stock);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductSalesAnalytics, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID product_id = 2; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 3; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* float yoy_growth = 7; */
        if (message.yoyGrowth !== 0)
            writer.tag(7, WireType.Bit32).float(message.yoyGrowth);
        /* float margin_ytd = 8; */
        if (message.marginYtd !== 0)
            writer.tag(8, WireType.Bit32).float(message.marginYtd);
        /* google.protobuf.Timestamp last_sale = 9; */
        if (message.lastSale)
            Timestamp.internalBinaryWrite(message.lastSale, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* float inventory_turns = 13; */
        if (message.inventoryTurns !== 0)
            writer.tag(13, WireType.Bit32).float(message.inventoryTurns);
        /* float standard_margin_ytd = 14; */
        if (message.standardMarginYtd !== 0)
            writer.tag(14, WireType.Bit32).float(message.standardMarginYtd);
        /* rd.proto.decimal.Decimal units_ytd_v2 = 15; */
        if (message.unitsYtdV2)
            Decimal.internalBinaryWrite(message.unitsYtdV2, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal units_last_ytd_v2 = 16; */
        if (message.unitsLastYtdV2)
            Decimal.internalBinaryWrite(message.unitsLastYtdV2, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal units_last_12mo_v2 = 17; */
        if (message.unitsLast12MoV2)
            Decimal.internalBinaryWrite(message.unitsLast12MoV2, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal units_last_3mo_v2 = 18; */
        if (message.unitsLast3MoV2)
            Decimal.internalBinaryWrite(message.unitsLast3MoV2, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal units_last_1mo_v2 = 19; */
        if (message.unitsLast1MoV2)
            Decimal.internalBinaryWrite(message.unitsLast1MoV2, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money revenue_ytd = 20; */
        if (message.revenueYtd)
            Money.internalBinaryWrite(message.revenueYtd, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney average_cost_ytd = 21; */
        if (message.averageCostYtd)
            FractionalMoney.internalBinaryWrite(message.averageCostYtd, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney standard_cost_ytd = 22; */
        if (message.standardCostYtd)
            FractionalMoney.internalBinaryWrite(message.standardCostYtd, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal stock = 23; */
        if (message.stock)
            Decimal.internalBinaryWrite(message.stock, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.ProductSalesAnalytics
 */
export const ProductSalesAnalytics = new ProductSalesAnalytics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductSalesRollup$Type extends MessageType<ProductSalesRollup> {
    constructor() {
        super("rd.txn.ProductSalesRollup", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "series_start", kind: "message", T: () => Timestamp },
            { no: 5, name: "series_end", kind: "message", T: () => Timestamp },
            { no: 6, name: "company_id", kind: "message", T: () => UUID },
            { no: 7, name: "product_id", kind: "message", T: () => UUID },
            { no: 8, name: "sales_hash", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "sales_data_by_location_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => ProductSalesRollup_SalesData } }
        ]);
    }
    create(value?: PartialMessage<ProductSalesRollup>): ProductSalesRollup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.salesHash = "";
        message.salesDataByLocationId = {};
        if (value !== undefined)
            reflectionMergePartial<ProductSalesRollup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductSalesRollup): ProductSalesRollup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp series_start */ 4:
                    message.seriesStart = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.seriesStart);
                    break;
                case /* google.protobuf.Timestamp series_end */ 5:
                    message.seriesEnd = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.seriesEnd);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 6:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID product_id */ 7:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                case /* string sales_hash */ 8:
                    message.salesHash = reader.string();
                    break;
                case /* map<string, rd.txn.ProductSalesRollup.SalesData> sales_data_by_location_id */ 9:
                    this.binaryReadMap9(message.salesDataByLocationId, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap9(map: ProductSalesRollup["salesDataByLocationId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ProductSalesRollup["salesDataByLocationId"] | undefined, val: ProductSalesRollup["salesDataByLocationId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = ProductSalesRollup_SalesData.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.ProductSalesRollup.sales_data_by_location_id");
            }
        }
        map[key ?? ""] = val ?? ProductSalesRollup_SalesData.create();
    }
    internalBinaryWrite(message: ProductSalesRollup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp series_start = 4; */
        if (message.seriesStart)
            Timestamp.internalBinaryWrite(message.seriesStart, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp series_end = 5; */
        if (message.seriesEnd)
            Timestamp.internalBinaryWrite(message.seriesEnd, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 6; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID product_id = 7; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string sales_hash = 8; */
        if (message.salesHash !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.salesHash);
        /* map<string, rd.txn.ProductSalesRollup.SalesData> sales_data_by_location_id = 9; */
        for (let k of globalThis.Object.keys(message.salesDataByLocationId)) {
            writer.tag(9, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            ProductSalesRollup_SalesData.internalBinaryWrite(message.salesDataByLocationId[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.ProductSalesRollup
 */
export const ProductSalesRollup = new ProductSalesRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProductSalesRollup_SalesData$Type extends MessageType<ProductSalesRollup_SalesData> {
    constructor() {
        super("rd.txn.ProductSalesRollup.SalesData", [
            { no: 1, name: "location_id", kind: "message", T: () => UUID },
            { no: 2, name: "units_sold", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "price_of_goods_sold", kind: "message", T: () => Money },
            { no: 5, name: "last_sale", kind: "message", T: () => Timestamp },
            { no: 6, name: "cost_of_goods_sold_v2", kind: "message", T: () => FractionalMoney },
            { no: 7, name: "standard_cost_of_goods_sold", kind: "message", T: () => FractionalMoney },
            { no: 8, name: "units_sold_v2", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<ProductSalesRollup_SalesData>): ProductSalesRollup_SalesData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.unitsSold = 0;
        if (value !== undefined)
            reflectionMergePartial<ProductSalesRollup_SalesData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductSalesRollup_SalesData): ProductSalesRollup_SalesData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID location_id */ 1:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* int32 units_sold */ 2:
                    message.unitsSold = reader.int32();
                    break;
                case /* rd.proto.money.Money price_of_goods_sold */ 3:
                    message.priceOfGoodsSold = Money.internalBinaryRead(reader, reader.uint32(), options, message.priceOfGoodsSold);
                    break;
                case /* google.protobuf.Timestamp last_sale */ 5:
                    message.lastSale = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastSale);
                    break;
                case /* rd.proto.money.FractionalMoney cost_of_goods_sold_v2 */ 6:
                    message.costOfGoodsSoldV2 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.costOfGoodsSoldV2);
                    break;
                case /* rd.proto.money.FractionalMoney standard_cost_of_goods_sold */ 7:
                    message.standardCostOfGoodsSold = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.standardCostOfGoodsSold);
                    break;
                case /* rd.proto.decimal.Decimal units_sold_v2 */ 8:
                    message.unitsSoldV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.unitsSoldV2);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductSalesRollup_SalesData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID location_id = 1; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 units_sold = 2; */
        if (message.unitsSold !== 0)
            writer.tag(2, WireType.Varint).int32(message.unitsSold);
        /* rd.proto.money.Money price_of_goods_sold = 3; */
        if (message.priceOfGoodsSold)
            Money.internalBinaryWrite(message.priceOfGoodsSold, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp last_sale = 5; */
        if (message.lastSale)
            Timestamp.internalBinaryWrite(message.lastSale, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney cost_of_goods_sold_v2 = 6; */
        if (message.costOfGoodsSoldV2)
            FractionalMoney.internalBinaryWrite(message.costOfGoodsSoldV2, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney standard_cost_of_goods_sold = 7; */
        if (message.standardCostOfGoodsSold)
            FractionalMoney.internalBinaryWrite(message.standardCostOfGoodsSold, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal units_sold_v2 = 8; */
        if (message.unitsSoldV2)
            Decimal.internalBinaryWrite(message.unitsSoldV2, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.ProductSalesRollup.SalesData
 */
export const ProductSalesRollup_SalesData = new ProductSalesRollup_SalesData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CondensedSalePDFData$Type extends MessageType<CondensedSalePDFData> {
    constructor() {
        super("rd.txn.CondensedSalePDFData", [
            { no: 1, name: "condensed_sales", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CondensedSalePDFData_Sale }
        ]);
    }
    create(value?: PartialMessage<CondensedSalePDFData>): CondensedSalePDFData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.condensedSales = [];
        if (value !== undefined)
            reflectionMergePartial<CondensedSalePDFData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CondensedSalePDFData): CondensedSalePDFData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.txn.CondensedSalePDFData.Sale condensed_sales */ 1:
                    message.condensedSales.push(CondensedSalePDFData_Sale.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CondensedSalePDFData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.txn.CondensedSalePDFData.Sale condensed_sales = 1; */
        for (let i = 0; i < message.condensedSales.length; i++)
            CondensedSalePDFData_Sale.internalBinaryWrite(message.condensedSales[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.CondensedSalePDFData
 */
export const CondensedSalePDFData = new CondensedSalePDFData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CondensedSalePDFData_Sale$Type extends MessageType<CondensedSalePDFData_Sale> {
    constructor() {
        super("rd.txn.CondensedSalePDFData.Sale", [
            { no: 1, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sold_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "purchase_order_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sale_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "additional_fee_totals_by_name", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 7, name: "sales_tax", kind: "message", T: () => Money },
            { no: 9, name: "total", kind: "message", T: () => Money },
            { no: 10, name: "signature_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "tax_rate", kind: "message", T: () => TaxRate },
            { no: 13, name: "products", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CondensedSalePDFData_Sale_Product },
            { no: 14, name: "show_discount", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "card_surcharge", kind: "message", T: () => Money },
            { no: 17, name: "card_surcharge_rate_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "early_payment_discount", kind: "message", T: () => Money },
            { no: 19, name: "show_early_payment_discount", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "job_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "sale_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "restocking_fee", kind: "message", T: () => Money },
            { no: 23, name: "show_discount_percentage", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 24, name: "subtotal_discount_applied", kind: "message", T: () => Money },
            { no: 25, name: "subtotal_discount_rate", kind: "message", T: () => Decimal },
            { no: 26, name: "sale_taxes", kind: "message", T: () => SaleTaxes },
            { no: 27, name: "card_surcharge_without_tax", kind: "message", T: () => Money },
            { no: 28, name: "show_multiple_sale_taxes", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 29, name: "cash_rounding_delta", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<CondensedSalePDFData_Sale>): CondensedSalePDFData_Sale {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.purchaseOrderName = "";
        message.saleNotes = "";
        message.additionalFeeTotalsByName = {};
        message.signatureUrl = "";
        message.customerName = "";
        message.products = [];
        message.showDiscount = false;
        message.cardSurchargeRateString = "";
        message.showEarlyPaymentDiscount = false;
        message.jobName = "";
        message.saleType = "";
        message.showDiscountPercentage = false;
        message.showMultipleSaleTaxes = false;
        if (value !== undefined)
            reflectionMergePartial<CondensedSalePDFData_Sale>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CondensedSalePDFData_Sale): CondensedSalePDFData_Sale {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identifier */ 1:
                    message.identifier = reader.string();
                    break;
                case /* google.protobuf.Timestamp sold_at */ 2:
                    message.soldAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.soldAt);
                    break;
                case /* string purchase_order_name */ 3:
                    message.purchaseOrderName = reader.string();
                    break;
                case /* string sale_notes */ 4:
                    message.saleNotes = reader.string();
                    break;
                case /* map<string, rd.proto.money.Money> additional_fee_totals_by_name */ 6:
                    this.binaryReadMap6(message.additionalFeeTotalsByName, reader, options);
                    break;
                case /* rd.proto.money.Money sales_tax */ 7:
                    message.salesTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.salesTax);
                    break;
                case /* rd.proto.money.Money total */ 9:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* string signature_url */ 10:
                    message.signatureUrl = reader.string();
                    break;
                case /* string customer_name */ 11:
                    message.customerName = reader.string();
                    break;
                case /* rd.company.TaxRate tax_rate */ 12:
                    message.taxRate = TaxRate.internalBinaryRead(reader, reader.uint32(), options, message.taxRate);
                    break;
                case /* repeated rd.txn.CondensedSalePDFData.Sale.Product products */ 13:
                    message.products.push(CondensedSalePDFData_Sale_Product.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool show_discount */ 14:
                    message.showDiscount = reader.bool();
                    break;
                case /* rd.proto.money.Money card_surcharge */ 16:
                    message.cardSurcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurcharge);
                    break;
                case /* string card_surcharge_rate_string */ 17:
                    message.cardSurchargeRateString = reader.string();
                    break;
                case /* rd.proto.money.Money early_payment_discount */ 18:
                    message.earlyPaymentDiscount = Money.internalBinaryRead(reader, reader.uint32(), options, message.earlyPaymentDiscount);
                    break;
                case /* bool show_early_payment_discount */ 19:
                    message.showEarlyPaymentDiscount = reader.bool();
                    break;
                case /* string job_name */ 20:
                    message.jobName = reader.string();
                    break;
                case /* string sale_type */ 21:
                    message.saleType = reader.string();
                    break;
                case /* rd.proto.money.Money restocking_fee */ 22:
                    message.restockingFee = Money.internalBinaryRead(reader, reader.uint32(), options, message.restockingFee);
                    break;
                case /* bool show_discount_percentage */ 23:
                    message.showDiscountPercentage = reader.bool();
                    break;
                case /* rd.proto.money.Money subtotal_discount_applied */ 24:
                    message.subtotalDiscountApplied = Money.internalBinaryRead(reader, reader.uint32(), options, message.subtotalDiscountApplied);
                    break;
                case /* rd.proto.decimal.Decimal subtotal_discount_rate */ 25:
                    message.subtotalDiscountRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.subtotalDiscountRate);
                    break;
                case /* rd.txn.SaleTaxes sale_taxes */ 26:
                    message.saleTaxes = SaleTaxes.internalBinaryRead(reader, reader.uint32(), options, message.saleTaxes);
                    break;
                case /* rd.proto.money.Money card_surcharge_without_tax */ 27:
                    message.cardSurchargeWithoutTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurchargeWithoutTax);
                    break;
                case /* bool show_multiple_sale_taxes */ 28:
                    message.showMultipleSaleTaxes = reader.bool();
                    break;
                case /* rd.proto.money.Money cash_rounding_delta */ 29:
                    message.cashRoundingDelta = Money.internalBinaryRead(reader, reader.uint32(), options, message.cashRoundingDelta);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: CondensedSalePDFData_Sale["additionalFeeTotalsByName"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CondensedSalePDFData_Sale["additionalFeeTotalsByName"] | undefined, val: CondensedSalePDFData_Sale["additionalFeeTotalsByName"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.CondensedSalePDFData.Sale.additional_fee_totals_by_name");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: CondensedSalePDFData_Sale, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identifier = 1; */
        if (message.identifier !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier);
        /* google.protobuf.Timestamp sold_at = 2; */
        if (message.soldAt)
            Timestamp.internalBinaryWrite(message.soldAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string purchase_order_name = 3; */
        if (message.purchaseOrderName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.purchaseOrderName);
        /* string sale_notes = 4; */
        if (message.saleNotes !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.saleNotes);
        /* map<string, rd.proto.money.Money> additional_fee_totals_by_name = 6; */
        for (let k of globalThis.Object.keys(message.additionalFeeTotalsByName)) {
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.additionalFeeTotalsByName[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money sales_tax = 7; */
        if (message.salesTax)
            Money.internalBinaryWrite(message.salesTax, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total = 9; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string signature_url = 10; */
        if (message.signatureUrl !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.signatureUrl);
        /* string customer_name = 11; */
        if (message.customerName !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.customerName);
        /* rd.company.TaxRate tax_rate = 12; */
        if (message.taxRate)
            TaxRate.internalBinaryWrite(message.taxRate, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.CondensedSalePDFData.Sale.Product products = 13; */
        for (let i = 0; i < message.products.length; i++)
            CondensedSalePDFData_Sale_Product.internalBinaryWrite(message.products[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* bool show_discount = 14; */
        if (message.showDiscount !== false)
            writer.tag(14, WireType.Varint).bool(message.showDiscount);
        /* rd.proto.money.Money card_surcharge = 16; */
        if (message.cardSurcharge)
            Money.internalBinaryWrite(message.cardSurcharge, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* string card_surcharge_rate_string = 17; */
        if (message.cardSurchargeRateString !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.cardSurchargeRateString);
        /* rd.proto.money.Money early_payment_discount = 18; */
        if (message.earlyPaymentDiscount)
            Money.internalBinaryWrite(message.earlyPaymentDiscount, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* bool show_early_payment_discount = 19; */
        if (message.showEarlyPaymentDiscount !== false)
            writer.tag(19, WireType.Varint).bool(message.showEarlyPaymentDiscount);
        /* string job_name = 20; */
        if (message.jobName !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.jobName);
        /* string sale_type = 21; */
        if (message.saleType !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.saleType);
        /* rd.proto.money.Money restocking_fee = 22; */
        if (message.restockingFee)
            Money.internalBinaryWrite(message.restockingFee, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* bool show_discount_percentage = 23; */
        if (message.showDiscountPercentage !== false)
            writer.tag(23, WireType.Varint).bool(message.showDiscountPercentage);
        /* rd.proto.money.Money subtotal_discount_applied = 24; */
        if (message.subtotalDiscountApplied)
            Money.internalBinaryWrite(message.subtotalDiscountApplied, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal subtotal_discount_rate = 25; */
        if (message.subtotalDiscountRate)
            Decimal.internalBinaryWrite(message.subtotalDiscountRate, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.SaleTaxes sale_taxes = 26; */
        if (message.saleTaxes)
            SaleTaxes.internalBinaryWrite(message.saleTaxes, writer.tag(26, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money card_surcharge_without_tax = 27; */
        if (message.cardSurchargeWithoutTax)
            Money.internalBinaryWrite(message.cardSurchargeWithoutTax, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* bool show_multiple_sale_taxes = 28; */
        if (message.showMultipleSaleTaxes !== false)
            writer.tag(28, WireType.Varint).bool(message.showMultipleSaleTaxes);
        /* rd.proto.money.Money cash_rounding_delta = 29; */
        if (message.cashRoundingDelta)
            Money.internalBinaryWrite(message.cashRoundingDelta, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.CondensedSalePDFData.Sale
 */
export const CondensedSalePDFData_Sale = new CondensedSalePDFData_Sale$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CondensedSalePDFData_Sale_Product$Type extends MessageType<CondensedSalePDFData_Sale_Product> {
    constructor() {
        super("rd.txn.CondensedSalePDFData.Sale.Product", [
            { no: 1, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "tint_color", kind: "message", T: () => TintColor },
            { no: 4, name: "sub_total", kind: "message", T: () => Money },
            { no: 5, name: "returned_sub_total", kind: "message", T: () => Money },
            { no: 8, name: "price", kind: "message", T: () => Money },
            { no: 9, name: "tier_1_price", kind: "message", T: () => Money },
            { no: 10, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "custom_tint_color", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "quantity_v2", kind: "message", T: () => Decimal },
            { no: 13, name: "quantity_returned_v2", kind: "message", T: () => Decimal },
            { no: 14, name: "uom_id", kind: "message", T: () => UUID },
            { no: 15, name: "quantity_uom", kind: "message", T: () => Decimal },
            { no: 16, name: "uom_id_returned", kind: "message", T: () => UUID },
            { no: 17, name: "quantity_returned_uom", kind: "message", T: () => Decimal },
            { no: 18, name: "uom_snapshot", kind: "message", T: () => LedgerEntry_UomSnapshot },
            { no: 19, name: "uom_snapshot_returned", kind: "message", T: () => LedgerEntry_UomSnapshot },
            { no: 20, name: "non_taxable_display", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "gift_card_overwritten_balance", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CondensedSalePDFData_Sale_Product>): CondensedSalePDFData_Sale_Product {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.name = "";
        message.notes = "";
        message.customTintColor = "";
        message.nonTaxableDisplay = "";
        message.giftCardOverwrittenBalance = "";
        if (value !== undefined)
            reflectionMergePartial<CondensedSalePDFData_Sale_Product>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CondensedSalePDFData_Sale_Product): CondensedSalePDFData_Sale_Product {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identifier */ 1:
                    message.identifier = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* rd.tintcolor.TintColor tint_color */ 3:
                    message.tintColor = TintColor.internalBinaryRead(reader, reader.uint32(), options, message.tintColor);
                    break;
                case /* rd.proto.money.Money sub_total */ 4:
                    message.subTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.subTotal);
                    break;
                case /* rd.proto.money.Money returned_sub_total */ 5:
                    message.returnedSubTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.returnedSubTotal);
                    break;
                case /* rd.proto.money.Money price */ 8:
                    message.price = Money.internalBinaryRead(reader, reader.uint32(), options, message.price);
                    break;
                case /* rd.proto.money.Money tier_1_price */ 9:
                    message.tier1Price = Money.internalBinaryRead(reader, reader.uint32(), options, message.tier1Price);
                    break;
                case /* string notes */ 10:
                    message.notes = reader.string();
                    break;
                case /* string custom_tint_color */ 11:
                    message.customTintColor = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal quantity_v2 */ 12:
                    message.quantityV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityV2);
                    break;
                case /* rd.proto.decimal.Decimal quantity_returned_v2 */ 13:
                    message.quantityReturnedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReturnedV2);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 14:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_uom */ 15:
                    message.quantityUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityUom);
                    break;
                case /* rd.proto.uuid.UUID uom_id_returned */ 16:
                    message.uomIdReturned = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomIdReturned);
                    break;
                case /* rd.proto.decimal.Decimal quantity_returned_uom */ 17:
                    message.quantityReturnedUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReturnedUom);
                    break;
                case /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot */ 18:
                    message.uomSnapshot = LedgerEntry_UomSnapshot.internalBinaryRead(reader, reader.uint32(), options, message.uomSnapshot);
                    break;
                case /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot_returned */ 19:
                    message.uomSnapshotReturned = LedgerEntry_UomSnapshot.internalBinaryRead(reader, reader.uint32(), options, message.uomSnapshotReturned);
                    break;
                case /* string non_taxable_display */ 20:
                    message.nonTaxableDisplay = reader.string();
                    break;
                case /* string gift_card_overwritten_balance */ 21:
                    message.giftCardOverwrittenBalance = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CondensedSalePDFData_Sale_Product, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identifier = 1; */
        if (message.identifier !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* rd.tintcolor.TintColor tint_color = 3; */
        if (message.tintColor)
            TintColor.internalBinaryWrite(message.tintColor, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money sub_total = 4; */
        if (message.subTotal)
            Money.internalBinaryWrite(message.subTotal, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money returned_sub_total = 5; */
        if (message.returnedSubTotal)
            Money.internalBinaryWrite(message.returnedSubTotal, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money price = 8; */
        if (message.price)
            Money.internalBinaryWrite(message.price, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money tier_1_price = 9; */
        if (message.tier1Price)
            Money.internalBinaryWrite(message.tier1Price, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 10; */
        if (message.notes !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.notes);
        /* string custom_tint_color = 11; */
        if (message.customTintColor !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.customTintColor);
        /* rd.proto.decimal.Decimal quantity_v2 = 12; */
        if (message.quantityV2)
            Decimal.internalBinaryWrite(message.quantityV2, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_returned_v2 = 13; */
        if (message.quantityReturnedV2)
            Decimal.internalBinaryWrite(message.quantityReturnedV2, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 14; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_uom = 15; */
        if (message.quantityUom)
            Decimal.internalBinaryWrite(message.quantityUom, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id_returned = 16; */
        if (message.uomIdReturned)
            UUID.internalBinaryWrite(message.uomIdReturned, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_returned_uom = 17; */
        if (message.quantityReturnedUom)
            Decimal.internalBinaryWrite(message.quantityReturnedUom, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot = 18; */
        if (message.uomSnapshot)
            LedgerEntry_UomSnapshot.internalBinaryWrite(message.uomSnapshot, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry.UomSnapshot uom_snapshot_returned = 19; */
        if (message.uomSnapshotReturned)
            LedgerEntry_UomSnapshot.internalBinaryWrite(message.uomSnapshotReturned, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* string non_taxable_display = 20; */
        if (message.nonTaxableDisplay !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.nonTaxableDisplay);
        /* string gift_card_overwritten_balance = 21; */
        if (message.giftCardOverwrittenBalance !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.giftCardOverwrittenBalance);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.CondensedSalePDFData.Sale.Product
 */
export const CondensedSalePDFData_Sale_Product = new CondensedSalePDFData_Sale_Product$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderShipmentPDFData$Type extends MessageType<OrderShipmentPDFData> {
    constructor() {
        super("rd.txn.OrderShipmentPDFData", [
            { no: 1, name: "order_shipment", kind: "message", T: () => OrderShipment },
            { no: 2, name: "order", kind: "message", T: () => Order },
            { no: 3, name: "company", kind: "message", T: () => Company },
            { no: 4, name: "location", kind: "message", T: () => Location },
            { no: 5, name: "vendor", kind: "message", T: () => Vendor },
            { no: 6, name: "vendor_contact", kind: "message", T: () => Contacts_Contact$ },
            { no: 7, name: "products", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OrderShipmentPDFData_Product },
            { no: 8, name: "total", kind: "message", T: () => Money },
            { no: 9, name: "account_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "status_tag", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "invoice_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "due_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "invoice_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "show_invoice_section", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "show_value", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "reference_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<OrderShipmentPDFData>): OrderShipmentPDFData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.products = [];
        message.accountNumber = "";
        message.statusTag = "";
        message.invoiceDate = "";
        message.dueDate = "";
        message.invoiceNumber = "";
        message.showInvoiceSection = false;
        message.showValue = false;
        message.identifier = "";
        message.referenceNumber = "";
        if (value !== undefined)
            reflectionMergePartial<OrderShipmentPDFData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderShipmentPDFData): OrderShipmentPDFData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.OrderShipment order_shipment */ 1:
                    message.orderShipment = OrderShipment.internalBinaryRead(reader, reader.uint32(), options, message.orderShipment);
                    break;
                case /* rd.txn.Order order */ 2:
                    message.order = Order.internalBinaryRead(reader, reader.uint32(), options, message.order);
                    break;
                case /* rd.company.Company company */ 3:
                    message.company = Company.internalBinaryRead(reader, reader.uint32(), options, message.company);
                    break;
                case /* rd.company.Location location */ 4:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.vendors.Vendor vendor */ 5:
                    message.vendor = Vendor.internalBinaryRead(reader, reader.uint32(), options, message.vendor);
                    break;
                case /* rd.vendors.Contacts.Contact vendor_contact */ 6:
                    message.vendorContact = Contacts_Contact$.internalBinaryRead(reader, reader.uint32(), options, message.vendorContact);
                    break;
                case /* repeated rd.txn.OrderShipmentPDFData.Product products */ 7:
                    message.products.push(OrderShipmentPDFData_Product.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.Money total */ 8:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* string account_number */ 9:
                    message.accountNumber = reader.string();
                    break;
                case /* string status_tag */ 10:
                    message.statusTag = reader.string();
                    break;
                case /* string invoice_date */ 11:
                    message.invoiceDate = reader.string();
                    break;
                case /* string due_date */ 12:
                    message.dueDate = reader.string();
                    break;
                case /* string invoice_number */ 13:
                    message.invoiceNumber = reader.string();
                    break;
                case /* bool show_invoice_section */ 14:
                    message.showInvoiceSection = reader.bool();
                    break;
                case /* bool show_value */ 15:
                    message.showValue = reader.bool();
                    break;
                case /* string identifier */ 16:
                    message.identifier = reader.string();
                    break;
                case /* string reference_number */ 18:
                    message.referenceNumber = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderShipmentPDFData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.OrderShipment order_shipment = 1; */
        if (message.orderShipment)
            OrderShipment.internalBinaryWrite(message.orderShipment, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Order order = 2; */
        if (message.order)
            Order.internalBinaryWrite(message.order, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Company company = 3; */
        if (message.company)
            Company.internalBinaryWrite(message.company, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 4; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Vendor vendor = 5; */
        if (message.vendor)
            Vendor.internalBinaryWrite(message.vendor, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.vendors.Contacts.Contact vendor_contact = 6; */
        if (message.vendorContact)
            Contacts_Contact$.internalBinaryWrite(message.vendorContact, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.OrderShipmentPDFData.Product products = 7; */
        for (let i = 0; i < message.products.length; i++)
            OrderShipmentPDFData_Product.internalBinaryWrite(message.products[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total = 8; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string account_number = 9; */
        if (message.accountNumber !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.accountNumber);
        /* string status_tag = 10; */
        if (message.statusTag !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.statusTag);
        /* string invoice_date = 11; */
        if (message.invoiceDate !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.invoiceDate);
        /* string due_date = 12; */
        if (message.dueDate !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.dueDate);
        /* string invoice_number = 13; */
        if (message.invoiceNumber !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.invoiceNumber);
        /* bool show_invoice_section = 14; */
        if (message.showInvoiceSection !== false)
            writer.tag(14, WireType.Varint).bool(message.showInvoiceSection);
        /* bool show_value = 15; */
        if (message.showValue !== false)
            writer.tag(15, WireType.Varint).bool(message.showValue);
        /* string identifier = 16; */
        if (message.identifier !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.identifier);
        /* string reference_number = 18; */
        if (message.referenceNumber !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.referenceNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.OrderShipmentPDFData
 */
export const OrderShipmentPDFData = new OrderShipmentPDFData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OrderShipmentPDFData_Product$Type extends MessageType<OrderShipmentPDFData_Product> {
    constructor() {
        super("rd.txn.OrderShipmentPDFData.Product", [
            { no: 1, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "total", kind: "message", T: () => Money },
            { no: 4, name: "quantity_ordered", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "cost_v2", kind: "message", T: () => FractionalMoney },
            { no: 9, name: "custom_fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SaleForm_CustomField },
            { no: 10, name: "vendor_sku", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "quantity_ordered_v2", kind: "message", T: () => Decimal },
            { no: 12, name: "quantity_received_v2", kind: "message", T: () => Decimal },
            { no: 13, name: "uom_id", kind: "message", T: () => UUID },
            { no: 14, name: "quantity_ordered_uom", kind: "message", T: () => Decimal },
            { no: 15, name: "quantity_received_uom", kind: "message", T: () => Decimal },
            { no: 16, name: "total_unit_fee", kind: "message", T: () => FractionalMoney }
        ]);
    }
    create(value?: PartialMessage<OrderShipmentPDFData_Product>): OrderShipmentPDFData_Product {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.name = "";
        message.quantityOrdered = 0;
        message.notes = "";
        message.customFields = [];
        message.vendorSku = "";
        if (value !== undefined)
            reflectionMergePartial<OrderShipmentPDFData_Product>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OrderShipmentPDFData_Product): OrderShipmentPDFData_Product {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identifier */ 1:
                    message.identifier = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* rd.proto.money.Money total */ 3:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* int32 quantity_ordered */ 4:
                    message.quantityOrdered = reader.int32();
                    break;
                case /* string notes */ 7:
                    message.notes = reader.string();
                    break;
                case /* rd.proto.money.FractionalMoney cost_v2 */ 8:
                    message.costV2 = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.costV2);
                    break;
                case /* repeated rd.company.SaleForm.CustomField custom_fields */ 9:
                    message.customFields.push(SaleForm_CustomField.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string vendor_sku */ 10:
                    message.vendorSku = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal quantity_ordered_v2 */ 11:
                    message.quantityOrderedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityOrderedV2);
                    break;
                case /* rd.proto.decimal.Decimal quantity_received_v2 */ 12:
                    message.quantityReceivedV2 = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReceivedV2);
                    break;
                case /* rd.proto.uuid.UUID uom_id */ 13:
                    message.uomId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uomId);
                    break;
                case /* rd.proto.decimal.Decimal quantity_ordered_uom */ 14:
                    message.quantityOrderedUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityOrderedUom);
                    break;
                case /* rd.proto.decimal.Decimal quantity_received_uom */ 15:
                    message.quantityReceivedUom = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.quantityReceivedUom);
                    break;
                case /* rd.proto.money.FractionalMoney total_unit_fee */ 16:
                    message.totalUnitFee = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.totalUnitFee);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OrderShipmentPDFData_Product, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identifier = 1; */
        if (message.identifier !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* rd.proto.money.Money total = 3; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int32 quantity_ordered = 4; */
        if (message.quantityOrdered !== 0)
            writer.tag(4, WireType.Varint).int32(message.quantityOrdered);
        /* string notes = 7; */
        if (message.notes !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.notes);
        /* rd.proto.money.FractionalMoney cost_v2 = 8; */
        if (message.costV2)
            FractionalMoney.internalBinaryWrite(message.costV2, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.company.SaleForm.CustomField custom_fields = 9; */
        for (let i = 0; i < message.customFields.length; i++)
            SaleForm_CustomField.internalBinaryWrite(message.customFields[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string vendor_sku = 10; */
        if (message.vendorSku !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.vendorSku);
        /* rd.proto.decimal.Decimal quantity_ordered_v2 = 11; */
        if (message.quantityOrderedV2)
            Decimal.internalBinaryWrite(message.quantityOrderedV2, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_received_v2 = 12; */
        if (message.quantityReceivedV2)
            Decimal.internalBinaryWrite(message.quantityReceivedV2, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uom_id = 13; */
        if (message.uomId)
            UUID.internalBinaryWrite(message.uomId, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_ordered_uom = 14; */
        if (message.quantityOrderedUom)
            Decimal.internalBinaryWrite(message.quantityOrderedUom, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal quantity_received_uom = 15; */
        if (message.quantityReceivedUom)
            Decimal.internalBinaryWrite(message.quantityReceivedUom, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney total_unit_fee = 16; */
        if (message.totalUnitFee)
            FractionalMoney.internalBinaryWrite(message.totalUnitFee, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.OrderShipmentPDFData.Product
 */
export const OrderShipmentPDFData_Product = new OrderShipmentPDFData_Product$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PaymentIdempotentKeyPair$Type extends MessageType<PaymentIdempotentKeyPair> {
    constructor() {
        super("rd.txn.PaymentIdempotentKeyPair", [
            { no: 1, name: "authorize_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "capture_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PaymentIdempotentKeyPair>): PaymentIdempotentKeyPair {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.authorizeKey = "";
        message.captureKey = "";
        if (value !== undefined)
            reflectionMergePartial<PaymentIdempotentKeyPair>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PaymentIdempotentKeyPair): PaymentIdempotentKeyPair {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string authorize_key */ 1:
                    message.authorizeKey = reader.string();
                    break;
                case /* string capture_key */ 2:
                    message.captureKey = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PaymentIdempotentKeyPair, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string authorize_key = 1; */
        if (message.authorizeKey !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.authorizeKey);
        /* string capture_key = 2; */
        if (message.captureKey !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.captureKey);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.PaymentIdempotentKeyPair
 */
export const PaymentIdempotentKeyPair = new PaymentIdempotentKeyPair$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PotentialDiscountMetadata$Type extends MessageType<PotentialDiscountMetadata> {
    constructor() {
        super("rd.txn.PotentialDiscountMetadata", [
            { no: 1, name: "rate", kind: "message", T: () => Decimal },
            { no: 2, name: "term_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expires_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<PotentialDiscountMetadata>): PotentialDiscountMetadata {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.termName = "";
        if (value !== undefined)
            reflectionMergePartial<PotentialDiscountMetadata>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PotentialDiscountMetadata): PotentialDiscountMetadata {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.decimal.Decimal rate */ 1:
                    message.rate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.rate);
                    break;
                case /* string term_name */ 2:
                    message.termName = reader.string();
                    break;
                case /* google.protobuf.Timestamp expires_at */ 3:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PotentialDiscountMetadata, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.decimal.Decimal rate = 1; */
        if (message.rate)
            Decimal.internalBinaryWrite(message.rate, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string term_name = 2; */
        if (message.termName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.termName);
        /* google.protobuf.Timestamp expires_at = 3; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.PotentialDiscountMetadata
 */
export const PotentialDiscountMetadata = new PotentialDiscountMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpsertSaleV3Metadata$Type extends MessageType<UpsertSaleV3Metadata> {
    constructor() {
        super("rd.txn.UpsertSaleV3Metadata", [
            { no: 1, name: "payment_due_at", kind: "message", T: () => Timestamp },
            { no: 2, name: "total", kind: "message", T: () => Money },
            { no: 4, name: "stripe_reader_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "idempotency_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "potential_discount_metadata", kind: "message", T: () => PotentialDiscountMetadata },
            { no: 9, name: "adjusted_totals_by_returned_from_sale_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 10, name: "additional_deposit", kind: "message", T: () => Money },
            { no: 14, name: "tender_submissions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TenderSubmissionMetadata },
            { no: 15, name: "additional_deposit_surcharge_total", kind: "message", T: () => Money },
            { no: 16, name: "deposit_refund_tender_submission_metadata", kind: "message", T: () => TenderSubmissionMetadata },
            { no: 17, name: "principal_to_refund", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<UpsertSaleV3Metadata>): UpsertSaleV3Metadata {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripeReaderId = "";
        message.idempotencyKey = "";
        message.adjustedTotalsByReturnedFromSaleId = {};
        message.tenderSubmissions = [];
        if (value !== undefined)
            reflectionMergePartial<UpsertSaleV3Metadata>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpsertSaleV3Metadata): UpsertSaleV3Metadata {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp payment_due_at */ 1:
                    message.paymentDueAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.paymentDueAt);
                    break;
                case /* rd.proto.money.Money total */ 2:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* string stripe_reader_id */ 4:
                    message.stripeReaderId = reader.string();
                    break;
                case /* string idempotency_key */ 5:
                    message.idempotencyKey = reader.string();
                    break;
                case /* rd.txn.PotentialDiscountMetadata potential_discount_metadata */ 6:
                    message.potentialDiscountMetadata = PotentialDiscountMetadata.internalBinaryRead(reader, reader.uint32(), options, message.potentialDiscountMetadata);
                    break;
                case /* map<string, rd.proto.money.Money> adjusted_totals_by_returned_from_sale_id */ 9:
                    this.binaryReadMap9(message.adjustedTotalsByReturnedFromSaleId, reader, options);
                    break;
                case /* rd.proto.money.Money additional_deposit */ 10:
                    message.additionalDeposit = Money.internalBinaryRead(reader, reader.uint32(), options, message.additionalDeposit);
                    break;
                case /* repeated rd.txn.TenderSubmissionMetadata tender_submissions */ 14:
                    message.tenderSubmissions.push(TenderSubmissionMetadata.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.Money additional_deposit_surcharge_total */ 15:
                    message.additionalDepositSurchargeTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.additionalDepositSurchargeTotal);
                    break;
                case /* rd.txn.TenderSubmissionMetadata deposit_refund_tender_submission_metadata */ 16:
                    message.depositRefundTenderSubmissionMetadata = TenderSubmissionMetadata.internalBinaryRead(reader, reader.uint32(), options, message.depositRefundTenderSubmissionMetadata);
                    break;
                case /* rd.proto.money.Money principal_to_refund */ 17:
                    message.principalToRefund = Money.internalBinaryRead(reader, reader.uint32(), options, message.principalToRefund);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap9(map: UpsertSaleV3Metadata["adjustedTotalsByReturnedFromSaleId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UpsertSaleV3Metadata["adjustedTotalsByReturnedFromSaleId"] | undefined, val: UpsertSaleV3Metadata["adjustedTotalsByReturnedFromSaleId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.UpsertSaleV3Metadata.adjusted_totals_by_returned_from_sale_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: UpsertSaleV3Metadata, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp payment_due_at = 1; */
        if (message.paymentDueAt)
            Timestamp.internalBinaryWrite(message.paymentDueAt, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total = 2; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string stripe_reader_id = 4; */
        if (message.stripeReaderId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.stripeReaderId);
        /* string idempotency_key = 5; */
        if (message.idempotencyKey !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.idempotencyKey);
        /* rd.txn.PotentialDiscountMetadata potential_discount_metadata = 6; */
        if (message.potentialDiscountMetadata)
            PotentialDiscountMetadata.internalBinaryWrite(message.potentialDiscountMetadata, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> adjusted_totals_by_returned_from_sale_id = 9; */
        for (let k of globalThis.Object.keys(message.adjustedTotalsByReturnedFromSaleId)) {
            writer.tag(9, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.adjustedTotalsByReturnedFromSaleId[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money additional_deposit = 10; */
        if (message.additionalDeposit)
            Money.internalBinaryWrite(message.additionalDeposit, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.TenderSubmissionMetadata tender_submissions = 14; */
        for (let i = 0; i < message.tenderSubmissions.length; i++)
            TenderSubmissionMetadata.internalBinaryWrite(message.tenderSubmissions[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money additional_deposit_surcharge_total = 15; */
        if (message.additionalDepositSurchargeTotal)
            Money.internalBinaryWrite(message.additionalDepositSurchargeTotal, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata deposit_refund_tender_submission_metadata = 16; */
        if (message.depositRefundTenderSubmissionMetadata)
            TenderSubmissionMetadata.internalBinaryWrite(message.depositRefundTenderSubmissionMetadata, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money principal_to_refund = 17; */
        if (message.principalToRefund)
            Money.internalBinaryWrite(message.principalToRefund, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.UpsertSaleV3Metadata
 */
export const UpsertSaleV3Metadata = new UpsertSaleV3Metadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TotalsLineItem$Type extends MessageType<TotalsLineItem> {
    constructor() {
        super("rd.txn.TotalsLineItem", [
            { no: 1, name: "type", kind: "enum", T: () => ["rd.txn.TotalsLineItem.Type", TotalsLineItem_Type, "TYPE_"] },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "rate", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "amount", kind: "message", T: () => Money },
            { no: 7, name: "product_type", kind: "enum", T: () => ["rd.txn.TotalsLineItem.ProductType", TotalsLineItem_ProductType, "PRODUCT_TYPE_"] },
            { no: 8, name: "from_sale_id", kind: "message", T: () => UUID },
            { no: 9, name: "from_sale_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TotalsLineItem>): TotalsLineItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.description = "";
        message.rate = "";
        message.productType = 0;
        message.fromSaleIdentifier = "";
        if (value !== undefined)
            reflectionMergePartial<TotalsLineItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TotalsLineItem): TotalsLineItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.TotalsLineItem.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* string rate */ 4:
                    message.rate = reader.string();
                    break;
                case /* rd.proto.money.Money amount */ 5:
                    message.amount = Money.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                case /* rd.txn.TotalsLineItem.ProductType product_type */ 7:
                    message.productType = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID from_sale_id */ 8:
                    message.fromSaleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.fromSaleId);
                    break;
                case /* string from_sale_identifier */ 9:
                    message.fromSaleIdentifier = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TotalsLineItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.TotalsLineItem.Type type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* string rate = 4; */
        if (message.rate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.rate);
        /* rd.proto.money.Money amount = 5; */
        if (message.amount)
            Money.internalBinaryWrite(message.amount, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TotalsLineItem.ProductType product_type = 7; */
        if (message.productType !== 0)
            writer.tag(7, WireType.Varint).int32(message.productType);
        /* rd.proto.uuid.UUID from_sale_id = 8; */
        if (message.fromSaleId)
            UUID.internalBinaryWrite(message.fromSaleId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string from_sale_identifier = 9; */
        if (message.fromSaleIdentifier !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.fromSaleIdentifier);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TotalsLineItem
 */
export const TotalsLineItem = new TotalsLineItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaxLine$Type extends MessageType<TaxLine> {
    constructor() {
        super("rd.txn.TaxLine", [
            { no: 1, name: "tax_rate_id", kind: "message", T: () => UUID },
            { no: 2, name: "rate", kind: "message", T: () => Decimal },
            { no: 3, name: "tax_rate_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "tax", kind: "message", T: () => Money },
            { no: 5, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "tax_components", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaxComponent }
        ]);
    }
    create(value?: PartialMessage<TaxLine>): TaxLine {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taxRateName = "";
        message.label = "";
        message.taxComponents = [];
        if (value !== undefined)
            reflectionMergePartial<TaxLine>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaxLine): TaxLine {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID tax_rate_id */ 1:
                    message.taxRateId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.taxRateId);
                    break;
                case /* rd.proto.decimal.Decimal rate */ 2:
                    message.rate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.rate);
                    break;
                case /* string tax_rate_name */ 3:
                    message.taxRateName = reader.string();
                    break;
                case /* rd.proto.money.Money tax */ 4:
                    message.tax = Money.internalBinaryRead(reader, reader.uint32(), options, message.tax);
                    break;
                case /* string label */ 5:
                    message.label = reader.string();
                    break;
                case /* repeated rd.company.TaxComponent tax_components */ 6:
                    message.taxComponents.push(TaxComponent.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaxLine, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID tax_rate_id = 1; */
        if (message.taxRateId)
            UUID.internalBinaryWrite(message.taxRateId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal rate = 2; */
        if (message.rate)
            Decimal.internalBinaryWrite(message.rate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string tax_rate_name = 3; */
        if (message.taxRateName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.taxRateName);
        /* rd.proto.money.Money tax = 4; */
        if (message.tax)
            Money.internalBinaryWrite(message.tax, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string label = 5; */
        if (message.label !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.label);
        /* repeated rd.company.TaxComponent tax_components = 6; */
        for (let i = 0; i < message.taxComponents.length; i++)
            TaxComponent.internalBinaryWrite(message.taxComponents[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TaxLine
 */
export const TaxLine = new TaxLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaleTaxes$Type extends MessageType<SaleTaxes> {
    constructor() {
        super("rd.txn.SaleTaxes", [
            { no: 1, name: "base_taxes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaxLine },
            { no: 2, name: "surcharge_taxes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaxLine }
        ]);
    }
    create(value?: PartialMessage<SaleTaxes>): SaleTaxes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.baseTaxes = [];
        message.surchargeTaxes = [];
        if (value !== undefined)
            reflectionMergePartial<SaleTaxes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SaleTaxes): SaleTaxes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.txn.TaxLine base_taxes */ 1:
                    message.baseTaxes.push(TaxLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.txn.TaxLine surcharge_taxes */ 2:
                    message.surchargeTaxes.push(TaxLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SaleTaxes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.txn.TaxLine base_taxes = 1; */
        for (let i = 0; i < message.baseTaxes.length; i++)
            TaxLine.internalBinaryWrite(message.baseTaxes[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.TaxLine surcharge_taxes = 2; */
        for (let i = 0; i < message.surchargeTaxes.length; i++)
            TaxLine.internalBinaryWrite(message.surchargeTaxes[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.SaleTaxes
 */
export const SaleTaxes = new SaleTaxes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreditHistoryLink$Type extends MessageType<CreditHistoryLink> {
    constructor() {
        super("rd.txn.CreditHistoryLink", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "amount", kind: "message", T: () => Money },
            { no: 4, name: "type", kind: "enum", T: () => ["rd.txn.CreditHistoryLink.Type", CreditHistoryLink_Type, "TYPE_"] },
            { no: 5, name: "transaction_type", kind: "enum", T: () => ["rd.txn.CreditHistoryLink.TransactionType", CreditHistoryLink_TransactionType, "TRANSACTION_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<CreditHistoryLink>): CreditHistoryLink {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.type = 0;
        message.transactionType = 0;
        if (value !== undefined)
            reflectionMergePartial<CreditHistoryLink>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreditHistoryLink): CreditHistoryLink {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                case /* rd.proto.money.Money amount */ 3:
                    message.amount = Money.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                case /* rd.txn.CreditHistoryLink.Type type */ 4:
                    message.type = reader.int32();
                    break;
                case /* rd.txn.CreditHistoryLink.TransactionType transaction_type */ 5:
                    message.transactionType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreditHistoryLink, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        /* rd.proto.money.Money amount = 3; */
        if (message.amount)
            Money.internalBinaryWrite(message.amount, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.CreditHistoryLink.Type type = 4; */
        if (message.type !== 0)
            writer.tag(4, WireType.Varint).int32(message.type);
        /* rd.txn.CreditHistoryLink.TransactionType transaction_type = 5; */
        if (message.transactionType !== 0)
            writer.tag(5, WireType.Varint).int32(message.transactionType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.CreditHistoryLink
 */
export const CreditHistoryLink = new CreditHistoryLink$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Receivable$Type extends MessageType<Receivable> {
    constructor() {
        super("rd.txn.Receivable", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "date", kind: "message", T: () => Timestamp },
            { no: 3, name: "original", kind: "message", T: () => Money },
            { no: 4, name: "balance", kind: "message", T: () => Money },
            { no: 5, name: "running_balance", kind: "message", T: () => Money },
            { no: 6, name: "type", kind: "enum", T: () => ["rd.txn.Receivable.Type", Receivable_Type, "TYPE_"] },
            { no: 7, name: "invoice", kind: "message", T: () => Receivable_Invoice },
            { no: 8, name: "transaction", kind: "message", T: () => Receivable_Transaction },
            { no: 9, name: "customer", kind: "message", T: () => Receivable_Customer },
            { no: 10, name: "job", kind: "message", T: () => Receivable_Job },
            { no: 11, name: "purchase_order", kind: "message", T: () => Receivable_PurchaseOrder },
            { no: 12, name: "location", kind: "message", T: () => Receivable_Location },
            { no: 13, name: "user", kind: "message", T: () => User },
            { no: 14, name: "contact", kind: "message", T: () => Receivable_Contact },
            { no: 15, name: "days_to_pay", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<Receivable>): Receivable {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<Receivable>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Receivable): Receivable {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp date */ 2:
                    message.date = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.date);
                    break;
                case /* rd.proto.money.Money original */ 3:
                    message.original = Money.internalBinaryRead(reader, reader.uint32(), options, message.original);
                    break;
                case /* rd.proto.money.Money balance */ 4:
                    message.balance = Money.internalBinaryRead(reader, reader.uint32(), options, message.balance);
                    break;
                case /* rd.proto.money.Money running_balance */ 5:
                    message.runningBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.runningBalance);
                    break;
                case /* rd.txn.Receivable.Type type */ 6:
                    message.type = reader.int32();
                    break;
                case /* rd.txn.Receivable.Invoice invoice */ 7:
                    message.invoice = Receivable_Invoice.internalBinaryRead(reader, reader.uint32(), options, message.invoice);
                    break;
                case /* rd.txn.Receivable.Transaction transaction */ 8:
                    message.transaction = Receivable_Transaction.internalBinaryRead(reader, reader.uint32(), options, message.transaction);
                    break;
                case /* rd.txn.Receivable.Customer customer */ 9:
                    message.customer = Receivable_Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* rd.txn.Receivable.Job job */ 10:
                    message.job = Receivable_Job.internalBinaryRead(reader, reader.uint32(), options, message.job);
                    break;
                case /* rd.txn.Receivable.PurchaseOrder purchase_order */ 11:
                    message.purchaseOrder = Receivable_PurchaseOrder.internalBinaryRead(reader, reader.uint32(), options, message.purchaseOrder);
                    break;
                case /* rd.txn.Receivable.Location location */ 12:
                    message.location = Receivable_Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.user.User user */ 13:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* rd.txn.Receivable.Contact contact */ 14:
                    message.contact = Receivable_Contact.internalBinaryRead(reader, reader.uint32(), options, message.contact);
                    break;
                case /* rd.proto.decimal.Decimal days_to_pay */ 15:
                    message.daysToPay = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.daysToPay);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Receivable, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp date = 2; */
        if (message.date)
            Timestamp.internalBinaryWrite(message.date, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money original = 3; */
        if (message.original)
            Money.internalBinaryWrite(message.original, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money balance = 4; */
        if (message.balance)
            Money.internalBinaryWrite(message.balance, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money running_balance = 5; */
        if (message.runningBalance)
            Money.internalBinaryWrite(message.runningBalance, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Receivable.Type type = 6; */
        if (message.type !== 0)
            writer.tag(6, WireType.Varint).int32(message.type);
        /* rd.txn.Receivable.Invoice invoice = 7; */
        if (message.invoice)
            Receivable_Invoice.internalBinaryWrite(message.invoice, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Receivable.Transaction transaction = 8; */
        if (message.transaction)
            Receivable_Transaction.internalBinaryWrite(message.transaction, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Receivable.Customer customer = 9; */
        if (message.customer)
            Receivable_Customer.internalBinaryWrite(message.customer, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Receivable.Job job = 10; */
        if (message.job)
            Receivable_Job.internalBinaryWrite(message.job, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Receivable.PurchaseOrder purchase_order = 11; */
        if (message.purchaseOrder)
            Receivable_PurchaseOrder.internalBinaryWrite(message.purchaseOrder, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Receivable.Location location = 12; */
        if (message.location)
            Receivable_Location.internalBinaryWrite(message.location, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User user = 13; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.Receivable.Contact contact = 14; */
        if (message.contact)
            Receivable_Contact.internalBinaryWrite(message.contact, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal days_to_pay = 15; */
        if (message.daysToPay)
            Decimal.internalBinaryWrite(message.daysToPay, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Receivable
 */
export const Receivable = new Receivable$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Receivable_Invoice$Type extends MessageType<Receivable_Invoice> {
    constructor() {
        super("rd.txn.Receivable.Invoice", [
            { no: 1, name: "due_date", kind: "message", T: () => Timestamp },
            { no: 2, name: "days_overdue", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "potential_discount", kind: "message", T: () => Money },
            { no: 4, name: "potential_discount_expires_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<Receivable_Invoice>): Receivable_Invoice {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.daysOverdue = 0;
        if (value !== undefined)
            reflectionMergePartial<Receivable_Invoice>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Receivable_Invoice): Receivable_Invoice {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp due_date */ 1:
                    message.dueDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.dueDate);
                    break;
                case /* int32 days_overdue */ 2:
                    message.daysOverdue = reader.int32();
                    break;
                case /* rd.proto.money.Money potential_discount */ 3:
                    message.potentialDiscount = Money.internalBinaryRead(reader, reader.uint32(), options, message.potentialDiscount);
                    break;
                case /* google.protobuf.Timestamp potential_discount_expires_at */ 4:
                    message.potentialDiscountExpiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.potentialDiscountExpiresAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Receivable_Invoice, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp due_date = 1; */
        if (message.dueDate)
            Timestamp.internalBinaryWrite(message.dueDate, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 days_overdue = 2; */
        if (message.daysOverdue !== 0)
            writer.tag(2, WireType.Varint).int32(message.daysOverdue);
        /* rd.proto.money.Money potential_discount = 3; */
        if (message.potentialDiscount)
            Money.internalBinaryWrite(message.potentialDiscount, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp potential_discount_expires_at = 4; */
        if (message.potentialDiscountExpiresAt)
            Timestamp.internalBinaryWrite(message.potentialDiscountExpiresAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Receivable.Invoice
 */
export const Receivable_Invoice = new Receivable_Invoice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Receivable_Transaction$Type extends MessageType<Receivable_Transaction> {
    constructor() {
        super("rd.txn.Receivable.Transaction", [
            { no: 1, name: "type", kind: "enum", T: () => ["rd.txn.Receivable.Transaction.Type", Receivable_Transaction_Type, "TYPE_"] },
            { no: 2, name: "id", kind: "message", T: () => UUID },
            { no: 3, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Receivable_Transaction>): Receivable_Transaction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.identifier = "";
        if (value !== undefined)
            reflectionMergePartial<Receivable_Transaction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Receivable_Transaction): Receivable_Transaction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.Receivable.Transaction.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID id */ 2:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string identifier */ 3:
                    message.identifier = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Receivable_Transaction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.Receivable.Transaction.Type type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* rd.proto.uuid.UUID id = 2; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 3; */
        if (message.identifier !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.identifier);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Receivable.Transaction
 */
export const Receivable_Transaction = new Receivable_Transaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Receivable_Customer$Type extends MessageType<Receivable_Customer> {
    constructor() {
        super("rd.txn.Receivable.Customer", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Receivable_Customer>): Receivable_Customer {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<Receivable_Customer>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Receivable_Customer): Receivable_Customer {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Receivable_Customer, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Receivable.Customer
 */
export const Receivable_Customer = new Receivable_Customer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Receivable_Job$Type extends MessageType<Receivable_Job> {
    constructor() {
        super("rd.txn.Receivable.Job", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Receivable_Job>): Receivable_Job {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<Receivable_Job>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Receivable_Job): Receivable_Job {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Receivable_Job, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Receivable.Job
 */
export const Receivable_Job = new Receivable_Job$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Receivable_PurchaseOrder$Type extends MessageType<Receivable_PurchaseOrder> {
    constructor() {
        super("rd.txn.Receivable.PurchaseOrder", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Receivable_PurchaseOrder>): Receivable_PurchaseOrder {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<Receivable_PurchaseOrder>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Receivable_PurchaseOrder): Receivable_PurchaseOrder {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Receivable_PurchaseOrder, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Receivable.PurchaseOrder
 */
export const Receivable_PurchaseOrder = new Receivable_PurchaseOrder$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Receivable_Location$Type extends MessageType<Receivable_Location> {
    constructor() {
        super("rd.txn.Receivable.Location", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "prefix", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Receivable_Location>): Receivable_Location {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.prefix = "";
        if (value !== undefined)
            reflectionMergePartial<Receivable_Location>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Receivable_Location): Receivable_Location {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string prefix */ 3:
                    message.prefix = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Receivable_Location, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string prefix = 3; */
        if (message.prefix !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.prefix);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Receivable.Location
 */
export const Receivable_Location = new Receivable_Location$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Receivable_Contact$Type extends MessageType<Receivable_Contact> {
    constructor() {
        super("rd.txn.Receivable.Contact", [
            { no: 1, name: "id_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Receivable_Contact>): Receivable_Contact {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.idString = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<Receivable_Contact>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Receivable_Contact): Receivable_Contact {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id_string */ 1:
                    message.idString = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Receivable_Contact, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id_string = 1; */
        if (message.idString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.idString);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Receivable.Contact
 */
export const Receivable_Contact = new Receivable_Contact$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AllocatedReceivable$Type extends MessageType<AllocatedReceivable> {
    constructor() {
        super("rd.txn.AllocatedReceivable", [
            { no: 1, name: "receivable", kind: "message", T: () => Receivable },
            { no: 2, name: "allocation", kind: "message", T: () => Money },
            { no: 3, name: "discount", kind: "message", T: () => Money },
            { no: 4, name: "reversed_discount", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<AllocatedReceivable>): AllocatedReceivable {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AllocatedReceivable>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AllocatedReceivable): AllocatedReceivable {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.Receivable receivable */ 1:
                    message.receivable = Receivable.internalBinaryRead(reader, reader.uint32(), options, message.receivable);
                    break;
                case /* rd.proto.money.Money allocation */ 2:
                    message.allocation = Money.internalBinaryRead(reader, reader.uint32(), options, message.allocation);
                    break;
                case /* rd.proto.money.Money discount */ 3:
                    message.discount = Money.internalBinaryRead(reader, reader.uint32(), options, message.discount);
                    break;
                case /* rd.proto.money.Money reversed_discount */ 4:
                    message.reversedDiscount = Money.internalBinaryRead(reader, reader.uint32(), options, message.reversedDiscount);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AllocatedReceivable, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.Receivable receivable = 1; */
        if (message.receivable)
            Receivable.internalBinaryWrite(message.receivable, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money allocation = 2; */
        if (message.allocation)
            Money.internalBinaryWrite(message.allocation, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money discount = 3; */
        if (message.discount)
            Money.internalBinaryWrite(message.discount, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money reversed_discount = 4; */
        if (message.reversedDiscount)
            Money.internalBinaryWrite(message.reversedDiscount, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.AllocatedReceivable
 */
export const AllocatedReceivable = new AllocatedReceivable$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TenderSubmissionMetadata$Type extends MessageType<TenderSubmissionMetadata> {
    constructor() {
        super("rd.txn.TenderSubmissionMetadata", [
            { no: 1, name: "tender_method_id", kind: "message", T: () => UUID },
            { no: 2, name: "amount", kind: "message", T: () => Money },
            { no: 3, name: "surcharge", kind: "message", T: () => Money },
            { no: 4, name: "surcharge_tax", kind: "message", T: () => Money },
            { no: 5, name: "submission_type", kind: "enum", T: () => ["rd.txn.TenderSubmissionMetadata.SubmissionType", TenderSubmissionMetadata_SubmissionType, "SUBMISSION_TYPE_"] },
            { no: 6, name: "charge_account", kind: "message", T: () => TenderSubmissionMetadata_ChargeAccount },
            { no: 7, name: "previous_card", kind: "message", T: () => TenderSubmissionMetadata_PreviousCard },
            { no: 8, name: "present_card", kind: "message", T: () => TenderSubmissionMetadata_PresentCard },
            { no: 9, name: "saved_card", kind: "message", T: () => TenderSubmissionMetadata_SavedCard },
            { no: 10, name: "manually_entered_card", kind: "message", T: () => TenderSubmissionMetadata_ManuallyEnteredCard },
            { no: 11, name: "cash", kind: "message", T: () => TenderSubmissionMetadata_Cash },
            { no: 12, name: "check", kind: "message", T: () => TenderSubmissionMetadata_Check },
            { no: 13, name: "write_off", kind: "message", T: () => TenderSubmissionMetadata_WriteOff },
            { no: 14, name: "custom", kind: "message", T: () => TenderSubmissionMetadata_Custom },
            { no: 15, name: "previous_ach", kind: "message", T: () => TenderSubmissionMetadata_PreviousACH },
            { no: 16, name: "saved_ach", kind: "message", T: () => TenderSubmissionMetadata_SavedACH },
            { no: 17, name: "gift_card", kind: "message", T: () => TenderSubmissionMetadata_GiftCard },
            { no: 18, name: "previous_interac_card", kind: "message", T: () => TenderSubmissionMetadata_PreviousInteracCard },
            { no: 19, name: "surcharge_tax_by_tax_rate_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } }
        ]);
    }
    create(value?: PartialMessage<TenderSubmissionMetadata>): TenderSubmissionMetadata {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.submissionType = 0;
        message.surchargeTaxByTaxRateId = {};
        if (value !== undefined)
            reflectionMergePartial<TenderSubmissionMetadata>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TenderSubmissionMetadata): TenderSubmissionMetadata {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID tender_method_id */ 1:
                    message.tenderMethodId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.tenderMethodId);
                    break;
                case /* rd.proto.money.Money amount */ 2:
                    message.amount = Money.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                case /* rd.proto.money.Money surcharge */ 3:
                    message.surcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.surcharge);
                    break;
                case /* rd.proto.money.Money surcharge_tax */ 4:
                    message.surchargeTax = Money.internalBinaryRead(reader, reader.uint32(), options, message.surchargeTax);
                    break;
                case /* rd.txn.TenderSubmissionMetadata.SubmissionType submission_type */ 5:
                    message.submissionType = reader.int32();
                    break;
                case /* rd.txn.TenderSubmissionMetadata.ChargeAccount charge_account */ 6:
                    message.chargeAccount = TenderSubmissionMetadata_ChargeAccount.internalBinaryRead(reader, reader.uint32(), options, message.chargeAccount);
                    break;
                case /* rd.txn.TenderSubmissionMetadata.PreviousCard previous_card */ 7:
                    message.previousCard = TenderSubmissionMetadata_PreviousCard.internalBinaryRead(reader, reader.uint32(), options, message.previousCard);
                    break;
                case /* rd.txn.TenderSubmissionMetadata.PresentCard present_card */ 8:
                    message.presentCard = TenderSubmissionMetadata_PresentCard.internalBinaryRead(reader, reader.uint32(), options, message.presentCard);
                    break;
                case /* rd.txn.TenderSubmissionMetadata.SavedCard saved_card */ 9:
                    message.savedCard = TenderSubmissionMetadata_SavedCard.internalBinaryRead(reader, reader.uint32(), options, message.savedCard);
                    break;
                case /* rd.txn.TenderSubmissionMetadata.ManuallyEnteredCard manually_entered_card */ 10:
                    message.manuallyEnteredCard = TenderSubmissionMetadata_ManuallyEnteredCard.internalBinaryRead(reader, reader.uint32(), options, message.manuallyEnteredCard);
                    break;
                case /* rd.txn.TenderSubmissionMetadata.Cash cash */ 11:
                    message.cash = TenderSubmissionMetadata_Cash.internalBinaryRead(reader, reader.uint32(), options, message.cash);
                    break;
                case /* rd.txn.TenderSubmissionMetadata.Check check */ 12:
                    message.check = TenderSubmissionMetadata_Check.internalBinaryRead(reader, reader.uint32(), options, message.check);
                    break;
                case /* rd.txn.TenderSubmissionMetadata.WriteOff write_off */ 13:
                    message.writeOff = TenderSubmissionMetadata_WriteOff.internalBinaryRead(reader, reader.uint32(), options, message.writeOff);
                    break;
                case /* rd.txn.TenderSubmissionMetadata.Custom custom */ 14:
                    message.custom = TenderSubmissionMetadata_Custom.internalBinaryRead(reader, reader.uint32(), options, message.custom);
                    break;
                case /* rd.txn.TenderSubmissionMetadata.PreviousACH previous_ach */ 15:
                    message.previousAch = TenderSubmissionMetadata_PreviousACH.internalBinaryRead(reader, reader.uint32(), options, message.previousAch);
                    break;
                case /* rd.txn.TenderSubmissionMetadata.SavedACH saved_ach */ 16:
                    message.savedAch = TenderSubmissionMetadata_SavedACH.internalBinaryRead(reader, reader.uint32(), options, message.savedAch);
                    break;
                case /* rd.txn.TenderSubmissionMetadata.GiftCard gift_card */ 17:
                    message.giftCard = TenderSubmissionMetadata_GiftCard.internalBinaryRead(reader, reader.uint32(), options, message.giftCard);
                    break;
                case /* rd.txn.TenderSubmissionMetadata.PreviousInteracCard previous_interac_card */ 18:
                    message.previousInteracCard = TenderSubmissionMetadata_PreviousInteracCard.internalBinaryRead(reader, reader.uint32(), options, message.previousInteracCard);
                    break;
                case /* map<string, rd.proto.money.Money> surcharge_tax_by_tax_rate_id */ 19:
                    this.binaryReadMap19(message.surchargeTaxByTaxRateId, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap19(map: TenderSubmissionMetadata["surchargeTaxByTaxRateId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof TenderSubmissionMetadata["surchargeTaxByTaxRateId"] | undefined, val: TenderSubmissionMetadata["surchargeTaxByTaxRateId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.TenderSubmissionMetadata.surcharge_tax_by_tax_rate_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: TenderSubmissionMetadata, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID tender_method_id = 1; */
        if (message.tenderMethodId)
            UUID.internalBinaryWrite(message.tenderMethodId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money amount = 2; */
        if (message.amount)
            Money.internalBinaryWrite(message.amount, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money surcharge = 3; */
        if (message.surcharge)
            Money.internalBinaryWrite(message.surcharge, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money surcharge_tax = 4; */
        if (message.surchargeTax)
            Money.internalBinaryWrite(message.surchargeTax, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata.SubmissionType submission_type = 5; */
        if (message.submissionType !== 0)
            writer.tag(5, WireType.Varint).int32(message.submissionType);
        /* rd.txn.TenderSubmissionMetadata.ChargeAccount charge_account = 6; */
        if (message.chargeAccount)
            TenderSubmissionMetadata_ChargeAccount.internalBinaryWrite(message.chargeAccount, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata.PreviousCard previous_card = 7; */
        if (message.previousCard)
            TenderSubmissionMetadata_PreviousCard.internalBinaryWrite(message.previousCard, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata.PresentCard present_card = 8; */
        if (message.presentCard)
            TenderSubmissionMetadata_PresentCard.internalBinaryWrite(message.presentCard, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata.SavedCard saved_card = 9; */
        if (message.savedCard)
            TenderSubmissionMetadata_SavedCard.internalBinaryWrite(message.savedCard, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata.ManuallyEnteredCard manually_entered_card = 10; */
        if (message.manuallyEnteredCard)
            TenderSubmissionMetadata_ManuallyEnteredCard.internalBinaryWrite(message.manuallyEnteredCard, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata.Cash cash = 11; */
        if (message.cash)
            TenderSubmissionMetadata_Cash.internalBinaryWrite(message.cash, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata.Check check = 12; */
        if (message.check)
            TenderSubmissionMetadata_Check.internalBinaryWrite(message.check, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata.WriteOff write_off = 13; */
        if (message.writeOff)
            TenderSubmissionMetadata_WriteOff.internalBinaryWrite(message.writeOff, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata.Custom custom = 14; */
        if (message.custom)
            TenderSubmissionMetadata_Custom.internalBinaryWrite(message.custom, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata.PreviousACH previous_ach = 15; */
        if (message.previousAch)
            TenderSubmissionMetadata_PreviousACH.internalBinaryWrite(message.previousAch, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata.SavedACH saved_ach = 16; */
        if (message.savedAch)
            TenderSubmissionMetadata_SavedACH.internalBinaryWrite(message.savedAch, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata.GiftCard gift_card = 17; */
        if (message.giftCard)
            TenderSubmissionMetadata_GiftCard.internalBinaryWrite(message.giftCard, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata.PreviousInteracCard previous_interac_card = 18; */
        if (message.previousInteracCard)
            TenderSubmissionMetadata_PreviousInteracCard.internalBinaryWrite(message.previousInteracCard, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> surcharge_tax_by_tax_rate_id = 19; */
        for (let k of globalThis.Object.keys(message.surchargeTaxByTaxRateId)) {
            writer.tag(19, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.surchargeTaxByTaxRateId[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TenderSubmissionMetadata
 */
export const TenderSubmissionMetadata = new TenderSubmissionMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TenderSubmissionMetadata_ChargeAccount$Type extends MessageType<TenderSubmissionMetadata_ChargeAccount> {
    constructor() {
        super("rd.txn.TenderSubmissionMetadata.ChargeAccount", [
            { no: 2, name: "cash_register_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<TenderSubmissionMetadata_ChargeAccount>): TenderSubmissionMetadata_ChargeAccount {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TenderSubmissionMetadata_ChargeAccount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TenderSubmissionMetadata_ChargeAccount): TenderSubmissionMetadata_ChargeAccount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID cash_register_id */ 2:
                    message.cashRegisterId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.cashRegisterId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TenderSubmissionMetadata_ChargeAccount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID cash_register_id = 2; */
        if (message.cashRegisterId)
            UUID.internalBinaryWrite(message.cashRegisterId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TenderSubmissionMetadata.ChargeAccount
 */
export const TenderSubmissionMetadata_ChargeAccount = new TenderSubmissionMetadata_ChargeAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TenderSubmissionMetadata_PreviousCard$Type extends MessageType<TenderSubmissionMetadata_PreviousCard> {
    constructor() {
        super("rd.txn.TenderSubmissionMetadata.PreviousCard", []);
    }
    create(value?: PartialMessage<TenderSubmissionMetadata_PreviousCard>): TenderSubmissionMetadata_PreviousCard {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TenderSubmissionMetadata_PreviousCard>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TenderSubmissionMetadata_PreviousCard): TenderSubmissionMetadata_PreviousCard {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TenderSubmissionMetadata_PreviousCard, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TenderSubmissionMetadata.PreviousCard
 */
export const TenderSubmissionMetadata_PreviousCard = new TenderSubmissionMetadata_PreviousCard$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TenderSubmissionMetadata_PresentCard$Type extends MessageType<TenderSubmissionMetadata_PresentCard> {
    constructor() {
        super("rd.txn.TenderSubmissionMetadata.PresentCard", [
            { no: 1, name: "stripe_reader_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "should_save_card", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "nickname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "stripe_payment_intent_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "set_is_primary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "is_interac", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "postal_code", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true } }
        ]);
    }
    create(value?: PartialMessage<TenderSubmissionMetadata_PresentCard>): TenderSubmissionMetadata_PresentCard {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripeReaderId = "";
        message.shouldSaveCard = false;
        message.nickname = "";
        message.stripePaymentIntentId = "";
        message.setIsPrimary = false;
        message.isInterac = false;
        message.postalCode = "";
        if (value !== undefined)
            reflectionMergePartial<TenderSubmissionMetadata_PresentCard>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TenderSubmissionMetadata_PresentCard): TenderSubmissionMetadata_PresentCard {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stripe_reader_id */ 1:
                    message.stripeReaderId = reader.string();
                    break;
                case /* bool should_save_card */ 3:
                    message.shouldSaveCard = reader.bool();
                    break;
                case /* string nickname */ 4:
                    message.nickname = reader.string();
                    break;
                case /* string stripe_payment_intent_id */ 5:
                    message.stripePaymentIntentId = reader.string();
                    break;
                case /* bool set_is_primary */ 6:
                    message.setIsPrimary = reader.bool();
                    break;
                case /* bool is_interac */ 7:
                    message.isInterac = reader.bool();
                    break;
                case /* string postal_code */ 8:
                    message.postalCode = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TenderSubmissionMetadata_PresentCard, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stripe_reader_id = 1; */
        if (message.stripeReaderId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stripeReaderId);
        /* bool should_save_card = 3; */
        if (message.shouldSaveCard !== false)
            writer.tag(3, WireType.Varint).bool(message.shouldSaveCard);
        /* string nickname = 4; */
        if (message.nickname !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.nickname);
        /* string stripe_payment_intent_id = 5; */
        if (message.stripePaymentIntentId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.stripePaymentIntentId);
        /* bool set_is_primary = 6; */
        if (message.setIsPrimary !== false)
            writer.tag(6, WireType.Varint).bool(message.setIsPrimary);
        /* bool is_interac = 7; */
        if (message.isInterac !== false)
            writer.tag(7, WireType.Varint).bool(message.isInterac);
        /* string postal_code = 8; */
        if (message.postalCode !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.postalCode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TenderSubmissionMetadata.PresentCard
 */
export const TenderSubmissionMetadata_PresentCard = new TenderSubmissionMetadata_PresentCard$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TenderSubmissionMetadata_SavedCard$Type extends MessageType<TenderSubmissionMetadata_SavedCard> {
    constructor() {
        super("rd.txn.TenderSubmissionMetadata.SavedCard", [
            { no: 1, name: "stripe_payment_method_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "stripe_payment_intent_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "set_is_primary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "should_save_card", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "nickname", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TenderSubmissionMetadata_SavedCard>): TenderSubmissionMetadata_SavedCard {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripePaymentMethodId = "";
        message.stripePaymentIntentId = "";
        message.setIsPrimary = false;
        message.shouldSaveCard = false;
        message.nickname = "";
        if (value !== undefined)
            reflectionMergePartial<TenderSubmissionMetadata_SavedCard>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TenderSubmissionMetadata_SavedCard): TenderSubmissionMetadata_SavedCard {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stripe_payment_method_id */ 1:
                    message.stripePaymentMethodId = reader.string();
                    break;
                case /* string stripe_payment_intent_id */ 2:
                    message.stripePaymentIntentId = reader.string();
                    break;
                case /* bool set_is_primary */ 3:
                    message.setIsPrimary = reader.bool();
                    break;
                case /* bool should_save_card */ 4:
                    message.shouldSaveCard = reader.bool();
                    break;
                case /* string nickname */ 5:
                    message.nickname = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TenderSubmissionMetadata_SavedCard, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stripe_payment_method_id = 1; */
        if (message.stripePaymentMethodId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stripePaymentMethodId);
        /* string stripe_payment_intent_id = 2; */
        if (message.stripePaymentIntentId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.stripePaymentIntentId);
        /* bool set_is_primary = 3; */
        if (message.setIsPrimary !== false)
            writer.tag(3, WireType.Varint).bool(message.setIsPrimary);
        /* bool should_save_card = 4; */
        if (message.shouldSaveCard !== false)
            writer.tag(4, WireType.Varint).bool(message.shouldSaveCard);
        /* string nickname = 5; */
        if (message.nickname !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.nickname);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TenderSubmissionMetadata.SavedCard
 */
export const TenderSubmissionMetadata_SavedCard = new TenderSubmissionMetadata_SavedCard$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TenderSubmissionMetadata_ManuallyEnteredCard$Type extends MessageType<TenderSubmissionMetadata_ManuallyEnteredCard> {
    constructor() {
        super("rd.txn.TenderSubmissionMetadata.ManuallyEnteredCard", [
            { no: 1, name: "card", kind: "message", T: () => ManuallyEnteredCard },
            { no: 2, name: "should_save_card", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "nickname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "stripe_payment_intent_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "set_is_primary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TenderSubmissionMetadata_ManuallyEnteredCard>): TenderSubmissionMetadata_ManuallyEnteredCard {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.shouldSaveCard = false;
        message.nickname = "";
        message.stripePaymentIntentId = "";
        message.setIsPrimary = false;
        if (value !== undefined)
            reflectionMergePartial<TenderSubmissionMetadata_ManuallyEnteredCard>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TenderSubmissionMetadata_ManuallyEnteredCard): TenderSubmissionMetadata_ManuallyEnteredCard {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.payments.ManuallyEnteredCard card */ 1:
                    message.card = ManuallyEnteredCard.internalBinaryRead(reader, reader.uint32(), options, message.card);
                    break;
                case /* bool should_save_card */ 2:
                    message.shouldSaveCard = reader.bool();
                    break;
                case /* string nickname */ 3:
                    message.nickname = reader.string();
                    break;
                case /* string stripe_payment_intent_id */ 4:
                    message.stripePaymentIntentId = reader.string();
                    break;
                case /* bool set_is_primary */ 5:
                    message.setIsPrimary = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TenderSubmissionMetadata_ManuallyEnteredCard, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.payments.ManuallyEnteredCard card = 1; */
        if (message.card)
            ManuallyEnteredCard.internalBinaryWrite(message.card, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool should_save_card = 2; */
        if (message.shouldSaveCard !== false)
            writer.tag(2, WireType.Varint).bool(message.shouldSaveCard);
        /* string nickname = 3; */
        if (message.nickname !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nickname);
        /* string stripe_payment_intent_id = 4; */
        if (message.stripePaymentIntentId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.stripePaymentIntentId);
        /* bool set_is_primary = 5; */
        if (message.setIsPrimary !== false)
            writer.tag(5, WireType.Varint).bool(message.setIsPrimary);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TenderSubmissionMetadata.ManuallyEnteredCard
 */
export const TenderSubmissionMetadata_ManuallyEnteredCard = new TenderSubmissionMetadata_ManuallyEnteredCard$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TenderSubmissionMetadata_Cash$Type extends MessageType<TenderSubmissionMetadata_Cash> {
    constructor() {
        super("rd.txn.TenderSubmissionMetadata.Cash", [
            { no: 1, name: "cash_received", kind: "message", T: () => Money },
            { no: 2, name: "cash_register_id", kind: "message", T: () => UUID },
            { no: 3, name: "cash_rounding_delta", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<TenderSubmissionMetadata_Cash>): TenderSubmissionMetadata_Cash {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TenderSubmissionMetadata_Cash>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TenderSubmissionMetadata_Cash): TenderSubmissionMetadata_Cash {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money cash_received */ 1:
                    message.cashReceived = Money.internalBinaryRead(reader, reader.uint32(), options, message.cashReceived);
                    break;
                case /* rd.proto.uuid.UUID cash_register_id */ 2:
                    message.cashRegisterId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.cashRegisterId);
                    break;
                case /* rd.proto.money.Money cash_rounding_delta */ 3:
                    message.cashRoundingDelta = Money.internalBinaryRead(reader, reader.uint32(), options, message.cashRoundingDelta);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TenderSubmissionMetadata_Cash, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money cash_received = 1; */
        if (message.cashReceived)
            Money.internalBinaryWrite(message.cashReceived, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID cash_register_id = 2; */
        if (message.cashRegisterId)
            UUID.internalBinaryWrite(message.cashRegisterId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money cash_rounding_delta = 3; */
        if (message.cashRoundingDelta)
            Money.internalBinaryWrite(message.cashRoundingDelta, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TenderSubmissionMetadata.Cash
 */
export const TenderSubmissionMetadata_Cash = new TenderSubmissionMetadata_Cash$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TenderSubmissionMetadata_Check$Type extends MessageType<TenderSubmissionMetadata_Check> {
    constructor() {
        super("rd.txn.TenderSubmissionMetadata.Check", [
            { no: 1, name: "check_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TenderSubmissionMetadata_Check>): TenderSubmissionMetadata_Check {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.checkNumber = "";
        if (value !== undefined)
            reflectionMergePartial<TenderSubmissionMetadata_Check>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TenderSubmissionMetadata_Check): TenderSubmissionMetadata_Check {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string check_number */ 1:
                    message.checkNumber = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TenderSubmissionMetadata_Check, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string check_number = 1; */
        if (message.checkNumber !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.checkNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TenderSubmissionMetadata.Check
 */
export const TenderSubmissionMetadata_Check = new TenderSubmissionMetadata_Check$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TenderSubmissionMetadata_WriteOff$Type extends MessageType<TenderSubmissionMetadata_WriteOff> {
    constructor() {
        super("rd.txn.TenderSubmissionMetadata.WriteOff", []);
    }
    create(value?: PartialMessage<TenderSubmissionMetadata_WriteOff>): TenderSubmissionMetadata_WriteOff {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TenderSubmissionMetadata_WriteOff>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TenderSubmissionMetadata_WriteOff): TenderSubmissionMetadata_WriteOff {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TenderSubmissionMetadata_WriteOff, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TenderSubmissionMetadata.WriteOff
 */
export const TenderSubmissionMetadata_WriteOff = new TenderSubmissionMetadata_WriteOff$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TenderSubmissionMetadata_Custom$Type extends MessageType<TenderSubmissionMetadata_Custom> {
    constructor() {
        super("rd.txn.TenderSubmissionMetadata.Custom", [
            { no: 1, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TenderSubmissionMetadata_Custom>): TenderSubmissionMetadata_Custom {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.note = "";
        if (value !== undefined)
            reflectionMergePartial<TenderSubmissionMetadata_Custom>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TenderSubmissionMetadata_Custom): TenderSubmissionMetadata_Custom {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string note */ 1:
                    message.note = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TenderSubmissionMetadata_Custom, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string note = 1; */
        if (message.note !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.note);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TenderSubmissionMetadata.Custom
 */
export const TenderSubmissionMetadata_Custom = new TenderSubmissionMetadata_Custom$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TenderSubmissionMetadata_PreviousACH$Type extends MessageType<TenderSubmissionMetadata_PreviousACH> {
    constructor() {
        super("rd.txn.TenderSubmissionMetadata.PreviousACH", []);
    }
    create(value?: PartialMessage<TenderSubmissionMetadata_PreviousACH>): TenderSubmissionMetadata_PreviousACH {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TenderSubmissionMetadata_PreviousACH>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TenderSubmissionMetadata_PreviousACH): TenderSubmissionMetadata_PreviousACH {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TenderSubmissionMetadata_PreviousACH, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TenderSubmissionMetadata.PreviousACH
 */
export const TenderSubmissionMetadata_PreviousACH = new TenderSubmissionMetadata_PreviousACH$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TenderSubmissionMetadata_SavedACH$Type extends MessageType<TenderSubmissionMetadata_SavedACH> {
    constructor() {
        super("rd.txn.TenderSubmissionMetadata.SavedACH", [
            { no: 1, name: "stripe_payment_method_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "nickname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "set_is_primary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "stripe_payment_intent_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TenderSubmissionMetadata_SavedACH>): TenderSubmissionMetadata_SavedACH {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripePaymentMethodId = "";
        message.nickname = "";
        message.setIsPrimary = false;
        message.stripePaymentIntentId = "";
        if (value !== undefined)
            reflectionMergePartial<TenderSubmissionMetadata_SavedACH>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TenderSubmissionMetadata_SavedACH): TenderSubmissionMetadata_SavedACH {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stripe_payment_method_id */ 1:
                    message.stripePaymentMethodId = reader.string();
                    break;
                case /* string nickname */ 2:
                    message.nickname = reader.string();
                    break;
                case /* bool set_is_primary */ 3:
                    message.setIsPrimary = reader.bool();
                    break;
                case /* string stripe_payment_intent_id */ 4:
                    message.stripePaymentIntentId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TenderSubmissionMetadata_SavedACH, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stripe_payment_method_id = 1; */
        if (message.stripePaymentMethodId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stripePaymentMethodId);
        /* string nickname = 2; */
        if (message.nickname !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nickname);
        /* bool set_is_primary = 3; */
        if (message.setIsPrimary !== false)
            writer.tag(3, WireType.Varint).bool(message.setIsPrimary);
        /* string stripe_payment_intent_id = 4; */
        if (message.stripePaymentIntentId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.stripePaymentIntentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TenderSubmissionMetadata.SavedACH
 */
export const TenderSubmissionMetadata_SavedACH = new TenderSubmissionMetadata_SavedACH$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TenderSubmissionMetadata_GiftCard$Type extends MessageType<TenderSubmissionMetadata_GiftCard> {
    constructor() {
        super("rd.txn.TenderSubmissionMetadata.GiftCard", [
            { no: 1, name: "gift_card_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<TenderSubmissionMetadata_GiftCard>): TenderSubmissionMetadata_GiftCard {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TenderSubmissionMetadata_GiftCard>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TenderSubmissionMetadata_GiftCard): TenderSubmissionMetadata_GiftCard {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID gift_card_id */ 1:
                    message.giftCardId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.giftCardId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TenderSubmissionMetadata_GiftCard, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID gift_card_id = 1; */
        if (message.giftCardId)
            UUID.internalBinaryWrite(message.giftCardId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TenderSubmissionMetadata.GiftCard
 */
export const TenderSubmissionMetadata_GiftCard = new TenderSubmissionMetadata_GiftCard$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TenderSubmissionMetadata_PreviousInteracCard$Type extends MessageType<TenderSubmissionMetadata_PreviousInteracCard> {
    constructor() {
        super("rd.txn.TenderSubmissionMetadata.PreviousInteracCard", [
            { no: 1, name: "stripe_reader_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TenderSubmissionMetadata_PreviousInteracCard>): TenderSubmissionMetadata_PreviousInteracCard {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stripeReaderId = "";
        if (value !== undefined)
            reflectionMergePartial<TenderSubmissionMetadata_PreviousInteracCard>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TenderSubmissionMetadata_PreviousInteracCard): TenderSubmissionMetadata_PreviousInteracCard {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string stripe_reader_id */ 1:
                    message.stripeReaderId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TenderSubmissionMetadata_PreviousInteracCard, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string stripe_reader_id = 1; */
        if (message.stripeReaderId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stripeReaderId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.TenderSubmissionMetadata.PreviousInteracCard
 */
export const TenderSubmissionMetadata_PreviousInteracCard = new TenderSubmissionMetadata_PreviousInteracCard$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CCPRebateReportUpload$Type extends MessageType<CCPRebateReportUpload> {
    constructor() {
        super("rd.txn.CCPRebateReportUpload", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "uploaded_by_user_id", kind: "message", T: () => UUID },
            { no: 6, name: "status", kind: "enum", T: () => ["rd.txn.CCPRebateReportUpload.Status", CCPRebateReportUpload_Status, "STATUS_"] },
            { no: 7, name: "file_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "total_rows", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "rows_matched", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "total_rebate_amount", kind: "message", T: () => FractionalMoney },
            { no: 13, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "error_file_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CCPRebateReportUpload>): CCPRebateReportUpload {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        message.fileUrl = "";
        message.totalRows = 0;
        message.rowsMatched = 0;
        message.errorMessage = "";
        message.errorFileUrl = "";
        if (value !== undefined)
            reflectionMergePartial<CCPRebateReportUpload>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CCPRebateReportUpload): CCPRebateReportUpload {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID uploaded_by_user_id */ 5:
                    message.uploadedByUserId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.uploadedByUserId);
                    break;
                case /* rd.txn.CCPRebateReportUpload.Status status */ 6:
                    message.status = reader.int32();
                    break;
                case /* string file_url */ 7:
                    message.fileUrl = reader.string();
                    break;
                case /* int32 total_rows */ 9:
                    message.totalRows = reader.int32();
                    break;
                case /* int32 rows_matched */ 10:
                    message.rowsMatched = reader.int32();
                    break;
                case /* rd.proto.money.FractionalMoney total_rebate_amount */ 12:
                    message.totalRebateAmount = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.totalRebateAmount);
                    break;
                case /* string error_message */ 13:
                    message.errorMessage = reader.string();
                    break;
                case /* string error_file_url */ 14:
                    message.errorFileUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CCPRebateReportUpload, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID uploaded_by_user_id = 5; */
        if (message.uploadedByUserId)
            UUID.internalBinaryWrite(message.uploadedByUserId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.CCPRebateReportUpload.Status status = 6; */
        if (message.status !== 0)
            writer.tag(6, WireType.Varint).int32(message.status);
        /* string file_url = 7; */
        if (message.fileUrl !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.fileUrl);
        /* int32 total_rows = 9; */
        if (message.totalRows !== 0)
            writer.tag(9, WireType.Varint).int32(message.totalRows);
        /* int32 rows_matched = 10; */
        if (message.rowsMatched !== 0)
            writer.tag(10, WireType.Varint).int32(message.rowsMatched);
        /* rd.proto.money.FractionalMoney total_rebate_amount = 12; */
        if (message.totalRebateAmount)
            FractionalMoney.internalBinaryWrite(message.totalRebateAmount, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* string error_message = 13; */
        if (message.errorMessage !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.errorMessage);
        /* string error_file_url = 14; */
        if (message.errorFileUrl !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.errorFileUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.CCPRebateReportUpload
 */
export const CCPRebateReportUpload = new CCPRebateReportUpload$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaleCountBySource$Type extends MessageType<SaleCountBySource> {
    constructor() {
        super("rd.txn.SaleCountBySource", [
            { no: 1, name: "pos", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "ecomm", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SaleCountBySource>): SaleCountBySource {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pos = 0;
        message.ecomm = 0;
        if (value !== undefined)
            reflectionMergePartial<SaleCountBySource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SaleCountBySource): SaleCountBySource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 pos */ 1:
                    message.pos = reader.int32();
                    break;
                case /* int32 ecomm */ 2:
                    message.ecomm = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SaleCountBySource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 pos = 1; */
        if (message.pos !== 0)
            writer.tag(1, WireType.Varint).int32(message.pos);
        /* int32 ecomm = 2; */
        if (message.ecomm !== 0)
            writer.tag(2, WireType.Varint).int32(message.ecomm);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.SaleCountBySource
 */
export const SaleCountBySource = new SaleCountBySource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Delivery$Type extends MessageType<Delivery> {
    constructor() {
        super("rd.txn.Delivery", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "company_id", kind: "message", T: () => UUID },
            { no: 4, name: "location_id", kind: "message", T: () => UUID },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "created_by", kind: "message", T: () => User },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "updated_by", kind: "message", T: () => User },
            { no: 9, name: "departure_time", kind: "message", T: () => Timestamp },
            { no: 10, name: "return_time", kind: "message", T: () => Timestamp },
            { no: 11, name: "carrier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "assigned_to", kind: "message", T: () => User },
            { no: 15, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "internal_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Delivery>): Delivery {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.carrier = "";
        message.notes = "";
        message.internalNotes = "";
        if (value !== undefined)
            reflectionMergePartial<Delivery>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Delivery): Delivery {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                case /* rd.proto.uuid.UUID company_id */ 3:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 4:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 6:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 7:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User updated_by */ 8:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* google.protobuf.Timestamp departure_time */ 9:
                    message.departureTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.departureTime);
                    break;
                case /* google.protobuf.Timestamp return_time */ 10:
                    message.returnTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.returnTime);
                    break;
                case /* string carrier */ 11:
                    message.carrier = reader.string();
                    break;
                case /* rd.user.User assigned_to */ 12:
                    message.assignedTo = User.internalBinaryRead(reader, reader.uint32(), options, message.assignedTo);
                    break;
                case /* string notes */ 15:
                    message.notes = reader.string();
                    break;
                case /* string internal_notes */ 16:
                    message.internalNotes = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Delivery, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        /* rd.proto.uuid.UUID company_id = 3; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 4; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 6; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 7; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 8; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp departure_time = 9; */
        if (message.departureTime)
            Timestamp.internalBinaryWrite(message.departureTime, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp return_time = 10; */
        if (message.returnTime)
            Timestamp.internalBinaryWrite(message.returnTime, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string carrier = 11; */
        if (message.carrier !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.carrier);
        /* rd.user.User assigned_to = 12; */
        if (message.assignedTo)
            User.internalBinaryWrite(message.assignedTo, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 15; */
        if (message.notes !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.notes);
        /* string internal_notes = 16; */
        if (message.internalNotes !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.internalNotes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Delivery
 */
export const Delivery = new Delivery$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Delivery_StatusMetadata$Type extends MessageType<Delivery_StatusMetadata> {
    constructor() {
        super("rd.txn.Delivery.StatusMetadata", [
            { no: 1, name: "at", kind: "message", T: () => Timestamp },
            { no: 2, name: "by", kind: "message", T: () => User }
        ]);
    }
    create(value?: PartialMessage<Delivery_StatusMetadata>): Delivery_StatusMetadata {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Delivery_StatusMetadata>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Delivery_StatusMetadata): Delivery_StatusMetadata {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp at */ 1:
                    message.at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.at);
                    break;
                case /* rd.user.User by */ 2:
                    message.by = User.internalBinaryRead(reader, reader.uint32(), options, message.by);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Delivery_StatusMetadata, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp at = 1; */
        if (message.at)
            Timestamp.internalBinaryWrite(message.at, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User by = 2; */
        if (message.by)
            User.internalBinaryWrite(message.by, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.Delivery.StatusMetadata
 */
export const Delivery_StatusMetadata = new Delivery_StatusMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeliveryStop$Type extends MessageType<DeliveryStop> {
    constructor() {
        super("rd.txn.DeliveryStop", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "delivery_id", kind: "message", T: () => UUID },
            { no: 4, name: "dispatch_location_id", kind: "message", T: () => UUID },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "created_by", kind: "message", T: () => User },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "updated_by", kind: "message", T: () => User },
            { no: 9, name: "sale_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 10, name: "customer_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 14, name: "internal_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "status", kind: "enum", T: () => ["rd.txn.DeliveryStop.Status", DeliveryStop_Status, "STATUS_"] },
            { no: 16, name: "metadata_by_status", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "message", T: () => Delivery_StatusMetadata } },
            { no: 17, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "details", kind: "message", T: () => DeliveryDetails },
            { no: 19, name: "delivery_attempts_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => DeliveryStop_DeliveryAttempt } }
        ]);
    }
    create(value?: PartialMessage<DeliveryStop>): DeliveryStop {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.saleIds = [];
        message.customerIds = [];
        message.internalNotes = "";
        message.status = 0;
        message.metadataByStatus = {};
        message.position = 0;
        message.deliveryAttemptsById = {};
        if (value !== undefined)
            reflectionMergePartial<DeliveryStop>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeliveryStop): DeliveryStop {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID delivery_id */ 3:
                    message.deliveryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.deliveryId);
                    break;
                case /* rd.proto.uuid.UUID dispatch_location_id */ 4:
                    message.dispatchLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.dispatchLocationId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 6:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 7:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User updated_by */ 8:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* repeated rd.proto.uuid.UUID sale_ids */ 9:
                    message.saleIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID customer_ids */ 10:
                    message.customerIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string internal_notes */ 14:
                    message.internalNotes = reader.string();
                    break;
                case /* rd.txn.DeliveryStop.Status status */ 15:
                    message.status = reader.int32();
                    break;
                case /* map<int32, rd.txn.Delivery.StatusMetadata> metadata_by_status */ 16:
                    this.binaryReadMap16(message.metadataByStatus, reader, options);
                    break;
                case /* int32 position */ 17:
                    message.position = reader.int32();
                    break;
                case /* rd.txn.DeliveryDetails details */ 18:
                    message.details = DeliveryDetails.internalBinaryRead(reader, reader.uint32(), options, message.details);
                    break;
                case /* map<string, rd.txn.DeliveryStop.DeliveryAttempt> delivery_attempts_by_id */ 19:
                    this.binaryReadMap19(message.deliveryAttemptsById, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap16(map: DeliveryStop["metadataByStatus"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof DeliveryStop["metadataByStatus"] | undefined, val: DeliveryStop["metadataByStatus"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int32();
                    break;
                case 2:
                    val = Delivery_StatusMetadata.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.DeliveryStop.metadata_by_status");
            }
        }
        map[key ?? 0] = val ?? Delivery_StatusMetadata.create();
    }
    private binaryReadMap19(map: DeliveryStop["deliveryAttemptsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof DeliveryStop["deliveryAttemptsById"] | undefined, val: DeliveryStop["deliveryAttemptsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = DeliveryStop_DeliveryAttempt.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.txn.DeliveryStop.delivery_attempts_by_id");
            }
        }
        map[key ?? ""] = val ?? DeliveryStop_DeliveryAttempt.create();
    }
    internalBinaryWrite(message: DeliveryStop, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID delivery_id = 3; */
        if (message.deliveryId)
            UUID.internalBinaryWrite(message.deliveryId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID dispatch_location_id = 4; */
        if (message.dispatchLocationId)
            UUID.internalBinaryWrite(message.dispatchLocationId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 6; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 7; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 8; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID sale_ids = 9; */
        for (let i = 0; i < message.saleIds.length; i++)
            UUID.internalBinaryWrite(message.saleIds[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID customer_ids = 10; */
        for (let i = 0; i < message.customerIds.length; i++)
            UUID.internalBinaryWrite(message.customerIds[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string internal_notes = 14; */
        if (message.internalNotes !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.internalNotes);
        /* rd.txn.DeliveryStop.Status status = 15; */
        if (message.status !== 0)
            writer.tag(15, WireType.Varint).int32(message.status);
        /* map<int32, rd.txn.Delivery.StatusMetadata> metadata_by_status = 16; */
        for (let k of globalThis.Object.keys(message.metadataByStatus)) {
            writer.tag(16, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k));
            writer.tag(2, WireType.LengthDelimited).fork();
            Delivery_StatusMetadata.internalBinaryWrite(message.metadataByStatus[k as any], writer, options);
            writer.join().join();
        }
        /* int32 position = 17; */
        if (message.position !== 0)
            writer.tag(17, WireType.Varint).int32(message.position);
        /* rd.txn.DeliveryDetails details = 18; */
        if (message.details)
            DeliveryDetails.internalBinaryWrite(message.details, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.txn.DeliveryStop.DeliveryAttempt> delivery_attempts_by_id = 19; */
        for (let k of globalThis.Object.keys(message.deliveryAttemptsById)) {
            writer.tag(19, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            DeliveryStop_DeliveryAttempt.internalBinaryWrite(message.deliveryAttemptsById[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.DeliveryStop
 */
export const DeliveryStop = new DeliveryStop$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeliveryStop_DeliveryAttempt$Type extends MessageType<DeliveryStop_DeliveryAttempt> {
    constructor() {
        super("rd.txn.DeliveryStop.DeliveryAttempt", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "status", kind: "enum", T: () => ["rd.txn.DeliveryStop.DeliveryAttempt.Status", DeliveryStop_DeliveryAttempt_Status, "STATUS_"] },
            { no: 3, name: "at", kind: "message", T: () => Timestamp },
            { no: 4, name: "by", kind: "message", T: () => User },
            { no: 5, name: "signature_attachment_id", kind: "message", T: () => UUID },
            { no: 6, name: "photo_attachment_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 7, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DeliveryStop_DeliveryAttempt>): DeliveryStop_DeliveryAttempt {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        message.photoAttachmentIds = [];
        message.notes = "";
        if (value !== undefined)
            reflectionMergePartial<DeliveryStop_DeliveryAttempt>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeliveryStop_DeliveryAttempt): DeliveryStop_DeliveryAttempt {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.txn.DeliveryStop.DeliveryAttempt.Status status */ 2:
                    message.status = reader.int32();
                    break;
                case /* google.protobuf.Timestamp at */ 3:
                    message.at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.at);
                    break;
                case /* rd.user.User by */ 4:
                    message.by = User.internalBinaryRead(reader, reader.uint32(), options, message.by);
                    break;
                case /* rd.proto.uuid.UUID signature_attachment_id */ 5:
                    message.signatureAttachmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.signatureAttachmentId);
                    break;
                case /* repeated rd.proto.uuid.UUID photo_attachment_ids */ 6:
                    message.photoAttachmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string notes */ 7:
                    message.notes = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeliveryStop_DeliveryAttempt, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.DeliveryStop.DeliveryAttempt.Status status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* google.protobuf.Timestamp at = 3; */
        if (message.at)
            Timestamp.internalBinaryWrite(message.at, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User by = 4; */
        if (message.by)
            User.internalBinaryWrite(message.by, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID signature_attachment_id = 5; */
        if (message.signatureAttachmentId)
            UUID.internalBinaryWrite(message.signatureAttachmentId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID photo_attachment_ids = 6; */
        for (let i = 0; i < message.photoAttachmentIds.length; i++)
            UUID.internalBinaryWrite(message.photoAttachmentIds[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 7; */
        if (message.notes !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.notes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.DeliveryStop.DeliveryAttempt
 */
export const DeliveryStop_DeliveryAttempt = new DeliveryStop_DeliveryAttempt$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeliveryDetails$Type extends MessageType<DeliveryDetails> {
    constructor() {
        super("rd.txn.DeliveryDetails", [
            { no: 1, name: "address", kind: "message", T: () => Address },
            { no: 2, name: "contact", kind: "message", T: () => DeliveryDetails_Contact },
            { no: 3, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "requested_date", kind: "message", T: () => Timestamp },
            { no: 5, name: "customer_contact_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "requested_date_range", kind: "message", T: () => TimestampRange }
        ]);
    }
    create(value?: PartialMessage<DeliveryDetails>): DeliveryDetails {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notes = "";
        message.customerContactIdStrings = [];
        if (value !== undefined)
            reflectionMergePartial<DeliveryDetails>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeliveryDetails): DeliveryDetails {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.address.Address address */ 1:
                    message.address = Address.internalBinaryRead(reader, reader.uint32(), options, message.address);
                    break;
                case /* rd.txn.DeliveryDetails.Contact contact */ 2:
                    message.contact = DeliveryDetails_Contact.internalBinaryRead(reader, reader.uint32(), options, message.contact);
                    break;
                case /* string notes */ 3:
                    message.notes = reader.string();
                    break;
                case /* google.protobuf.Timestamp requested_date */ 4:
                    message.requestedDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.requestedDate);
                    break;
                case /* repeated string customer_contact_id_strings */ 5:
                    message.customerContactIdStrings.push(reader.string());
                    break;
                case /* rd.proto.timestamprange.TimestampRange requested_date_range */ 6:
                    message.requestedDateRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.requestedDateRange);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeliveryDetails, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.address.Address address = 1; */
        if (message.address)
            Address.internalBinaryWrite(message.address, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.DeliveryDetails.Contact contact = 2; */
        if (message.contact)
            DeliveryDetails_Contact.internalBinaryWrite(message.contact, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 3; */
        if (message.notes !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.notes);
        /* google.protobuf.Timestamp requested_date = 4; */
        if (message.requestedDate)
            Timestamp.internalBinaryWrite(message.requestedDate, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated string customer_contact_id_strings = 5; */
        for (let i = 0; i < message.customerContactIdStrings.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.customerContactIdStrings[i]);
        /* rd.proto.timestamprange.TimestampRange requested_date_range = 6; */
        if (message.requestedDateRange)
            TimestampRange.internalBinaryWrite(message.requestedDateRange, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.DeliveryDetails
 */
export const DeliveryDetails = new DeliveryDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeliveryDetails_Contact$Type extends MessageType<DeliveryDetails_Contact> {
    constructor() {
        super("rd.txn.DeliveryDetails.Contact", [
            { no: 1, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true } }
        ]);
    }
    create(value?: PartialMessage<DeliveryDetails_Contact>): DeliveryDetails_Contact {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.phone = "";
        message.name = "";
        message.email = "";
        if (value !== undefined)
            reflectionMergePartial<DeliveryDetails_Contact>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeliveryDetails_Contact): DeliveryDetails_Contact {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string phone */ 1:
                    message.phone = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string email */ 3:
                    message.email = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeliveryDetails_Contact, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string phone = 1; */
        if (message.phone !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.phone);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string email = 3; */
        if (message.email !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.email);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.txn.DeliveryDetails.Contact
 */
export const DeliveryDetails_Contact = new DeliveryDetails_Contact$Type();
